var _defs, _path, _g, _g2, _g3, _g4, _rect, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _path2, _g16, _g17, _g18, _path3, _path4, _path5, _path6, _g19, _g20, _path7, _g21, _g22, _path8, _g23, _g24, _path9, _g25, _g26, _path0, _g27, _g28, _path1, _g29, _g30, _path10, _g31, _g32, _path11, _path12, _path13, _path14, _path15, _path16, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g72, _g73, _path80, _path81, _g74, _path82, _g75, _g76;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg401403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 580,
    height: 300,
    viewBox: "0 0 580 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31673",
    "data-name": "Path 31673",
    d: "M11942.183-10829.162c113.03,33.808,27.605,34.313,55.6,45.212s70.16,44.438,48.173,55.836-49.475,33.462-99.827,36.253-154.992-9.8-252.388,3.438-110.383-25.393-157.874-45.6-47.572-50.867-30.931-72.639,40.725-112.523,40.725-112.523S11829.152-10862.97,11942.183-10829.162Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11057",
    "data-name": "Rectangle 11057",
    width: 567.969,
    height: 235.505,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10972",
    "data-name": "Rectangle 10972",
    width: 565.742,
    height: 90.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10973",
    "data-name": "Rectangle 10973",
    width: 19.651,
    height: 0.819,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10974",
    "data-name": "Rectangle 10974",
    width: 565.742,
    height: 58.721,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10975",
    "data-name": "Rectangle 10975",
    width: 92.176,
    height: 30.07,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10977",
    "data-name": "Rectangle 10977",
    width: 288.661,
    height: 49.966,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10978",
    "data-name": "Rectangle 10978",
    width: 565.742,
    height: 129.274,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10980",
    "data-name": "Rectangle 10980",
    width: 297.222,
    height: 36.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30972",
    "data-name": "Path 30972",
    d: "M307.291,106.569c-7.816.565-16.037-.691-23.857-1.124-2.8-.156-5.732.25-8.492-.059-3.116-.348-5.946-1.455-8.895-2.21-13.7-3.5-28.665-1.675-42.818-1.584-7.75.048-15.507-.082-23.243.283-7.716.361-15.42,1.262-23.168,1.258a79.374,79.374,0,0,1-22.437-3.385c-5.836-1.71-11.554-3.395-17.89-3.76-6.846-.387-13.713.781-20.581.087-6.934-.7-13.486-1.5-20.559-1.531-14.613-.072-29.234,1.057-43.836.892a68.469,68.469,0,0,0-10.195-.762C36.892,94.006,32.5,93.1,27.95,92.8c-5.6-.354-11.457.2-17.165.561v19.22c1.44.207,2.869.4,4.3.6-1.428.079-2.858.156-4.3.236v1.243c3.919-.228,7.841-.5,11.8-.622a65.258,65.258,0,0,0,8.986.2c7.4.545,14.523,1.879,22.019,2.734,10.21,1.161,20.635.619,30.843,1.888.729.091,1.438.21,2.161.316-1.261,1.118-26.273,3.029-37.15,3.292-1.645.037,21.621,3.668,32.562,3.674,11.438.015,21.922,2.67,33.161,3.288,10.717.6,21.083-1.563,31.711-1.224,9.9.32,19.763,1.425,29.569-.154.948-.154.869-1.278-.159-1.168-9.5.947-18.623-.829-27.975-1.521-.141-.329-.547-.59-1.306-.685-9.58-1.228-19.443-.114-28.97-1.8-1.149-.2-2.3-.393-3.452-.589a7.071,7.071,0,0,0,1.515-.983c6.784-.241,13.43.1,20.233.273,7.541.186,15.08-.09,22.643-.1,5.758-.019,11.864.21,17.291-1.374,2.14-.615,3.448-2.385,1.61-3.728a6.933,6.933,0,0,0-1-.611c2.491-.04,5.045.07,7.557.047a65.966,65.966,0,0,0,9.344.809c10.986-.066,22.082-.781,33.045-.473.938.026,1.318-1.123.28-1.2-7.565-.511-15-1.482-22.539-2.036a227.578,227.578,0,0,0,24.444-.856c.653-.059,1.321-.131,1.981-.2a110.928,110.928,0,0,0,15.063-.9,5.012,5.012,0,0,0,2.507-1.041c.826-.076,1.661-.15,2.481-.222,3.567-.285,7.136-.788,10.7-1.273,2.293.374,4.6.769,7.011,1.089,5.883.79,11.586-.744,17.523-.744a172.683,172.683,0,0,0,20.97-1.149c.9-.1,1.1-1.129.041-1.049",
    transform: "translate(-10.785 -92.69)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.288,
    cy: 0.497,
    r: 4.076,
    gradientTransform: "matrix(0.126, 0, 0, -0.4, -0.046, 3.714)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffee74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10982",
    "data-name": "Rectangle 10982",
    width: 289.27,
    height: 26.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30973",
    "data-name": "Path 30973",
    d: "M477.636,102.86c-2.605-.2-5.209-.465-7.757-.611-1.974-.106-4.042.175-5.984-.041a44.917,44.917,0,0,1-6.3-1.559c-9.664-2.473-20.231-1.183-30.228-1.113-5.473.029-10.952-.06-16.417.194-5.438.255-10.891.889-16.362.889a55.914,55.914,0,0,1-15.84-2.389,55.67,55.67,0,0,0-12.63-2.652c-4.844-.277-9.681.543-14.538.066-4.9-.495-9.526-1.064-14.52-1.092-10.321-.045-20.653.749-30.956.636a48.087,48.087,0,0,0-7.2-.54c-3.126-.474-6.225-1.12-9.433-1.32-4.9-.308-10.055.357-14.952.546-4.732.2-9.438.213-14.183.251a11.652,11.652,0,0,0-4.93.853c-.426.032-.863.066-1.286.116-.822.088-1.41.59-1.226,1.1-1.725.073-3.437.079-5.056.138-.459.022-.65.307-.575.537-1.378-.025-2.759-.1-4.138-.247-.738-.072-1.239.587-.559.9a26.1,26.1,0,0,0,9.325,2.043c-1.293-.028-2.6-.028-3.888.04-4.578.225-9.49.621-14.136,1.286-1.46-.066-2.931-.126-4.4-.161-5.206-.141-10.615,1.375-15.733.514-.609-.11-1.187.643-.509.8a45.847,45.847,0,0,0,6.548,1.107c2.573.225,5.147-.01,7.706.386.81.129,1.619.252,2.45.373a133.425,133.425,0,0,1-13.835.757c-9.113-.078-17.939.512-26.986,1.051-.9.056-1.045,1.024-.056,1.011,9.642-.117,19.311.8,28.906,1.242,9.241.426,18.3-1.077,27.511-1.433,5.108-.2,10.455-.509,15.573-.235,4.2.219,8.526-.072,12.692.476,2.235.294,4.45.627,6.652.938-1.488.081-2.968.166-4.471.241-1.77.09-3.52.208-5.288.33-1.349.085-3.423-.122-4.659.114.12-.021.112-.156-.019-.156l-.429.009a.206.206,0,0,0-.179.1c-.038.1-.073.2-.117.3-.022.079.026.179.167.191,6.854.549,13.472-.32,20.287-.517a47.219,47.219,0,0,0,6.357.136c5.216.386,10.248,1.324,15.552,1.933,7.195.819,14.563.429,21.77,1.331.515.063,1.029.144,1.518.219-.879.794-18.539,2.138-26.224,2.323-1.161.031,15.26,2.593,23,2.6,8.075.009,15.48,1.885,23.412,2.322,7.571.417,14.883-1.107,22.392-.863,7,.226,13.963,1,20.879-.11.672-.116.618-.909-.114-.829-6.7.668-13.148-.586-19.743-1.074-.11-.232-.393-.415-.931-.484-6.76-.866-13.726-.076-20.447-1.271-.823-.138-1.632-.273-2.445-.415a5.085,5.085,0,0,0,1.073-.693c4.789-.17,9.486.069,14.283.194,5.322.129,10.648-.068,16-.073,4.064-.009,8.371.148,12.21-.973,1.5-.432,2.436-1.682,1.137-2.632a5.766,5.766,0,0,0-.709-.429c1.755-.029,3.564.044,5.326.031a46.078,46.078,0,0,0,6.608.569c7.757-.041,15.592-.545,23.339-.332.659.021.923-.794.2-.845-5.344-.358-10.6-1.048-15.921-1.437a162.018,162.018,0,0,0,17.262-.606c.459-.044.941-.082,1.4-.138a78.192,78.192,0,0,0,10.635-.637,3.587,3.587,0,0,0,1.774-.732c.583-.057,1.168-.11,1.744-.156,2.529-.2,5.043-.555,7.556-.906,1.629.266,3.257.55,4.968.772,4.142.559,8.165-.527,12.361-.521,1.958,0,3.862-.034,5.748-.11Z",
    transform: "translate(-188.366 -93.248)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.517,
    cy: 0.498,
    r: 4.067,
    gradientTransform: "matrix(0.092, 0, 0, -0.4, -0.866, 5.205)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10983",
    "data-name": "Rectangle 10983",
    width: 332.931,
    height: 20.744,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10984",
    "data-name": "Rectangle 10984",
    width: 312.528,
    height: 20.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10985",
    "data-name": "Rectangle 10985",
    width: 329.715,
    height: 20.432,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10987",
    "data-name": "Rectangle 10987",
    width: 37.773,
    height: 10.314,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30977",
    "data-name": "Path 30977",
    d: "M2.634,119.435V129.75c.351-.012.691-.044,1.039-.044,12.311-.013,38.49-6.059,36.641-6.122-9.645-.342-29.141-2.384-37.68-4.149",
    transform: "translate(-2.634 -119.435)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -0.383,
    cy: -1.43,
    r: 16.441,
    gradientTransform: "matrix(0.261, 0, 0, -1.061, -0.072, 12.027)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10989",
    "data-name": "Rectangle 10989",
    width: 222.928,
    height: 43.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30978",
    "data-name": "Path 30978",
    d: "M224.379,117.9c-14.412-1.28-28.467-2.662-42.978-2.475a146.041,146.041,0,0,1-22.048-1.789c1.314-.289,2.61-.584,3.9-.884,4.083-.929,8.183-.364,12.286-.909a52.1,52.1,0,0,0,10.419-2.6c1.092-.386.173-2.14-.806-1.893-8.165,2.031-16.776-1.531-25.059-1.206-2.356.085-4.7.229-7.016.368a171.991,171.991,0,0,0-22.527-3.016,61.314,61.314,0,0,0-6.188-.094c5.278-.537,10.387-1.7,14.843-4.814a1.18,1.18,0,0,0-.889-2.122,52.42,52.42,0,0,1-6.581.58,1.019,1.019,0,0,0-.925-1.27c-2.569-.136-5.312-.151-8.046-.316a2.246,2.246,0,0,0-1.954-2.608c-.68-.12-1.375-.207-2.053-.279-2.14-1.6-5.106-1.971-7.852-2-7.55-.088-15.056-.139-22.593-.59C80.5,89.534,72.277,87.971,64.483,88.7c-5.109.474-10.044,1.995-15.034,3.109a53.178,53.178,0,0,0-11.463,1.262c-11.776.2-23.563-.709-35.352-1.189v39.915c10.943-1.745,22.084-1.042,33-2.88,8.447-1.425,16.452-3.647,24.787-4.556a50.636,50.636,0,0,0,10.1-.32c10.873.468,21.413,2.517,32.333,1.214a.335.335,0,0,0,.254-.446c-.065-.229-.119-.462-.173-.7a.33.33,0,0,0-.274-.235l-.7-.01c-.2,0-.22.31-.021.365-1.98-.565-5.284-.065-7.436-.282-2.806-.283-5.608-.559-8.416-.768-2.4-.181-4.747-.38-7.126-.568,3.515-.716,7.055-1.521,10.593-2.216,6.637-1.284,13.524-.609,20.233-1.124,8.153-.64,16.668.1,24.82.565,14.661.829,29.1,4.372,43.8,3.377,15.294-1.029,30.7-3.208,46.056-2.938,1.578.032,1.359-2.244-.09-2.373",
    transform: "translate(-2.634 -88.507)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -0.068,
    cy: 0.712,
    r: 3.87,
    gradientTransform: "matrix(0.196, 0, 0, -1.061, -0.014, 4.991)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10990",
    "data-name": "Rectangle 10990",
    width: 359.026,
    height: 46.173,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10991",
    "data-name": "Rectangle 10991",
    width: 444.073,
    height: 28.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30981",
    "data-name": "Path 30981",
    d: "M444.116,162.215c.647-.2,1.3-.4,1.945-.612,1.366-.451.323-2.616-.888-2.331-10.085,2.334-20.43-2.175-30.582-1.924-2.89.054-5.755.2-8.607.33a209.4,209.4,0,0,0-27.391-4.108c-2.525-.214-5.052-.255-7.572-.225,6.479-.564,12.788-1.9,18.416-5.616a1.429,1.429,0,0,0-.989-2.616,62.155,62.155,0,0,1-8.081.587,1.2,1.2,0,0,0-1.063-1.559c-3.122-.211-6.493-.285-9.822-.537a2.662,2.662,0,0,0-2.268-3.228c-.81-.16-1.66-.272-2.488-.373-2.52-2-6.138-2.505-9.495-2.589-9.237-.251-18.413-.448-27.617-1.127-9.515-.694-19.489-2.758-29.07-2.008-6.278.492-12.394,2.252-18.549,3.53a65.167,65.167,0,0,0-14.093,1.35c-20.1.026-40.124-2.561-60.243-2.711-9.725-.075-18.818,1.428-28.424,2.711-9.517,1.264-18.872-1.246-28.326-.6-8.745.611-16.75,3.925-24.937,7.287-10.135,4.168-20.358,6.574-31.165,6.427-10.653-.15-21.177-2.134-31.762-3.018-10.615-.9-21.3-.8-31.964-1.055-8.692-.21-17.57-1.126-26.446-1.457v15.469Z",
    transform: "translate(-2.634 -134.119)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.45,
    cy: 1.033,
    r: 5.041,
    gradientTransform: "matrix(-0.093, -0.015, 0.001, -0.592, -0.007, 1.744)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10992",
    "data-name": "Rectangle 10992",
    width: 539.256,
    height: 69.429,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30983",
    "data-name": "Path 30983",
    d: "M540.587,140.456c-16.856-1.877-33.3-3.87-50.407-4.027a171.551,171.551,0,0,1-25.812-2.676c1.573-.307,3.107-.616,4.662-.938,4.861-.988,9.64-.232,14.516-.75A62.705,62.705,0,0,0,496,129.272c1.315-.426.366-2.519-.813-2.25-9.744,2.181-19.619-2.232-29.4-2.067-2.771.034-5.533.156-8.282.255a199.52,199.52,0,0,0-26.3-4.143c-2.4-.225-4.846-.282-7.264-.27,6.239-.495,12.342-1.739,17.837-5.278a1.366,1.366,0,0,0-.9-2.522,62.222,62.222,0,0,1-7.8.509,1.148,1.148,0,0,0-.986-1.522c-3-.214-6.232-.308-9.442-.574a2.53,2.53,0,0,0-2.118-3.123c-.781-.16-1.588-.269-2.394-.379-2.388-1.945-5.862-2.453-9.091-2.564-8.873-.3-17.7-.547-26.546-1.271-9.16-.731-18.721-2.787-27.947-2.137-6.046.43-11.977,2.084-17.928,3.273a62.723,62.723,0,0,0-13.6,1.2c-19.351-.11-38.575-2.745-57.932-3.028-9.354-.142-18.137,1.242-27.423,2.4-9.187,1.157-18.121-1.324-27.235-.765-8.448.521-16.224,3.659-24.163,6.837-9.838,3.944-19.734,6.182-30.133,5.971-10.24-.214-20.341-2.207-30.5-3.131-10.215-.939-20.51-.914-30.767-1.236-18.723-.594-38.308-4.6-56.878,1.848-4.014,1.406-7.886,3.484-12.059,4.077-3.694.517-7.541-.357-11.263-.144-3.936.242-7.977.71-12.03,1.13v4.979c2.589.159,5.2.274,7.866.329,7.867.169,15.232,3.338,23.1,1.968,3.236-.547,6.348-1.268,9.446-1.939,4.651,1.064,9.32,2.155,14.013,2.822,1.066.157,2.158.326,3.248.495a5.476,5.476,0,0,0,3.188,2.121,99.088,99.088,0,0,0,19.839,2.194c.86.159,1.739.305,2.6.44a204.756,204.756,0,0,0,32.257,2.4c-10.05.862-20.01,2.554-30.1,3.332-1.378.114-1.007,2.378.222,2.36,14.561-.291,29.17,1.434,43.708,1.88a60.564,60.564,0,0,0,12.467-1.317c3.323.12,6.719-.025,10.022.135a9.117,9.117,0,0,0-1.4,1.176c-2.6,2.567-1.085,6.075,1.657,7.342,7.007,3.261,15.113,2.993,22.75,3.189,10,.247,19.948,1.013,29.973.863,9.027-.135,17.851-.612,26.827.056a8.911,8.911,0,0,0,1.889,1.962c-1.56.361-3.107.693-4.667,1.06-12.813,3.025-25.732.549-38.562,2.67a2.155,2.155,0,0,0-1.829,1.306c-12.467,1.091-24.767,4.318-37.223,2.161-1.358-.235-1.59,1.97-.351,2.294,12.774,3.373,25.972,1.5,39.128,1.18,14.12-.371,27.567,4.157,41.845,3.313,14.95-.888,29.17-5.789,44.314-5.478,14.494.3,45.748-6.126,43.587-6.251-14.391-.829-47.274-5.3-48.805-7.527.966-.191,1.933-.395,2.911-.547,13.672-2.2,27.4-.822,41.067-2.8,10.039-1.459,19.63-3.866,29.5-4.713a60.071,60.071,0,0,0,11.918-.126c12.762.834,25.023,3.521,37.972,2.268a.425.425,0,0,0,.338-.52c-.069-.274-.12-.549-.166-.825a.342.342,0,0,0-.316-.273l-.807-.048a.228.228,0,0,0-.06.439c-2.279-.712-6.2-.217-8.715-.523-3.3-.4-6.558-.8-9.865-1.126-2.789-.273-5.558-.562-8.337-.853,4.189-.753,8.4-1.609,12.627-2.329,7.935-1.344,15.968-.37,23.9-.8,9.64-.546,19.621.555,29.165,1.308,17.192,1.361,33.933,5.9,51.312,5.108,18.077-.815,36.378-2.978,54.431-2.265,1.86.081,1.766-2.611.066-2.793",
    transform: "translate(-2.634 -101.812)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.48,
    cy: 0.491,
    r: 2.148,
    gradientTransform: "matrix(-0.172, -0.022, 0.002, -0.592, -0.001, 1.66)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10994",
    "data-name": "Rectangle 10994",
    width: 239.828,
    height: 38.901,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30984",
    "data-name": "Path 30984",
    d: "M241.71,141.286c-9.135-.813-18.061-1.689-27.279-1.569a93.3,93.3,0,0,1-13.98-1.133c.831-.185,1.654-.37,2.479-.559,2.582-.592,5.188-.235,7.786-.577a32.593,32.593,0,0,0,6.617-1.653c.69-.247.1-1.358-.52-1.193-5.172,1.283-10.635-.978-15.893-.771-1.494.05-2.984.148-4.458.235a111.278,111.278,0,0,0-14.293-1.921,38.461,38.461,0,0,0-3.923-.057,19.557,19.557,0,0,0,9.421-3.048.752.752,0,0,0-.565-1.352,31.77,31.77,0,0,1-4.177.365.644.644,0,0,0-.587-.8c-1.637-.085-3.367-.1-5.1-.2a1.425,1.425,0,0,0-1.245-1.657c-.436-.081-.866-.129-1.3-.175a8.495,8.495,0,0,0-4.979-1.271c-4.792-.057-9.549-.087-14.335-.373-4.954-.285-10.169-1.28-15.118-.823a77.5,77.5,0,0,0-9.534,1.976,33.4,33.4,0,0,0-7.281.807c-10.42.169-20.855-1.022-31.289-.944a102.6,102.6,0,0,0-14.677,1.617c-4.911.731-9.8-.5-14.7-.091-4.519.38-8.6,2.163-12.763,3.969a40.057,40.057,0,0,1-16.022,3.567c-5.522.006-11.033-.936-16.531-1.321-4.937-.339-9.884-.277-14.823-.289v11.635c3.826.292,7.685.4,11.554.307-3.869.42-7.7,1.066-11.554,1.594v1.774c6.408.01,12.854.489,19.244.545a32.559,32.559,0,0,0,6.674-.854c1.8.021,3.617-.1,5.392-.04a4.947,4.947,0,0,0-.71.64c-1.314,1.415-.373,3.283,1.145,3.932,3.876,1.673,8.235,1.435,12.344,1.452,5.4.015,10.789.305,16.17.109,4.848-.181,9.6-.546,14.443-.291a4.964,4.964,0,0,0,1.082,1.035c-.828.216-1.641.409-2.47.619-6.8,1.789-13.839.611-20.68,1.9a1.087,1.087,0,0,0-.929.727c-6.675.735-13.192,2.613-19.964,1.6-.743-.114-.794,1.074-.126,1.24,7,1.66,14.043.5,21.122.17,7.584-.364,14.981,1.91,22.634,1.283,8.018-.653,15.5-3.455,23.67-3.468,7.811-.007,24.416-3.84,23.243-3.881-7.772-.28-25.622-2.29-26.513-3.474.5-.116,1.022-.239,1.543-.333,7.286-1.346,14.721-.766,22.006-1.992,5.359-.907,10.434-2.313,15.722-2.891a32.294,32.294,0,0,0,6.416-.2c6.9.3,13.59,1.6,20.51.772a.22.22,0,0,0,.17-.283,4.523,4.523,0,0,1-.116-.446.2.2,0,0,0-.183-.138l-.429-.022c-.129,0-.141.2-.022.236-1.253-.355-3.348-.04-4.711-.175-1.785-.18-3.558-.355-5.343-.49-1.521-.114-3.018-.235-4.528-.355,2.24-.458,4.472-.969,6.727-1.409,4.217-.816,8.586-.385,12.837-.715,5.172-.409,10.579.06,15.743.361,9.311.53,18.464,2.773,27.8,2.138,9.7-.655,19.48-2.027,29.224-1.86,1,.021.86-1.43-.059-1.51",
    transform: "translate(-2.634 -122.635)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.37,
    cy: 0.498,
    r: 2.75,
    gradientTransform: "translate(-0.019 2.235) rotate(180) scale(0.166 0.591)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10995",
    "data-name": "Rectangle 10995",
    width: 7.687,
    height: 4.655,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10996",
    "data-name": "Rectangle 10996",
    width: 9.065,
    height: 5.076,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10997",
    "data-name": "Rectangle 10997",
    width: 482.096,
    height: 56.36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10998",
    "data-name": "Rectangle 10998",
    width: 13.792,
    height: 8.352,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10999",
    "data-name": "Rectangle 10999",
    width: 16.27,
    height: 9.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11000",
    "data-name": "Rectangle 11000",
    width: 8.66,
    height: 5.237,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11001",
    "data-name": "Rectangle 11001",
    width: 10.201,
    height: 5.711,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11002",
    "data-name": "Rectangle 11002",
    width: 8.654,
    height: 5.24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11003",
    "data-name": "Rectangle 11003",
    width: 10.204,
    height: 5.703,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11004",
    "data-name": "Rectangle 11004",
    width: 5.915,
    height: 3.577,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11005",
    "data-name": "Rectangle 11005",
    width: 6.97,
    height: 3.899,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11006",
    "data-name": "Rectangle 11006",
    width: 10.022,
    height: 6.069,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11007",
    "data-name": "Rectangle 11007",
    width: 11.82,
    height: 6.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11008",
    "data-name": "Rectangle 11008",
    width: 7.287,
    height: 4.413,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11009",
    "data-name": "Rectangle 11009",
    width: 8.588,
    height: 4.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11010",
    "data-name": "Rectangle 11010",
    width: 5.916,
    height: 3.578,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11011",
    "data-name": "Rectangle 11011",
    width: 6.975,
    height: 3.898,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11012",
    "data-name": "Rectangle 11012",
    width: 64.187,
    height: 111.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11013",
    "data-name": "Rectangle 11013",
    width: 0.313,
    height: 5.937,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11014",
    "data-name": "Rectangle 11014",
    width: 33.548,
    height: 99.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11015",
    "data-name": "Rectangle 11015",
    width: 3.76,
    height: 41.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11016",
    "data-name": "Rectangle 11016",
    width: 8.412,
    height: 53.883,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11017",
    "data-name": "Rectangle 11017",
    width: 3.829,
    height: 34.432,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11018",
    "data-name": "Rectangle 11018",
    width: 2.738,
    height: 15.491,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11019",
    "data-name": "Rectangle 11019",
    width: 6.044,
    height: 1.722,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11020",
    "data-name": "Rectangle 11020",
    width: 1.902,
    height: 0.97,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11021",
    "data-name": "Rectangle 11021",
    width: 6.208,
    height: 2.168,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11022",
    "data-name": "Rectangle 11022",
    width: 1.031,
    height: 0.667,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11023",
    "data-name": "Rectangle 11023",
    width: 3.281,
    height: 1.548,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11024",
    "data-name": "Rectangle 11024",
    width: 1.286,
    height: 0.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11025",
    "data-name": "Rectangle 11025",
    width: 1.758,
    height: 0.632,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11026",
    "data-name": "Rectangle 11026",
    width: 6.042,
    height: 1.777,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11027",
    "data-name": "Rectangle 11027",
    width: 1.904,
    height: 0.963,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11028",
    "data-name": "Rectangle 11028",
    width: 6.183,
    height: 2.334,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11029",
    "data-name": "Rectangle 11029",
    width: 1.032,
    height: 0.673,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11030",
    "data-name": "Rectangle 11030",
    width: 3.259,
    height: 1.621,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11031",
    "data-name": "Rectangle 11031",
    width: 1.287,
    height: 0.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11032",
    "data-name": "Rectangle 11032",
    width: 1.756,
    height: 0.656,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11033",
    "data-name": "Rectangle 11033",
    width: 249.395,
    height: 121.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11034",
    "data-name": "Rectangle 11034",
    width: 223.192,
    height: 107.903,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11035",
    "data-name": "Rectangle 11035",
    width: 18.595,
    height: 10.902,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11036",
    "data-name": "Rectangle 11036",
    width: 7.706,
    height: 4.813,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11037",
    "data-name": "Rectangle 11037",
    width: 12.403,
    height: 8.344,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11038",
    "data-name": "Rectangle 11038",
    width: 13.552,
    height: 8.804,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11039",
    "data-name": "Rectangle 11039",
    width: 23.923,
    height: 17.054,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11040",
    "data-name": "Rectangle 11040",
    width: 22.51,
    height: 13.132,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11041",
    "data-name": "Rectangle 11041",
    width: 23.949,
    height: 16.401,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11042",
    "data-name": "Rectangle 11042",
    width: 28.154,
    height: 17.485,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11043",
    "data-name": "Rectangle 11043",
    width: 78.829,
    height: 39.324,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11044",
    "data-name": "Rectangle 11044",
    width: 6.003,
    height: 15.809,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11045",
    "data-name": "Rectangle 11045",
    width: 2.007,
    height: 7.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11046",
    "data-name": "Rectangle 11046",
    width: 8.636,
    height: 5.96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11047",
    "data-name": "Rectangle 11047",
    width: 10.98,
    height: 18.103,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11048",
    "data-name": "Rectangle 11048",
    width: 20.892,
    height: 17.418,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11049",
    "data-name": "Rectangle 11049",
    width: 124.448,
    height: 53.037,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11050",
    "data-name": "Rectangle 11050",
    width: 61.92,
    height: 26.927,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11051",
    "data-name": "Rectangle 11051",
    width: 214.817,
    height: 82.423,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11052",
    "data-name": "Rectangle 11052",
    width: 226.671,
    height: 81.654,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11053",
    "data-name": "Rectangle 11053",
    width: 219.568,
    height: 84.627,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11054",
    "data-name": "Rectangle 11054",
    width: 491.185,
    height: 116.489,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11055",
    "data-name": "Rectangle 11055",
    width: 443.223,
    height: 105.115,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 300
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    clipPath: "url(#clip-_404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_35",
    "data-name": "Mask Group 35",
    transform: "translate(-11481.867 10945.818)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14647",
    "data-name": "Group 14647",
    transform: "translate(11491.503 -10892.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14646",
    "data-name": "Group 14646",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14645",
    "data-name": "Group 14645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14644",
    "data-name": "Group 14644",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30965",
    "data-name": "Path 30965",
    d: "M516.272,64.15a242.148,242.148,0,0,1-51.039-1.81c-22.33-3.275-44.715-8.484-67.409-8.605s-45.2,3.242-67.917,3.137c-20.792-.1-41.77-1.667-61.939-6.765-5.351-1.355-10.659-2.886-15.855-4.728-4.563-1.619-8.986-3.8-13.6-5.244-8.8-2.765-18.169-2.62-27.21-1.073-18.138,3.1-35,10.644-53,14.228-21.053,4.19-42.876,4.833-64.274,6.125-11.184.674-22.379,1.394-33.513,2.649-10.524,1.187-20.943,3.1-31.461,4.322A151.72,151.72,0,0,1,0,67.308v60.877H565.742V59.826c-16.4,1.924-32.993,3.269-49.47,4.324",
    transform: "translate(0 17.756)",
    fill: "#a27755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14398",
    "data-name": "Group 14398",
    transform: "translate(0 55.717)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14397",
    "data-name": "Group 14397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14396",
    "data-name": "Group 14396",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30966",
    "data-name": "Path 30966",
    d: "M516.272,64.15a242.148,242.148,0,0,1-51.039-1.81c-20.859-3.059-41.769-7.807-62.931-8.514-5.758,1.745-11.485,3.6-17.247,5.335-10.328,3.1-20.868,5.724-31.7,6.512-11.92.869-23.857,1.989-35.8,2.549-12.154.571-24.315-.084-36.484.389s-24.356,1.218-36.539.669c-.338-.016-.553-.514-.189-.668,9.223-3.869,19.439-4.05,29.207-5.758,5.517-.961,11.017-2.26,16.656-2.329,5.748-.072,11.5.2,17.252.088a236.064,236.064,0,0,0,35.43-3.17c2.136-.368,4.27-.763,6.4-1.17-6.451.371-12.907.628-19.384.6-20.792-.1-41.77-1.667-61.939-6.765-5.351-1.355-10.659-2.886-15.855-4.728-4.563-1.619-8.986-3.8-13.6-5.244-8.8-2.765-18.169-2.62-27.21-1.073-3.675.63-7.3,1.443-10.889,2.366q8.148-.412,16.317-.424a.357.357,0,0,1,.1.7c-7.825,2.8-15.584,5.764-23.3,8.831-7.315,2.908-14.663,5.755-21.74,9.169-6.018,2.9-12.568,6.057-19.5,5.318-1.968-.21-3.907-.709-5.89-.79a23.186,23.186,0,0,0-5.723.591c-3.346.7-6.59,1.725-9.875,2.627a46.824,46.824,0,0,1-15.636,1.65c-5.886-.335-11.764-.825-17.655-1.051a116.594,116.594,0,0,0-17.726.464c-6.12.706-12.241,1.346-18.388,1.817C40.971,71.9,20.482,72.141,0,72.037v56.148H565.742V59.826c-16.4,1.924-32.993,3.269-49.47,4.324",
    transform: "translate(0 -37.961)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14401",
    "data-name": "Group 14401",
    transform: "translate(77.757 85.676)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14400",
    "data-name": "Group 14400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14399",
    "data-name": "Group 14399",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30967",
    "data-name": "Path 30967",
    d: "M61.146,58.907q5.742-.209,11.482-.407A116.009,116.009,0,0,0,55,58.966c-.677.079-1.353.151-2.027.226q4.084-.136,8.168-.285",
    transform: "translate(-52.977 -58.373)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14404",
    "data-name": "Group 14404",
    transform: "translate(0 87.22)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14403",
    "data-name": "Group 14403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14402",
    "data-name": "Group 14402",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30968",
    "data-name": "Path 30968",
    d: "M538.938,63.17c-14.159-1.221-28.423-2.1-42.635-2.21-14.234-.109-28.495.655-42.723,1.073q-21.95.643-43.9,1.281c-14.252.417-28.5,1.262-42.744,1.613a120,120,0,0,1-20.889-1c-6.377-.963-12.719-2.094-19.073-3.185q-1.607-.277-3.219-.546c-9.659-.119-19.32-.186-28.972-.528-14.51-.511-28.945-.175-43.439.658-14.422.828-28.837,1.912-43.285,2.177-14.7.269-29.425-.022-44.135-.038-29.223-.035-58.369,1.162-87.568,2.118-25.446.831-50.973,1.13-76.358-1v54.562H565.743V64.564c-8.943-.191-17.883-.627-26.805-1.394",
    transform: "translate(0 -59.425)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14407",
    "data-name": "Group 14407",
    transform: "translate(198.993 55.718)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14406",
    "data-name": "Group 14406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14405",
    "data-name": "Group 14405",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30969",
    "data-name": "Path 30969",
    d: "M161.622,39.8c3.97,1.459,7.842,3.126,11.845,4.528a71.583,71.583,0,0,1,10.624,4.433.356.356,0,0,1,0,.618c-7.327,5-15.9,8.616-24.181,11.9a83.52,83.52,0,0,1-13.474,4.252c-3.6.76-7.446.992-10.857,2.4,2.165.354,4.446-.3,6.521-.86,2.254-.618,4.541-1.076,6.812-1.645,5.7-1.433,11.268-3.289,16.9-4.945,5.454-1.6,10.905-3.21,16.509-4.271a116.414,116.414,0,0,1,16.126-1.769c9.762-.477,19.531-.238,29.3.047a203.007,203.007,0,0,1-23.2-4.384c-5.351-1.353-10.66-2.884-15.855-4.726-4.563-1.619-8.986-3.8-13.6-5.246a54.289,54.289,0,0,0-21.965-1.8,26.3,26.3,0,0,1,8.488,1.46",
    transform: "translate(-135.578 -37.962)",
    fill: "#c79584"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10976",
    "data-name": "Rectangle 10976",
    width: 565.742,
    height: 129.274,
    transform: "translate(0 95.673)",
    fill: "#ebb38b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14410",
    "data-name": "Group 14410",
    transform: "translate(277.082 95.672)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14409",
    "data-name": "Group 14409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14408",
    "data-name": "Group 14408",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30970",
    "data-name": "Path 30970",
    d: "M236.428,87.088c19.555-.387,39.048-.228,58.592.547,20.5.812,41,2.31,61.183,6.013,40.366,7.409,80.385,17.084,121.238,21.5V65.183H331.6c4.393.59,8.776,1.17,13.163,1.7,27.844,3.426,56.445,1.776,83.922,7.926.749.172.5,1.176-.166,1.245-2.46.26-4.92.511-7.386.735-41.05,3.734-82.437,3.254-123.6,2.307-20.576-.468-41.194-.42-61.726,1.2-8.112.634-16.214.655-24.345.979-7.6.3-15.482.8-22.68,3.433,15.684,2.849,31.766,2.687,47.647,2.375",
    transform: "translate(-188.781 -65.184)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14413",
    "data-name": "Group 14413",
    transform: "translate(0 95.672)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14412",
    "data-name": "Group 14412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14411",
    "data-name": "Group 14411",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30971",
    "data-name": "Path 30971",
    d: "M513.218,133.583c10.581,1.675,21.68-.16,31.791,4.022a.634.634,0,0,1-.15,1.16c-20.975,3.358-41.945,7.233-63.013,9.912-18.96,2.4-38.11,3.828-56.777,8.051a43.913,43.913,0,0,1,9.181,2.58,75.861,75.861,0,0,0,12.734,3.652c7.315,1.384,15.648,2.422,20.86,8.329a.642.642,0,0,1-.283,1.058c-18.546,7.356-39.584,5.774-59.091,5.09a.637.637,0,0,1-.16-1.248c10.409-2.228,20.619-5.281,30.958-7.8-39.449-1.763-79.808-9.741-119.047-3.2,30.733,1.412,61.3,5.394,92.054,6.548.812.037.816,1.3,0,1.267-32.624-1.221-65.036-5.639-97.662-6.779-1.607.333-3.222.674-4.826,1.061a.631.631,0,0,1-.376-1.2c-.562-.016-1.123-.038-1.684-.051a.633.633,0,0,1-.16-1.243c20.27-4.227,41.029-5.073,61.45-8.349-18.642-3.741-37.863.019-56.7-.656-21.068-.751-42.158-2.652-63.239-1.431,7.99,1.8,16.182,2.686,23.958,5.363a.641.641,0,0,1,0,1.23c-16.421,4.273-33.582,2.836-50.407,3.1,20.3,6.515,42.28,7,63.29,9.763,19.116,2.5,40.04,2.416,57.6,11.315a.633.633,0,0,1-.147,1.16c-15.5,2.5-31.254,1.494-46.852.683-16.456-.853-32.977-.178-49.378-2-16.647-1.849-32.973-5.847-49.605-7.662-15.3-1.675-30.955-1.93-45.839-6.232-.487-.135-.69-.925-.153-1.158,19.417-8.566,41.114-7.233,61.862-9.143-30.84-5.821-62.165-9.774-92.124-19.48a.636.636,0,0,1,0-1.223,45.385,45.385,0,0,1,11.139-2.585c-6.217-1-12.323-2.514-18.472-3.9a134.493,134.493,0,0,0-24.318-3.354c-14.792-.578-29.889.74-44.386-2.878a.639.639,0,0,1,0-1.226c34.537-11.428,71.513-16.43,107.873-17.585-9.364-1.063-18.9-.809-28.034-3.368a.636.636,0,0,1,0-1.224c28.875-9.847,61.4-4.507,88.563-19.759-34.4-1.5-68.69-7.757-103.207-5.824a467.324,467.324,0,0,1-53.975-.264c-17.613-1.044-35.229-2.344-52.88-2.053a.636.636,0,0,1-.159-1.246q20.763-4.877,41.547-9.628H0V194.459H565.742V117.443c-16.836,7.359-34.926,11.062-52.525,16.139",
    transform: "translate(0 -65.184)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14418",
    "data-name": "Group 14418",
    transform: "translate(15.83 136.046)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14417",
    "data-name": "Group 14417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14416",
    "data-name": "Group 14416",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14415",
    "data-name": "Group 14415",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14414",
    "data-name": "Group 14414",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10979",
    "data-name": "Rectangle 10979",
    width: 297.565,
    height: 37.576,
    transform: "translate(0 -0.24)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14423",
    "data-name": "Group 14423",
    transform: "translate(276.472 136.864)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14422",
    "data-name": "Group 14422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14421",
    "data-name": "Group 14421",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14420",
    "data-name": "Group 14420",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14419",
    "data-name": "Group 14419",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10981",
    "data-name": "Rectangle 10981",
    width: 289.575,
    height: 26.591,
    transform: "translate(-0.305 -0.228)",
    fill: "url(#radial-gradient-2)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14426",
    "data-name": "Group 14426",
    transform: "translate(0 107.088)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14425",
    "data-name": "Group 14425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14424",
    "data-name": "Group 14424",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30974",
    "data-name": "Path 30974",
    d: "M326.387,82.228c-3.15.044-6.305.272-9.454.295-6.056.048-12.1.349-18.163.445-14.506.226-29.045.254-43.555-.084-28.556-.681-57.055-1.93-85.625-1.669A1532,1532,0,0,1,0,72.961V91.076a3.1,3.1,0,0,0,.8.884c4.487,3.188,13.649,1.022,18.74,1.079,14.588.161,29.045.1,43.621-.395,29.706-1,59.419-1.733,89.134-2.407,29.964-.687,59.869-2.74,89.823-3.364,16.632-.346,33.171-.565,49.773-1.786,12.237-.9,25.759.037,37.812-1.833,8.3-1.284-1.865-1.044-3.319-1.024",
    transform: "translate(0 -72.961)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14429",
    "data-name": "Group 14429",
    transform: "translate(253.215 95.002)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14428",
    "data-name": "Group 14428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14427",
    "data-name": "Group 14427",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30975",
    "data-name": "Path 30975",
    d: "M485.047,64.726a1390.251,1390.251,0,0,1-156.64,7.863c-27.26-.232-54.462,1.044-81.718,1.745-13.841.357-27.721.336-41.572.131-5.774-.09-11.553-.385-17.33-.429-3.007-.022-6.018-.248-9.025-.291-1.383-.013-11.084-.244-3.163,1.032,11.507,1.858,24.411.907,36.083,1.8,15.84,1.209,31.627,1.412,47.5,1.742,28.593.591,57.13,2.624,85.723,3.275,28.36.649,56.716,1.358,85.066,2.332,13.916.468,27.717.521,41.635.352,3.5-.043,9.027,1.066,13.442.487Z",
    transform: "translate(-172.52 -64.727)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14432",
    "data-name": "Group 14432",
    transform: "translate(0 167.953)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14431",
    "data-name": "Group 14431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14430",
    "data-name": "Group 14430",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30976",
    "data-name": "Path 30976",
    d: "M323.17,123.381c-3.15.044-6.308.276-9.452.3-6.056.048-12.107.354-18.156.445-14.51.22-29.054.258-43.56-.091-28.555-.681-57.054-1.929-85.631-1.66A1528.782,1528.782,0,0,1,0,114.429v19.813c4.838,1.441,12.028-.09,16.329-.047,14.583.156,29.044.09,43.623-.395,29.7-1,59.424-1.735,89.134-2.414,29.96-.681,59.863-2.745,89.823-3.357,16.632-.345,33.167-.562,49.774-1.791,12.234-.9,25.753.041,37.8-1.829,8.3-1.283-1.858-1.044-3.317-1.029",
    transform: "translate(0 -114.43)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14437",
    "data-name": "Group 14437",
    transform: "translate(3.866 175.3)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14436",
    "data-name": "Group 14436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14435",
    "data-name": "Group 14435",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14434",
    "data-name": "Group 14434",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14433",
    "data-name": "Group 14433",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10986",
    "data-name": "Rectangle 10986",
    width: 39.529,
    height: 10.315,
    transform: "translate(0)",
    fill: "url(#radial-gradient-3)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14442",
    "data-name": "Group 14442",
    transform: "translate(3.866 129.906)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14441",
    "data-name": "Group 14441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14440",
    "data-name": "Group 14440",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14439",
    "data-name": "Group 14439",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14438",
    "data-name": "Group 14438",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10988",
    "data-name": "Rectangle 10988",
    width: 223.412,
    height: 43.822,
    transform: "translate(0 -0.536)",
    fill: "url(#radial-gradient-4)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14445",
    "data-name": "Group 14445",
    transform: "translate(206.717 178.774)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14444",
    "data-name": "Group 14444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14443",
    "data-name": "Group 14443",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30979",
    "data-name": "Path 30979",
    d: "M499.866,137.3a161.78,161.78,0,0,0-16.572-2.025c-1.858-.135-3.706-.135-5.557-.09,4.729-.476,9.325-1.531,13.343-4.32a1.063,1.063,0,0,0-.8-1.908,45.835,45.835,0,0,1-5.916.52.913.913,0,0,0-.835-1.139c-2.3-.116-4.767-.137-7.226-.285a2.017,2.017,0,0,0-1.76-2.345c-.611-.109-1.23-.179-1.849-.247-1.9-1.437-4.582-1.77-7.047-1.8-6.784-.085-13.531-.131-20.3-.53-7-.405-14.4-1.816-21.4-1.165-4.593.434-9.032,1.8-13.513,2.8a47.625,47.625,0,0,0-10.293,1.139c-14.767.241-29.546-1.449-44.318-1.333-7.146.047-13.773,1.253-20.785,2.288-6.941,1.033-13.891-.709-20.8-.131-6.407.54-12.184,3.063-18.08,5.623a56.734,56.734,0,0,1-22.694,5.056c-7.82.006-15.611-1.344-23.412-1.879-7.817-.543-15.668-.354-23.5-.424-14.306-.141-29.433-2.864-43.279,2.365-2.982,1.135-5.843,2.787-9,3.307-2.784.456-5.752-.15-8.583.081-7.9.665-16.217,2.538-24.115,1.684-1.069-.116-.863,1.418.041,1.576a119.085,119.085,0,0,0,21.2,1.717c6,0,11.774,2.288,17.716,1.113,2.435-.477,4.772-1.071,7.092-1.632,3.606.735,7.217,1.485,10.825,1.91.818.1,1.669.213,2.5.329a4.392,4.392,0,0,0,2.538,1.554,75.765,75.765,0,0,0,15.228,1.343c.665.106,1.344.2,2,.3a156.339,156.339,0,0,0,24.711,1.284c-7.626.823-15.14,2.278-22.791,3.048-1.045.109-.658,1.829.291,1.789,11.08-.462,22.294.609,33.4.7a46.519,46.519,0,0,0,9.446-1.209c2.538.029,5.117-.141,7.637-.07a7.385,7.385,0,0,0-1.008.913c-1.86,2.006-.537,4.654,1.628,5.574,5.481,2.369,11.652,2.027,17.481,2.047,7.645.021,15.257.44,22.882.159,6.875-.258,13.59-.762,20.454-.408a7.506,7.506,0,0,0,1.535,1.469c-1.165.295-2.329.578-3.5.879a42.075,42.075,0,0,1-5.574,1.042h68.657c4.189-.914,6.865-1.632,6.267-1.657-11.005-.385-36.288-3.238-37.549-4.915.718-.16,1.437-.336,2.177-.464,10.324-1.905,20.861-1.089,31.176-2.827,7.584-1.283,14.782-3.273,22.255-4.092a45.19,45.19,0,0,0,9.087-.291c9.771.426,19.249,2.263,29.052,1.091a.306.306,0,0,0,.232-.4c-.059-.207-.116-.414-.16-.631a.286.286,0,0,0-.25-.2l-.625-.009c-.175,0-.2.277-.015.326-1.789-.5-4.747-.062-6.678-.252-2.527-.248-5.046-.5-7.563-.694-2.156-.164-4.279-.338-6.408-.5,3.159-.65,6.338-1.368,9.526-1.995,5.962-1.152,12.141-.549,18.169-1.008,7.328-.574,14.972.091,22.3.509,4.33.242,8.632.75,12.923,1.29Z",
    transform: "translate(-140.84 -121.802)",
    fill: "#c79584"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14450",
    "data-name": "Group 14450",
    transform: "translate(3.866 196.852)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14449",
    "data-name": "Group 14449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14448",
    "data-name": "Group 14448",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14447",
    "data-name": "Group 14447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14446",
    "data-name": "Group 14446",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30980",
    "data-name": "Path 30980",
    d: "M449.016,135.825,3.294,129.251,1.813,164.474l445.722,6.574Z",
    transform: "translate(-3.018 -136.396)",
    fill: "url(#radial-gradient-5)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14455",
    "data-name": "Group 14455",
    transform: "translate(3.866 149.433)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14454",
    "data-name": "Group 14454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14453",
    "data-name": "Group 14453",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14452",
    "data-name": "Group 14452",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14451",
    "data-name": "Group 14451",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30982",
    "data-name": "Path 30982",
    d: "M548.237,105.336,4.8,93.364l-5.188,82.47,543.441,11.972Z",
    transform: "translate(-4.049 -105.763)",
    fill: "url(#radial-gradient-6)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14460",
    "data-name": "Group 14460",
    transform: "translate(3.866 179.996)",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14459",
    "data-name": "Group 14459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14458",
    "data-name": "Group 14458",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14457",
    "data-name": "Group 14457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14456",
    "data-name": "Group 14456",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10993",
    "data-name": "Rectangle 10993",
    width: 240.136,
    height: 39.755,
    transform: "translate(0 -0.338)",
    fill: "url(#radial-gradient-7)"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30985",
    "data-name": "Path 30985",
    d: "M191.591,124.684a2.6,2.6,0,0,0-3.778-1.251c-1.833,1.008-2.67,2.818-3.192,4.758a.164.164,0,0,0,.264.169,5.573,5.573,0,0,0,5.671.84c.794-.343,1.575-.55,1.735-1.491a6.559,6.559,0,0,0-.7-3.025",
    transform: "translate(86.352 57.564)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14463",
    "data-name": "Group 14463",
    transform: "translate(270.967 182.537)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14462",
    "data-name": "Group 14462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14461",
    "data-name": "Group 14461",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30986",
    "data-name": "Path 30986",
    d: "M191.252,125.561c-.812-.355-1.629.495-2.439.123a3.071,3.071,0,0,1-1.124-.857c-.374-.433-.443-.625-.96-.289a2.749,2.749,0,0,0-1.625,2.077.19.19,0,0,1-.244.164c-.085.267-.164.53-.239.806a.164.164,0,0,0,.264.169,5.573,5.573,0,0,0,5.671.84c.794-.343,1.576-.55,1.735-1.49,0-.024.01-.063.01-.1a1.785,1.785,0,0,0-1.049-1.441",
    transform: "translate(-184.615 -124.366)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14466",
    "data-name": "Group 14466",
    transform: "translate(269.771 182.592)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14465",
    "data-name": "Group 14465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14464",
    "data-name": "Group 14464",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30987",
    "data-name": "Path 30987",
    d: "M192.706,126a4.382,4.382,0,0,0-.175-.552,4.048,4.048,0,0,0-.446-.945.1.1,0,0,0-.015-.037c0-.006-.007-.006-.007-.012s-.012-.023-.022-.034a.04.04,0,0,0-.069.034,6.848,6.848,0,0,1,.283.865c.069.267.181.791-.273.835-.17.021-.332.021-.5.054a4.084,4.084,0,0,0-2.045,1.1,2.459,2.459,0,0,1-1.308.794,3.312,3.312,0,0,1-1.32-.4,2.952,2.952,0,0,0-1.365-.311,1.025,1.025,0,0,1-.16-.524c.075-.233.129-.468.189-.649.021-.066-.025-.094-.069-.088.05-.157.1-.308.15-.437a.078.078,0,0,0-.141-.059c-.028.069-.069.15-.1.229-.009.01-.009.016-.025.026-.25.559-.5,1.123-.744,1.694-.339.04-.828.21-.734.521.164.5.935.363,1.334.342a2.835,2.835,0,0,1,1.394.6,3.25,3.25,0,0,0,1.318.421,4.6,4.6,0,0,0,1.485-.264,3.658,3.658,0,0,0,1.259-.4.157.157,0,0,0,.079-.116,7.3,7.3,0,0,1,2-.74.192.192,0,0,0,.179-.244c-.088-.571-.038-1.14-.154-1.71",
    transform: "translate(-183.8 -124.403)",
    fill: "#6b372f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14469",
    "data-name": "Group 14469",
    transform: "translate(48.335 124.448)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14468",
    "data-name": "Group 14468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14467",
    "data-name": "Group 14467",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30988",
    "data-name": "Path 30988",
    d: "M446.1,101.878c-6.2-.374-40.019-12.85-46.222-13.061-32.367-1.1-64.883-3.436-97.263-2.5-11.331.31-22.671.5-34,.07-24.07-.9-48.24-2.654-72.3-.725-24.407,1.954-47.49,8.548-70.97,13.8-18.637,4.161-20.089,6.875-39.243,8.85-4.4.449-62.242,1.035-51.946,10.687,6.672,6.25,22.574,5.746,31.925,7.051,14.344,2.018,28.518,4.849,43.012,6.144,18.6,1.667,37.276-.81,55.874,1.083,22.637,2.3,44.638,7.12,67.573,7.747,24.913.684,49.759-1.526,74.63-2.469,26.135-.988,53.941,4.387,79.045-3.683,14.01-4.5,29.911-5.08,44.364-7,19.883-2.654,39.779-5.572,59.366-10.145,3.847-.9,22.837,1.229,24.8-2.985,2.79-5.965-16.439-5.928-19.995-7.142-9.487-3.225-33.437-4.785-48.66-5.714",
    transform: "translate(-32.932 -84.789)",
    fill: "#c79584"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30989",
    "data-name": "Path 30989",
    d: "M431.258,101.925c-5.83-.335-37.634-11.28-43.469-11.465-30.439-.966-61.012-3.018-91.462-2.2-10.653.274-21.316.439-31.967.065-22.638-.79-45.369-2.328-68-.636-22.953,1.717-44.656,7.5-66.738,12.107-17.522,3.655-18.891,6.035-36.9,7.77-4.141.4-58.538.906-48.86,9.377,6.272,5.491,21.235,5.046,30.023,6.189,13.491,1.761,26.824,4.252,40.451,5.392,17.487,1.468,35.053-.713,52.542.948,21.285,2.021,41.979,6.253,63.546,6.8,23.428.6,46.8-1.339,70.18-2.169,24.585-.857,50.732,3.847,74.341-3.232,13.176-3.953,28.132-4.46,41.713-6.15,18.7-2.322,37.413-4.883,55.828-8.9,3.621-.791,21.48,1.076,23.339-2.626,2.62-5.233-15.469-5.2-18.812-6.266-8.922-2.831-31.43-4.2-45.763-5.011",
    transform: "translate(19.981 40.659)",
    fill: "#adaeab"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30990",
    "data-name": "Path 30990",
    d: "M477.021,106.937c-8.922-2.831-31.43-4.2-45.763-5.011-5.83-.335-37.634-11.28-43.469-11.466-30.439-.964-61.012-3.016-91.462-2.2-10.653.274-21.316.439-31.967.065-22.638-.79-45.369-2.328-68-.636-22.953,1.716-44.656,7.5-66.738,12.107-17.522,3.655-18.891,6.035-36.9,7.769-4.141.4-58.538.907-48.86,9.379,6.272,5.489,21.234,5.046,30.023,6.189,13.491,1.761,26.824,4.251,40.451,5.392,17.487,1.468,35.053-.715,52.542.947,21.285,2.023,41.979,6.254,63.546,6.8,23.427.6,46.8-1.339,70.18-2.171,24.585-.857,50.732,3.848,74.341-3.232,13.176-3.951,28.132-4.46,41.713-6.148,18.7-2.322,37.413-4.883,55.828-8.9,3.621-.791,21.48,1.077,23.339-2.626,2.62-5.231-15.469-5.2-18.812-6.264M442.083,111.2c-26.912,4.6-54.532,3.088-81.4,7.739,6.979-.343,14.183-.3,20.054,3.129a.754.754,0,0,1-.183,1.362c-16.913,6.156-35.458,3.992-53.069,3.754-7.487-.1-14.965.49-22.452.2-6.352-.241-13.2-.735-18.809-4.033a.745.745,0,0,1,.186-1.358c.559-.189,1.133-.368,1.7-.549a.741.741,0,0,1,.346-.495c3.342-1.842,7.052-2.72,10.579-4.117-6.91-2.181-14.566-.6-21.626.022-7.954.7-16.035.464-24.023.68-13.06.357-26.127.9-39.17,1.714,8.533.671,17.046,1.686,25.606,1.876,10.625.226,21.576.021,31.765,3.461a.747.747,0,0,1,0,1.433c-10.157,2.822-20.68,2.993-31.138,3.465-9.482.439-19.628,3.329-28.913.239a.744.744,0,0,1,0-1.433,35.548,35.548,0,0,1,3.47-.882c-12.355-.8-24.651-2.2-37.009-2.847-13.267-.69-26.714,1.11-39.845-1.506-.771-.153-.666-1.223,0-1.43a89.474,89.474,0,0,1,15.238-3.213c-6.937.363-13.864.658-20.805.81-9.448.205-18.859-.239-28.307-.276-4.726-.015-9.414.324-14.127.423-3.669.088-7.283.591-10.933-.022a.741.741,0,0,1,0-1.428c30.636-6.14,62.149-3.875,92.949-8.464-3.571-.065-7.152-.037-10.723.048-5.419.114-10.926-.085-16.31.433-6.735.649-15.241,2.191-21.036-2.271a.74.74,0,0,1,.161-1.167c6.753-4.124,15.367-2.978,22.785-4.891A230.874,230.874,0,0,1,174.873,96c8.306-2.4,17.04-1.666,25.666-2.665,10.891-1.255,21.7-3.258,32.682-3.608.9-.028.945,1.186.192,1.456-3.527,1.27-7.616,1.321-10.957,3.081,21.794,5.9,45.468,1.632,67.719,1.788,12.485.087,25.082.627,37.54-.191,11.062-.738,22.282-1.468,33.194.931.79.173.638,1.2,0,1.437-3.44,1.293-7.091,1.735-10.631,2.57,15.784,1.038,31.793-1.032,47.318,2.662a.75.75,0,0,1,.182,1.368c-4.769,2.817-10.279,3.759-15.853,4.325,20.08-.233,40.159-2.3,60.155.609a.749.749,0,0,1,0,1.438",
    transform: "translate(19.981 40.659)",
    fill: "#9d9e9c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30991",
    "data-name": "Path 30991",
    d: "M52.785,114.29c-.606-.247-.82-1.286,0-1.437,22.135-4.067,44.69-.528,66.932-3.059-1.895-.611-3.788-1.224-5.66-1.929a.744.744,0,0,1,.192-1.456c7.688-.119,15.127-1.842,22.543-3.691-.021-.145-.04-.3-.059-.514a.745.745,0,0,1,.558-.719A334.948,334.948,0,0,1,200.738,90.9c.291-.029.59-.046.888-.065C212.989,90,224.4,89.619,235.815,89.6a.686.686,0,0,1,.478.182c15.951-.007,31.882.958,47.87.732,11.566-.17,23.142-.523,34.708-.407,10.744.114,21.457.74,32.2.844,10.488.112,21.064.128,31.465,1.632,10.261,1.472,20.446,4.518,30.4,7.418a.738.738,0,0,1,.525.525c.317,1.669,1.755,2.627,3.644,3.2,1.923,0,3.731.081,5.146.12,8.962.22,17.917,1.4,26.9,1.788,15.772.671,31.267,4.565,46.919,6.36-.54-4.035-15.975-4.092-19.044-5.068-8.922-2.83-31.43-4.2-45.763-5.011-5.827-.333-37.633-11.278-43.469-11.465-30.437-.966-61.011-3.018-91.461-2.2-10.653.273-21.316.437-31.969.065-22.637-.791-45.369-2.328-67.995-.637-22.953,1.717-44.656,7.5-66.737,12.107-17.523,3.655-18.894,6.035-36.9,7.77-4.139.4-58.536.906-48.858,9.379a12.423,12.423,0,0,0,1.047.79c4.086-.744,8.315-.961,12.419-1.54q-2.265-.991-4.55-1.905",
    transform: "translate(19.981 40.659)",
    fill: "#8b8185"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30992",
    "data-name": "Path 30992",
    d: "M251.865,118.88a4.662,4.662,0,0,0-6.784-2.234c-3.283,1.808-4.775,5.062-5.721,8.528a.3.3,0,0,0,.48.311,9.975,9.975,0,0,0,10.17,1.5c1.422-.616,2.825-.98,3.107-2.66.3-1.748-.668-3.834-1.252-5.448",
    transform: "translate(111.953 54.252)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14472",
    "data-name": "Group 14472",
    transform: "translate(351.299 173.657)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14471",
    "data-name": "Group 14471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14470",
    "data-name": "Group 14470",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30993",
    "data-name": "Path 30993",
    d: "M251.256,120.456c-1.46-.631-2.916.889-4.383.229a5.6,5.6,0,0,1-2.009-1.544c-.677-.766-.794-1.123-1.722-.527-1.631,1.047-2.579,1.738-2.906,3.73a.35.35,0,0,1-.439.305c-.157.471-.3.953-.437,1.435a.3.3,0,0,0,.48.311,9.975,9.975,0,0,0,10.17,1.5c1.422-.618,2.825-.982,3.107-2.66a1.1,1.1,0,0,0,.022-.182,3.215,3.215,0,0,0-1.883-2.6",
    transform: "translate(-239.347 -118.316)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14475",
    "data-name": "Group 14475",
    transform: "translate(349.156 173.761)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14474",
    "data-name": "Group 14474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14473",
    "data-name": "Group 14473",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30994",
    "data-name": "Path 30994",
    d: "M253.861,121.242a6.738,6.738,0,0,0-.31-.994,6.623,6.623,0,0,0-.794-1.678.193.193,0,0,0-.034-.078c0-.012-.006-.012-.012-.018a.222.222,0,0,1-.037-.057c-.046-.065-.163-.022-.128.053a13.49,13.49,0,0,1,.514,1.537c.125.493.329,1.428-.49,1.513-.305.043-.59.043-.9.1A7.28,7.28,0,0,0,248,123.586a4.346,4.346,0,0,1-2.338,1.421,5.9,5.9,0,0,1-2.373-.716,5.5,5.5,0,0,0-2.445-.552,1.687,1.687,0,0,1-.28-.941c.128-.423.235-.831.34-1.164.034-.106-.047-.16-.129-.16.082-.272.175-.536.269-.781.05-.139-.186-.241-.252-.1-.065.126-.116.267-.185.418-.013.015-.025.019-.029.043-.458,1-.911,2.009-1.347,3.022-.608.081-1.488.392-1.319.929.3.9,1.682.666,2.4.624a5.107,5.107,0,0,1,2.494,1.091,5.788,5.788,0,0,0,2.379.753,8.5,8.5,0,0,0,2.655-.473,6.285,6.285,0,0,0,2.254-.719.3.3,0,0,0,.153-.21,12.606,12.606,0,0,1,3.567-1.321.36.36,0,0,0,.339-.442c-.178-1.016-.082-2.046-.289-3.068",
    transform: "translate(-237.887 -118.386)",
    fill: "#6b372f"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30995",
    "data-name": "Path 30995",
    d: "M271.641,119.088a2.913,2.913,0,0,0-4.251-1.4c-2.065,1.133-3,3.175-3.594,5.354a.188.188,0,0,0,.3.188,6.281,6.281,0,0,0,6.383.947c.888-.387,1.766-.619,1.948-1.673a7.36,7.36,0,0,0-.79-3.412",
    transform: "translate(123.385 54.851)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14478",
    "data-name": "Group 14478",
    transform: "translate(387.174 174.266)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14477",
    "data-name": "Group 14477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14476",
    "data-name": "Group 14476",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30996",
    "data-name": "Path 30996",
    d: "M271.269,120.077c-.926-.4-1.838.553-2.755.137a3.445,3.445,0,0,1-1.258-.969c-.426-.474-.5-.7-1.088-.329a3.1,3.1,0,0,0-1.817,2.345.224.224,0,0,1-.286.186c-.094.292-.182.6-.269.907a.188.188,0,0,0,.3.188,6.277,6.277,0,0,0,6.383.945c.888-.386,1.766-.619,1.948-1.672.006-.04.009-.076.018-.116a2.011,2.011,0,0,0-1.18-1.623",
    transform: "translate(-263.789 -118.731)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14481",
    "data-name": "Group 14481",
    transform: "translate(385.835 174.327)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14480",
    "data-name": "Group 14480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14479",
    "data-name": "Group 14479",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30997",
    "data-name": "Path 30997",
    d: "M272.9,120.571a4.207,4.207,0,0,0-.2-.627,4.415,4.415,0,0,0-.492-1.057.1.1,0,0,1-.024-.05l-.01-.009c-.013-.012-.013-.025-.025-.037-.022-.04-.1-.018-.081.037a6.677,6.677,0,0,1,.326.966c.076.31.2.891-.3.951a5.444,5.444,0,0,0-.566.059,4.578,4.578,0,0,0-2.3,1.227,2.717,2.717,0,0,1-1.468.894,3.754,3.754,0,0,1-1.491-.445,3.381,3.381,0,0,0-1.531-.351,1,1,0,0,1-.181-.589c.079-.258.144-.52.214-.731a.072.072,0,0,0-.081-.094c.053-.176.112-.343.169-.5.029-.081-.116-.151-.159-.059-.04.076-.076.166-.122.258,0,0-.013.012-.013.026-.291.634-.572,1.258-.841,1.9-.386.044-.935.245-.828.583.186.561,1.051.417,1.507.392a3.168,3.168,0,0,1,1.562.68,3.484,3.484,0,0,0,1.488.471,4.932,4.932,0,0,0,1.663-.3,3.971,3.971,0,0,0,1.425-.451.219.219,0,0,0,.092-.128,8.009,8.009,0,0,1,2.235-.835.216.216,0,0,0,.21-.269c-.106-.646-.046-1.287-.175-1.924",
    transform: "translate(-262.877 -118.772)",
    fill: "#6b372f"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30998",
    "data-name": "Path 30998",
    d: "M301.119,88.549a2.92,2.92,0,0,0-4.255-1.4c-2.072,1.133-3,3.175-3.6,5.357a.187.187,0,0,0,.3.191,6.289,6.289,0,0,0,6.385.941c.9-.392,1.777-.619,1.954-1.666a7.449,7.449,0,0,0-.784-3.418",
    transform: "translate(137.17 40.567)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14484",
    "data-name": "Group 14484",
    transform: "translate(430.431 129.44)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14483",
    "data-name": "Group 14483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14482",
    "data-name": "Group 14482",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30999",
    "data-name": "Path 30999",
    d: "M300.735,89.533c-.914-.4-1.832.558-2.749.142a3.462,3.462,0,0,1-1.262-.97c-.427-.481-.49-.7-1.079-.327-1.029.662-1.612,1.086-1.823,2.344a.213.213,0,0,1-.279.182c-.1.3-.186.6-.276.914a.187.187,0,0,0,.3.191,6.285,6.285,0,0,0,6.385.939c.9-.39,1.777-.619,1.954-1.666a.408.408,0,0,0,.012-.116,2,2,0,0,0-1.18-1.634",
    transform: "translate(-293.261 -88.19)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14487",
    "data-name": "Group 14487",
    transform: "translate(429.091 129.506)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14486",
    "data-name": "Group 14486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14485",
    "data-name": "Group 14485",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31000",
    "data-name": "Path 31000",
    d: "M302.373,90.022a3.5,3.5,0,0,0-.2-.618,4.469,4.469,0,0,0-.5-1.058c0-.018-.013-.029-.018-.047s-.006-.006-.021-.006a.064.064,0,0,0-.022-.041c-.018-.035-.092-.012-.069.035.116.32.23.638.316.97.081.307.21.889-.3.941-.2.025-.376.031-.561.065a4.575,4.575,0,0,0-2.3,1.233,2.737,2.737,0,0,1-1.475.889,3.735,3.735,0,0,1-1.485-.443A3.394,3.394,0,0,0,294.2,91.6a1.076,1.076,0,0,1-.179-.594c.079-.266.144-.517.213-.734a.072.072,0,0,0-.082-.094,5.073,5.073,0,0,1,.166-.49c.034-.088-.117-.151-.153-.063s-.076.163-.116.255c-.013.006-.018.019-.025.031-.279.625-.572,1.262-.842,1.9-.38.05-.936.239-.823.583.181.562,1.051.41,1.5.393a3.106,3.106,0,0,1,1.562.677,3.566,3.566,0,0,0,1.5.468,5.175,5.175,0,0,0,1.666-.291,4.077,4.077,0,0,0,1.416-.448.189.189,0,0,0,.091-.132,7.945,7.945,0,0,1,2.246-.837.214.214,0,0,0,.2-.276c-.112-.636-.04-1.28-.173-1.924",
    transform: "translate(-292.348 -88.235)",
    fill: "#6b372f"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31001",
    "data-name": "Path 31001",
    d: "M163.866,83.312a2.007,2.007,0,0,0-2.906-.964,5.489,5.489,0,0,0-2.458,3.666.127.127,0,0,0,.206.129,4.289,4.289,0,0,0,4.365.636c.606-.255,1.2-.42,1.33-1.133a5.078,5.078,0,0,0-.536-2.334",
    transform: "translate(74.134 38.387)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14490",
    "data-name": "Group 14490",
    transform: "translate(232.63 121.922)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14489",
    "data-name": "Group 14489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14488",
    "data-name": "Group 14488",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31002",
    "data-name": "Path 31002",
    d: "M163.6,83.987c-.619-.274-1.246.38-1.87.1a2.324,2.324,0,0,1-.865-.662c-.294-.332-.342-.484-.738-.226-.7.451-1.108.743-1.25,1.6a.152.152,0,0,1-.188.128c-.07.2-.129.4-.185.619a.128.128,0,0,0,.207.129,4.286,4.286,0,0,0,4.365.637c.606-.257,1.2-.42,1.33-1.133a.223.223,0,0,1,.009-.078,1.382,1.382,0,0,0-.815-1.114",
    transform: "translate(-158.495 -83.068)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14493",
    "data-name": "Group 14493",
    transform: "translate(231.717 121.964)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14492",
    "data-name": "Group 14492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14491",
    "data-name": "Group 14491",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31003",
    "data-name": "Path 31003",
    d: "M164.72,84.323a3.569,3.569,0,0,0-.142-.429,3.147,3.147,0,0,0-.333-.718c-.006-.018-.006-.023-.019-.035v-.006c-.012,0-.012-.016-.016-.029s-.07-.006-.053.029a5.058,5.058,0,0,1,.217.662c.053.2.132.608-.211.643-.135.018-.251.022-.38.046a3.116,3.116,0,0,0-1.578.841,1.885,1.885,0,0,1-1.005.611,2.762,2.762,0,0,1-1.019-.3,2.272,2.272,0,0,0-1.048-.241.758.758,0,0,1-.12-.405c.057-.173.1-.354.153-.5.012-.038-.025-.065-.059-.065a2.411,2.411,0,0,1,.116-.33c.018-.068-.082-.109-.112-.048s-.05.119-.075.181a.082.082,0,0,0-.019.016c-.192.432-.389.862-.578,1.3-.257.034-.637.161-.553.4.122.385.712.28,1.022.261a2.315,2.315,0,0,1,1.071.468,2.376,2.376,0,0,0,1.017.32,3.406,3.406,0,0,0,1.139-.2,2.749,2.749,0,0,0,.97-.308.113.113,0,0,0,.059-.09,5.44,5.44,0,0,1,1.529-.568.154.154,0,0,0,.15-.188c-.078-.437-.037-.875-.122-1.314",
    transform: "translate(-157.873 -83.097)",
    fill: "#6b372f"
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31004",
    "data-name": "Path 31004",
    d: "M89.887,95.207a3.377,3.377,0,0,0-4.918-1.625c-2.4,1.315-3.479,3.68-4.167,6.209a.216.216,0,0,0,.348.216,7.271,7.271,0,0,0,7.393,1.093c1.035-.452,2.05-.715,2.254-1.937.223-1.268-.479-2.78-.91-3.956",
    transform: "translate(37.79 43.549)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14496",
    "data-name": "Group 14496",
    transform: "translate(118.583 139.136)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14495",
    "data-name": "Group 14495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14494",
    "data-name": "Group 14494",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31005",
    "data-name": "Path 31005",
    d: "M89.447,96.356c-1.057-.468-2.115.641-3.184.161a4.044,4.044,0,0,1-1.457-1.123c-.5-.553-.58-.818-1.252-.38-1.183.76-1.876,1.258-2.111,2.717a.262.262,0,0,1-.327.214c-.106.343-.222.69-.314,1.054a.215.215,0,0,0,.348.214,7.27,7.27,0,0,0,7.394,1.093c1.033-.451,2.049-.713,2.253-1.936a.623.623,0,0,0,.018-.128,2.3,2.3,0,0,0-1.368-1.888",
    transform: "translate(-80.793 -94.796)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14499",
    "data-name": "Group 14499",
    transform: "translate(117.03 139.21)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14498",
    "data-name": "Group 14498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14497",
    "data-name": "Group 14497",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31006",
    "data-name": "Path 31006",
    d: "M91.339,96.922a3.929,3.929,0,0,0-.22-.718,5.6,5.6,0,0,0-.574-1.23c-.012-.016-.023-.035-.029-.046l-.01-.01a.112.112,0,0,0-.029-.047c-.023-.048-.112-.021-.092.034a9.411,9.411,0,0,1,.374,1.129c.091.352.233,1.029-.354,1.095-.226.026-.432.026-.655.068a5.36,5.36,0,0,0-2.664,1.427,3.16,3.16,0,0,1-1.708,1.035,4.3,4.3,0,0,1-1.717-.514,3.852,3.852,0,0,0-1.777-.41,1.33,1.33,0,0,1-.213-.678c.1-.311.17-.609.254-.85.029-.072-.041-.116-.1-.116.065-.2.125-.39.194-.565a.1.1,0,0,0-.182-.078c-.041.092-.085.194-.135.305-.01.006-.01.019-.022.028-.327.729-.659,1.462-.978,2.2-.437.06-1.082.28-.954.674.211.656,1.22.484,1.747.462a3.632,3.632,0,0,1,1.81.784,4.1,4.1,0,0,0,1.719.542,5.893,5.893,0,0,0,1.93-.336,4.721,4.721,0,0,0,1.65-.522.251.251,0,0,0,.1-.15,9.3,9.3,0,0,1,2.6-.967.257.257,0,0,0,.247-.316c-.128-.747-.059-1.49-.213-2.232",
    transform: "translate(-79.735 -94.846)",
    fill: "#6b372f"
  }))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31007",
    "data-name": "Path 31007",
    d: "M51.064,108.988a2.464,2.464,0,0,0-3.58-1.183,6.79,6.79,0,0,0-3.028,4.51.159.159,0,0,0,.258.16,5.289,5.289,0,0,0,5.372.8c.75-.335,1.484-.523,1.637-1.412a6.145,6.145,0,0,0-.659-2.875",
    transform: "translate(20.791 50.263)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14502",
    "data-name": "Group 14502",
    transform: "translate(65.24 159.527)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14501",
    "data-name": "Group 14501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14500",
    "data-name": "Group 14500",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31008",
    "data-name": "Path 31008",
    d: "M50.737,109.822c-.766-.339-1.534.468-2.3.117a2.854,2.854,0,0,1-1.066-.812c-.361-.4-.421-.6-.913-.282-.859.556-1.362.919-1.532,1.979a.178.178,0,0,1-.233.148c-.082.254-.161.511-.233.769a.159.159,0,0,0,.258.159,5.286,5.286,0,0,0,5.372.8c.749-.335,1.482-.523,1.637-1.412.007-.028.007-.062.013-.1a1.691,1.691,0,0,0-1-1.371",
    transform: "translate(-44.45 -108.689)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14505",
    "data-name": "Group 14505",
    transform: "translate(64.113 159.58)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14504",
    "data-name": "Group 14504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14503",
    "data-name": "Group 14503",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31009",
    "data-name": "Path 31009",
    d: "M52.119,110.232a4.184,4.184,0,0,0-.163-.515,3.71,3.71,0,0,0-.421-.891.116.116,0,0,0-.019-.043l-.01-.006c0-.013-.012-.026-.012-.037-.022-.034-.09-.009-.07.031a6.47,6.47,0,0,1,.269.816c.072.258.176.75-.255.8-.166.018-.317.023-.48.053a3.921,3.921,0,0,0-1.936,1.035,2.287,2.287,0,0,1-1.234.75,3.111,3.111,0,0,1-1.252-.376,2.9,2.9,0,0,0-1.29-.3.9.9,0,0,1-.153-.495c.07-.222.122-.437.183-.614a.062.062,0,0,0-.072-.082c.044-.147.1-.285.139-.414.025-.07-.1-.129-.129-.053a1.8,1.8,0,0,0-.1.22c-.006.006-.012.006-.019.019-.239.533-.48,1.063-.709,1.6-.319.041-.788.2-.694.489.151.477.888.348,1.262.332a2.616,2.616,0,0,1,1.321.575,3.014,3.014,0,0,0,1.253.392,4.086,4.086,0,0,0,1.4-.244,3.372,3.372,0,0,0,1.195-.382.182.182,0,0,0,.078-.11,6.744,6.744,0,0,1,1.883-.7.182.182,0,0,0,.176-.229c-.088-.543-.035-1.086-.147-1.625",
    transform: "translate(-43.681 -108.725)",
    fill: "#6b372f"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31010",
    "data-name": "Path 31010",
    d: "M114.327,120.436a2,2,0,0,0-2.906-.958,5.465,5.465,0,0,0-2.454,3.659.124.124,0,0,0,.205.122,4.258,4.258,0,0,0,4.361.649c.606-.263,1.2-.42,1.333-1.143a4.959,4.959,0,0,0-.539-2.328",
    transform: "translate(50.965 55.753)",
    fill: "#a06b46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14508",
    "data-name": "Group 14508",
    transform: "translate(159.927 176.413)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14507",
    "data-name": "Group 14507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14506",
    "data-name": "Group 14506",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31011",
    "data-name": "Path 31011",
    d: "M114.064,121.11c-.625-.274-1.245.387-1.876.091a2.42,2.42,0,0,1-.866-.659c-.288-.327-.341-.473-.737-.22a2.128,2.128,0,0,0-1.246,1.6.149.149,0,0,1-.192.129c-.059.2-.129.408-.181.622a.124.124,0,0,0,.205.123,4.259,4.259,0,0,0,4.361.649c.608-.264,1.2-.42,1.333-1.143a.785.785,0,0,1,.013-.078,1.385,1.385,0,0,0-.815-1.11",
    transform: "translate(-108.961 -120.194)",
    fill: "#94582f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14511",
    "data-name": "Group 14511",
    transform: "translate(159.006 176.456)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14510",
    "data-name": "Group 14510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14509",
    "data-name": "Group 14509",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31012",
    "data-name": "Path 31012",
    d: "M115.183,121.444a3.822,3.822,0,0,0-.129-.424,3.181,3.181,0,0,0-.339-.721l-.016-.034h-.007l-.012-.029c-.022-.029-.07-.007-.059.023a6.756,6.756,0,0,1,.225.655c.051.214.132.615-.213.647-.134.021-.257.021-.385.041a3.191,3.191,0,0,0-1.579.848,1.836,1.836,0,0,1-1.005.6,2.6,2.6,0,0,1-1.013-.3,2.286,2.286,0,0,0-1.047-.242.825.825,0,0,1-.126-.4c.056-.185.1-.36.151-.5.012-.054-.025-.076-.059-.07.034-.117.078-.235.116-.332.023-.065-.082-.107-.106-.047s-.056.109-.079.176c-.007.01-.015.01-.015.022q-.3.638-.571,1.3c-.263.031-.646.169-.572.4.128.386.722.286,1.035.269.382-.025.749.282,1.064.467a2.38,2.38,0,0,0,1.017.318,3.378,3.378,0,0,0,1.139-.2,2.817,2.817,0,0,0,.97-.3.158.158,0,0,0,.063-.094,5.529,5.529,0,0,1,1.535-.574.144.144,0,0,0,.139-.182c-.079-.436-.029-.875-.123-1.317",
    transform: "translate(-108.334 -120.223)",
    fill: "#6b372f"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31013",
    "data-name": "Path 31013",
    d: "M70.118,37.6c-.95-4.3,1.4-9.465-.929-13.5-1.039-1.8-2.419-3.342-3.537-5.09-2.009-3.145-1.942-5.511-1.9-9.082.028-1.943-.8-6.091-3.018-6.79-.4-.125-.888.229-1.154.484C58.155,5,58.148,7.339,57.822,9.194q1.149,1.959-1.19-1.427a22.716,22.716,0,0,1-.543-3.486c-.181-1.413-.057-2.877-.822-4.1-.189-.3-.671-.15-.913-.038-2.808,1.27-3,6.292-3.989,8.657a3.61,3.61,0,0,0-.327,1.565c.075,1.135-.493,5.953-.439,1.936.034-2.316.354-5.03-.327-7.258-.17-.561-.907-.131-1.16.1-1.434,1.312-1.71,3.355-2.165,5.169s-1.03,3.619-1.449,5.434c-.125.545-.236,1.807-.458,2.843-.461-1.974-.536-4.218-.813-6.123-.273-1.861-.054-4.628-1.92-5.674-.412-.23-1.017.269-1.07.677-.624,4.8-.727,9.645-1.383,14.46-.333,2.458.5,5.284.512,7.734.023,3.3-.182,6.621-.329,9.919-.009.222.345.046.36-.109.392-3.568,2.153,7.174,2.3,3.617,1.149.4-.1-11.089.233-9.976a26.527,26.527,0,0,0,3.354,6.684c2.181,3.421,5.344,3.313,9.1,3.223,3.658-.084,7.306-.518,10.968-.343,1.582.073,2.664.484,4.047-.255,1.686-.9,1.039-3.383.721-4.819",
    transform: "translate(18.137 0)",
    fill: "#200"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31014",
    "data-name": "Path 31014",
    d: "M125.461,117c-.073-.031-.073-.065-.1-.107-.046-.018-.048-.066-.072-.106a.708.708,0,0,0-.27-.239,3.288,3.288,0,0,0-1.089-.668c-6.885-2.463-13.5-6.555-19.839-10.085-6.483-3.537-11.648-8.093-16.93-12.756-.062-2.889-.116-5.8-.443-8.668-.829-7.215-2.627-14.212-2.693-21.505-.038-11.423,3.486-24.275,1.243-35.741a94.353,94.353,0,0,0,1.155-16.374c-.126-.179-.264-.349-.4-.517a15.521,15.521,0,0,1-1.076,4.832c-.183.417-.872.567-1.067.056A19.966,19.966,0,0,1,82.834,7.7c-1.516.307-3.046.559-4.584.746-.644,5.872-1.063,11.771-2.227,17.578a.585.585,0,0,1-1.1.207c-1.2-2.551-1.2-5.466-1.148-8.244-.019-.709.007-1.441.047-2.181.04-1.653.063-3.307.084-4.964a8.635,8.635,0,0,0-.442-2.036c-.685.028-1.369.041-2.053.046a32.276,32.276,0,0,0-1.206,4.8.584.584,0,0,1-1.1.208,8.643,8.643,0,0,1-.866-5.074c-1.261-.056-2.517-.144-3.762-.286-.173,4.074-.154,8.149-1.142,12.138-.134.542-.838.432-1.07.056-.948-1.55-.681-3.415-.618-5.152a40.657,40.657,0,0,0,.068-6.122A44.076,44.076,0,0,0,60.1,14.431a132.713,132.713,0,0,0-2.169,13.584c-.075.631-1.049.737-1.148.065-.543-3.665.047-7.638-1.022-11.206-.873,3.978-1.287,8.039-2.184,12.016-.019.091-.043.192-.063.292.016,5.375-.244,10.606-2.024,16.017-2.191,6.611-2.02,12.921-1.557,19.773.568,8.024.057,16.114.439,24.138-1.5,3.42-3.784,6.518-6.049,10.023-3.766,5.943-6.529,9.728-13.575,12.985a120.263,120.263,0,0,1-17.435,6.21,1.563,1.563,0,0,0-.663-.013,7.18,7.18,0,0,0-2.1.638c-1.708.732-1.054,2.862.5,3.316,6.4,1.82,15.567.738,23.048-.969a2.061,2.061,0,0,0,1.465,3.025c5.457,1.494,12.474.418,18.1.486a48.754,48.754,0,0,0,15.582-2.8c0,.107-.06.172-.057.263a1.54,1.54,0,0,0,.062,1.121,5.373,5.373,0,0,0-.023.6,1.371,1.371,0,0,0,2.354.722c2.955.235,6.125-1.353,8.685-2.485,1.576-.738,3.2-1.415,4.842-2.089,6.779,2.7,15.593,3.242,22.164,3.047,1.572-.087,3.279-1.55,2.567-3.041a9.567,9.567,0,0,0-1.289-2.046c4.546,1.107,9.191,1.88,13.9,2.538,2.846.407,4.12-2.018,3-3.65",
    transform: "translate(4.465 3.603)",
    fill: "#552517"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31015",
    "data-name": "Path 31015",
    d: "M101.341,116.869c-4.133-2.185-8.685-3.785-13.041-5.6a47.682,47.682,0,0,1-12.364-7.317c-1.6-1.33-3.285-2.558-5-3.749-1.642-1.164-3.574-1.728-5.19-2.906-3.847-2.9-5.715-5.974-5.243-10.484a.224.224,0,0,0-.217-.238c-.037-1.664.032-3.346.026-4.965.085-4.308-.3-8.642-.543-12.985-.3-4.494-.524-9.028-.407-13.518.057-4.918.9-9.755,1.271-14.716.289-4.336-.084-8.72-.1-13.1a101.4,101.4,0,0,1,.967-12.367,20.3,20.3,0,0,1-.98-7.211c-.1.022-.205.047-.31.069-.094.857-.188,1.711-.3,2.569-.531,4.594-1.041,9.123-1.428,13.685-.314,4.7.142,9.433.11,14.14-.045,4.541-.944,9.079-1.223,13.613a125.466,125.466,0,0,0,.2,14.556c.26,4.132.76,8.3.8,12.454.085,3.768-.232,7.516.577,11.216a21.749,21.749,0,0,0,1.088,3.072.616.616,0,0,0,.141.205,8.269,8.269,0,0,0,1.049,1.9c2.809,3.942,7.5,4.844,11.423,7.537,4.019,2.743,7.276,5.724,11.805,7.778,5.419,2.486,11.086,4.529,16.6,6.724.33.139.6-.241.279-.367",
    transform: "translate(26.775 3.609)",
    fill: "#834b04"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31016",
    "data-name": "Path 31016",
    d: "M72.249,95.042c-1.71-2.814-4.983-3.131-7.434-5.227-1.838-1.6-2.922-4.067-4.224-6-1.256-1.8-2.686-3.549-4.029-5.351-4.955-6.728-4.888-14.591-6.282-22.258-.076-.167-.377-.15-.32.016.712,7.358.059,15.583,4.171,22.249a70.1,70.1,0,0,0,7.525,10.058A11.281,11.281,0,0,0,65.6,91.718c2.4,1.016,4.463,1.821,6.338,3.575.148.134.392-.06.307-.251",
    transform: "translate(23.365 26.236)",
    fill: "#834b04"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31017",
    "data-name": "Path 31017",
    d: "M47.291,61.729c-.338,7.327-4.2,13.277-8.922,19.129-3.5,4.336-5.414,10.568-10.952,13.3-.252.114-.044.436.178.385,2.511-.634,4.217-2.532,5.7-4.321,2.116-2.5,4.088-5.093,6.2-7.619,5.21-6.2,8.41-13.086,8.31-20.876,0-.25-.443-.25-.517,0",
    transform: "translate(12.77 28.784)",
    fill: "#834b04"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31018",
    "data-name": "Path 31018",
    d: "M45.558,70.418a61.568,61.568,0,0,1-6.213,7.38c-2.423,2.423-4.418,4.786-7.982,6.038-3.282,1.139-6.515,2.444-9.907,3.467-3.539,1.143-6.831,3.072-10.679,3.433a.186.186,0,1,0,0,.37c3.5-.176,6.555-1.666,9.838-2.544A79.279,79.279,0,0,0,31.93,84.9c3.157-1.438,4.973-3.341,7.211-5.842,2.409-2.68,5.052-5.351,6.74-8.448a.192.192,0,0,0-.323-.194",
    transform: "translate(4.944 32.908)",
    fill: "#834b04"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14514",
    "data-name": "Group 14514",
    transform: "translate(42.157 12.363)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14513",
    "data-name": "Group 14513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14512",
    "data-name": "Group 14512",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31019",
    "data-name": "Path 31019",
    d: "M92.77,110.941c-4.662-4.886-13.167-6.256-17.262-11.691-4.424-5.874-5.573-13.167-6.256-19.994-.735-7.706-.205-15.542.185-23.267.37-7.35,2.429-15.216,1.4-22.483a35.214,35.214,0,0,0-2.764-8.161c-.238-.6-.443-1.182-.64-1.763-.119.7-.241,1.406-.38,2.106a.585.585,0,0,1-1.1.208c-1.205-2.552-1.2-5.467-1.148-8.246-.019-.707.006-1.438.047-2.175q.055-2.481.084-4.967A8.763,8.763,0,0,0,64.544,8.6c-.716.041-1.434.066-2.15.081a30.534,30.534,0,0,0-1.16,4.638.584.584,0,0,1-1.1.21,8.376,8.376,0,0,1-.873-4.871C58,8.617,56.742,8.545,55.5,8.422c-.161,3.989-.166,7.979-1.13,11.883-.135.542-.84.432-1.069.056-.95-1.548-.682-3.414-.619-5.152a40.436,40.436,0,0,0,.07-6.135,45.122,45.122,0,0,0-1.616,5.021c-.59,2.591-1.03,5.2-1.409,7.826a176.528,176.528,0,0,1-.434,19.44C48.513,49.736,46.1,57.615,46.164,66.1a104.344,104.344,0,0,0,1.479,17.628c-.55,3.311-1.151,6.609-1.932,9.854-2.285,10.016-8.219,18.232-16.7,25-.819.641.238,1.742,1.127,1.293,9.256-4.584,17.735-11.283,22.113-19.926a46.746,46.746,0,0,0,4.229-13.993A77.459,77.459,0,0,0,56.559,97c1.152,11.4,15.508,17.278,25.138,22.38,1.281.65,2.646-.925,1.569-1.851a22.761,22.761,0,0,0-5.348-3.272c-4.014-1.861-5.325-5.018-7.835-7.993a6.785,6.785,0,0,1-.518-.572,2.107,2.107,0,0,0,.36-2.081c-.151-.5-.3-.967-.44-1.406a13.174,13.174,0,0,0,1.481,1.137,26.544,26.544,0,0,0,6.923,3.229c2.7.815,5.71,1.174,8.354,2.237,2.067.784,3.771,2.08,5.872,2.864.54.217,1.048-.31.655-.731",
    transform: "translate(-28.722 -8.423)",
    fill: "#994d08"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14517",
    "data-name": "Group 14517",
    transform: "translate(65.975 13.013)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14516",
    "data-name": "Group 14516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14515",
    "data-name": "Group 14515",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31020",
    "data-name": "Path 31020",
    d: "M44.95,9.459c.045,1.782.091,3.562.148,5.344a38.463,38.463,0,0,0,.063-5.937c-.072.2-.139.395-.211.593",
    transform: "translate(-44.95 -8.866)",
    fill: "#b56c25"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14520",
    "data-name": "Group 14520",
    transform: "translate(55.262 11.723)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14519",
    "data-name": "Group 14519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14518",
    "data-name": "Group 14518",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31021",
    "data-name": "Path 31021",
    d: "M71.143,102.232c-2.46-5.353-6.765-9.76-8.705-15.356a25.382,25.382,0,0,1-1.287-5.453l0-1.042a1.292,1.292,0,0,0,.729-1.271c-.2-1.9-.333-3.828-.436-5.749.117-1.521.28-3.1.415-4.647A105.384,105.384,0,0,0,63.1,87.164c.191,1.145,2.329.86,2.262-.257-1.093-16.387.677-33.02-1.979-49.276.493-1.805.851-3.64,1.226-5.47.213,8.213,1.634,16.358,1.513,24.579-.087,8.924-1.513,17.868.446,26.664a.9.9,0,0,0,1.726-.207c-.324-8.837.009-17.629.186-26.463.189-8.988-1.883-17.782-2.307-26.73a.782.782,0,0,0-1.019-.707A158.079,158.079,0,0,0,67.637,7.987c-.842.151-1.688.269-2.536.383-.643,5.855-1.06,11.738-2.222,17.523a.585.585,0,0,1-1.1.208c-1.2-2.551-1.2-5.467-1.146-8.244-.021-.709.006-1.438.046-2.177q.057-2.483.084-4.968a8.59,8.59,0,0,0-.392-1.905q-1.077.059-2.152.078a30.885,30.885,0,0,0-1.16,4.638.584.584,0,0,1-1.1.208,8.4,8.4,0,0,1-.873-4.87c-1.262-.04-2.517-.11-3.765-.233-.16,3.988-.164,7.976-1.129,11.88-.135.542-.841.432-1.07.056a4.262,4.262,0,0,1-.461-1.079c.069,1.849.147,3.7.245,5.548a.608.608,0,0,0-.44.54C47.037,35.68,46.434,45.881,45.19,56.054c-1.033,8.288-1.688,16.666-.768,24.971-.183,0-.393.048-.387.228.882,8.762-1.788,17.3-6.28,25.047-.461.776.738,1.372,1.274.666,4.792-5.988,6.5-13.4,6.145-20.7a4.583,4.583,0,0,0,.1.614c.154.8,1.13,1.017,1.826.785a38.362,38.362,0,0,1-1.522,5.588c-.376,1.226,1.616,1.6,2.112.511,2.758-5.919,3.493-12.188,3.884-18.543a1.959,1.959,0,0,0,.269.01c-.05.506-.044,1.069-.066,1.575A77.5,77.5,0,0,0,51.729,91.5c.578,5.265,4.088,8.663,5.388,13.6.208.658,1.43.524,1.378-.17-.725-4.657-3.5-8.664-4.167-13.439-.735-4.791-.032-9.9.55-14.7.64-5.282,1.036-10.665,1.162-16.045A107.109,107.109,0,0,0,57,72.573a48.3,48.3,0,0,0,1.355,13.149,23.341,23.341,0,0,0,1.231,3.634c.238.919.474,1.838.781,2.715a1,1,0,0,0,1.042.66,81.108,81.108,0,0,0,8.219,10.255c.517.622,1.86-.057,1.513-.756",
    transform: "translate(-37.651 -7.987)",
    fill: "#b56c25"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14523",
    "data-name": "Group 14523",
    transform: "translate(75.801 40.496)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14522",
    "data-name": "Group 14522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14521",
    "data-name": "Group 14521",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31022",
    "data-name": "Path 31022",
    d: "M54.008,28.048c-.1-.7-1.479-.555-1.39.173,1,13.378-1.91,26.8-.653,40.134a1.034,1.034,0,0,0,2.04-.006c1.4-13.346,2.275-27.045,0-40.3",
    transform: "translate(-51.645 -27.591)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14526",
    "data-name": "Group 14526",
    transform: "translate(70.905 50.455)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14525",
    "data-name": "Group 14525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14524",
    "data-name": "Group 14524",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31023",
    "data-name": "Path 31023",
    d: "M56.621,87.345a33.52,33.52,0,0,1-5.23-13.562.576.576,0,0,0-.638-.451c1.08-5.676.351-11.4.186-17.159a172.359,172.359,0,0,0-1.419-21.3c-.112-.627-1.273-.691-1.208.012a210.891,210.891,0,0,1,.3,40.113c-.045.881,1.493,1.044,1.755.219a4.96,4.96,0,0,1,.125-.655,30.205,30.205,0,0,0,4.92,13.424c.506.643,1.654.06,1.209-.637",
    transform: "translate(-48.309 -34.376)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14529",
    "data-name": "Group 14529",
    transform: "translate(67.827 13.467)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14528",
    "data-name": "Group 14528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14527",
    "data-name": "Group 14527",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31024",
    "data-name": "Path 31024",
    d: "M48.789,15.162a.811.811,0,0,0-.942-.727c-.2-1.755-.385-3.509-.575-5.26a52.7,52.7,0,0,1-1.06,10.656c.075.308.134.621.214.925a1,1,0,0,0,.415.5,126.505,126.505,0,0,0,.446,21.351A1.228,1.228,0,0,0,49.7,42.6c1-9.052-.493-18.411-.914-27.434",
    transform: "translate(-46.212 -9.175)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14532",
    "data-name": "Group 14532",
    transform: "translate(76.012 12.546)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14531",
    "data-name": "Group 14531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14530",
    "data-name": "Group 14530",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31025",
    "data-name": "Path 31025",
    d: "M54.064,15.419q.055-2.483.084-4.968a8.594,8.594,0,0,0-.392-1.9c-.655.041-1.312.081-1.968.094a58.505,58.505,0,0,0,1.864,14.808.88.88,0,0,0,.873.59,23.551,23.551,0,0,1-.506-6.448c-.021-.706.006-1.435.046-2.172",
    transform: "translate(-51.788 -8.548)",
    fill: "#e4a167"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31026",
    "data-name": "Path 31026",
    d: "M74.9,80.6h-.145l-.405-.153L71.58,81.9l.232,1.048.43-.032,2.354-.148.652-.341Z",
    transform: "translate(33.481 37.63)",
    fill: "#3a1d0b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31027",
    "data-name": "Path 31027",
    d: "M69.337,87.47l-.2-1.957-.483-.534-.724-.348-.113-.041-1.733.228-2.175.458-1.358.888c2.254.994,4.462,1.807,6.79,1.306",
    transform: "translate(29.256 39.566)",
    fill: "#e9ab62"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31028",
    "data-name": "Path 31028",
    d: "M62.793,85.662l-.772.506,4.741,2.121.21.069.035.012.787-.39,1.485-.439.324-.376-.021-.2c-2.328.5-4.535-.313-6.79-1.306",
    transform: "translate(29.01 40.068)",
    fill: "#3a1d0b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31029",
    "data-name": "Path 31029",
    d: "M87.583,88.653l.845-1.344c-1.932,1.343-4,.608-5.911-.9l-.267,1.446.285.768,4.554.693Z",
    transform: "translate(38.472 40.417)",
    fill: "#3a1d0b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31030",
    "data-name": "Path 31030",
    d: "M88.344,88l.7-1.127-.4-1.328-2.613-.6-.641-.013-2.765,1.1L82.433,87.1c1.908,1.507,3.979,2.243,5.911.9",
    transform: "translate(38.557 39.726)",
    fill: "#e9ab62"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31031",
    "data-name": "Path 31031",
    d: "M80.528,81.929l-.148.038-1.239.176-1.528,1.024,3.269-.242Z",
    transform: "translate(36.303 38.321)",
    fill: "#3a1d0b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31032",
    "data-name": "Path 31032",
    d: "M75.494,80.663a.433.433,0,0,0-.157-.266.446.446,0,0,0-.3-.11h-.063l-.33-.12a.479.479,0,0,0-.365.025L71.506,81.64a.458.458,0,0,0-.226.5l.226,1.048a.537.537,0,0,0,.154.25.481.481,0,0,0,.329.112l.432-.032,2.354-.15a.522.522,0,0,0,.176-.047l.658-.339a.459.459,0,0,0,.236-.49Zm-.753,2.25-2.354.148-.43.031-.232-1.048,2.771-1.45.405.151h.145l.346,1.827Z",
    transform: "translate(33.336 37.486)",
    fill: "#3a1d0b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31033",
    "data-name": "Path 31033",
    d: "M70.187,87.573l-.205-1.952a.483.483,0,0,0-.117-.266l-.484-.534a.337.337,0,0,0-.047-.043.7.7,0,0,0-.1-.068l-.718-.342a.048.048,0,0,0-.032-.01l-.113-.047a.476.476,0,0,0-.226-.031l-1.735.229h-.035l-2.175.467a.3.3,0,0,0-.154.063l-1.362.888-.769.5a.436.436,0,0,0-.2.415.474.474,0,0,0,.16.311.539.539,0,0,0,.11.07l4.745,2.121c.013.01.028.012.035.023l.213.066.034.01a.446.446,0,0,0,.352-.021l.751-.377,1.452-.424a.518.518,0,0,0,.216-.139l.32-.376a.462.462,0,0,0,.1-.342Zm-.762.615-1.485.439-.787.389-.035-.01-.21-.069-4.741-2.122.772-.5L64.3,85.42l2.175-.456,1.733-.229.113.043.724.346.483.534.2,1.956.021.2Z",
    transform: "translate(28.864 39.42)",
    fill: "#3a1d0b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31034",
    "data-name": "Path 31034",
    d: "M88.1,89.771c.01-.012.016-.022.026-.035l.838-1.347.7-1.124a.472.472,0,0,0,.053-.374l-.4-1.328a.448.448,0,0,0-.145-.22.428.428,0,0,0-.2-.1l-2.613-.6a.3.3,0,0,0-.1-.009l-.64-.013a.375.375,0,0,0-.176.029l-2.767,1.107a.449.449,0,0,0-.274.333l-.194,1.07-.263,1.447a.374.374,0,0,0,.018.236l.283.766a.473.473,0,0,0,.135.192.5.5,0,0,0,.229.107l4.559.688a.47.47,0,0,0,.43-.172Zm-5.416-.313-.283-.766.266-1.447.192-1.07,2.767-1.1.64.012,2.614.6.4,1.328-.7,1.126-.847,1.344-.492.663Z",
    transform: "translate(38.326 39.581)",
    fill: "#3a1d0b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31035",
    "data-name": "Path 31035",
    d: "M81.457,82.916l-.358-.988a.43.43,0,0,0-.131-.2.469.469,0,0,0-.432-.092l-.117.035-1.2.17a.382.382,0,0,0-.189.072L77.5,82.937a.455.455,0,0,0-.173.525.489.489,0,0,0,.135.2.479.479,0,0,0,.336.112l3.27-.244a.458.458,0,0,0,.341-.2.451.451,0,0,0,.048-.405m-3.7.4,1.528-1.023,1.24-.176.147-.04.355,1Z",
    transform: "translate(36.158 38.175)",
    fill: "#3a1d0b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14535",
    "data-name": "Group 14535",
    transform: "translate(121.332 125.304)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14534",
    "data-name": "Group 14534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14533",
    "data-name": "Group 14533",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31036",
    "data-name": "Path 31036",
    d: "M88.213,85.72a5.559,5.559,0,0,0-2.516-.294,15.2,15.2,0,0,0-2.454.247.652.652,0,0,0-.054,1.286,27.138,27.138,0,0,0,4.968-.007c.768,0,.685-1.041.056-1.231",
    transform: "translate(-82.666 -85.372)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14538",
    "data-name": "Group 14538",
    transform: "translate(123.953 127.122)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14537",
    "data-name": "Group 14537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14536",
    "data-name": "Group 14536",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31037",
    "data-name": "Path 31037",
    d: "M86.09,86.776a8.656,8.656,0,0,1-1.1-.154.47.47,0,0,0-.16.926,2.338,2.338,0,0,0,1.391-.2.32.32,0,0,0-.129-.574",
    transform: "translate(-84.452 -86.61)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14541",
    "data-name": "Group 14541",
    transform: "translate(91.408 123.97)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14540",
    "data-name": "Group 14540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14539",
    "data-name": "Group 14539",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31038",
    "data-name": "Path 31038",
    d: "M68.278,85.371a1.486,1.486,0,0,0-.181-.07c.379-.216.251-.91-.242-.831-.933.144-1.879-.018-2.8.2a4.894,4.894,0,0,0-2.717,1.477.3.3,0,0,0,.389.436,6.839,6.839,0,0,1,3.034-1.11,5.348,5.348,0,0,1,.652-.012,6.541,6.541,0,0,0-1.063.339c-.339.144-.26.712.142.658.467-.066.925-.191,1.393-.274a10.593,10.593,0,0,0,1.364-.135.372.372,0,0,0,.029-.681",
    transform: "translate(-62.278 -84.463)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14544",
    "data-name": "Group 14544",
    transform: "translate(97.271 125.913)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14543",
    "data-name": "Group 14543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14542",
    "data-name": "Group 14542",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31039",
    "data-name": "Path 31039",
    d: "M66.964,85.788a1.482,1.482,0,0,0-.5.072.3.3,0,0,0,.047.568,1.293,1.293,0,0,0,.509,0,.321.321,0,0,0-.056-.64",
    transform: "translate(-66.273 -85.787)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14547",
    "data-name": "Group 14547",
    transform: "translate(105.076 118.199)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14546",
    "data-name": "Group 14546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14545",
    "data-name": "Group 14545",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31040",
    "data-name": "Path 31040",
    d: "M74.314,80.531a3.326,3.326,0,0,0-1.391.367,5.263,5.263,0,0,0-1.221.687.273.273,0,0,0,.175.493,4.139,4.139,0,0,0,1.224-.291,3.948,3.948,0,0,1,1.3-.2c.675.01.594-1.069-.09-1.058",
    transform: "translate(-71.591 -80.531)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14550",
    "data-name": "Group 14550",
    transform: "translate(107.062 119.26)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14549",
    "data-name": "Group 14549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14548",
    "data-name": "Group 14548",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31041",
    "data-name": "Path 31041",
    d: "M74.026,81.279a4.153,4.153,0,0,0-.875.021c-.272,0-.274.418-.018.468a1.718,1.718,0,0,0,.932,0,.255.255,0,0,0-.04-.489",
    transform: "translate(-72.943 -81.254)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14553",
    "data-name": "Group 14553",
    transform: "translate(115.203 120.92)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14552",
    "data-name": "Group 14552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14551",
    "data-name": "Group 14551",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31042",
    "data-name": "Path 31042",
    d: "M80.225,82.767a.243.243,0,0,0-.066-.279c-.167-.188-.5-.068-.722-.034a2.774,2.774,0,0,1-.744.087.177.177,0,0,0-.1.333,1.547,1.547,0,0,0,.825.141c.277-.01.658,0,.812-.248",
    transform: "translate(-78.49 -82.385)",
    fill: "#a6643d"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31043",
    "data-name": "Path 31043",
    d: "M32.278,91.754l-.144,0-.412.139L29,90.348l.27-1.035.426.041,2.345.23.644.36Z",
    transform: "translate(13.564 41.776)",
    fill: "#3a1d0b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31044",
    "data-name": "Path 31044",
    d: "M26.937,84.829l-.267,1.948-.5.527-.729.321-.117.043L23.6,87.378l-2.161-.525-1.33-.931c2.287-.923,4.519-1.659,6.832-1.093",
    transform: "translate(9.404 39.586)",
    fill: "#e9ab62"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31045",
    "data-name": "Path 31045",
    d: "M20.344,86.332l-.754-.53L24.4,83.831l.208-.066.037-.007.775.415,1.474.486.308.389-.025.191c-2.313-.565-4.546.17-6.834,1.093",
    transform: "translate(9.163 39.177)",
    fill: "#3a1d0b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31046",
    "data-name": "Path 31046",
    d: "M45.215,84.2l.8,1.375c-1.882-1.4-3.978-.732-5.937.7l-.22-1.446.311-.76,4.573-.545Z",
    transform: "translate(18.642 39.067)",
    fill: "#3a1d0b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31047",
    "data-name": "Path 31047",
    d: "M45.942,85.166l.669,1.145-.443,1.315-2.635.518-.64-.01L40.165,86.94,40,85.867c1.959-1.434,4.055-2.106,5.937-.7",
    transform: "translate(18.712 39.473)",
    fill: "#e9ab62"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31048",
    "data-name": "Path 31048",
    d: "M37.946,90.212l-.153-.048-1.223-.213-1.5-1.069,3.263.343Z",
    transform: "translate(16.405 41.574)",
    fill: "#3a1d0b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31049",
    "data-name": "Path 31049",
    d: "M33.276,90.182a.441.441,0,0,0-.219-.49l-.643-.367a.969.969,0,0,0-.179-.054l-2.345-.227L29.459,89a.472.472,0,0,0-.495.346L28.7,90.39a.453.453,0,0,0,.216.5l2.723,1.538a.457.457,0,0,0,.367.035l.333-.113.062.006a.492.492,0,0,0,.305-.1.448.448,0,0,0,.16-.267Zm-.445-.092-.407,1.81-.144,0-.412.139-2.724-1.543.272-1.035.426.043,2.345.23Z",
    transform: "translate(13.419 41.63)",
    fill: "#3a1d0b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31050",
    "data-name": "Path 31050",
    d: "M27.8,85.253a.485.485,0,0,0-.094-.341l-.313-.39a.477.477,0,0,0-.207-.15L25.752,83.9l-.74-.4a.438.438,0,0,0-.349-.029l-.035.009-.213.06a.113.113,0,0,1-.037.018l-4.811,1.968-.116.066a.523.523,0,0,0-.169.311.462.462,0,0,0,.188.423l.756.528,1.328.931a.46.46,0,0,0,.16.069l2.155.531.032.009,1.729.28a.488.488,0,0,0,.226-.023l.119-.046A.055.055,0,0,1,26,88.6l.732-.323a.43.43,0,0,0,.1-.06.117.117,0,0,0,.047-.046l.5-.518a.491.491,0,0,0,.123-.254l.266-1.954Zm-.456-.059-.025.191-.266,1.948-.5.527-.729.321-.116.043-1.728-.289-2.161-.525-1.33-.931-.754-.53,4.811-1.971.208-.066.037-.007.775.415,1.474.486Z",
    transform: "translate(9.017 39.031)",
    fill: "#3a1d0b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31051",
    "data-name": "Path 31051",
    d: "M45.261,83.4a.454.454,0,0,0-.424-.191l-4.572.546a.4.4,0,0,0-.235.1.41.41,0,0,0-.141.183l-.307.756a.383.383,0,0,0-.029.242l.216,1.453.159,1.069a.44.44,0,0,0,.269.345L42.927,89.1a.39.39,0,0,0,.172.041l.643,0c.031,0,.063,0,.092,0l2.636-.517a.509.509,0,0,0,.2-.092.464.464,0,0,0,.15-.223L47.258,87a.446.446,0,0,0-.038-.374l-.663-1.146-.8-1.377c-.007-.01-.016-.029-.025-.04Zm-.376.263.476.674.8,1.375.669,1.146-.443,1.314-2.633.52-.641-.01-2.727-1.195-.161-1.073L40,84.972l.313-.76Z",
    transform: "translate(18.497 38.921)",
    fill: "#3a1d0b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31052",
    "data-name": "Path 31052",
    d: "M38.872,89.134a.487.487,0,0,0-.342-.216l-3.257-.348a.456.456,0,0,0-.335.1.42.42,0,0,0-.144.192.447.447,0,0,0,.156.533l1.494,1.071a.463.463,0,0,0,.186.082l1.193.208.122.032a.453.453,0,0,0,.43-.078.479.479,0,0,0,.139-.192l.389-.983a.457.457,0,0,0-.032-.4m-.392.238-.389.986-.151-.048L36.716,90.1l-1.5-1.069Z",
    transform: "translate(16.26 41.427)",
    fill: "#3a1d0b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14556",
    "data-name": "Group 14556",
    transform: "translate(59.044 125.218)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14555",
    "data-name": "Group 14555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14554",
    "data-name": "Group 14554",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31053",
    "data-name": "Path 31053",
    d: "M45.751,86.8a5.509,5.509,0,0,1-2.522.21,15.683,15.683,0,0,1-2.448-.321.653.653,0,0,1-.01-1.289,27.392,27.392,0,0,1,4.965.163c.766.025.649,1.067.015,1.237",
    transform: "translate(-40.228 -85.314)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14559",
    "data-name": "Group 14559",
    transform: "translate(61.705 124.197)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14558",
    "data-name": "Group 14558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14557",
    "data-name": "Group 14557",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31054",
    "data-name": "Path 31054",
    d: "M43.67,85.456a7.225,7.225,0,0,0-1.108.117.471.471,0,0,1-.134-.932,2.322,2.322,0,0,1,1.388.238.325.325,0,0,1-.147.577",
    transform: "translate(-42.041 -84.618)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562",
    transform: "translate(29.125 125.097)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14561",
    "data-name": "Group 14561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14560",
    "data-name": "Group 14560",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31055",
    "data-name": "Path 31055",
    d: "M25.8,86.669a1.055,1.055,0,0,1-.183.07c.373.226.223.913-.266.818-.926-.17-1.879-.045-2.793-.288A4.856,4.856,0,0,1,19.9,85.7a.294.294,0,0,1,.4-.417,6.907,6.907,0,0,0,2.993,1.208,5.259,5.259,0,0,0,.65.029,6.3,6.3,0,0,1-1.054-.379c-.33-.148-.235-.715.163-.647.464.079.92.22,1.381.32a9.845,9.845,0,0,1,1.365.178.369.369,0,0,1,.006.678",
    transform: "translate(-19.843 -85.231)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14565",
    "data-name": "Group 14565",
    transform: "translate(34.993 124.849)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14564",
    "data-name": "Group 14564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14563",
    "data-name": "Group 14563",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31056",
    "data-name": "Path 31056",
    d: "M24.522,85.735a1.624,1.624,0,0,1-.5-.09.3.3,0,0,1,.069-.569,1.387,1.387,0,0,1,.5.019.322.322,0,0,1-.076.64",
    transform: "translate(-23.841 -85.062)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14568",
    "data-name": "Group 14568",
    transform: "translate(42.578 131.923)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14567",
    "data-name": "Group 14567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14566",
    "data-name": "Group 14566",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31057",
    "data-name": "Path 31057",
    d: "M31.689,91.5a3.347,3.347,0,0,1-1.374-.407,5.841,5.841,0,0,1-1.2-.721.277.277,0,0,1,.191-.493,4.194,4.194,0,0,1,1.214.333,4.253,4.253,0,0,0,1.3.241c.678.009.564,1.083-.125,1.046",
    transform: "translate(-29.009 -89.882)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14571",
    "data-name": "Group 14571",
    transform: "translate(44.562 131.903)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14570",
    "data-name": "Group 14570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14569",
    "data-name": "Group 14569",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31058",
    "data-name": "Path 31058",
    d: "M31.437,90.437a3.932,3.932,0,0,1-.876-.051c-.272,0-.257-.423,0-.465a1.661,1.661,0,0,1,.936.029.256.256,0,0,1-.056.487",
    transform: "translate(-30.361 -89.868)",
    fill: "#a6643d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14574",
    "data-name": "Group 14574",
    transform: "translate(52.759 130.453)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14573",
    "data-name": "Group 14573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14572",
    "data-name": "Group 14572",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31059",
    "data-name": "Path 31059",
    d: "M37.68,89.163a.239.239,0,0,1-.073.277c-.178.181-.514.057-.725.01a3.5,3.5,0,0,0-.738-.114.173.173,0,0,1-.094-.33,1.488,1.488,0,0,1,.829-.116c.273.018.655.016.8.273",
    transform: "translate(-35.945 -88.88)",
    fill: "#a6643d"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31060",
    "data-name": "Path 31060",
    d: "M92.528,111.069c-4.8-3.12-10.054-5.294-14.8-8.616A114.071,114.071,0,0,1,65.2,92.2c-1.752-4.334-1.876-9.489-2.513-14.03a108.791,108.791,0,0,1-.869-26.833c.86-8.2.712-16.267,1.005-24.486.15-4.164.5-8.326.7-12.486a32.973,32.973,0,0,0-.082-3.769,11.07,11.07,0,0,0-.829-1.171c-.065.64-.138,1.277-.244,1.911-.252,4.322-.878,8.629-1.095,12.956-.251,4.939-.081,9.884-.051,14.83.028,5.247-.782,10.462-1.325,15.668-.932,8.887.31,18.251,1.807,27.03,1.061,6.2.433,12.062,6.351,15.827.205.128.587-.3.4-.481A12.988,12.988,0,0,1,67.092,95.6c2.439,2.775,5.511,4.775,8.726,6.854,5.212,3.363,10.613,6.826,16.461,8.986.179.066.442-.241.25-.368",
    transform: "translate(27.868 4.407)",
    fill: "#3a1d0b"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31061",
    "data-name": "Path 31061",
    d: "M78.766,81.9a83.6,83.6,0,0,0-8.817-5.965c-1.8-1.032-3.775-1.438-5.447-2.74a28.154,28.154,0,0,1-3.727-3.925c-.134-.157-.427.156-.319.323,1.772,2.639,3.437,4.93,6.232,6.523,3.79,2.168,7.663,4.465,11.579,6.386.261.131.766-.4.5-.6",
    transform: "translate(28.267 32.382)",
    fill: "#3a1d0b"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31062",
    "data-name": "Path 31062",
    d: "M77.445,89.431c-7.255-4.562-15.658-7.249-20.017-15.2-.122-.219-.465.076-.393.272,3.374,8.962,12.282,11.432,20.155,15.3.181.081.454-.257.255-.374",
    transform: "translate(26.673 34.685)",
    fill: "#3a1d0b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31063",
    "data-name": "Path 31063",
    d: "M51.663,82.41c-1.02-3.226-2.627-6.251-3.694-9.468-.092-.28-.572.069-.525.292,1.271,6.3,3.137,12.341,4.165,18.706.066.387.59.013.584-.258-.051-3.3.477-6.09-.53-9.272",
    transform: "translate(22.19 34.069)",
    fill: "#3a1d0b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31064",
    "data-name": "Path 31064",
    d: "M48.044,68.741c-2.875,3.894-5.272,7.86-8.589,11.437-1.516,1.629-3.247,3.189-4.62,4.957A30.207,30.207,0,0,1,28.8,89.282c-1.686.829-3.226,1.8-4.879,2.708-.283.157-1.187.678-2.177,1.217-1.333.272-2.715.481-4.176.631-.336.04-.766.753-.257.819a8.147,8.147,0,0,0,1.526.041,21.173,21.173,0,0,0,9.728-1.87c-.063.194-.034.358.216.346,4.177-.223,5.9-5.6,8.365-8.194A48.587,48.587,0,0,0,43.4,77.442c1.745-2.806,3.126-5.812,4.94-8.579.166-.258-.147-.313-.292-.122",
    transform: "translate(7.99 32.1)",
    fill: "#3a1d0b"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31065",
    "data-name": "Path 31065",
    d: "M43.054,29.612c.025-.257-.311-.1-.346.072-.724,3.725-1.237,7.488-2.049,11.2-.888,4.085-2.058,7.359-1.481,11.576,1.158,8.473,1.639,16.665,2.087,25.2.019.421.615.012.624-.272a188.3,188.3,0,0,0-.884-23.978c-.4-4.466.527-8.438,1.114-12.816.481-3.636.543-7.328.935-10.982",
    transform: "translate(18.253 13.787)",
    fill: "#3a1d0b"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31066",
    "data-name": "Path 31066",
    d: "M42.626,22a.54.54,0,0,0,.432-.414q.077-1.909.134-3.825-.3,2.116-.565,4.239",
    transform: "translate(19.938 8.309)",
    fill: "#3a1d0b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31067",
    "data-name": "Path 31067",
    d: "M46.442,20.278a.679.679,0,0,1-.2-.2c-.948-1.548-.683-3.414-.619-5.152.053-1.447.205-3.073.176-4.647-.059-.423-.119-.84-.183-1.255-.172.476-.341.951-.511,1.428-.848,11.106-1.656,22.436-1.113,33.553.018.267.4.009.407-.179a144.912,144.912,0,0,1,1.644-19.473,31.166,31.166,0,0,0,.4-4.076",
    transform: "translate(20.493 4.221)",
    fill: "#3a1d0b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31068",
    "data-name": "Path 31068",
    d: "M51.753,8.994c0-.012-.012-.016-.016-.025-.141.473-.28.945-.41,1.418.142,5.378,1.33,10.745.6,16.1a104.134,104.134,0,0,0-.719,16.894c.007.2.3.012.3-.135.379-11.613,3.468-22.8.239-34.25",
    transform: "translate(23.926 4.195)",
    fill: "#3a1d0b"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31069",
    "data-name": "Path 31069",
    d: "M41.438,20.4c-.157.85-.317,1.7-.508,2.545s-.364,2.061-.614,3.3c0,.616-.013,1.234-.006,1.848.06,5.372-1.251,10.6-2.623,15.755a39.1,39.1,0,0,0-1,12.549c.226,4.393.053,8.919.7,13.267.044.31.486.019.467-.2-.628-8.921-.854-18.64,1.33-27.3A74.758,74.758,0,0,0,41.438,20.4",
    transform: "translate(17.116 9.543)",
    fill: "#3a1d0b"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31070",
    "data-name": "Path 31070",
    d: "M39.678,56.66c-.007-.205-.327-.034-.338.112-.307,3.427.319,7.092-.822,10.4-1.3,3.779-3.916,7.16-5.868,10.612-.194.343.2.424.383.157a74.25,74.25,0,0,0,6.568-10.7c1.44-3.054.138-7.371.076-10.577",
    transform: "translate(15.248 26.458)",
    fill: "#3a1d0b"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31071",
    "data-name": "Path 31071",
    d: "M34.156,75.7c-2.191,2.235-5.1,3.354-7.98,4.418-3.006,1.113-5.965,2.5-8.915,3.766-.135.059-.252.4-.019.327,3.339-.966,6.587-2.269,9.847-3.467a15.394,15.394,0,0,0,7.306-4.883c.15-.191-.094-.307-.239-.161",
    transform: "translate(8.002 35.378)",
    fill: "#3a1d0b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31072",
    "data-name": "Path 31072",
    d: "M53.351,71C51.225,76,49.4,80.055,45.285,83.815c-4.076,3.724-8.235,7.242-13.318,9.507-.222.1-.3.5.028.4,5.695-1.854,10.3-6.426,14.968-10.02,4.518-3.471,5.111-7.557,6.8-12.667.114-.343-.314-.258-.411-.028",
    transform: "translate(14.863 33.117)",
    fill: "#3a1d0b"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31073",
    "data-name": "Path 31073",
    d: "M45.395,79.528a11.023,11.023,0,0,0-1.017,1.829c-.2.448-.631,1.183-.3,1.642.122.161.4-.007.493-.1a2.955,2.955,0,0,0,.625-1.431,15.942,15.942,0,0,1,.606-1.851c.132-.321-.277-.283-.411-.09",
    transform: "translate(20.561 37.129)",
    fill: "#3a1d0b"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31074",
    "data-name": "Path 31074",
    d: "M52.372,7.02c.134-.49.272-.986.418-1.484a3.232,3.232,0,0,1-.52-.336c-.239.966-.458,1.927-.653,2.875.15.057.3.131.439.2.06-.242.112-.483.175-.728a6.073,6.073,0,0,0,2.3,1.271c1.841.8,3.7,1.6,5.563,2.365.038.018.112-.1.062-.123-2.56-1.347-5.268-2.5-7.786-4.042",
    transform: "translate(24.144 2.432)",
    fill: "#3a1d0b"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31075",
    "data-name": "Path 31075",
    d: "M53.433,1.673c-.4,1.158-.759,2.338-1.079,3.523a1.133,1.133,0,0,0,.6.329c.351-1.11.725-2.218,1.105-3.292a6.219,6.219,0,0,0,.693.3c.2.084.386.159.58.239a4.227,4.227,0,0,0-1.9-1.1",
    transform: "translate(24.488 0.783)",
    fill: "#3a1d0b"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31076",
    "data-name": "Path 31076",
    d: "M63.554.7A18,18,0,0,0,61.078.19a25.119,25.119,0,0,0,6.7,3.2c.084.022.239-.239.129-.3C66.479,2.358,64.992,1.545,63.554.7",
    transform: "translate(28.569 0.089)",
    fill: "#3a1d0b"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31077",
    "data-name": "Path 31077",
    d: "M70.936,22.728c-3.11-.992-6.188-2.866-9.228-4.243-1.634-.737-3.314-1.328-4.98-1.945-.856-.317-1.977-.574-3-.957.051-.079.082-.185.006-.208a3.18,3.18,0,0,1-2-2.517,4.221,4.221,0,0,0-.907.034c-.013.462-.015.914,0,1.353a5.276,5.276,0,0,0,1.032,1.19,4.75,4.75,0,0,0,.809.179c.455.173.96.238,1.38.429,1.882.848,3.779,1.6,5.695,2.34,3.633,1.4,7.389,3.843,11.117,4.5.053.009.153-.134.078-.157",
    transform: "translate(23.768 6.009)",
    fill: "#3a1d0b"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31078",
    "data-name": "Path 31078",
    d: "M313.4,114.33c-.884-.172-1.477-1.206-1.66-2.219-.129-.063-.238-.1-.37-.178a176.732,176.732,0,0,0-18.724-8.895c-10.466-4.192-21.159-7.863-31.97-11.259,1.082-.483,1.923-.9,2.37-1.111,4.16-1.955,8.448-4.434,12.992-5.018,3.973-.511,8.064.037,12.134.458a15.492,15.492,0,0,0,1.3-1.424c-.613-.137-1.179-.282-1.792-.4.681.032,1.353.026,2.045.04a2.072,2.072,0,0,0,.277-2,49.074,49.074,0,0,0-16.456-.456c1.06-1.008,2.127-1.977,3.182-2.988a4.011,4.011,0,0,1-.355-2.522,3.118,3.118,0,0,1-1.139-1.085c-.571.367-1.136.768-1.675,1.184-2.693,2.081-5.134,4.691-8.08,6.264a43.662,43.662,0,0,1-16.135,5.046c-8.579-2.771-16.825-6.2-25.11-9.518-4.908-1.967-10.055-3.868-14.837-6.191-1.048-.509-2.125-1.063-3.192-1.635a17.873,17.873,0,0,1,1.576-1.1,45.553,45.553,0,0,1,5.648-2.511c3.923-1.735,9.062-6.034,13.189-5.414,2.5.377,5.3.081,7.736.784,2.188.63,4.309,1.534,6.534,2.033,1.411.317,2.84.586,4.287.866a10.641,10.641,0,0,1,1.893-1.936c-2.927-.951-5.824-1.929-8.641-3.164A24.216,24.216,0,0,0,233.1,58.4,58.241,58.241,0,0,0,244.326,54.1c5.031-2.724,10.2-3.552,15.46-4.679a3.722,3.722,0,0,1-.235-1.027c-1.309.338-2.588-.917-2.828-2.48a3.571,3.571,0,0,1-.023-.87c-1.378.019-2.78,0-4.145.041A29.453,29.453,0,0,0,242.518,47.5c-5.232,2.071-10.7,3.184-15.966,5.092.23-.37.47-.776.669-1.12,1.93-3.341,3.443-7.321,6.191-9.772.421-.418.829-.847,1.23-1.3a5.507,5.507,0,0,1-.509-.583,4.479,4.479,0,0,1-.555-2.834,25.264,25.264,0,0,1-2.532,2.279c-2.2,1.735-3.346,4.745-4.779,7.339A45.279,45.279,0,0,1,220.7,55.03c-.1.126-.216.225-.327.342a62.787,62.787,0,0,1-12.027,4.91c-4.157,1.168-8.278,1.292-12.476,1.518-2.42.131-4.854.267-7.283.4-3.214-1.314-6.392-3.421-9.292-4.644-5.451-2.3-10.833-5.2-16.4-7.082-3.163-1.073-6.364-1.808-9.405-3.386-2.166-1.127-4.273-2.284-6.462-3.244l.226-.019a66.484,66.484,0,0,1-14-6.169c-4.227-2.529-8.375-5.323-12.554-8.027-1.487-.961-2.958-1.961-4.4-3.032-1.722-.636-3.468-1.264-5.1-1.983-7.276-3.216-14.018-8.344-20.87-12.2C83.14,8.353,75.282,4.611,67.7.861c-.261-.128-.524-.28-.785-.415A10.639,10.639,0,0,0,64.752.2C63.685.208,62.584.1,61.47.016a4.7,4.7,0,0,1,.484.842c.178.415-.156,1.11-.442.925A18.18,18.18,0,0,0,57.855.076c-.2.032-.405.057-.606.106.239.451.467.92.713,1.35.023.026.047.05.07.073a11.84,11.84,0,0,0,3.029,1.457C63.447,3.619,65.2,6.49,67.511,7.4c.348.135.129,1.123-.229,1.066-2.494-.39-4.59-2.147-6.9-3.285-1.164-.572-2.473-.528-3.619-1.13-.749-.39-1.408-1.167-2.177-1.478Q53.943,4.385,53.4,6.217a11.306,11.306,0,0,0,1.221.233,1.77,1.77,0,0,1,1.114.939c.144.26-.023.866-.263.906a3.7,3.7,0,0,1-2.532-.452c-.252.929-.492,1.858-.7,2.784a13.289,13.289,0,0,1,3.575,2.834c.3.294-.048,1.157-.373.951a12.047,12.047,0,0,0-3.669-1.524c-.079.421-.142.838-.208,1.256a16.7,16.7,0,0,0,3.6,2.971c.38.088.751.183,1.111.305a3.291,3.291,0,0,1,2.139,1.447.631.631,0,0,1-.342.862c-1.325.1-2.6-.473-3.916-.547a20.487,20.487,0,0,0-3.186-.31q-.059.757-.09,1.5c.059.088.122.164.185.245,1.183.531,2.376,1.042,3.57,1.531,8,3.275,16.06,6.627,23.7,10.458,3.721,1.867,7.406,4.143,11.115,6.084,2.059,1.077,4.377,1.882,6.54,2.916,1.274,1.562,2.588,3.035,3.892,4.468,3.034,3.326,5.4,6.647,6.162,11.851.506,3.493.818,7.121,2.138,10.163,1.572,3.619,3.449,6.737,3.32,11.011-.132,4.424.784,8.652.261,12.94a53.47,53.47,0,0,0-.3,10.615,33.755,33.755,0,0,0,.888,6.248c.15.55.32,1.079.515,1.606a4.213,4.213,0,0,1,.417-1.239,4.71,4.71,0,0,1,1.833-2.015c-.038-.264-.1-.484-.141-.731-1.093-4.883-.58-8.826.346-13.744.665-3.534.25-7.166.911-10.692a14.292,14.292,0,0,0,2.078,3.211c1.509,1.742,3.834,2.136,5.171,4.049,2.111,3.022,4.923,5.346,7.2,8.153a5,5,0,0,1,1.863-1.986,3.24,3.24,0,0,1,1.452-.427c-.233-.267-.429-.568-.677-.822-2.009-2.341-4.716-3.951-6.777-6.245a33.558,33.558,0,0,1-5.671-7.729c-2.677-5.651-4.381-12.332-6.344-18.7-1.23-3.988-1.431-8.268-1.98-12.611,4.6,2,9.239,4.088,13.688,6.454,4.707,2.507,8.812,5.13,13.914,6.52,4.995,1.362,9.586,4.022,14.482,5.7,2.081.715,4.212,1.73,6.322,2.315,2.99,2.743,5.188,6.467,8.106,9.248A23.994,23.994,0,0,1,175.32,88.9c1.22,3.1,2.915,5.795,4.342,8.721a23.66,23.66,0,0,1,2.7,12.715,17.82,17.82,0,0,0,1.126,8.9c1.62,3.756,3.383,7.591,5,11.47a18.874,18.874,0,0,1,.983-4.193c-.889-2.4-1.873-4.805-2.811-7.226-.022-1.588-.007-3.207-.151-4.779-.048-.533-.051-1.077-.063-1.606.336-1.54.467-3.192.646-4.67.091-.75.245-1.689.279-2.605,2.379,2.1,5.024,3.36,7.2,5.9,1.041,1.212,2.122,2.445,3.217,3.678a16.277,16.277,0,0,1-.97-2.632,9.115,9.115,0,0,1-.233-3.7c-.414-.473-.841-.954-1.3-1.4-1.917-2.042-4.921-3.068-6.586-5.329-1.529-2.08-2.341-4.543-3.542-6.868-1.327-2.574-3.3-4.444-4.775-6.91-1.657-2.773-1.873-6.11-3.072-9.175a58.157,58.157,0,0,0-2.648-5.8c6.451,2.207,13.1,4.151,19.089,7.27a84.023,84.023,0,0,0,11.418,5.246c2.284.784,4.5,1.9,6.794,2.677.762.646,1.521,1.286,2.247,1.973,3.079,2.913,6,6.106,9,9.148a.22.22,0,0,0,.114.066c.318.559.627,1.155.926,1.742a47.821,47.821,0,0,1,4.105,10.874c.682,2.955.8,5.983,1.364,8.946a20.329,20.329,0,0,0,2.224,6.624c.323.561.649,1.11.973,1.641.776,1.952,1.72,3.815,2.677,5.7a2.511,2.511,0,0,1,1.251-.9,2.41,2.41,0,0,1,.944-.318c-1.393-2.93-3.272-6.063-3.669-9.344-.44-3.644.458-7.34.407-10.983,2.294,1.76,4.97,2.864,7.343,4.563a75.48,75.48,0,0,1,10.226,8.786,3.431,3.431,0,0,1,.749-1.368,4.756,4.756,0,0,1,.659-.562c-1.817-2.1-3.411-4.4-5.186-6.533-3.341-4.011-8.856-5.855-11.623-10.331-2.79-4.518-4.778-9.832-7.847-14.054-.354-.487-.724-.976-1.088-1.438,4.49,1.415,9.009,2.8,13.427,4.265a148.2,148.2,0,0,0,20.28,5.676c2.8,1.8,5.811,3.258,8.415,5.551a111.639,111.639,0,0,1,9.681,9.85c3.869,4.375,7.65,9.087,11.818,13.218a8.094,8.094,0,0,1,1.086-1.41c.514-.549.443-2.139.6-2.911l.009-.034c-2.629-2.6-5.381-5.068-7.993-7.612-3.385-3.292-4.9-8.045-7-12.339,1.582.288,3.222.445,4.554.682,4.394.772,8.983,1.431,13.186,3.134,6.7,2.714,13.37,5.629,20.155,8.2.007-.144.028-.313.043-.49.053-1.418-1.472-4.048-2.618-4.271",
    transform: "translate(23.798 0.007)",
    fill: "#552517"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31079",
    "data-name": "Path 31079",
    d: "M212.3,56.9c.856.016,1.616.018,2.382.018a4.608,4.608,0,0,1-1.209,1.813c-.445-.079-.914-.173-1.337-.26.066-.627.1-.944.164-1.57",
    transform: "translate(99.222 26.615)",
    fill: "#241a13"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31080",
    "data-name": "Path 31080",
    d: "M201.329,32.9c-2.212,1.3-4.918,1.635-7.281,2.279-2.776.754-5.464,2.363-8.155,3.484a61.75,61.75,0,0,1-8.078,2.913c-2.544.658-5.262.84-7.684,2.052-.132.066-.207-.164-.092-.214a50.235,50.235,0,0,1,6.618-2.6c2.636-.712,5.3-1.659,7.891-2.592,2.765-1,5.516-2.284,8.287-3.248s5.824-1.4,8.42-2.357c.132-.05.2.216.075.286",
    transform: "translate(79.507 15.251)",
    fill: "#834b04"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31081",
    "data-name": "Path 31081",
    d: "M236.392,80.782c.163.063.078.371-.088.308-5.136-1.937-10.07-4.98-15.4-6.209a74.03,74.03,0,0,0-8.523-1.428c-1.286-.141-2.605-.439-3.86-.656-1.228-.211-2.563-.68-3.634-.922-.029-.007-.062-.051-.1-.068.019.01.057.026.07.056.938,2.451,2.768,5.143,4.165,7.717,1.349,2.489,2.162,5.111,3.98,7.276,2.356,2.795,6.578,3.7,7.7,7.682.035.123-.126.233-.179.09-.747-2.028-2.886-3.15-4.5-4.2a18.611,18.611,0,0,1-4.1-3.364c-1.538-1.763-2.144-4.422-3.071-6.625-1.234-2.94-3.1-5.529-4.308-8.388-.084-.2.109-.363.229-.266-.051-.094-.016-.258.084-.288,1.055-.335,2.021.521,3.163.718,1.249.213,2.532.426,3.765.669,2.641.521,5.4.606,8.048,1.214,5.839,1.339,10.989,4.51,16.563,6.681",
    transform: "translate(95.662 33.408)",
    fill: "#834b04"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31082",
    "data-name": "Path 31082",
    d: "M220.355,58.26c-2.5.365-5.187-.768-7.794-.853-2.771-.091-5.84,1.512-8.517,2.4a30.676,30.676,0,0,0-8.07,3.75,20.607,20.607,0,0,1-3.872,2.5.088.088,0,0,0-.065.035c1.951.542,3.978.842,5.661,2.21a.129.129,0,0,1,.012.173c-.247-.092-.483-.167-.759-.26a11.145,11.145,0,0,0-2.908-.951c-1.126-.376-2.25-.731-3.39-1.07a12.389,12.389,0,0,0,1.255-.942c1.262-.787,2.445-1.792,3.661-2.646a26.25,26.25,0,0,1,7.717-3.672,52.077,52.077,0,0,1,8.66-2.207,10.222,10.222,0,0,1,3.122.3c1.752.352,3.546.619,5.257.889.173.028.207.32.029.346",
    transform: "translate(89.177 26.518)",
    fill: "#834b04"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31083",
    "data-name": "Path 31083",
    d: "M178.918,27.4a20.956,20.956,0,0,1-2.363,2.849,27.844,27.844,0,0,0-2.761,4.76c-1.484,2.745-3.677,4.905-4.955,7.528-.054.113-.21.012-.163-.112a15.678,15.678,0,0,1,1.792-3.273,51.67,51.67,0,0,0,2.677-4.728,26.669,26.669,0,0,1,2.219-3.869c1-1.3,2.241-2.254,3.279-3.523.139-.173.418.125.274.367",
    transform: "translate(78.893 12.622)",
    fill: "#834b04"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31084",
    "data-name": "Path 31084",
    d: "M114.275,28.961c-.273.028-.55.065-.819.078-.23.012-.276.492-.05.462.694-.012,1.384-.048,2.074-.1q-.6-.216-1.205-.442",
    transform: "translate(52.975 13.546)",
    fill: "#834b04"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31085",
    "data-name": "Path 31085",
    d: "M172.865,41.887c-3.141.593-5.62,3.887-8.635,5.437-1.268.65-2.684.982-4,1.506a21.387,21.387,0,0,0-5.423,2.866c-.123.1-.25-.153-.129-.25a35.3,35.3,0,0,1,4.359-2.959c1.7-1.022,3.5-1.469,5.237-2.316,2.862-1.4,5.527-4.641,8.558-4.5.122.006.12.2.028.219",
    transform: "translate(72.329 19.488)",
    fill: "#834b04"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31086",
    "data-name": "Path 31086",
    d: "M228.8,78.95c.037.031-.025.084-.054.043a2.5,2.5,0,0,0-1.189-.722c-.028-.009-.01-.081.019-.07a3.728,3.728,0,0,1,1.224.75",
    transform: "translate(106.429 36.577)",
    fill: "#834b04"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31087",
    "data-name": "Path 31087",
    d: "M175.671,76.364c.137,1.8.2,3.706.269,5.58.057,1.57-.245,3.228-.258,4.816-.016,1.915.751,3.686,1.267,5.475a33.1,33.1,0,0,0,1.858,5.8c.059.119-.1.25-.181.144-.92-1.211-1.3-2.886-1.933-4.333a25.2,25.2,0,0,1-1.83-5.839,17.138,17.138,0,0,1,.254-4.874c.313-2.254-.129-4.6.09-6.771a.233.233,0,1,1,.465,0",
    transform: "translate(81.745 35.603)",
    fill: "#834b04"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31088",
    "data-name": "Path 31088",
    d: "M177.862,64.209c.116.094.01.31-.131.214a13.353,13.353,0,0,0-4.9-1.551,21.935,21.935,0,0,1-3.526-1.124c.082.087.176.179.247.254a.255.255,0,0,1,.211.079c2.313,2.426,4.287,5.88,6.3,8.827,1.993,2.927,3.26,6.438,5.169,9.4a19.353,19.353,0,0,0,3.426,3.442,35.869,35.869,0,0,0,4.117,3.1,21.23,21.23,0,0,1,5.852,5.872c.053.081-.034.182-.076.112a16.745,16.745,0,0,0-7.5-6.231,20.039,20.039,0,0,1-6.539-5.591,22.48,22.48,0,0,1-1.957-3.771c-.972-1.954-1.983-3.888-3.094-5.736-1.785-2.972-3.683-5.827-5.663-8.624a.137.137,0,0,1-.117-.09c-.418-.81-1.13-1.016-1.788-1.441a.2.2,0,0,1-.025-.292c-.217-.132-.433-.233-.627-.333-.235-.123-.148-.489.12-.426,1.911.449,3.766,1.292,5.7,1.794a12.48,12.48,0,0,1,4.8,2.112",
    transform: "translate(78.16 28.203)",
    fill: "#834b04"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31089",
    "data-name": "Path 31089",
    d: "M153.085,54.929c3.063,1.469,5.889,3.6,8.921,5.056,3.113,1.491,6.583,2.356,9.546,3.617.1.041.059.2-.046.157-3.163-1.233-6.517-1.767-9.69-3.119-3.078-1.314-5.928-3.361-8.978-4.879-5.778-2.868-12.072-4.168-17.986-6.687,1.3,1.538,1.843,4.038,2.345,6.065a51.4,51.4,0,0,0,4.409,11.809c1.139,2.15,2.453,4.182,3.769,6.187a38.349,38.349,0,0,1,2.442,4.9c.992,2.125,2.626,3.081,4.274,4.4a52.3,52.3,0,0,0,4.858,4.051c.138.084,0,.286-.119.207-1.479-.979-2.974-2.335-4.466-3.474-1.265-.961-2.934-1.522-4.022-2.808a20.8,20.8,0,0,1-2.488-4.682,67.825,67.825,0,0,0-3.647-5.94A46.847,46.847,0,0,1,137.2,58.585c-.906-3.131-1.256-8.263-3.84-10.05-.223-.156-.025-.647.214-.524.2.1.349.226.543.326,3.082,1.083,6.11,2.345,9.236,3.229a59.667,59.667,0,0,1,9.736,3.363",
    transform: "translate(62.331 22.448)",
    fill: "#834b04"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31090",
    "data-name": "Path 31090",
    d: "M143.339,73.346c-.859,3.2.04,6.129.22,9.417s1.44,6.324,2.1,9.373c.031.142-.169.238-.21.1-.891-2.963-2.642-5.677-2.726-8.9-.085-3.258-.468-7.069.462-10.057.032-.113.186-.062.154.06",
    transform: "translate(66.687 34.25)",
    fill: "#834b04"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31091",
    "data-name": "Path 31091",
    d: "M103.861,36.669c3.8,2.147,7.791,3.818,11.592,5.922a51.431,51.431,0,0,0,5.687,2.909c2.218.882,4.543,1.5,6.778,2.288,4.59,1.62,9.118,3.743,13.5,5.642.12.053.057.272-.066.22C137.1,51.9,132.614,50.5,128.23,49.071c-4.314-1.4-8.547-2.623-12.6-4.883-3.625-2.024-7.562-3.41-11.054-5.717-4.091-2.7-8.506-4.666-12.791-6.928.239,1.158.606,2.3.806,3.461.307,1.777.619,3.568.929,5.3.627,3.5,1.3,6.84,2.141,10.089a134.409,134.409,0,0,0,6.385,17.763c.038.092-.1.2-.144.1-2.514-5.312-5.326-11.1-7.08-17.338-.865-3.066-1.522-6.335-2.1-9.6-.307-1.725-.628-3.52-.907-5.277a45.7,45.7,0,0,1-.766-4.725c-.021-.389.226-.6.44-.509a.207.207,0,0,1,.192-.054c3.872.889,8.238,3.685,12.178,5.916",
    transform: "translate(42.587 14.382)",
    fill: "#834b04"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31092",
    "data-name": "Path 31092",
    d: "M95.3,54.384a86,86,0,0,1-.407,13.276c-.437,4.544-.8,9.068-1.014,13.513-.006.087-.078.07-.088.012-.649-3.7-.183-8.053.244-12.138.5-4.835.936-9.774.985-14.65a.14.14,0,1,1,.28-.013",
    transform: "translate(43.719 25.372)",
    fill: "#834b04"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31093",
    "data-name": "Path 31093",
    d: "M109.057,27.244c-5.042-2.224-10.185-4.609-14.991-7.3C84.364,14.5,74.907,7.672,65.361,1.8c-.848-.521-1.729-1.005-2.6-1.474A9.512,9.512,0,0,0,61.271.194C60.309.2,59.322.109,58.322.031A71.346,71.346,0,0,1,66.07,4.157c9.511,5.9,19.015,12.486,28.826,17.666,4.851,2.558,10.08,4.832,15.107,6.948.395.166.778.327,1.158.461,2.661.6,5.31,1.281,7.938,2.011-3.217-1.723-6.777-2.558-10.042-4",
    transform: "translate(27.28 0.014)",
    fill: "#834b04"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14577",
    "data-name": "Group 14577",
    transform: "translate(75.367 2.591)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14576",
    "data-name": "Group 14576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14575",
    "data-name": "Group 14575",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31094",
    "data-name": "Path 31094",
    d: "M300.52,108.785c-4.776-2.325-9.714-4.082-14.512-6.332-4.551-2.137-9.247-2.875-14-4-2.235-.53-4.472-1.133-6.662-1.807a56.683,56.683,0,0,0-9.913-5.092c-.427-.159-.866-.327-1.312-.511a37.174,37.174,0,0,0,5.017-2.344c3.1-1.635,6.257-2.949,9.48-4.321.468-.175.358-.994-.16-.906-6.024,1.005-11.875,6.123-17.93,4.9A106.433,106.433,0,0,1,230.58,82.46c-9.257-3.87-18.266-8.654-27.5-12.78,5.692-3.236,11.1-8.35,16.562-10.97,4.8-2.3,9.9-3.452,14.8-5.381,4.758-1.87,9.524-3.881,14.335-5.391.283-.088.307-.7-.019-.669-5.015.371-9.736,2.3-14.61,4.027-4.659,1.648-9.546,2.476-14.13,4.412a71.19,71.19,0,0,0-8.347,4.314A90.961,90.961,0,0,1,197.165,64.4a38.216,38.216,0,0,1-7.553.668c-2.77-1.324-5.569-2.547-8.31-3.91-3.533-1.755-6.964-4.1-10.49-5.8-7.173-3.449-15.309-5.447-22.647-8.423a106.948,106.948,0,0,1-12.148-6.065,29.142,29.142,0,0,0,3.32.023c.518-.023,1.045-.079,1.569-.131a60.58,60.58,0,0,1-7.867-3.929c-2.1-1.258-4.19-2.585-6.27-3.932a19.24,19.24,0,0,0-4.163-.288,30.562,30.562,0,0,0-5.874-2.957c-3-1.032-6.219-1.528-9.047-3.026a1.112,1.112,0,0,0-1.4.247c-1.88-.687-3.763-1.374-5.616-2.1Q83.547,15.893,66.213,7.451a16.258,16.258,0,0,1-3.779-1.819q-1.788-.859-3.577-1.711a9.654,9.654,0,0,1-2.316-.693A20.382,20.382,0,0,1,54.876,2.02l-.533-.255c-.426,1.2-.813,2.419-1.171,3.631a10.191,10.191,0,0,0,1.227.236,1.775,1.775,0,0,1,1.114.939c.144.26-.023.866-.263.906a3.721,3.721,0,0,1-2.538-.455c-.25.931-.489,1.86-.7,2.789a13.254,13.254,0,0,1,3.575,2.834c.3.291-.048,1.155-.373.95a12,12,0,0,0-3.661-1.522c-.081.421-.141.845-.21,1.265a16.679,16.679,0,0,0,3.6,2.959c.38.09.751.183,1.111.305a3.294,3.294,0,0,1,2.139,1.449.622.622,0,0,1-.072.669c1.113.52,2.222,1.051,3.319,1.6,4.933,2.472,10.029,4.6,14.851,7.342,4.484,2.555,8.962,5.544,13.723,7.254,1.8.64,3.621,1.139,5.479,1.6a4.3,4.3,0,0,0,.721.272,47.16,47.16,0,0,1,4.835,4.212c4.358,4.48,5.392,11.208,6.934,17.6,1.278,5.3,2.745,11.306,5.14,15.774a51.5,51.5,0,0,0,8.357,11.244c.332.327.793-.123.531-.512-1.481-2.216-2.922-4.678-4.231-7.03-1.67-3-2.18-6.386-2.938-9.9-.618-2.868-1.521-5.671-2.229-8.579-.828-3.377-1.13-6.942-1.865-10.464a33.57,33.57,0,0,0-2.921-8.539,19.954,19.954,0,0,1,6.054,2.228c.345.211.669-.15.773-.568a154.094,154.094,0,0,0,14.641,8.572,87.2,87.2,0,0,0,11.453,4.444c3.319,2.216,7.634,3.051,11,4.56,2.755,1.239,5.42,3.026,8.187,4.4,1.032,1.261,2.055,2.592,3.038,3.925a94.373,94.373,0,0,0,6.17,7.634,17.794,17.794,0,0,1,4.127,7.249c1.981,5.933,6.465,10.122,8.821,15.872a20.425,20.425,0,0,1,1.5,10.177,11.085,11.085,0,0,0,.684,6,.384.384,0,0,0,.729-.183c-.321-6.144,2.036-11.849-.484-17.422-2.852-6.305-7.393-12.48-8.963-19.308-.6-2.592-2.285-4.631-3.825-6.586-.383-2.011-.794-4.262-1.378-6.411,5.1,2.235,10.16,4.625,15.27,6.7,6.427,2.618,12.8,5.39,19.172,8.164,2.632,2.85,6.534,4.027,9.266,6.782,3.376,3.4,7.45,7.237,10.042,11.539,1.22,2.024,1.92,4.4,3.141,6.407a19.08,19.08,0,0,1,3.122,7.314c.575,3.7.545,7.4,1.7,10.957.059.188.346.128.345-.094-.217-4.77,1.143-10.211-.051-14.823-.627-2.417-1.876-4.333-2.649-6.637a29.764,29.764,0,0,0-2.676-6.142,61.6,61.6,0,0,0-6.451-8.633c7.224,2.915,14.55,5.6,22.007,7.841,4.945,1.482,9.964,2.881,14.889,4.38,2.231.681,4.49,1.46,6.727,2.188.31.2.615.393.922.568,3.238,2.049,8.484,3.781,10.415,7.48.953,1.826,1.754,3.534,3.571,4.2.205.075.486-.308.276-.527-2.067-2.114-2.7-5.645-4.317-8.209a12.4,12.4,0,0,0-.841-1.165c3.752.6,7.541,1.231,11.3,1.936,4.965.933,9.925,2.789,14.786,4.124.426.117.618-.553.213-.751",
    transform: "translate(-51.349 -1.765)",
    fill: "#994d08"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14580",
    "data-name": "Group 14580",
    transform: "translate(75.346 2.571)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14579",
    "data-name": "Group 14579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14578",
    "data-name": "Group 14578",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31095",
    "data-name": "Path 31095",
    d: "M274.377,97.292c-4.136-1.645-8.577-2.482-12.762-4.013-2.037-.743-4.154-1.388-6.253-1.939,4.622-1.962,9.342-5.136,13.629-7.921.4-.26.207-1.024-.257-.875-4.255,1.187-8.357,3.807-12.311,5.958a19.748,19.748,0,0,1-4.645,2.031c-.906-.2-1.794-.39-2.689-.524-.32-.062-.354.486-.087.644a.167.167,0,0,1,.082.045c-.135-.015-.276-.023-.412-.047-1.65-.283-3.232-.828-4.892-1.013-.1-.044-.169.183-.079.276.377.226.763.439,1.177.66-1.814-.286-3.7-1.826-5.39-2.326a3.476,3.476,0,0,1-.517-.137.455.455,0,0,0,.217-.668c2.416.749,4.852,1.422,7.321,2.05.352.122.53-.486.183-.641-6.514-2.946-13.179-5.708-19.941-8.117-5.759-2.335-11.218-5.47-16.907-7.964C206.462,71.289,203,69.9,199.511,68.65a37.72,37.72,0,0,0,4.716-.932,21.314,21.314,0,0,0,6.106-2.956.544.544,0,0,0,.135-.678c1.745-.74,3.492-1.526,5.278-2.231a38.086,38.086,0,0,1,4.484-1.237c1.28-.336,2.347-1.613,3.546-2.191a116.419,116.419,0,0,1,11.156-4.792c.468-.169.354-1.041-.147-.922a58.7,58.7,0,0,0-11.5,3.754c-1.456.6-2.756,1.7-4.293,1.98a17.074,17.074,0,0,0-3.612,1.022c-3.631,1.494-7.142,3.715-10.921,4.864a72.289,72.289,0,0,1-10.169,2.162.333.333,0,0,0-.232.373c-.55-.179-1.118-.317-1.663-.5A43.754,43.754,0,0,0,205.4,63.895c.433-.148.31-.939-.106-.818-6.818,1.562-13.149.646-19.938.766a.438.438,0,0,0-.282.085c-3.528-1.522-7.074-3-10.635-4.39a244.066,244.066,0,0,0-25.072-10.111c-.148-.035-.22.214-.085.286,4.452,2.367,9.162,4.286,13.653,6.341.047.021.106.06.175.092a1.281,1.281,0,0,0-.126.258c-1.415-.486-2.836-.972-4.243-1.509-1.343-.512-2.662-1.073-3.972-1.635a.465.465,0,0,0-.251-.423c-1.6-.832-3.319-1.682-4.905-2.585-5.284-3.006-10.616-6.38-16.1-9.132a30.256,30.256,0,0,0,6.534-.722,58.839,58.839,0,0,1-7-3.558c-.928-.553-1.852-1.126-2.773-1.7-1.071-.112-2.141-.242-3.2-.424-2.74-.468-5.538-1.135-8.359-1.628-.638-.239-1.268-.448-1.893-.646A136.109,136.109,0,0,1,102.5,26.915c-.345-.154-.687.057-.929.451-.988-.471-2-.866-2.99-1.274C93.261,21.738,86.964,18.748,80.97,15.7,75.338,12.835,69.6,9.735,63.828,6.948c-.026-.277-.147-.521-.379-.568A16.566,16.566,0,0,1,58,3.729a5.919,5.919,0,0,1-1.453-.493c-.749-.395-1.41-1.171-2.183-1.484Q53.724,3.566,53.178,5.4a10.6,10.6,0,0,0,1.227.236,1.766,1.766,0,0,1,1.115.938c.142.261-.025.866-.264.906a3.7,3.7,0,0,1-2.532-.451c-.252.931-.49,1.858-.7,2.781A13.365,13.365,0,0,1,55.6,12.651c.3.292-.048,1.157-.373.95a11.947,11.947,0,0,0-3.669-1.522c-.076.417-.153.831-.22,1.243.026.032.053.059.079.088a157.084,157.084,0,0,1,17.83,10.284c.465.327.931-.876.5-1.3a2.783,2.783,0,0,0-.314-.285c1.077.552,2.144,1.088,3.206,1.65a.378.378,0,0,0,.147.163A56.476,56.476,0,0,0,86.242,32.4c2.523,1.2,5.14,2.137,7.729,3.117a19.2,19.2,0,0,0,3.5,1.4c.994.449,1.977.888,2.944,1.412a.319.319,0,0,0,.363-.048,29.781,29.781,0,0,1,3.433,6.917c1.889,5.193,2.513,10.766,4.342,15.643.087.23.433.087.365-.153-.473-1.958-.756-4.016-1.047-6.078.5,1.758,1,3.537,1.5,5.3,1.129,3.978,1.6,9.59,3.716,12.84,1.488,2.282,3.211,4.207,4.549,6.661a38.577,38.577,0,0,0,3.687,5.6c.018.047.084.022.065-.044a66.959,66.959,0,0,0-3.841-7.251c-1.422-2.109-3.116-4.249-3.857-6.9-1.4-4.982-2.011-10.509-3.075-15.9-.556-2.809-1.3-6.047-2.279-9.345a.753.753,0,0,0,.154-.693A21.551,21.551,0,0,0,106.5,39.5c2.79.925,5.526,1.939,8.266,3.068a3.6,3.6,0,0,1,.509.2,74.5,74.5,0,0,1-7.113-2.621c-.358-.154-.569.567-.225.773,5.664,2.934,11.652,4.579,17.4,7.195a55.305,55.305,0,0,0,9.813,3.154c5.388,2.225,10.585,5.442,16.061,7.412.39.178.776.363,1.154.561,1.32.611,2.808,1.088,4.143,1.829a1.147,1.147,0,0,0,.189,1.377c6.418,4.932,13.108,10.1,16.358,17.9,1.43,3.439,2.886,6.907,4.6,10.111,1.893,3.533,4.56,6.564,5.507,10.646.081.351.474.2.456-.117-.288-4.81-3.029-7.072-4.72-11.258-1.67-4.136-2.837-8.7-4.779-12.744a34.638,34.638,0,0,0-16.207-16.213,2.347,2.347,0,0,0-.478-.452c.169.012.314.059.473.075,3.771,2,7.623,3.352,10.673,6.959.185.239.518-.123.341-.358-.615-.8-1.275-1.6-1.968-2.354a44.973,44.973,0,0,1,5.268,4.676c.355.363.879-.374.553-.763a38.589,38.589,0,0,0-3.718-3.873,25.514,25.514,0,0,0,3.534.842c3.363,1.017,6.769,1.877,10.045,3.154,5.175,2.017,10.32,4.532,15.64,5.734.556.125.869-.889.313-1.061C194.512,72.095,186.5,68.4,186.5,68.4s13.2,4.949,19.9,7.16c-.343.016-.393.641-.085.822,6.586,2.943,13.835,4.231,20.4,6.688,3.643,1.361,7.474,2.811,11.266,4-6.172-1.524-12.2-3.916-18.284-5.795-6.6-2.039-13.158-4.381-19.773-6.47-.314-.079-.454.4-.166.55a148.345,148.345,0,0,0,18.388,7.678c-.227-.035-.452-.069-.685-.084-.815-.317-1.659-.656-2.464-.95-3.564-1.3-7.086-3.217-10.839-3.574l-.022,0c-2.552-1.764-5.456-2.63-8.257-3.746-3.743-1.487-7.574-2.991-11.341-4.334-.55-.2-.838.784-.3,1.016,3.342,1.456,6.822,2.611,10.233,3.876,3.031,1.12,6.3,1.948,9.1,3.754a.645.645,0,0,0,.363.731c1.641.614,4.955,1.813,4.955,1.813s-.476-.094-.69-.147a.265.265,0,0,0-.329.2.586.586,0,0,0-.129.942c3.047,2.059,6.214,4.079,9.712,4.829a42.016,42.016,0,0,1,7.568,9.373c1.482,2.392,3.474,5,4.06,7.916a38.724,38.724,0,0,0,1.18,4.836c.132.346.663.151.547-.233-.716-2.74-.615-5.764-1.848-8.331a67.423,67.423,0,0,0-3.44-6.251c-2.42-3.92-5.164-7.829-9.008-9.8-.415-.213-.756.252-.746.715-1.78-.892-3.528-1.962-5.316-2.9,1.289.3,2.564.589,3.879.844,4.107,1.488,8.288,2.98,12.363,4.5.559.208.87-.85.317-1.076-1.218-.495-2.435-1.024-3.68-1.537,2.949.756,5.874,1.66,8.834,2.507,3.233.922,6.5,1.7,9.712,2.736,1.221.39,2.538.86,3.782.327a13.37,13.37,0,0,0,6.741,1.19c3.31,1.167,6.822,1.805,10.041,2.958,3.9,1.39,7.794,1.757,11.789,2.7a.278.278,0,0,0,.153-.521",
    transform: "translate(-51.335 -1.752)",
    fill: "#b56c25"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14583",
    "data-name": "Group 14583",
    transform: "translate(81.047 0.112)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14582",
    "data-name": "Group 14582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14581",
    "data-name": "Group 14581",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31096",
    "data-name": "Path 31096",
    d: "M73.787,10.645c-2.07-3.382-5.166-4.149-8.007-5.492-3.379-1.6-6.749-3.4-10.123-5.077-.144.025-.3.044-.439.078.239.451.467.922.713,1.352l.07.072a11.84,11.84,0,0,0,3.029,1.457c2,.468,3.562,2.57,5.376,3.762,2.982,1.073,6.847,1.3,9.187,4.139.094.159.286-.175.192-.291",
    transform: "translate(-55.219 -0.076)",
    fill: "#b56c25"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14586",
    "data-name": "Group 14586",
    transform: "translate(75.344 12.9)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14585",
    "data-name": "Group 14585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14584",
    "data-name": "Group 14584",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31097",
    "data-name": "Path 31097",
    d: "M58.832,12.424c-1.121-.68-2.307-1.372-3.448-2.1a.175.175,0,0,1-.159-.013,12.151,12.151,0,0,0-3.666-1.522c-.075.415-.159.829-.226,1.243l.007.009a65.177,65.177,0,0,0,7.16,3.537c.454.2.765-.891.332-1.154",
    transform: "translate(-51.333 -8.789)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14589",
    "data-name": "Group 14589",
    transform: "translate(77.18 3.923)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14588",
    "data-name": "Group 14588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14587",
    "data-name": "Group 14587",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31098",
    "data-name": "Path 31098",
    d: "M64.85,10.247A133.686,133.686,0,0,0,53.312,2.673c-.254.762-.5,1.532-.728,2.3a10.338,10.338,0,0,0,1.236.239,1.768,1.768,0,0,1,1.115.939.425.425,0,0,1,.041.122,92.706,92.706,0,0,1,9.664,4.719c.3.185.49-.565.21-.741",
    transform: "translate(-52.584 -2.673)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14592",
    "data-name": "Group 14592",
    transform: "translate(81.311 9.065)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14591",
    "data-name": "Group 14591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14590",
    "data-name": "Group 14590",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31099",
    "data-name": "Path 31099",
    d: "M68.789,13.719c.4.332-.022,1.51-.47,1.212-4.048-2.709-8.475-4.506-12.6-6.906-.665-.387-.178-2.106.509-1.817a50.463,50.463,0,0,1,12.565,7.51",
    transform: "translate(-55.399 -6.176)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14595",
    "data-name": "Group 14595",
    transform: "translate(90.405 12.018)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14594",
    "data-name": "Group 14594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14593",
    "data-name": "Group 14593",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31100",
    "data-name": "Path 31100",
    d: "M77.478,18.6a.467.467,0,0,1,.2.432,77.1,77.1,0,0,1,7.7,5.166c.37.279-.031,1.237-.43,1.01-6.063-3.455-13.634-5.278-19.364-9.273-.547-.385-.382-2.143.379-1.949a37.25,37.25,0,0,1,6.308,2.291c-.892-.716-1.78-1.408-2.7-2.036-2.5-1.707-5.234-3.182-7.757-4.879-.429-.289-.151-1.322.326-1.155,5.7,1.986,10.126,7.516,15.345,10.393",
    transform: "translate(-61.595 -8.188)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14598",
    "data-name": "Group 14598",
    transform: "translate(99.528 24.002)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14597",
    "data-name": "Group 14597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14596",
    "data-name": "Group 14596",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31101",
    "data-name": "Path 31101",
    d: "M75.693,20.829c.04-.373.327-.784.6-.633a128.419,128.419,0,0,1,13.876,8.3c.363.261-.015,1.173-.376.956-3.991-2.42-8.3-4.036-12.175-6.744.144.6-.385,1.443-.862,1-2.66-2.476-5.762-4-8.7-5.9-.524-.338-.164-1.7.407-1.4a43.228,43.228,0,0,1,7.221,4.434",
    transform: "translate(-67.81 -16.353)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14601",
    "data-name": "Group 14601",
    transform: "translate(101.867 15.389)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14600",
    "data-name": "Group 14600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14599",
    "data-name": "Group 14599",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31102",
    "data-name": "Path 31102",
    d: "M79.081,17.162c.062-.442.351-.842.668-.652,2.409,1.466,4.7,3.611,7.1,5.224,2.111,1.421,4.418,2.033,6.335,3.892.407.395,0,1.515-.446,1.206-4.276-2.958-9.046-4.067-12.891-8.246-.031.508-.467.991-.765.643-2.8-3.269-6.371-4.588-9.471-7.186-.528-.442.056-1.758.578-1.532a20.62,20.62,0,0,1,8.89,6.65",
    transform: "translate(-69.404 -10.485)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14604",
    "data-name": "Group 14604",
    transform: "translate(115.57 28.411)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14603",
    "data-name": "Group 14603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14602",
    "data-name": "Group 14602",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31103",
    "data-name": "Path 31103",
    d: "M86.14,22.94a.442.442,0,0,1,.266.032,80.164,80.164,0,0,1,11.354,7.337.679.679,0,0,1,.182.727c.12-.269.364-.4.577-.23a38.792,38.792,0,0,0,8.089,4.773c.561.272.217,1.468-.358,1.233-2.806-1.148-6.46-1.967-8.3-5.159a.645.645,0,0,1-.043-.517c-.156.323-.48.552-.757.348-3.517-2.595-7.917-3.63-11.165-6.991-2.316-1.224-4.637-2.5-6.95-3.671-.6-.3-.185-1.7.414-1.431a66.2,66.2,0,0,1,6.7,3.549",
    transform: "translate(-78.74 -19.357)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14607",
    "data-name": "Group 14607",
    transform: "translate(127.314 30.88)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14606",
    "data-name": "Group 14606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14605",
    "data-name": "Group 14605",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31104",
    "data-name": "Path 31104",
    d: "M105.283,29.1c3.928,2.072,7.927,4.047,11.824,5.978.459.227.159,1.24-.308,1.044-2.924-1.223-5.975-2.426-8.9-3.923a.5.5,0,0,1-.734.173,36.632,36.632,0,0,0-6.416-3.606c-.132.31-.39.525-.685.415-.682-.252-1.412-.521-2.121-.785,1.83,1.234,3.63,2.555,5.407,3.865.073-.358.319-.691.665-.562a40.106,40.106,0,0,1,6.721,3.562c-.114-.493.227-1.123.713-.961a92.39,92.39,0,0,1,9.992,4.061,31.2,31.2,0,0,1-3.574-2.37c-.41-.327,0-1.324.437-1.076,1.5.845,2.968,1.993,4.389,2.947.336.226.164.86-.129,1.014,1.612.784,3.236,1.585,4.8,2.379.056-.018.07-.009.081,0,2.325,1.372,5.542,2.387,8.112,4.069,4.123,1.789,8.24,3.592,12.405,5.215.163-.308.459-.54.763-.345.87.567,1.829,1.105,2.733,1.654.509.2,1.038.4,1.532.574a.359.359,0,0,1,.151.486,87.245,87.245,0,0,0,12.122,6.382c.559.225.258,1.236-.307,1.049-5.915-1.934-11.723-5.977-16.85-8.7a.193.193,0,0,1-.1-.107c-3.954-1.34-7.882-2.842-11.714-4.576-.035-.016-.047.012-.076-.034l-.016,0c-1.745-.8-3.6-1.61-5.216-2.505a.511.511,0,0,1-.239-.451c-.851-.4-1.694-.79-2.536-1.218a.471.471,0,0,1-.543.172c-1.271-.48-2.611-.956-3.938-1.466.939.63,1.409.945,2.348,1.569.274.179-.035.694-.3.515-1.344-.9-2.817-1.764-4.146-2.649a.333.333,0,0,1-.123-.308c-2.687-1.054-5.368-2.193-7.952-3.511.957.6,1.952,1.218,2.881,1.792.492.305.183,1.43-.335,1.135-3.7-2.111-7.412-4.264-11.167-6.308-.063.283-.3.5-.528.345-4.455-3.094-9.439-5.909-13.594-8.908a.627.627,0,0,1-.189-.329,38.1,38.1,0,0,1-3.7-2.5c-.465-.368.025-1.427.5-1.233A83.077,83.077,0,0,1,96.1,25.41c.128-.361.408-.6.759-.473a37.394,37.394,0,0,1,8.422,4.167",
    transform: "translate(-86.741 -21.039)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14610",
    "data-name": "Group 14610",
    transform: "translate(126.856 39.211)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14609",
    "data-name": "Group 14609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14608",
    "data-name": "Group 14608",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31105",
    "data-name": "Path 31105",
    d: "M88.822,26.966A19.5,19.5,0,0,1,92.424,35c.087.515-.542.8-.675.318a23.211,23.211,0,0,0-2.014-4.7,12.938,12.938,0,0,1,.976,3.947.673.673,0,0,1-.207.527.43.43,0,0,1,.189.266c.663,2.075,1.208,4.32,1.679,6.442.145.653-.682,1.033-.879.41a61.016,61.016,0,0,1-1.66-6.48.578.578,0,0,1,.247-.616.36.36,0,0,1-.137-.2c-.7-2.827-2.068-4.891-3.427-7.22-.292-.5.216-1.237.609-.889a8.525,8.525,0,0,1,1.255,1.39c-.078-.142-.169-.286-.251-.427-.31-.553.329-1.325.693-.8",
    transform: "translate(-86.429 -26.715)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14613",
    "data-name": "Group 14613",
    transform: "translate(133.582 54.234)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14612",
    "data-name": "Group 14612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14611",
    "data-name": "Group 14611",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31106",
    "data-name": "Path 31106",
    d: "M91.972,37.287c.6,2.072.508,4.4,1.033,6.443a.3.3,0,0,1-.556.242c-.822-1.866-.98-4.133-1.421-6.266-.144-.7.756-1.067.944-.42",
    transform: "translate(-91.012 -36.951)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14616",
    "data-name": "Group 14616",
    transform: "translate(149.805 46.831)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14615",
    "data-name": "Group 14615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14614",
    "data-name": "Group 14614",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31107",
    "data-name": "Path 31107",
    d: "M110.551,36.975c.357.25.015,1.086-.355.85-2.627-1.681-5.479-3.141-7.99-5.052-.329-.252-.025-1.046.341-.829,2.633,1.562,5.406,3.223,8.005,5.031",
    transform: "translate(-102.065 -31.907)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14619",
    "data-name": "Group 14619",
    transform: "translate(191.895 70.651)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14618",
    "data-name": "Group 14618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14617",
    "data-name": "Group 14617",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31108",
    "data-name": "Path 31108",
    d: "M131.453,48.23a21.323,21.323,0,0,1,4.465,6.562c.1-.154.313-.2.4-.056A71.8,71.8,0,0,1,141.7,65.942c.1.247-.226.414-.327.2-.577-1.255-1.173-2.541-1.813-3.778a.228.228,0,0,1-.374-.012c-3.082-4.03-5.466-8.9-8.357-13.293-.3-.456.217-1.176.621-.825",
    transform: "translate(-130.742 -48.136)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14622",
    "data-name": "Group 14622",
    transform: "translate(176.191 57.691)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14621",
    "data-name": "Group 14621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14620",
    "data-name": "Group 14620",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31109",
    "data-name": "Path 31109",
    d: "M131.021,43.047a32.97,32.97,0,0,1,2.935,2.62c1.262.612,2.541,1.237,3.806,1.785.468.2.2,1.1-.272.916-.556-.214-1.145-.467-1.711-.7a29.764,29.764,0,0,1,5.115,8.416c.206.524-.43.888-.674.421-2.155-4.146-5.384-7.041-8.253-10.412a3.974,3.974,0,0,1-.525-.247,34.891,34.891,0,0,1,3.787,5.321c.279.454-.266,1.06-.575.611A24.378,24.378,0,0,0,125.6,43.4a.584.584,0,0,1-.261-.307c-1.672-.844-3.345-1.67-4.983-2.517-.6-.31-.264-1.493.363-1.227,3.192,1.352,6.349,2.934,9.512,4.477-.188-.5.361-1.1.79-.774",
    transform: "translate(-120.042 -39.306)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14625",
    "data-name": "Group 14625",
    transform: "translate(166.716 49.169)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14624",
    "data-name": "Group 14624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14623",
    "data-name": "Group 14623",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31110",
    "data-name": "Path 31110",
    d: "M174.689,48.456c-3.316.082-6.505,1.647-9.821,1.472-.351-.018-.575.427-.534.794a34.732,34.732,0,0,1-4.622-.694c-.412-.1-.568.787-.151.909a17.78,17.78,0,0,0,4.014.66c-.383.123-.437.882-.05,1,.025.009.059.023.091.038a1.578,1.578,0,0,0-.088.17c-6.273-2.407-13.324-4.054-19.059-6.344a.232.232,0,0,0-.151-.022c-1.088-.572-2.156-1.168-3.213-1.648-3.768-1.711-7.582-3.462-11.357-4.827a.434.434,0,0,0-.373.029c-1.344-.572-2.718-1.148-4.063-1.722a.375.375,0,0,0-.474.228c-.019-.009-.023-.035-.037-.05-1.525-1.726-7.158-3.561-10.747-4.927-.411-.157-.669.688-.261.881,3.577,1.682,7.121,3.443,10.754,4.91a.3.3,0,0,0,.338-.094.278.278,0,0,0,.123.1c1.341.593,2.708,1.182,4.054,1.748a.623.623,0,0,0,.276.282c4.1,1.857,8.331,3.561,12.445,5.429,1.344.611,2.679,1.322,4.02,1.958a.437.437,0,0,0,.138.211c5.048,3.624,10.92,5.947,16.29,8.862.407.223.75-.6.361-.851-1.811-1.162-3.69-2.262-5.57-3.286a62.806,62.806,0,0,1,11.824,4.763c.462.254.725-.646.267-.911-4.679-2.7-10.254-4.049-14.975-5.682a.28.28,0,0,0-.313.079c-.842-.449-1.686-.891-2.514-1.312.317.037.643.082.954.1a.409.409,0,0,0,.389-.232c3.721,1.145,7.483,2.1,11.156,3.36.025.006.035.04.05.054,2.131,2.272,8.274,4.1,12.394,6.217-1.472-.5-2.981-.938-4.434-1.418-.509-.169-.863.5-.7.942a58.053,58.053,0,0,0-6.377-2.384c-.718-.225-1.085,1.02-.4,1.356,5.206,2.52,10.864,3.988,15.695,7.662a.36.36,0,0,0,.525-.078q2.259,1.44,4.546,2.784a.439.439,0,0,0,.092.255c3.245,3.973,7.993,7.058,11.224,11.467.27.371.751-.116.49-.5a50.03,50.03,0,0,0-8.441-9.168,38.326,38.326,0,0,1,3.724,2.635c.412.33.81-.389.429-.729-1.089-.978-2.252-1.88-3.4-2.733,1.657.913,3.3,1.8,4.933,2.7.478.263.885-.7.421-1.01-3.683-2.41-7.634-4.612-11.246-7.039-.493-.332-.966.167-1,.655-1.761-1.176-3.515-2.375-5.215-3.647q1.979.667,3.919,1.38c5.313,2.689,10.613,5.329,15.73,8.522a.454.454,0,0,0,.138.631c5.861,2.8,12.42,4.581,18.442,6.8.194.072.288-.274.1-.36-5.271-2.473-11.553-4.389-17.289-6.763a.551.551,0,0,0-.1-.79c-1.209-.773-2.456-1.667-3.721-2.485,4.549,1.772,9.213,3.338,13.656,4.94a.394.394,0,0,0,.508-.191c.859.5,1.689,1,2.552,1.452-2.178-.731-4.336-1.518-6.5-2.287-.533-.191-.8.747-.279.95a86.109,86.109,0,0,0,9.345,3.379.527.527,0,0,0,.622-.408c.625.289,1.246.553,1.843.832-.371.1-.5.816-.041.958,3.512,1.077,7.029,2.335,10.574,3.407a80.476,80.476,0,0,0,10.816,4.7c.562.205.828-.779.295-1.02-4.641-2.081-9.165-5.373-14.04-6.7a.581.581,0,0,0-.479,1c-.316-.116-.647-.23-.97-.333.26-.273.291-.819-.1-.961A107.112,107.112,0,0,1,208.93,72.2c-.313-.164-.619.091-.737.456-9.6-3.976-19.561-7.61-28.7-12.116-.368-.182-.636.079-.722.449-.772-.291-1.546-.58-2.343-.84.385.1.624-.409.542-.809,5.227,2.162,10.82,3.568,15.538,6.876.4.28.791-.393.395-.712-5.291-4.264-11.764-5.959-17.824-8.366-.349-.141-.608.151-.677.508-2.8-1.591-5.624-3.166-8.529-4.512a20.4,20.4,0,0,0,9.427.088c.549-.147.373-1.151-.164-1.029-3.788.854-7.393-.126-11.121-.583,1.2.045,2.42.048,3.587.142.255.021.373-.3.307-.508,2.222-.38,4.494-1.5,6.709-1.688.555-.048.656-1.12.075-1.107m.994,12.94a.737.737,0,0,0-.208.411c-.809-.465-1.606-.9-2.45-1.3.885.3,1.75.583,2.658.889",
    transform: "translate(-113.587 -33.5)",
    fill: "#e4a167"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14628",
    "data-name": "Group 14628",
    transform: "translate(259.894 84.854)",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14627",
    "data-name": "Group 14627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14626",
    "data-name": "Group 14626",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31111",
    "data-name": "Path 31111",
    d: "M195.484,64.1c2.985.751,6.175,2.726,8.55,4.027a.494.494,0,0,1,.214.33c2.194.887,4.381,1.871,6.543,2.9.025-.223.185-.436.405-.4.2.029.41.078.611.123-.018-.009-.043-.016-.066-.026-.38-.144-.31-1.033.169-.942a128.1,128.1,0,0,1,16.894,4.6c.511.173.292.983-.17.976,3.458,1.264,6.89,2.746,10.18,4.325.327.156.161.746-.188.653-3.888-1.019-7.726-2.866-11.472-4.315a.622.622,0,0,1-.079-1.023c-3.2-.851-6.536-1.475-9.769-2.328,1.132.533,2.291,1.129,3.376,1.769a.4.4,0,0,1,.185.38,30.907,30.907,0,0,0,3.543.715c.283.038.258.53-.018.5a27.194,27.194,0,0,1-3.727-.75.347.347,0,0,1-.37.051c-.2-.112-.429-.244-.652-.342-.709-.214-1.4-.448-2.1-.721a.216.216,0,0,1-.075-.327,38.923,38.923,0,0,0-3.73-1.51c.737.326,1.46.659,2.165,1a.515.515,0,0,1,.263.583c.429.2.878.368,1.3.525.575.217.261,1.293-.307,1.069-1.079-.424-2.19-.933-3.261-1.444a18.112,18.112,0,0,1,2.692,3.3c.261.411-.249.931-.545.555-2.152-2.737-5.362-4.616-7.731-6.351a.6.6,0,0,1-.181-.213c-1.569-.7-3.132-1.477-4.717-2.18,1.275.772,2.535,1.582,3.822,2.3a.334.334,0,0,1,.377-.01,66.81,66.81,0,0,1,8.616,6.826c.351.3-.035.992-.4.691-.706-.586-1.4-1.19-2.106-1.76A88.572,88.572,0,0,1,219.6,84.3c.211.245-.147.606-.355.361a53.965,53.965,0,0,0-8.55-8.607.384.384,0,0,1,.238-.68c-.778-.584-1.528-1.176-2.3-1.732a.42.42,0,0,1-.461.073,94.083,94.083,0,0,1-9.65-5.313c-.524-.3-.088-1.283.445-1.077.709.274,1.413.6,2.094.936a.8.8,0,0,1-.01-.2,59.647,59.647,0,0,1-6.658-2.718.781.781,0,0,1-.211-1.215,124.128,124.128,0,0,1-16.765-5.068c-.649-.254-.295-1.457.354-1.218,5.687,2.106,11.868,3.818,17.538,5.88a.314.314,0,0,1,.178.382",
    transform: "translate(-177.071 -57.814)",
    fill: "#e4a167"
  }))))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31112",
    "data-name": "Path 31112",
    d: "M93.554,37.326a44.843,44.843,0,0,0-3.741-4.813C88.229,30.861,85.9,30.061,84,29.251c-2.3-.978-4.544-2.213-6.826-3.261a57.893,57.893,0,0,1-7.585-3.823c-.063-.041-.207.134-.134.2,3.661,3.1,8.246,4.59,12.348,6.8,2.012,1.083,4.129,1.879,6.091,3.1,2.071,1.287,3.489,3.781,5.372,5.4.11.094.393-.185.288-.33",
    transform: "translate(32.478 10.365)",
    fill: "#3a1d0b"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31113",
    "data-name": "Path 31113",
    d: "M101.191,22.248a131.3,131.3,0,0,0-11.682-7.233c-2.252-1.167-4.573-2.006-6.785-3.348-2.467-1.494-4.885-3.159-7.418-4.482-.073-.035-.211.192-.117.254,4.259,2.837,8.4,6.31,13.009,8.121,4.441,1.747,8.265,5.478,12.753,7.094.117.043.387-.308.241-.405",
    transform: "translate(35.154 3.359)",
    fill: "#3a1d0b"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31114",
    "data-name": "Path 31114",
    d: "M102.038,39.964c-1.9-3.242-6.184-5.111-9.411-6.772-4.745-2.442-9.254-5.306-14.076-7.613C73.92,23.362,69.512,20.891,64.7,19.05c-4.525-1.728-10.136-2.966-13.951-6.022-.125-.1-.445.161-.327.294,2.746,3.123,7.264,4.559,11.014,6.112a119.68,119.68,0,0,1,13.462,6.355c8.619,4.9,19.4,7.6,26.763,14.463.148.138.489-.106.382-.288",
    transform: "translate(23.57 6.084)",
    fill: "#2c0100"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31115",
    "data-name": "Path 31115",
    d: "M145.054,45.294c-3.107-1.8-6.509-2.982-9.633-4.789-3.319-1.917-6.718-3.674-10.042-5.577-6.482-3.716-12.527-8.378-19.329-11.5A220.454,220.454,0,0,1,84.316,11.48c-3.371-2.039-6.838-3.853-10.353-5.626-3.5-1.76-7.557-2.74-10.748-5.027-.157-.113-.558.213-.4.36,2.18,2.07,5.018,3.094,7.622,4.529C73.91,7.638,77.473,9.395,80.9,11.41c7.483,4.412,14.84,8.811,22.625,12.7,6.807,3.4,13.235,7.5,19.888,11.194,6.9,3.838,14.155,7.092,21.342,10.308.157.072.484-.21.3-.316",
    transform: "translate(29.363 0.376)",
    fill: "#2c0100"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31116",
    "data-name": "Path 31116",
    d: "M64.465,14.719c-2-1.568-4.463-2.272-6.521-3.753-1.983-1.425-3.631-2.833-5.972-3.592-.132-.044-.379.167-.288.305a11.368,11.368,0,0,0,3.344,2.729c-.641-.145-1.3-.283-2-.451-.183-.044-.589.3-.351.443,3.608,2.2,7.362,3.44,11.306,4.829.245.085.772-.286.483-.511",
    transform: "translate(24.166 3.447)",
    fill: "#2c0100"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31117",
    "data-name": "Path 31117",
    d: "M75.487,11.231a77.168,77.168,0,0,0-11.076-6.1,17.876,17.876,0,0,0-5.07-1.088c-1.9-.286-3.587-1.537-5.486-1.694a.365.365,0,0,0-.357.225c-.009.034-.021.065-.031.1-.078.235.23.157.324.059-.533.561,2.618,1.616,4.951,2.291-.018.066,0,.126.1.16,2.18.807,3.65,2.134,6.016,2.56,3.688.666,6.825,2.64,10.29,3.853.17.06.552-.213.339-.361",
    transform: "translate(25.003 1.098)",
    fill: "#2c0100"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31118",
    "data-name": "Path 31118",
    d: "M73.226,7.245c-2.984-1.776-5.908-3.715-9.307-4.529C61.083,2.036,58.654.144,55.7.128c-.147,0-.556.371-.3.464.059.019.119.041.178.063A.276.276,0,0,0,55.9.485l.012-.019a23.469,23.469,0,0,0,2.784,1.973A14.339,14.339,0,0,0,61.92,3.761c2.162.637,3.878.326,6.09,1.28,1.707.735,3.377,1.556,5.033,2.4.1.047.3-.131.183-.2",
    transform: "translate(25.875 0.06)",
    fill: "#2c0100"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31119",
    "data-name": "Path 31119",
    d: "M65.707,6.087a6.79,6.79,0,0,0-2.959-2.58,10.572,10.572,0,0,1-1.774-.4,7.215,7.215,0,0,1-2.043-1.415c-.1-.1-.289.041-.3.156-.116,1.115,1.143,2.225,1.956,2.839a2.637,2.637,0,0,0,.829.214c.364.091.878.345,1.261.456.95.273,1.786.788,2.733,1.049.137.037.4-.17.3-.316",
    transform: "translate(27.419 0.774)",
    fill: "#200"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31120",
    "data-name": "Path 31120",
    d: "M324.32,157.22c6.015-2.912,12.329-6.559,17.195-11.2,4.281-4.085,6.951-9.292,10.6-13.876.672-.844,1.368-1.654,2.071-2.46.217-.86.388-1.726.518-2.6,1.1-.552,2.21-1.083,3.32-1.622,4.327-4.664,8.466-9.234,10.612-15.43-1.456-5.086-6.031-9.546-10.011-12.834-3.408-2.817-7.058-5.282-10.7-7.757-.549-.319-1.091-.63-1.61-.926-17.942-10.237-37.372-13.955-58.84-8.532-11.868,3-26.876,7.465-35.679,15.231-4.3.432-8.456,1.082-12.141,1.8a59.527,59.527,0,0,0-14.109,4.623,96.432,96.432,0,0,0-14.57,10.466c-3.442,3.116-6.474,6.63-9.829,9.841-1.362,1.3-2.753,2.6-4.1,3.931q-1.325,1.631-2.611,3.275a5.639,5.639,0,0,0-1.026.647c-.225.27-.473.53-.69.8-2.265,2.867-3.15,6.533-5.188,9.42-.608,10.144,16.7,15.628,30.892,16.663,15.79,1.117,30.5.951,46.184,3.587,18.592,3.113,36.742,5.978,54.667-.217a3.566,3.566,0,0,0,1.62-1.086c1.02-.311,2.023-.644,3.019-1a.682.682,0,0,1,.412-.741",
    transform: "translate(87.706 36.247)",
    fill: "#c87b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14631",
    "data-name": "Group 14631",
    transform: "translate(241.52 125.548)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14630",
    "data-name": "Group 14630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14629",
    "data-name": "Group 14629",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31121",
    "data-name": "Path 31121",
    d: "M349.328,153.019A81.29,81.29,0,0,0,335.7,154.98c-.885.2-1.528-1.093-.644-1.522,6.015-2.913,12.33-6.559,17.195-11.2,4.281-4.085,6.953-9.292,10.6-13.876,5.972-7.49,13.378-13.053,16.515-22.1-1.45-5.092-6.021-9.559-10.007-12.85-3.473-2.869-7.193-5.375-10.907-7.9-.967.223-1.61,1.13-.65,1.835a117.752,117.752,0,0,1,10.166,7.948,13.41,13.41,0,0,1,.148,12.843c-4.293.929-8.737,1.654-12.69,2.586-7.358,1.7-14.729,3.326-22.216,4.654-17.2,3-37.325,4.2-50.81-6.21-1.026-.8-2.447.365-1.569,1.2a36.543,36.543,0,0,0,3.715,3.01.584.584,0,0,0,.371.619,20.407,20.407,0,0,1,6.634,5.517c-15.2,2.887-30.114,6.634-45.992,6.771-2.949.05-30.632-1.879-29.441-6,1.94-6.589,9.523-12.777,14.33-18.244a.323.323,0,0,0,.012-.474,78.5,78.5,0,0,0-8.751,6.743c-3.443,3.116-6.474,6.63-9.829,9.841a87.09,87.09,0,0,0-8.432,8.655c-2.593,3.282-3.371,7.625-6.162,10.628-1.5,1.619-4.192,1.648-6.2,1.82a104.413,104.413,0,0,0-21.375,4.594c-.164.1-.342.2-.5.311-5.961,3.9-5.961,11.18-1.366,15.693,5.177,5.071,14.1,6.769,22.045,7.485,22.23,1.957,44.884-1.321,66.819-3.841,13.261-1.534,26.587-.376,39.906-.066,17.783.44,34.329-1.538,50.344-7.706,1.255-.481,1.487-1.371,1.114-2.136.436-.182.838-.4,1.256-.6",
    transform: "translate(-164.552 -85.538)",
    fill: "#8b4a35"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14634",
    "data-name": "Group 14634",
    transform: "translate(229.672 128.624)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14633",
    "data-name": "Group 14633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14632",
    "data-name": "Group 14632",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31122",
    "data-name": "Path 31122",
    d: "M371.529,153.822c-10.613-2.815-21.385-2.243-32.053.178-.884.2-1.528-1.093-.643-1.522,6.013-2.912,12.329-6.559,17.193-11.2,4.281-4.085,6.953-9.292,10.6-13.876,5.978-7.5,13.384-13.06,16.521-22.114-1.456-5.086-6.031-9.546-10.012-12.834-2.071-1.71-4.227-3.288-6.421-4.82-.088.154-.065.33.159.47A36.542,36.542,0,0,1,374,93.938a8.4,8.4,0,0,0,2.723,3.358,27.264,27.264,0,0,1,3.15,6.029,1.525,1.525,0,0,0-.531.69c-5.071,13.358-18.273,16.2-33.68,20.478-6.693,1.867-12.483,5.82-19.53,3.7-9.9-2.974-20.73-5.852-29.852-10.28-.36-.227-.69-.465-1.049-.7a.668.668,0,0,0-.514-.1c-.489-.254-1-.477-1.468-.74-.647-.354-1.261.473-.619.82,1.5.884,2.972,1.651,4.458,2.438a46.161,46.161,0,0,1,11.752,12.476c-7.571.214-15.284.236-22.766,1.029-9.063.944-15.6,3.884-22.619,8.282-6.5,4.1-10.447,6.492-19.335,6.254a124.82,124.82,0,0,1-16.963-1.738,1.947,1.947,0,0,0-1.409-1.049c-4.748-.831-9-1.093-13.255-3.066-5.271-2.429-7.271-6.989-5.761-11.384.484-1.447,1.769-3.862,1.143-5.335-.213.252-.442.495-.647.754-2.595,3.282-3.373,7.625-6.163,10.628-1.108,1.195-2.872,1.525-4.522,1.683-2.122,3.1-3.545,6.5-3.031,9.906-13.491.075-29.946.982-36.68,11.171a1.916,1.916,0,0,0,.989,2.927c25.956,11.393,60.386,5.8,88.706,5.381,21.416-.3,42.967.157,64.4.028,13.7-.1,30.567,2.307,41.368-5.781a1.744,1.744,0,0,0,.762-1.412c6.916.807,14.045.807,18.6-2.7a5.1,5.1,0,0,0,2.224-3.217q-1.178-.332-2.347-.643",
    transform: "translate(-156.48 -87.634)",
    fill: "#8b4a35"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31123",
    "data-name": "Path 31123",
    d: "M308.6,133.138c1.067.26,2.14.495,3.213.69-1.061-.241-2.136-.473-3.213-.69",
    transform: "translate(144.344 62.274)",
    fill: "#c87b6b"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31124",
    "data-name": "Path 31124",
    d: "M388.936,181.374c6.584-1.139,13.66-2.9,19.618-6.019,5.241-2.745,9.247-7.014,14.021-10.412.878-.625,1.769-1.211,2.665-1.792a25.969,25.969,0,0,0,1.218-2.359c1.206-.228,2.423-.429,3.639-.643,5.447-3.288,10.687-6.537,14.46-11.9,0-5.291-3.164-10.839-6.082-15.1-2.5-3.649-5.325-7.026-8.146-10.409-.439-.458-.873-.907-1.29-1.334-14.421-14.793-32.067-23.729-54.2-24.442-12.235-.395-27.893-.244-38.5,4.792-4.257-.774-8.426-1.295-12.166-1.623a59.6,59.6,0,0,0-14.836.549,96.412,96.412,0,0,0-16.894,6.04c-4.17,2.043-8.055,4.585-12.165,6.746-1.669.876-3.363,1.736-5.03,2.645q-1.724,1.2-3.413,2.428a5.566,5.566,0,0,0-1.165.339c-.291.2-.6.379-.885.58-2.966,2.131-4.83,5.412-7.587,7.623-3.382,9.583,11.74,19.631,25.092,24.541,14.868,5.434,29.048,9.332,43.4,16.2,17.01,8.124,33.664,15.885,52.6,14.878a3.574,3.574,0,0,0,1.858-.6c1.066-.019,2.121-.063,3.179-.131a.682.682,0,0,1,.6-.6",
    transform: "translate(122.418 45.29)",
    fill: "#c87b6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14637",
    "data-name": "Group 14637",
    transform: "translate(347.394 142.075)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14636",
    "data-name": "Group 14636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14635",
    "data-name": "Group 14635",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31125",
    "data-name": "Path 31125",
    d: "M414.482,179.035a81.129,81.129,0,0,0-13.64-1.876c-.906-.048-1.165-1.474-.2-1.641,6.586-1.14,13.66-2.9,19.619-6.021,5.241-2.743,9.245-7.013,14.02-10.412,7.807-5.548,16.461-8.85,21.971-16.681.012-5.293-3.148-10.851-6.071-15.112-2.547-3.716-5.431-7.151-8.3-10.6-.992-.053-1.861.641-1.132,1.585a117.567,117.567,0,0,1,7.578,10.444,13.413,13.413,0,0,1-3.405,12.385c-4.381-.292-8.855-.822-12.909-1.017-7.541-.4-15.074-.87-22.637-1.659-17.362-1.866-37.037-6.261-47.123-19.994-.763-1.054-2.451-.323-1.841.724a36.7,36.7,0,0,0,2.74,3.917.584.584,0,0,0,.186.7,20.411,20.411,0,0,1,4.854,7.135c-15.407-1.421-30.776-1.934-46.075-6.188-2.847-.763-28.923-10.258-26.641-13.892,3.684-5.8,12.68-9.652,18.808-13.581a.321.321,0,0,0,.142-.452,78.988,78.988,0,0,0-10.271,4.066c-4.17,2.045-8.053,4.585-12.165,6.747A87.107,87.107,0,0,0,281.5,113.6c-3.4,2.438-5.347,6.4-8.856,8.516-1.887,1.142-4.485.427-6.464.037a104.488,104.488,0,0,0-21.812-1.485c-.188.056-.386.1-.57.163-6.8,2.1-8.815,9.1-5.646,14.7,3.578,6.3,11.689,10.4,19.126,13.282,20.826,8.015,43.5,11.118,65.284,14.751,13.169,2.184,25.658,6.976,38.374,10.949,16.972,5.332,33.419,8,50.514,6.489,1.341-.116,1.808-.907,1.66-1.745.471-.054.917-.15,1.374-.227",
    transform: "translate(-236.686 -96.799)",
    fill: "#8b4a35"
  }))))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31126",
    "data-name": "Path 31126",
    d: "M374.823,159.4c.954.543,1.92,1.066,2.9,1.55q-1.433-.788-2.9-1.55",
    transform: "translate(175.32 74.557)",
    fill: "#c87b6b"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14640",
    "data-name": "Group 14640",
    transform: "translate(0 108.458)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14639",
    "data-name": "Group 14639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14638",
    "data-name": "Group 14638",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31127",
    "data-name": "Path 31127",
    d: "M173.751,168.237c.681-1.049,1.378-2.108,2.1-3.166,3.875-5.677,8.817-11.589,12.078-17.1.007-.01.007-.016.013-.022a242.689,242.689,0,0,1,22.743-26.092c.47-.462-.4-.875-.878-.408a272.816,272.816,0,0,0-35.92,43.918c-.713.973-1.408,1.927-2.1,2.871Z",
    transform: "translate(80.354 -51.747)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31128",
    "data-name": "Path 31128",
    d: "M169.806,163.628c7.315-10.461,14.554-21.042,20.28-32.195.175-.341-.524-.484-.722-.135-6.286,11.253-13.839,21.853-21.548,32.33Z",
    transform: "translate(78.494 -47.138)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31129",
    "data-name": "Path 31129",
    d: "M159.687,163.364a100.111,100.111,0,0,1,6.973-10.16c1.011-1.315,2.112-2.645,3.2-3.991-1.83,2.9-3.539,5.727-5,8.466-1,1.877-1.977,3.776-2.935,5.685h1.667q1.2-2.444,2.516-5a205.823,205.823,0,0,1,10.822-17.843c2.243-2.808,4.449-5.67,6.479-8.613.178-.257-.349-.345-.53-.092-.549.743-1.117,1.491-1.681,2.222.235-.368.483-.747.722-1.114.335-.514-.731-.694-1.076-.188-2.312,3.4-4.626,6.819-6.853,10.142-2.736,3.225-5.545,6.393-8.037,9.48a96.983,96.983,0,0,0-7.838,11.01Z",
    transform: "translate(73.958 -46.874)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31130",
    "data-name": "Path 31130",
    d: "M199.311,160.318c8.652-7.422,17.44-14.677,26.438-21.668.458-.358-.336-.68-.8-.317-9.147,7.02-18.084,14.434-26.888,21.985Z",
    transform: "translate(92.64 -43.828)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31131",
    "data-name": "Path 31131",
    d: "M202.385,156.887q5.889-5.346,11.782-10.675c.574-.52-.528-1-1.121-.476q-6.226,5.544-12.433,11.15Z",
    transform: "translate(93.834 -40.397)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31132",
    "data-name": "Path 31132",
    d: "M190.955,163.279c5.344-5.225,10.712-10.417,16.2-15.491-3.364,3.442-6.706,6.92-9.932,10.478-1.481,1.631-2.913,3.308-4.312,5.012h2.285c1.239-1.59,2.5-3.162,3.794-4.7,5.56-6.6,11.641-12.794,17.581-19.075q4.209-3.553,8.937-7.151c.5-.377-.307-.721-.807-.355-1.322.973-2.62,1.959-3.867,2.928.782-.841,1.572-1.691,2.344-2.547.39-.433-.592-.616-.986-.2-2.281,2.4-4.528,4.783-6.763,7.1-9.066,7.665-17.7,15.756-26.215,24Z",
    transform: "translate(88.502 -46.789)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31133",
    "data-name": "Path 31133",
    d: "M185,164.49a397.489,397.489,0,0,1,27.042-34.209c.909-1.02-1.344-1.46-2.247-.467a401.953,401.953,0,0,0-28.04,34.675Z",
    transform: "translate(85.016 -48)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31134",
    "data-name": "Path 31134",
    d: "M148.875,163.744a120.941,120.941,0,0,1,17.805-32.368c.433-.565-.769-.746-1.2-.188a119.794,119.794,0,0,0-18.1,32.556Z",
    transform: "translate(68.935 -47.254)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31135",
    "data-name": "Path 31135",
    d: "M152.233,160.052a148.721,148.721,0,0,1,14.958-21.008c.23-.27-.377-.433-.622-.163a138.859,138.859,0,0,0-15.774,21.171Z",
    transform: "translate(70.533 -43.562)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31136",
    "data-name": "Path 31136",
    d: "M156.238,160.14a250.636,250.636,0,0,1,14.426-21.345c.2-.261-.363-.339-.564-.09a207.543,207.543,0,0,0-14.994,21.435Z",
    transform: "translate(72.549 -43.651)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31137",
    "data-name": "Path 31137",
    d: "M214.149,157.807q7.871-6.834,16.059-13.236c1.029-.8-.845-1.472-1.883-.663q-8.569,6.686-16.788,13.9Z",
    transform: "translate(98.944 -41.317)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31138",
    "data-name": "Path 31138",
    d: "M218.177,156.973q7.7-5.594,15.492-11.07c.646-.452-.471-.825-1.118-.373q-8.031,5.632-15.966,11.443Z",
    transform: "translate(101.306 -40.483)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31139",
    "data-name": "Path 31139",
    d: "M208.652,155.5c2.645-2.222,5.321-4.4,8.036-6.483.533-.409-.42-.782-.953-.367-2.865,2.225-5.685,4.518-8.467,6.85Z",
    transform: "translate(96.948 -39.012)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31140",
    "data-name": "Path 31140",
    d: "M207.483,161.547a220.7,220.7,0,0,1,34.357-25.495c.509-.3-.053-.7-.574-.4a226.372,226.372,0,0,0-35.584,25.891Z",
    transform: "translate(96.206 -45.058)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31141",
    "data-name": "Path 31141",
    d: "M307.807,154.66q5.8-2.021,11.639-3.8c.844-.258.076-.772-.766-.515-4.4,1.33-8.78,2.783-13.142,4.32Z",
    transform: "translate(142.913 -38.17)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31142",
    "data-name": "Path 31142",
    d: "M318.383,153.933c2.367-.53,4.744-1.01,7.127-1.415.8-.137.6-.8-.223-.68-3.641.525-7.246,1.252-10.829,2.094Z",
    transform: "translate(147.085 -37.443)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31143",
    "data-name": "Path 31143",
    d: "M299.548,155.274c4.233-1.959,8.479-3.879,12.749-5.726.741-.323,0-.809-.759-.486-4.656,1.99-9.286,4.074-13.9,6.211Z",
    transform: "translate(139.217 -38.785)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31144",
    "data-name": "Path 31144",
    d: "M287.359,154.583c2.34-1.2,4.669-2.4,6.966-3.631.729-.389-.44-.734-1.183-.346q-3.84,2.006-7.707,3.978Z",
    transform: "translate(133.51 -38.093)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31145",
    "data-name": "Path 31145",
    d: "M266.447,157.12c9-4.12,18.084-8.034,27.253-11.56.8-.307.044-.75-.76-.449q-14.788,5.522-29.239,12.009Z",
    transform: "translate(123.344 -40.63)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31146",
    "data-name": "Path 31146",
    d: "M274.89,161.049c15.3-8.469,30.853-16.518,46.593-23.9.634-.3,0-.743-.637-.445-16.035,7.519-31.854,15.739-47.446,24.341Z",
    transform: "translate(127.88 -44.56)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31147",
    "data-name": "Path 31147",
    d: "M273.792,148.508c-6.379,2.253-12.761,4.628-19.114,7.025h2.163c5.925-2.241,11.868-4.443,17.811-6.553.9-.321.034-.788-.86-.471",
    transform: "translate(119.123 -39.044)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31148",
    "data-name": "Path 31148",
    d: "M255.446,160.688c1.157-.668,2.326-1.35,3.523-2.024,13.189-7.421,26.943-14.146,40.52-20.83.556-.273.037-.619-.608-.363-14.033,5.579-27.525,12.68-40.8,20.076q-2.779,1.55-5.532,3.141Z",
    transform: "translate(118.128 -44.199)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31149",
    "data-name": "Path 31149",
    d: "M248.915,157.163q10.444-5.9,20.952-11.7c.788-.433-.44-.778-1.218-.355q-10.891,5.931-21.728,12.053Z",
    transform: "translate(115.495 -40.674)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31150",
    "data-name": "Path 31150",
    d: "M241.769,157.971q12.362-7.246,24.849-14.261c.734-.411-.411-.74-1.133-.333q-12.721,7.186-25.411,14.594Z",
    transform: "translate(112.292 -41.481)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31151",
    "data-name": "Path 31151",
    d: "M235.4,160.775c14.04-8.4,28.506-16.073,43.223-23.077.628-.3-.012-.694-.646-.4-15,7.11-29.733,14.915-44.028,23.474Z",
    transform: "translate(109.426 -44.286)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31152",
    "data-name": "Path 31152",
    d: "M228.348,160.791q3.549-2.409,7.135-4.767c-1.41,1.579-2.8,3.169-4.182,4.767h1.959c2.153-2.539,4.34-5.046,6.589-7.522a231.573,231.573,0,0,1,26.16-13.955c.931-.418,0-1-.931-.572a231.4,231.4,0,0,0-22.239,11.479,112.4,112.4,0,0,1,15.614-12.753c.368-.247-.241-.433-.621-.191a112.724,112.724,0,0,0-19.235,15.5q-6.2,3.9-12.226,8.018Z",
    transform: "translate(105.883 -44.301)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31153",
    "data-name": "Path 31153",
    d: "M220.625,160.475q9.1-6.675,18.508-12.931-8.485,6.336-16.769,12.931h3.52q7.745-6.224,15.681-12.154c1.318-.983-1.066-1.78-2.411-.794q7.389-4.753,14.909-9.244c.594-.355-.317-.63-.908-.294A355.51,355.51,0,0,0,218.6,160.475Z",
    transform: "translate(102.249 -43.986)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31154",
    "data-name": "Path 31154",
    d: "M158.562,161.611a207.871,207.871,0,0,1,17.813-25.765c.379-.461-.634-.621-1.01-.164a212.427,212.427,0,0,0-18.231,25.929Z",
    transform: "translate(73.498 -45.121)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31155",
    "data-name": "Path 31155",
    d: "M161.117,157.975c3.647-4.882,7.38-9.7,11.181-14.391.343-.423-.63-.574-.978-.141q-5.8,7.168-11.372,14.532Z",
    transform: "translate(74.815 -41.485)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31156",
    "data-name": "Path 31156",
    d: "M151.9,166.595c1.764-3.74,3.735-7.365,5.842-10.963q-2.814,5.445-5.46,10.963h1.544c2.3-4.838,4.675-9.637,7.163-14.354a91.649,91.649,0,0,1,21.42-26.98c.462-.4-.31-.715-.762-.335a91.619,91.619,0,0,0-19.929,23.57.709.709,0,0,0-.433.252,113.568,113.568,0,0,0-10.7,17.846Z",
    transform: "translate(70.436 -50.105)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31157",
    "data-name": "Path 31157",
    d: "M149.537,163.472a126.72,126.72,0,0,1,20.673-31.483c.408-.448-.41-.8-.845-.342-.624.655-1.2,1.317-1.8,1.979.059-.075.11-.141.167-.216.432-.546-.722-.719-1.146-.182a152.415,152.415,0,0,0-18.928,30.244Z",
    transform: "translate(69.067 -46.982)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31158",
    "data-name": "Path 31158",
    d: "M177.5,156.366c.468-.549.942-1.095,1.427-1.62a.19.19,0,0,0,.059-.211c2.052-2.444,4.176-4.976,6.366-7.565.307-.364-.549-.493-.856-.136-2.724,3.166-5.438,6.379-8.156,9.533Z",
    transform: "translate(82.48 -39.876)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31159",
    "data-name": "Path 31159",
    d: "M186.57,164.216a.176.176,0,0,1,.025-.031c11.633-13,24.445-24.742,39.171-33.708.574-.349-.035-.872-.618-.523a158.8,158.8,0,0,0-34.087,28c2.641-3.734,5.255-7.5,7.851-11.249.294-.42-.64-.591-.929-.178-4.136,5.943-8.394,11.843-12.711,17.686Z",
    transform: "translate(86.66 -47.727)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31160",
    "data-name": "Path 31160",
    d: "M173.955,165.728c4.23-4.755,8.5-9.495,12.8-14.121,8.062-8.658,17.755-16.1,25.709-24.674.247-.264-.364-.462-.622-.2-8.143,8.24-17.757,15.491-25.782,23.97-3.931,4.152-10.722,11.671-13.742,15.027Z",
    transform: "translate(80.602 -49.238)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31161",
    "data-name": "Path 31161",
    d: "M172.61,153.552c.169-.2.332-.389.465-.543.348-.4-.65-.524-1-.137-.2.229-.4.454-.6.68Z",
    transform: "translate(80.21 -37.062)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31162",
    "data-name": "Path 31162",
    d: "M179.7,154.9q1.57-2.336,3.118-4.8c.235-.374-.666-.52-.906-.139Q180.3,152.5,178.7,154.9Z",
    transform: "translate(83.583 -38.415)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31163",
    "data-name": "Path 31163",
    d: "M192.95,157.8a181.97,181.97,0,0,1,13.161-13.634c.487-.455-.464-.866-.963-.408A180.058,180.058,0,0,0,191.468,157.8Z",
    transform: "translate(89.557 -41.31)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31164",
    "data-name": "Path 31164",
    d: "M197.55,160.789q1.226-1.526,2.483-3.1c1.711-1.861,3.527-3.753,5.475-5.645q-3.155,4.335-6.154,8.745h1.337q4.443-6.519,9.232-12.8a80.092,80.092,0,0,1,9.741-7.237c-4.352,5.472-8.69,10.974-13.081,16.4-1,1.234-1.957,2.447-2.9,3.64h2.3q5.837-5.392,11.867-10.563c-2.927,3.528-5.834,7.07-8.8,10.563h4.487q2.18-1.852,4.547-3.768-1.737,1.834-3.357,3.768h1.723a95.025,95.025,0,0,1,16.926-15.149c.232-.164.252-.307.175-.423,3.578-2.558,7.2-5.056,10.885-7.455.574-.373-.343-.688-.9-.324a315.232,315.232,0,0,0-25.7,18.48c.112-.122.213-.245.33-.365a192.035,192.035,0,0,1,15.495-14.211c.608-.5-.492-.92-1.111-.424-1.353,1.083-2.667,2.183-3.936,3.269a.952.952,0,0,0-1.1.1q-8.348,7.521-16.261,15.562c.675-.844,1.355-1.706,2.048-2.561,3.085-3.8,6.332-7.474,9.609-11.125,3.837-2.99,7.8-5.814,11.808-8.529.518-.351-.3-.653-.822-.314-2.591,1.66-5.04,3.333-7.368,4.987.6-.621,1.19-1.253,1.8-1.88.556-.569-.854-.807-1.4-.247-1.957,1.99-3.755,3.956-5.476,5.894-4.75,3.65-9.3,7.556-13.732,11.583.255-.329.5-.658.763-.985,4.368-5.436,8.695-11.01,13.056-16.465.183-.227.046-.4-.2-.484.189-.107.361-.225.545-.332.622-.368-.037-.9-.666-.539a78.771,78.771,0,0,0-9.869,6.713.9.9,0,0,0-.926.205c-.423.5-.816,1.027-1.22,1.535-1.036.878-2.033,1.766-3,2.648,2.128-2.7,4.292-5.478,6.47-8.291.527-.682-1.005-1-1.523-.317-4.656,6.057-9.517,12.082-14.346,18.074-.169.181-.346.355-.514.543q7.155-9.8,14.542-19.423c.276-.36-.525-.521-.807-.164-5.263,6.68-10.364,13.546-15.448,20.416Z",
    transform: "translate(91.008 -44.299)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31165",
    "data-name": "Path 31165",
    d: "M190.645,160.824c7.383-8.243,14.083-16.872,23.209-23.054.555-.377-.072-.938-.647-.546a75.473,75.473,0,0,0-11.021,8.983.945.945,0,0,0-.693.22c-.556.484-1.1.975-1.644,1.462a.949.949,0,0,0-.332.2c-.173.189-.333.379-.5.556-4.092,3.907-8.008,7.935-11.711,12.178Z",
    transform: "translate(87.612 -44.335)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31166",
    "data-name": "Path 31166",
    d: "M164.511,159.411q.764-1.372,1.569-2.781c1.03-1.415,2.077-2.853,3.181-4.311.2-.264-.078-.424-.42-.418,2.306-3.825,4.7-7.623,7.21-11.285.363-.531-.807-.715-1.168-.185-3.753,5.511-7.352,11.241-10.7,17.083-.468.638-.926,1.271-1.38,1.9Z",
    transform: "translate(76.151 -42.921)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31167",
    "data-name": "Path 31167",
    d: "M183.584,157.7c3.664-4.491,7.295-9.013,10.838-13.572.295-.382-.577-.528-.866-.154-3.583,4.616-7.32,9.192-11.1,13.726Z",
    transform: "translate(85.341 -41.215)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31168",
    "data-name": "Path 31168",
    d: "M168.919,164.664a401.872,401.872,0,0,1,29.544-35.154c.452-.48-.443-.9-.914-.408a389.229,389.229,0,0,0-30.19,35.562Z",
    transform: "translate(78.281 -48.174)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31169",
    "data-name": "Path 31169",
    d: "M170.991,166.535c.23-.342.454-.68.688-1.027q6.275-6.825,12.783-13.437a265.458,265.458,0,0,1,30.658-26.745c.352-.263-.189-.606-.553-.358a220.352,220.352,0,0,0-30.482,25.979q-5.641,5.643-11.137,11.459a.5.5,0,0,0-.225.157c-.078.1-.15.208-.222.321q-1.741,1.854-3.393,3.652Z",
    transform: "translate(79.099 -50.045)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31170",
    "data-name": "Path 31170",
    d: "M145.93,158.38c2.953-5.331,6.184-10.5,9.584-15.482.436-.636-.957-.823-1.388-.191-3.461,5.053-6.68,10.295-9.708,15.673Z",
    transform: "translate(67.55 -41.89)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31171",
    "data-name": "Path 31171",
    d: "M229.245,160.9q3.265-1.99,6.658-3.834c-1.857,1.286-3.721,2.555-5.58,3.834h4.02A283.666,283.666,0,0,1,262.88,144.04c.989-.521-.066-1.182-1.077-.655-6,3.12-11.949,6.383-17.757,9.888.025-.112-.069-.2-.223-.269q5.5-3.824,11.112-7.5c2.137-1.4,4.331-2.806,6.552-4.209s6.062-2.4,8.739-3.652c.9-.423,0-.983-.917-.565-2.483,1.132-5.243,2-7.855,2.991-2.476.941-4.983,3.088-6.873,4.306-4.772,3.072-9.555,6.555-14.2,9.558-.054.035-.109.076-.159.106a122.466,122.466,0,0,0-12.954,6.854Zm12.577-6.529c.035-.025.073-.047.109-.072.418-.167.84-.34,1.261-.511-1.635,1-3.235,1.992-4.782,2.984,1.13-.791,2.279-1.637,3.413-2.4",
    transform: "translate(106.302 -44.408)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31172",
    "data-name": "Path 31172",
    d: "M242.159,159.46c14.328-7.623,28.945-14.29,44.638-18.673,1.07-.3.549-1.007-.536-.706-16.4,4.521-31.612,11.41-46.52,19.379Z",
    transform: "translate(112.137 -42.97)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31173",
    "data-name": "Path 31173",
    d: "M239.038,160.885c10.546-6.059,21.26-11.889,32.133-17.215,1.064-.521-.048-1.206-1.139-.666q-10.568,5.218-20.908,10.869c.113-.078.232-.164.354-.242,9.849-6.326,20.5-12.185,31.747-15.881,1.005-.329.512-1.027-.511-.7-15.884,5.045-29.748,13.641-43.36,23.476-.208.119-.417.242-.621.361Z",
    transform: "translate(110.73 -44.395)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31174",
    "data-name": "Path 31174",
    d: "M223.053,162.036c1.929-1.4,3.857-2.8,5.8-4.173,2.771-1.788,5.777-3.562,9.062-5.313.587-.311.39-.684-.06-.791a220.867,220.867,0,0,1,30.481-16.493c1-.445.025-1.054-.978-.615a249.46,249.46,0,0,0-43.6,25.248c-1,.715-2,1.434-2.96,2.137Z",
    transform: "translate(103.277 -45.547)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31175",
    "data-name": "Path 31175",
    d: "M215.706,162.654a268.6,268.6,0,0,1,44.47-28.752c.832-.43-.029-1-.879-.569a259.5,259.5,0,0,0-40.46,25.235q3.824-3.509,8.1-7.215c.652-.562-.65-1.035-1.3-.47-4.378,3.779-8.7,7.713-12.907,11.771Z",
    transform: "translate(99.503 -46.165)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31176",
    "data-name": "Path 31176",
    d: "M219.028,156.814c4.3-3.609,8.71-7.075,13.2-10.408.776-.578-.63-1.057-1.406-.478q-6.964,5.191-13.6,10.886Z",
    transform: "translate(101.604 -40.324)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31177",
    "data-name": "Path 31177",
    d: "M291.356,155.1q4.742-1.671,9.495-3.324c1.185-.414.046-1.071-1.126-.656-.135.048-.261.092-.395.142,1.008-.42,1.987-.85,3.007-1.273.909-.373,0-.914-.906-.542-4.463,1.839-8.922,3.738-13.373,5.652Z",
    transform: "translate(134.737 -38.612)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31178",
    "data-name": "Path 31178",
    d: "M298.158,156.243q4.17-1.86,8.335-3.7c.8-.355-.026-.872-.847-.515-2.774,1.2-5.545,2.423-8.285,3.64,5.164-2.906,10.434-5.649,15.75-8.243.763-.374-.37-.756-1.118-.389-5.912,2.9-11.742,5.988-17.507,9.209Z",
    transform: "translate(137.743 -39.753)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31179",
    "data-name": "Path 31179",
    d: "M304.32,155.631c2.276-.914,4.554-1.824,6.806-2.714.81-.321.012-.834-.816-.509-.86.338-1.723.684-2.595,1.023,2.984-1.559,6.069-3.106,9.232-4.625.866-.417-.405-.86-1.267-.451-4.816,2.3-9.589,4.738-14.3,7.276Z",
    transform: "translate(140.97 -39.142)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31180",
    "data-name": "Path 31180",
    d: "M312.767,155.95q8.263-4.143,16.779-7.672c.888-.37.04-1.024-.856-.656q-9.185,3.765-18.14,8.328Z",
    transform: "translate(145.257 -39.46)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31181",
    "data-name": "Path 31181",
    d: "M315.863,153.786c.917-.373,1.835-.752,2.754-1.12.652-.263.022-.712-.649-.443q-1.953.782-3.913,1.563Z",
    transform: "translate(146.896 -37.296)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31182",
    "data-name": "Path 31182",
    d: "M245.759,158.456q8.721-4.817,17.648-9.285c-5.35,3-10.61,6.143-15.874,9.285h4.07c6.915-3.985,13.958-7.81,21.021-11.4.979-.5-.49-.911-1.452-.417q-10.033,5.178-19.863,10.729c1.468-.928,2.963-1.863,4.527-2.792a215.97,215.97,0,0,1,22.527-11.635c1.03-.465,0-1.08-1.048-.618-2.275.988-4.44,2-6.529,3.025-.1-.266-.746-.421-1.39-.12-8.8,4.088-17.544,8.511-26.092,13.232Z",
    transform: "translate(113.804 -41.966)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31183",
    "data-name": "Path 31183",
    d: "M251.8,158.382c11.823-5.47,23.792-10.607,35.907-15.284,1.13-.436.046-1.077-1.1-.64-12.65,4.846-25.179,10.189-37.51,15.924Z",
    transform: "translate(116.513 -41.892)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31184",
    "data-name": "Path 31184",
    d: "M258.68,162.961q2.47-1.4,4.946-2.789c.533-.223,1.073-.44,1.619-.665q-2.963,1.713-5.908,3.454h2.312q6.162-3.611,12.419-7.061,3.393-1.367,6.862-2.724-8.76,4.817-17.435,9.785h4.525q5.887-2.411,11.808-4.739c-1.594.807-3.135,1.617-4.606,2.359q-2.343,1.178-4.676,2.381h4.874c1.754-.715,3.511-1.43,5.271-2.128-.58.376-1.148.753-1.722,1.123-.653.333-1.3.672-1.957,1.005h2.1q6.169-3.161,12.363-6.27c1.378-.525,2.78-1.047,4.176-1.565-2.2,1.529-4.4,3.044-6.558,4.518-.815.555-1.637,1.105-2.475,1.659q-1.973.826-3.941,1.659h5.5q8.481-3.947,17.079-7.653a1.115,1.115,0,0,0,.317-.2c.383-.128.754-.269,1.133-.4q-6.442,4.027-12.731,8.255h5.507q4.859-2,9.712-3.98c.408-.164.452-.357.31-.5,1.06-.351,2.1-.715,3.156-1.06,1.137-.377.081-1-1.049-.621-4.689,1.557-9.385,3.2-14.035,4.935a269.834,269.834,0,0,1,31.391-18.3c.746-.373-.019-.919-.788-.539-6.542,3.217-12.976,6.768-19.308,10.483a1.9,1.9,0,0,0-1.205.032q-8.359,2.9-16.613,6.106c.385-.251.76-.511,1.139-.771q3.619-2.464,7.292-5.014c1.209-.443,2.4-.9,3.622-1.327,1.008-.358.324-.875-.628-.754q2.688-1.86,5.431-3.724,2.7-.949,5.392-1.882c1.11-.383.079-1.026-1.024-.643-.464.159-.919.324-1.387.486q10.18-6.851,20.848-12.856c.662-.373-.327-.725-.976-.363-8.033,4.46-15.825,9.367-23.5,14.481-1.684.59-3.4,1.165-5.064,1.758,5.586-3.216,11.174-6.474,16.678-9.8.5-.3-.3-.574-.82-.267-6.527,3.892-13.207,7.684-19.835,11.487q-15.986,5.792-31.733,12.153,8.342-4.72,16.77-9.279c.7-.38.132-.7-.612-.684,6.815-2.607,13.673-5.174,20.534-7.568,1.06-.37.082-.969-.973-.6-6.8,2.36-13.582,4.889-20.331,7.461.387-.192.762-.395,1.148-.591.826-.42.009-.775-.9-.637.768-.377,1.529-.765,2.3-1.136,1.049-.5-.06-1.164-1.121-.656-7.295,3.481-14.556,7.24-21.68,11.17q-3.518,1.491-7.032,3Zm45.507-13.726c-1.813,1.236-3.614,2.466-5.369,3.686-1.94.7-3.837,1.419-5.755,2.131a2.034,2.034,0,0,0-.87.194c-.3.157-.6.308-.9.461-.575.214-1.168.423-1.739.637,2.617-1.578,5.3-3.166,8.024-4.763,2.191-.79,4.394-1.565,6.608-2.345m-16.141,5.852c1.81-.674,3.631-1.353,5.463-2.024q-4.176,2.442-8.167,4.87-5.85,2.254-11.443,4.541c4.6-2.344,9.242-5,13.989-6.74.63-.23.559-.515.157-.647",
    transform: "translate(119.081 -46.472)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31185",
    "data-name": "Path 31185",
    d: "M319.474,154.618q4.454-1.8,8.934-3.527c.876-.339.044-.972-.844-.634q-5.378,2.032-10.748,4.161Z",
    transform: "translate(148.188 -38.128)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31186",
    "data-name": "Path 31186",
    d: "M323.764,154.235a61.629,61.629,0,0,1,6.314-2.227c.963-.267.536-1.046-.455-.774a78.559,78.559,0,0,0-8.416,3Z",
    transform: "translate(150.242 -37.745)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31187",
    "data-name": "Path 31187",
    d: "M154.765,156.233c-2.435,3.6-4.832,7.227-7.141,10.913h1.048q1.535-2.5,3.113-4.967-1.284,2.545-2.494,4.967h1.032c1.83-3.721,3.687-7.433,5.539-11.145,4.868-7.176,10.1-14.127,15.587-20.763.216-.26-.342-.348-.555-.094-4.406,5.341-8.708,10.792-12.825,16.4.744-1.51,1.5-3.051,2.238-4.591,3.948-8.233,8.463-16.268,14.7-23.041.252-.273-.241-.49-.5-.208-6.163,6.589-10.713,14.425-14.7,22.449-1.71,3.439-3.4,6.813-5.04,10.076",
    transform: "translate(69.05 -50.656)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31188",
    "data-name": "Path 31188",
    d: "M144.575,170.432c2.737-7.4,6.367-14.7,9.426-21.935,2.316-5.483,4.578-11.156,8.042-16.12-4.59,10.164-7.574,20.931-11.381,31.251-.771,2.086-1.563,4.161-2.263,6.141l-.4.663h1.073c.026-.073.048-.147.076-.222,1.844-3.079,3.79-6.358,5.821-9.667.239-.389-.649-.506-.889-.11-1.164,1.943-2.356,3.865-3.493,5.733.222-.594.436-1.19.653-1.788,4.273-11.636,7.328-23.469,12.874-34.655a37.459,37.459,0,0,1,3.636-3.708c.3-.263-.207-.465-.508-.208-.68.591-1.322,1.2-1.926,1.805a69.455,69.455,0,0,1,3.8-5.823c.1-.1.179-.208.273-.3a.311.311,0,0,0,.085-.173c1.1-1.49,2.268-2.977,3.559-4.422.242-.274-.257-.492-.5-.213-1.284,1.45-2.464,2.927-3.572,4.415a.416.416,0,0,0-.2.123c-10.713,11.824-17.592,25.634-22.928,40.717-1.042,2.949-1.914,5.793-2.595,8.5Zm2.087-7.9c4.673-13.533,10.569-25.963,19.418-37.292-.9,1.411-1.748,2.827-2.527,4.245a76.853,76.853,0,0,0-9.589,17.1c-2.558,6.1-5.442,12.228-8.108,18.364.26-.793.524-1.6.806-2.414",
    transform: "translate(66.997 -53.943)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31189",
    "data-name": "Path 31189",
    d: "M164.089,161.557q2.272-3.245,4.551-6.493-1.761,3.353-3.354,6.493h.778c6.743-8.636,13.522-17.242,20.228-25.9.1-.138-.182-.183-.289-.048-6.22,7.94-12.527,15.812-18.822,23.694.914-1.811,1.857-3.693,2.861-5.564.092-.172-.114-.228-.326-.2,2.77-3.934,5.569-7.874,8.307-11.809.141-.2-.3-.269-.437-.07-4.64,6.628-9.374,13.26-14.074,19.9Z",
    transform: "translate(76.481 -45.068)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31190",
    "data-name": "Path 31190",
    d: "M176.834,148.19c-2.332,2.573-4.638,5.09-6.9,7.5h.658c1.362-1.481,4.826-5.256,6.8-7.416.21-.233-.357-.32-.567-.088",
    transform: "translate(79.487 -39.207)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31191",
    "data-name": "Path 31191",
    d: "M168.275,166.8q3.93-5.158,7.883-10.3-3.08,5.073-5.9,10.3h.641c2.64-4.783,5.387-9.477,8.233-14.143,2.279-2.938,4.6-6,6.989-9.012.161-.205-.282-.279-.442-.076q-2.114,2.71-4.2,5.37c5.41-8.4,11.206-16.7,17.269-24.441.15-.2-.26-.276-.408-.084-7.07,9.2-13.737,18.752-20.011,28.57q-5.339,6.887-10.622,13.816Z",
    transform: "translate(78.441 -50.314)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31192",
    "data-name": "Path 31192",
    d: "M185.226,142.053c-4.126,5.042-12.545,14.067-14.83,16.5h.559c5.053-5.356,10.011-10.8,14.688-16.436.153-.182-.264-.252-.417-.065",
    transform: "translate(79.701 -42.065)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31193",
    "data-name": "Path 31193",
    d: "M176.025,158.688c4.879-5.533,9.665-11.168,14.067-16.9.1-.131-.2-.185-.3-.053-4.438,5.771-9.322,11.419-14.3,16.954Z",
    transform: "translate(82.081 -42.198)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31194",
    "data-name": "Path 31194",
    d: "M189.34,159.2q4.894-5.119,9.731-10.29c-2.739,3.411-5.442,6.851-8.147,10.29h.938c4.87-6.2,9.734-12.411,14.886-18.309.288-.327-.468-.473-.757-.151-1.042,1.171-2.061,2.353-3.053,3.523q-7,7.5-14.07,14.937Z",
    transform: "translate(88.341 -42.711)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31195",
    "data-name": "Path 31195",
    d: "M188.477,158.754A183.179,183.179,0,0,1,203.825,141.9c.3-.289-.286-.537-.587-.255a185.58,185.58,0,0,0-15.389,17.114Z",
    transform: "translate(87.865 -42.265)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31196",
    "data-name": "Path 31196",
    d: "M180.209,166.71c.307-.572.609-1.139.931-1.722q9.821-10.46,19.343-21.184c.223-.248-.345-.361-.571-.112-5.858,6.553-11.77,13.092-17.771,19.533,7.532-13.141,15.815-25.837,24.169-38.423.194-.295-.426-.421-.625-.128-8.878,13.315-17.895,26.706-25.65,40.772-.405.426-.806.842-1.206,1.262Z",
    transform: "translate(83.645 -50.22)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31197",
    "data-name": "Path 31197",
    d: "M196.205,163.373h.816q2.675-2.891,5.375-5.764-2.279,2.871-4.522,5.764h.776q4.137-5.3,8.362-10.537a256.544,256.544,0,0,1,22.848-20.855c.321-.258-.233-.486-.552-.225-6.1,5.008-11.969,10.185-17.669,15.651.25-.286.492-.568.737-.851s-.4-.4-.628-.126c-1.777,2.046-3.564,4.091-5.231,6.1q-5.242,5.341-10.312,10.848",
    transform: "translate(91.773 -46.884)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31198",
    "data-name": "Path 31198",
    d: "M192.6,161.706c3.991-4.56,8.007-9.1,12.1-13.571q-4.13,6.75-8.13,13.571h1c5.027-5.668,10.182-11.253,15.557-16.506.364-.357-.349-.687-.719-.324q-7.067,6.979-13.7,14.425,4.06-6.81,8.243-13.531c.828-.872,1.632-1.761,2.48-2.636.261-.264-.37-.38-.616-.123-.112.114-.216.225-.327.339,1.639-2.572,3.326-5.2,5.092-7.827.207-.31-.47-.454-.684-.141-2.366,3.509-4.6,7.017-6.733,10.414-4.882,5.227-9.649,10.547-14.368,15.912Z",
    transform: "translate(89.71 -45.216)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31199",
    "data-name": "Path 31199",
    d: "M158.439,168.54q7.111-10.715,14.25-21.413c-2.409,4.995-4.741,10.019-7.039,15.063q-1,2.2-1.992,4.355c-.426.677-.841,1.334-1.256,1.995h1.055c.226-.514.456-1.027.694-1.548,2.941-4.7,5.88-9.452,8.852-14.095.182-.285-.44-.377-.624-.092-2.174,3.37-4.28,6.719-6.3,9.907.2-.436.4-.882.59-1.317,3.013-6.9,6.415-13.86,9.887-20.636,3.549-6.931,7.389-13.822,12.307-19.907.211-.266-.352-.365-.559-.1a132.165,132.165,0,0,0-12.783,20.77c-.917,1.766-1.816,3.534-2.668,5.266-.048-.128-.354-.145-.47.026q-7.312,10.88-14.676,21.727Z",
    transform: "translate(73.767 -52.05)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31200",
    "data-name": "Path 31200",
    d: "M182.551,166.842q4.416-4.654,8.9-9.245-2.118,2.622-4.192,5.125-1.893,2.072-3.816,4.12h.916c.12-.141.239-.279.363-.421,3.248-3.487,6.435-7.063,9.564-10.628.277-.317-.48-.446-.747-.136-.423.489-.851.989-1.28,1.477a.489.489,0,0,0-.321-.019c1.463-1.468,2.974-2.95,4.485-4.455-2.144,3.346-4.091,6.614-5.859,9.746q-1.975,2.232-3.975,4.437h.867c.545-.606,1.086-1.208,1.638-1.83-.336.619-.663,1.227-.985,1.83h.677q1-1.88,2.094-3.841c5.451-6.188,10.938-12.388,16.622-18.3.28-.292-.283-.546-.569-.251-4.949,5.139-9.758,10.494-14.517,15.856,1.751-3.031,3.678-6.166,5.764-9.376,1.722-1.686,3.49-3.4,5.269-5.1.288-.276-.26-.517-.556-.238-1.12,1.058-2.232,2.141-3.329,3.206a286.028,286.028,0,0,1,18.526-24.378c.159-.189-.261-.28-.421-.092a274.05,274.05,0,0,0-19.779,26.1q-8.19,8.08-16.116,16.411Z",
    transform: "translate(85.023 -50.352)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31201",
    "data-name": "Path 31201",
    d: "M155.188,169.634q1.336-2.814,2.687-5.611c.233-.484.483-.966.724-1.455a132.585,132.585,0,0,1,8.6-12.979c.189-.254-.357-.341-.555-.088-1.667,2.121-3.188,4.287-4.594,6.4a179.153,179.153,0,0,1,9.341-15.317c6.122-8.988,12.976-16.992,22.317-21.963.358-.192.01-.5-.36-.311-8.862,4.424-15.495,11.917-21.1,19.812a192.487,192.487,0,0,0-14.227,23.783c-.575,1.118-1.124,2.234-1.679,3.338-.845,1.494-1.654,2.956-2.441,4.389Z",
    transform: "translate(71.988 -53.145)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31202",
    "data-name": "Path 31202",
    d: "M208.2,155.457c1.639-2.206,3.248-4.425,4.794-6.646.166-.239-.415-.351-.577-.113-1.59,2.263-3.228,4.518-4.885,6.759Z",
    transform: "translate(97.074 -38.967)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31203",
    "data-name": "Path 31203",
    d: "M203.485,161.85q4.531-4.507,9.062-9.015c-2.247,2.921-4.375,5.936-6.4,9.015h1.07c.6-.75,1.192-1.515,1.807-2.254.119-.145,0-.257-.182-.292a126.723,126.723,0,0,1,8.349-10.939q2.774-2.629,5.776-5.353c.329-.3-.2-.567-.6-.374,2.313-2.414,4.811-4.858,7.516-7.274.412-.364-.358-.668-.766-.3a137.819,137.819,0,0,0-12.934,13.3c-4.634,4.455-9.206,8.975-13.779,13.489Z",
    transform: "translate(94.672 -45.361)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31204",
    "data-name": "Path 31204",
    d: "M216.238,158.554c6.015-5.6,12.257-10.941,18.585-16.183.405-.336-.374-.609-.791-.272-6.512,5.3-12.963,10.748-19.175,16.455Z",
    transform: "translate(100.497 -42.064)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31205",
    "data-name": "Path 31205",
    d: "M211.374,159.462c.358-.316.715-.634,1.08-.951-.3.318-.584.633-.881.951h1.136q2.827-3.012,5.682-6c2.281-1.882,4.664-3.8,7.173-5.749q-5.348,5.845-10.635,11.751h1.2q6.77-7.516,13.619-14.962c.258-.2.508-.405.775-.6.164-.122.159-.242.069-.321.969-1.049,1.933-2.117,2.918-3.173.382-.414-.7-.574-1.077-.16-1.38,1.493-2.746,2.972-4.085,4.419q-2.712,2.072-5.268,4.086c1.657-1.62,3.368-3.283,5.159-4.951.408-.38-.606-.534-1.007-.156q-5.125,4.819-10.051,9.9-3.487,2.9-6.865,5.921Z",
    transform: "translate(98.375 -42.972)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31206",
    "data-name": "Path 31206",
    d: "M201.156,156.412q4.181-4.9,8.415-9.706c.156-.175-.264-.261-.424-.084q-4.326,4.83-8.553,9.79Z",
    transform: "translate(93.826 -39.922)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31207",
    "data-name": "Path 31207",
    d: "M233.083,160.258c9.728-7.032,19.26-14.33,28.857-21.524.465-.349-.4-.621-.876-.266-9.722,7.236-19.393,14.654-29.258,21.79Z",
    transform: "translate(108.425 -43.768)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31208",
    "data-name": "Path 31208",
    d: "M227.5,158.523c5.9-4.562,11.859-9.031,18.024-13.261q-7.5,6.578-14.89,13.261h1.074q9-8.21,18.162-16.241c.332-.294-.5-.383-.826-.1s-.675.6-1.011.894a1.02,1.02,0,0,0-.6.137c-7.215,4.706-14.121,9.962-20.964,15.313Z",
    transform: "translate(105.928 -42.034)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31209",
    "data-name": "Path 31209",
    d: "M234.122,160.285c10.943-7.515,22.126-14.683,33.35-21.739.379-.241-.254-.43-.634-.191-11.309,7.033-22.543,14.331-33.567,21.93Z",
    transform: "translate(109.11 -43.795)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31210",
    "data-name": "Path 31210",
    d: "M222.177,160.638c2.133-1.735,4.321-3.52,6.543-5.36q-2.937,2.673-5.859,5.36h.866c5.784-5.291,11.583-10.55,17.735-15.226.31-.233-.252-.417-.567-.182-.911.678-1.779,1.369-2.639,2.046.621-.53,1.251-1.067,1.868-1.6.5-.432-.724-.593-1.223-.161-4.911,4.243-9.916,8.373-14.952,12.467,6.248-6.959,12.724-13.716,19.449-20.127.4-.385-.63-.52-1.027-.134-7.65,7.346-15.083,14.881-22,22.917Z",
    transform: "translate(103.076 -44.148)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31211",
    "data-name": "Path 31211",
    d: "M253.27,156.039c3.52-2.85,7.035-5.686,10.477-8.522.258-.211-.4-.277-.656-.072-3.517,2.859-7.072,5.721-10.629,8.594Z",
    transform: "translate(118.086 -39.55)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31212",
    "data-name": "Path 31212",
    d: "M260.332,155.426q4.042-3.23,8.049-6.489c.4-.326-.63-.43-1.022-.113q-4.069,3.324-8.209,6.6Z",
    transform: "translate(121.215 -38.936)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31213",
    "data-name": "Path 31213",
    d: "M267.9,158c.749-.54,1.494-1.086,2.254-1.616q7.279-4.141,14.629-8.134c.492-.266-.279-.487-.771-.223-2.482,1.343-4.927,2.673-7.317,4.005,4.892-2.963,9.834-5.758,14.9-8.318.691-.351-.046-.8-.738-.446a179.722,179.722,0,0,0-24.044,14.39l-.587.342Z",
    transform: "translate(124.527 -41.507)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31214",
    "data-name": "Path 31214",
    d: "M265.878,159.891q4.331-3.316,8.635-6.667c7.223-4.846,14.67-9.439,22.158-13.745.524-.3-.3-.556-.809-.263q-10.24,5.874-20.117,12.388a1.218,1.218,0,0,0-.727.214c-.694.567-1.419,1.136-2.146,1.7q-4.535,3.128-8.961,6.373Z",
    transform: "translate(123.443 -43.401)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31215",
    "data-name": "Path 31215",
    d: "M271.68,153.571c.383-.219.766-.443,1.148-.662.436-.248-.3-.443-.74-.2l-1.5.859Z",
    transform: "translate(126.567 -37.081)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31216",
    "data-name": "Path 31216",
    d: "M263.775,157.545q8.842-6.629,17.79-13.048c.445-.316-.389-.567-.841-.248-6.123,4.292-12.181,8.759-18.187,13.3Z",
    transform: "translate(122.8 -41.055)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31217",
    "data-name": "Path 31217",
    d: "M276.033,153.983c1.28-.621,2.567-1.231,3.856-1.821.584-.269-.044-.619-.641-.345-1.531.7-3.06,1.431-4.579,2.166Z",
    transform: "translate(128.473 -37.493)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31218",
    "data-name": "Path 31218",
    d: "M274.064,155.341q5.018-3.071,10.058-6.11c.556-.335-.38-.593-.928-.264q-5.282,3.164-10.538,6.374Z",
    transform: "translate(127.532 -38.851)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31219",
    "data-name": "Path 31219",
    d: "M281.1,155.3q4.967-2.963,9.9-5.925c.606-.365-.427-.666-1.041-.3-3.552,2.1-7,4.189-10.381,6.226Z",
    transform: "translate(130.771 -38.808)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31220",
    "data-name": "Path 31220",
    d: "M284.913,154.447c2.284-1.1,4.672-2.183,7.193-3.213.713-.292,0-.7-.716-.407q-4.075,1.686-8.058,3.619Z",
    transform: "translate(132.526 -37.957)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31221",
    "data-name": "Path 31221",
    d: "M298.16,152.454c.854-.341,1.726-.684,2.6-1.014.732-.279.029-.7-.718-.417-2.852,1.064-5.629,2.185-8.327,3.329h1.8c.606-.255,1.211-.512,1.816-.76-.5.252-1,.508-1.507.76h1.252q1.6-.8,3.206-1.579c.305-.145.148-.277-.126-.318",
    transform: "translate(136.449 -37.862)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31222",
    "data-name": "Path 31222",
    d: "M291.824,155.329c.15-.09.3-.178.446-.269,1.051-.395,2.094-.8,3.142-1.182.616-.228.026-.561-.591-.351,2.416-1.428,4.864-2.881,7.314-4.339.442-.263-.31-.5-.762-.23-3.253,1.942-6.574,3.87-9.775,5.781l-1.541.589Z",
    transform: "translate(135.672 -38.839)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31223",
    "data-name": "Path 31223",
    d: "M299.41,153.762c.713-.4,1.43-.794,2.14-1.192.506-.286-.337-.54-.84-.258q-1.292.724-2.6,1.45Z",
    transform: "translate(139.44 -37.272)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31224",
    "data-name": "Path 31224",
    d: "M309.065,153.518c.3-.128.614-.257.919-.383.545-.223,0-.575-.559-.349q-.887.361-1.773.732Z",
    transform: "translate(143.901 -37.028)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31225",
    "data-name": "Path 31225",
    d: "M256.07,157.989c7.81-5.8,15.781-11.052,24.913-14.507.493-.186.018-.449-.459-.27-9.3,3.484-17.434,8.842-25.415,14.777Z",
    transform: "translate(119.325 -41.5)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31226",
    "data-name": "Path 31226",
    d: "M262.17,155.352c3.109-2.2,6.226-4.362,9.336-6.4.2-.129-.17-.235-.373-.1-3.176,2.124-6.347,4.3-9.505,6.5Z",
    transform: "translate(122.374 -38.862)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31227",
    "data-name": "Path 31227",
    d: "M302.324,153.671c.709-.326,1.422-.656,2.133-.979.481-.219-.223-.432-.7-.217-.875.395-1.748.8-2.62,1.2Z",
    transform: "translate(140.855 -37.181)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31228",
    "data-name": "Path 31228",
    d: "M317.408,153.561c.385-.16.769-.326,1.154-.489.545-.226.009-.614-.556-.379-.694.288-1.389.58-2.081.867Z",
    transform: "translate(147.771 -37.071)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31229",
    "data-name": "Path 31229",
    d: "M321.975,153.952q1.99-.839,3.991-1.659c.593-.241.016-.682-.593-.436-1.679.685-3.351,1.388-5.02,2.094Z",
    transform: "translate(149.842 -37.462)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31230",
    "data-name": "Path 31230",
    d: "M238.435,162.23q4.262-3.065,8.6-6.025-3.316,2.937-6.5,6.025h1.688c3.768-3.6,7.667-7.076,11.654-10.468q6.794-4.218,13.691-8.23c.341-.2-.185-.349-.524-.16-3.683,2.089-7.221,4.215-10.628,6.316a216.306,216.306,0,0,1,21.5-15.033c.741-.458-.448-.81-1.17-.367a212.6,212.6,0,0,0-27.391,19.87c-3.969,2.63-7.892,5.309-11.761,8.071Z",
    transform: "translate(111.132 -45.741)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31231",
    "data-name": "Path 31231",
    d: "M249.339,158.579c8.988-5.852,18.257-11.246,27.73-16.229.677-.357-.349-.652-1.026-.3-9.609,5.024-19.037,10.54-28.173,16.53Z",
    transform: "translate(115.939 -42.089)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31232",
    "data-name": "Path 31232",
    d: "M244.589,159.108q6.039-4.331,12.273-8.409c-1.615,1.3-3.2,2.6-4.8,3.869-1.876,1.477-3.718,3-5.544,4.54h1.914a238.531,238.531,0,0,1,27.444-16.649c.393-.2-.028-.462-.429-.255A248.526,248.526,0,0,0,250.431,157c3.9-3.465,7.913-6.665,12.116-9.755,3.7-2.175,7.484-4.245,11.322-6.156.408-.2-.022-.462-.432-.258-1.261.633-2.48,1.267-3.688,1.914a.732.732,0,0,0-.753-.006,54.976,54.976,0,0,0-8.6,5.253c-5.677,3.518-11.193,7.232-16.6,11.111Z",
    transform: "translate(114.032 -42.618)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31233",
    "data-name": "Path 31233",
    d: "M243.371,156.884c5.162-3.831,10.375-7.566,15.8-11,.474-.3-.333-.527-.8-.23-5.517,3.442-10.83,7.289-16.1,11.231Z",
    transform: "translate(113.319 -40.394)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31234",
    "data-name": "Path 31234",
    d: "M153.05,163.836q4.593-6.323,9.162-12.67-.568,1.792-1.164,3.534c-2.552,2.993-5.05,6.013-7.422,9.135h.873c1.995-2.714,4.041-5.378,6.179-8.021-.976,2.695-1.976,5.368-3.038,8.021h.936A156.866,156.866,0,0,1,175,137.043c.25-.329-.446-.437-.694-.114-3.3,4.315-6.36,8.8-9.3,13.423-1.008,1.069-1.981,2.144-2.933,3.206q.645-1.955,1.255-3.969c2.567-3.584,5.1-7.234,7.631-10.807.2-.274-.395-.37-.589-.094-2.114,3.031-4.32,6.024-6.452,8.944,1.525-5.574,2.871-11.142,3.983-16.785.054-.276-.567-.255-.618.018a162.4,162.4,0,0,1-4.447,18.247q-5.418,7.364-10.842,14.726Zm11.02-11.919c-1.421,2.4-2.689,4.745-3.865,7.022.517-1.431,1.032-2.891,1.531-4.369q1.136-1.321,2.334-2.652",
    transform: "translate(71.096 -47.348)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31235",
    "data-name": "Path 31235",
    d: "M152.076,158.587c3.577-5.473,7.233-10.935,10.763-16.4.222-.339-.512-.442-.727-.107-3.6,5.5-7.3,10.976-10.86,16.506Z",
    transform: "translate(70.747 -42.097)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31236",
    "data-name": "Path 31236",
    d: "M159.452,167.705q1.984-3,4.141-5.886c-1,1.976-2.036,3.935-3.084,5.886h1.046c1.61-3.032,3.222-6.226,4.813-9.551,3.239-4.145,6.53-8.26,9.807-12.366.289-.364-.511-.49-.8-.129-2.52,3.132-5.071,6.267-7.521,9.325a297.333,297.333,0,0,0,12.579-32.392c.091-.294-.547-.277-.641.01A281.6,281.6,0,0,1,165.52,157.94c-2.466,3.206-4.927,6.415-7.182,9.765Z",
    transform: "translate(74.061 -51.216)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31237",
    "data-name": "Path 31237",
    d: "M174.948,141.747q-7.472,8.212-14.385,17h1.271c4.386-5.858,9.109-11.459,13.963-16.878.339-.376-.514-.5-.848-.126",
    transform: "translate(75.102 -42.261)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31238",
    "data-name": "Path 31238",
    d: "M193.245,143.015c.324-.321-.338-.6-.669-.274-5.362,5.263-11.793,9.932-17.126,15.508h1.362c5.04-5.514,11.319-10.145,16.433-15.234",
    transform: "translate(82.065 -41.759)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31239",
    "data-name": "Path 31239",
    d: "M174.469,169.505c.345-.4.7-.8,1.061-1.2-.252.407-.509.8-.763,1.2h1.171q1.435-2.272,2.855-4.666c4.107-4.1,8.287-8.128,12.493-12.113.377-.355-.332-.647-.707-.291-3.389,3.217-6.847,6.424-10.205,9.7,7.905-14.087,14.892-28.69,21.331-43.4.122-.279-.5-.282-.627,0a449.609,449.609,0,0,1-23.388,46.078q-2.239,2.27-4.333,4.688Z",
    transform: "translate(81.086 -53.016)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31240",
    "data-name": "Path 31240",
    d: "M166.568,166.951c2.726-3.39,5.6-6.655,8.529-9.887-.615,2.064-1.258,4.083-1.886,6.046q-1.744,1.944-3.3,3.841h1.255c.427-.527.865-1.06,1.312-1.593-.179.539-.36,1.064-.54,1.593h.688q.491-1.431.973-2.912a189.686,189.686,0,0,1,14.372-14.649c.395-.363-.335-.659-.732-.3-4.475,4.088-8.85,8.346-12.962,12.827.611-1.911,1.2-3.876,1.791-5.89,2.006-2.116,4.146-4.261,6.373-6.41.387-.37-.345-.668-.735-.294-1.779,1.7-3.5,3.41-5.178,5.108,2.85-9.984,5.143-20.086,7.116-30.277.044-.226-.461-.22-.506.009-2.033,10.5-4.6,20.908-7.546,31.229-3.542,3.763-6.928,7.581-10.161,11.556Z",
    transform: "translate(77.378 -50.462)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31241",
    "data-name": "Path 31241",
    d: "M181,156.564c3.3-3.4,6.735-6.649,10.246-9.841.446-.405-.408-.747-.857-.343-3.619,3.244-7.17,6.625-10.549,10.185Z",
    transform: "translate(84.118 -40.075)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31242",
    "data-name": "Path 31242",
    d: "M183.282,155.053q2.611-2.673,5.227-5.34c.286-.291-.44-.4-.722-.117q-2.69,2.726-5.407,5.457Z",
    transform: "translate(85.306 -38.563)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31243",
    "data-name": "Path 31243",
    d: "M198.823,163.115c4.744-6,9.589-12.094,14.029-18.27.222-.305-.47-.454-.688-.151-2.028,2.8-4.083,5.557-6.148,8.228,4.43-6.7,8.63-13.524,12.743-20.409.188-.316-.506-.455-.7-.138-6.322,10.428-12.844,21.021-20.164,30.74Z",
    transform: "translate(92.564 -46.625)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31244",
    "data-name": "Path 31244",
    d: "M200.881,159.182c5.372-6.1,10.779-12.182,16.243-18.163.374-.412-.6-.593-.979-.185-5.56,6.049-11.1,12.162-16.552,18.348Z",
    transform: "translate(93.358 -42.692)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31245",
    "data-name": "Path 31245",
    d: "M206.662,154.877c1.7-1.546,3.371-3.088,4.94-4.676.373-.377-.637-.564-1.008-.189-1.651,1.647-3.407,3.257-5.187,4.866Z",
    transform: "translate(96.077 -38.387)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31246",
    "data-name": "Path 31246",
    d: "M204.339,157.164a104.952,104.952,0,0,1,13.3-11.7c.525-.405-.395-.781-.914-.376-4.736,3.7-9.7,7.53-13.8,12.072Z",
    transform: "translate(94.914 -40.674)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31247",
    "data-name": "Path 31247",
    d: "M212.151,155.207q3.027-2.906,6.317-5.516c.565-.446-.5-.842-1.07-.389a82.745,82.745,0,0,0-6.719,5.9Z",
    transform: "translate(98.543 -38.717)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31248",
    "data-name": "Path 31248",
    d: "M215.635,164.334a80.99,80.99,0,0,1,8.707-6.664c.553-.374-.382-.691-.928-.326-2.006,1.336-3.909,2.724-5.677,4.1,7.6-10.191,14.5-20.867,21.362-31.518.226-.352-.631-.486-.86-.131-7.575,11.77-15.379,23.569-24.2,34.539Z",
    transform: "translate(100.116 -47.845)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31249",
    "data-name": "Path 31249",
    d: "M221.887,156.123c3.672-2.985,7.466-5.8,11.318-8.485.556-.387-.42-.707-.97-.321-4.011,2.781-7.976,5.7-11.8,8.806Z",
    transform: "translate(103.108 -39.633)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31250",
    "data-name": "Path 31250",
    d: "M230.6,165q1.929-2,3.831-4.036c6.285-5.726,12.718-11.3,19.188-16.8.427-.364-.6-.481-1.022-.131-4.524,3.818-9.016,7.726-13.481,11.642,7.374-8.742,14.275-17.786,20.832-27.146.272-.386-.751-.517-1.023-.132a338.619,338.619,0,0,1-27.07,33.809q-1.5,1.387-2.993,2.795Z",
    transform: "translate(107.047 -48.51)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31251",
    "data-name": "Path 31251",
    d: "M227.4,153.931c.577-.562,1.158-1.127,1.747-1.7.424-.412-.8-.571-1.227-.154l-1.932,1.857Z",
    transform: "translate(105.706 -37.441)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31252",
    "data-name": "Path 31252",
    d: "M234.356,159.007c7.014-6.032,14.312-11.768,21.362-17.638.5-.418-.724-.555-1.214-.144-7.145,5.9-14.523,11.633-21.516,17.782Z",
    transform: "translate(108.978 -42.517)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31253",
    "data-name": "Path 31253",
    d: "M237.159,157.989c5.842-5.136,11.986-9.891,18.29-14.441.449-.324-.357-.568-.809-.242a224.186,224.186,0,0,0-18.806,14.683Z",
    transform: "translate(110.309 -41.5)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31254",
    "data-name": "Path 31254",
    d: "M239.7,156.388a157.156,157.156,0,0,1,13.631-9.31c.628-.4-.452-.718-1.086-.311-4.635,2.987-9.718,5.993-14.092,9.621Z",
    transform: "translate(111.396 -39.898)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31255",
    "data-name": "Path 31255",
    d: "M244.692,164.81c2.561-1.711,5.175-3.344,7.745-5.012q-2.582,2.532-5.2,5.012h1.359a441.836,441.836,0,0,0,33.4-35.864c.335-.4-.756-.536-1.1-.132q-12.807,15.077-26.763,29.293a1.321,1.321,0,0,0-.958.169c-3.357,2.2-6.954,4.271-10.411,6.534Z",
    transform: "translate(113.55 -48.32)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31256",
    "data-name": "Path 31256",
    d: "M252.7,153.639c.39-.248.781-.5,1.171-.738.589-.367-.454-.64-1.051-.276-.542.332-1.079.669-1.616,1.014Z",
    transform: "translate(117.497 -37.149)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31257",
    "data-name": "Path 31257",
    d: "M253.617,153.848c.765-.471,1.535-.941,2.3-1.409.58-.354-.436-.618-1.019-.269q-1.4.832-2.786,1.678Z",
    transform: "translate(117.925 -37.358)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31258",
    "data-name": "Path 31258",
    d: "M262.894,160.26q7.99-4.835,15.965-9.7c-3.411,3.386-6.984,6.6-10.657,9.7h1.371c4.343-3.747,8.545-7.638,12.6-11.754,5.279-3.292,10.872-6.611,15.653-10.171.04-.029-.031-.051-.07-.026-4.987,3.242-10.053,6.562-15.148,9.743.067-.078.151-.157.223-.229.371-.377-.807-.525-1.177-.131-.738.782-1.491,1.562-2.257,2.328q-8.52,5.154-17.087,10.24Z",
    transform: "translate(122.695 -43.77)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31259",
    "data-name": "Path 31259",
    d: "M275.331,158.174c8.765-4.984,17.609-9.849,26.116-15.124.374-.229-.242-.42-.615-.191-8.673,5.351-17.732,10.273-26.714,15.314Z",
    transform: "translate(128.216 -41.685)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31260",
    "data-name": "Path 31260",
    d: "M280.009,157.992c7.8-4.838,15.712-9.505,23.518-14.315.666-.407-.432-.756-1.095-.349-8.043,4.949-16.357,9.6-24.387,14.664Z",
    transform: "translate(130.053 -41.502)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31261",
    "data-name": "Path 31261",
    d: "M285.117,155.592c3.473-2.328,6.986-4.582,10.543-6.733.743-.449-.528-.831-1.278-.376-3.759,2.291-7.487,4.637-11.134,7.108Z",
    transform: "translate(132.486 -39.102)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31262",
    "data-name": "Path 31262",
    d: "M290.148,155.566c1.954-1.174,3.929-2.3,5.9-3.426.794-.454-.54-.848-1.343-.389-1.984,1.143-4.217,2.351-6.42,3.586a1.046,1.046,0,0,0-.608-.11c3.222-2.061,6.493-4.187,9.694-6.377.587-.4-.511-.732-1.1-.338-3.619,2.416-7.348,4.729-11.078,7.054Z",
    transform: "translate(133.394 -39.076)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31263",
    "data-name": "Path 31263",
    d: "M292.872,155.1l.182-.128c.477-.285.961-.572,1.459-.86.136-.078.183-.156.176-.226,2.068-1.317,4.278-2.642,6.552-3.979.734-.432-.486-.809-1.234-.38-3.11,1.773-6.278,3.546-9.263,5.573Z",
    transform: "translate(135.993 -38.607)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31264",
    "data-name": "Path 31264",
    d: "M298.9,153.887c.928-.483,1.841-.947,2.673-1.4.744-.405-.512-.809-1.267-.383-1.048.593-2.1,1.19-3.135,1.782Z",
    transform: "translate(138.998 -37.397)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31265",
    "data-name": "Path 31265",
    d: "M302.777,154.859c2.115-1.494,4.234-2.987,6.305-4.519.649-.484-.914-.707-1.557-.236-2.21,1.615-4.494,3.172-6.756,4.755Z",
    transform: "translate(140.682 -38.37)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31266",
    "data-name": "Path 31266",
    d: "M304.836,161.706c10.874-6.728,20.848-15.118,26.9-26.349.1-.182-.39-.207-.493-.025-6.392,11.418-16.766,19.678-27.94,26.374Z",
    transform: "translate(141.868 -45.216)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31267",
    "data-name": "Path 31267",
    d: "M307.616,156.237a83.152,83.152,0,0,0,10.988-8.991c.327-.32-.633-.5-.978-.172a90.548,90.548,0,0,1-11.46,9.163Z",
    transform: "translate(143.206 -39.747)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31268",
    "data-name": "Path 31268",
    d: "M308.982,157.733c6.253-4.352,12.335-8.922,18.383-13.585.4-.314-.361-.631-.776-.317-6.238,4.755-12.535,9.439-19,13.9Z",
    transform: "translate(143.873 -41.243)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31269",
    "data-name": "Path 31269",
    d: "M313.5,159.145A198.377,198.377,0,0,0,336.79,141.02c.324-.3-.464-.484-.79-.191a208.18,208.18,0,0,1-23.814,18.316Z",
    transform: "translate(146.022 -42.655)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31270",
    "data-name": "Path 31270",
    d: "M325.061,156.55q7.413-4.74,14.438-10.016c.254-.191-.192-.427-.452-.23q-7.3,5.4-14.911,10.246Z",
    transform: "translate(151.612 -40.06)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31271",
    "data-name": "Path 31271",
    d: "M323.9,153.689c.533-.373,1.074-.741,1.6-1.12.276-.2-.355-.32-.624-.128-.577.423-1.161.837-1.75,1.248Z",
    transform: "translate(151.141 -37.2)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31272",
    "data-name": "Path 31272",
    d: "M144.243,164.689a176.986,176.986,0,0,0,5.14-35.725c.015-.257-.577-.117-.587.136a164.615,164.615,0,0,1-5.542,35.588Z",
    transform: "translate(67.006 -48.2)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31273",
    "data-name": "Path 31273",
    d: "M185.808,163.874a302.451,302.451,0,0,0,18.99-33.149c.1-.2-.367-.2-.471,0a296.4,296.4,0,0,1-19.16,33.152Z",
    transform: "translate(86.61 -47.384)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31274",
    "data-name": "Path 31274",
    d: "M120.324,160.149q7.791-10.218,15.466-20.51c.69-.917-.735-1.588-1.45-.652-5.363,7.05-10.7,14.139-16.113,21.162Z",
    transform: "translate(55.3 -43.659)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31275",
    "data-name": "Path 31275",
    d: "M134.064,162.179c6.73-8.837,13.44-17.7,20.407-26.318,1.1-1.364-1.026-2.392-2.143-1.014C145.067,143.791,138.1,153,131.1,162.179Z",
    transform: "translate(61.319 -45.689)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31276",
    "data-name": "Path 31276",
    d: "M138.1,160.884c6.854-7.629,13.647-15.323,20.4-22.986.672-.762-.556-1.337-1.234-.578-6.97,7.817-13.894,15.725-20.887,23.565Z",
    transform: "translate(63.789 -44.394)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31277",
    "data-name": "Path 31277",
    d: "M127.657,158.065c3.86-4.808,7.748-9.589,11.723-14.215.614-.713-.564-1.234-1.186-.514-4.135,4.807-8.174,9.753-12.182,14.729Z",
    transform: "translate(58.941 -41.575)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31278",
    "data-name": "Path 31278",
    d: "M126.381,168.386c12.372-16.6,25.3-32.734,40.439-46.655.534-.49-.079-1.127-.631-.622-15.535,14.218-29.13,30.437-41.964,47.277Z",
    transform: "translate(58.105 -51.897)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31279",
    "data-name": "Path 31279",
    d: "M143.434,169.144c3.39-3.87,6.763-7.758,10.169-11.616,3.01-3.113,6.156-6.113,9.429-8.94.6-.515.38-1.123-.1-1.29A202.127,202.127,0,0,1,193.5,120.547c.983-.691,0-1.7-.986-1.019-16.732,11.528-30.93,26.4-44.4,41.534-1.973,2.218-3.926,4.463-5.729,6.575-.434.506-.87,1.005-1.306,1.506Z",
    transform: "translate(65.99 -52.654)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31280",
    "data-name": "Path 31280",
    d: "M135.547,170.2c15.152-18.793,31.147-36.7,49.842-51.98.837-.684-.06-1.6-.913-.916-15.586,12.514-29.459,26.877-42.446,42.192q4.342-6.2,8.8-12.322c.691-.954-.788-1.657-1.5-.691-5.693,7.757-11.236,15.715-16.688,23.717Z",
    transform: "translate(62.043 -53.705)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31281",
    "data-name": "Path 31281",
    d: "M139.447,160.608c5.6-7.443,11.334-14.79,17.308-21.868.82-.972-.737-1.7-1.559-.725-6.141,7.3-11.969,14.9-17.682,22.593Z",
    transform: "translate(64.321 -44.119)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31282",
    "data-name": "Path 31282",
    d: "M127.715,157.883q3.558-7.019,6.891-14.134c.191-.405-.542-.521-.731-.116q-3.357,7.177-6.959,14.25Z",
    transform: "translate(59.364 -41.393)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31283",
    "data-name": "Path 31283",
    d: "M121.759,168.716c4.089-5.867,8.1-11.792,12.143-17.692-2.955,5.831-5.8,11.7-8.413,17.692h1.245c.214-.495.433-.988.65-1.491.859-1.544,1.7-3.134,2.586-4.747.135-.247-.032-.405-.264-.445,3.022-6.395,6.222-12.658,9.63-18.855,2.155-3.078,4.346-6.185,6.606-9.311.373-.523-.282-.91-.732-.572,2.651-4.214,5.464-8.349,8.36-12.345.431-.594-.468-1.049-.906-.442a261.934,261.934,0,0,0-14.556,22.751c-5.911,8.473-11.736,17-17.672,25.456Z",
    transform: "translate(56.333 -52.226)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31284",
    "data-name": "Path 31284",
    d: "M136.609,163.486c7.355-10.607,14.865-21.1,22.659-31.4.424-.562-.433-.98-.87-.42-8.009,10.359-15.794,21.05-23.415,31.819Z",
    transform: "translate(63.137 -46.996)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31285",
    "data-name": "Path 31285",
    d: "M130.956,164.934c1.242-1.661,2.476-3.324,3.728-4.98q-1.537,2.494-3.087,4.98h1.253q4.284-6.845,8.563-13.7,3.912-5,7.917-9.925-6.867,11.836-13.807,23.622H136.9c5.729-9.662,11.344-19.393,16.97-29.121.273-.329.552-.68.835-1.014.175-.21.175-.405.063-.534,1.019-1.761,2.028-3.545,3.066-5.319.411-.7-.794-.91-1.2-.216-1.453,2.485-2.886,4.974-4.311,7.431q-2.948,3.525-5.768,7.031c1.814-2.789,3.661-5.62,5.591-8.447.443-.652-.716-.848-1.149-.2q-5.627,8.373-11.011,16.92-5.176,6.7-10.255,13.474Z",
    transform: "translate(60.678 -48.445)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31286",
    "data-name": "Path 31286",
    d: "M119.062,159.2c3.578-6.14,7.173-12.269,10.854-18.344.189-.311-.357-.393-.545-.092-3.734,6.079-7.368,12.253-10.986,18.436Z",
    transform: "translate(55.374 -42.706)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31287",
    "data-name": "Path 31287",
    d: "M116.263,170.432c5.8-10.782,11.683-21.723,17.123-32.71.26-.527-.638-.674-.9-.15-2.4,4.769-4.824,9.552-7.29,14.3,5.188-11.513,10.076-23.168,14.826-34.841.211-.525-.665-.691-.881-.153-7.258,18.069-14.967,36.343-23.962,53.551Z",
    transform: "translate(53.873 -53.942)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31288",
    "data-name": "Path 31288",
    d: "M118.719,164.018c6.712-11.039,13.392-22.1,20.146-33.1.442-.721-.79-.914-1.227-.217-6.894,11.008-13.715,22.157-20.484,33.319Z",
    transform: "translate(54.798 -47.528)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31289",
    "data-name": "Path 31289",
    d: "M125.493,156.849c2.674-3.524,5.337-7.041,7.735-10.648.446-.671-.847-.864-1.286-.189-2.442,3.766-5.285,7.283-8.087,10.838Z",
    transform: "translate(57.932 -40.359)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31290",
    "data-name": "Path 31290",
    d: "M122.855,160.761c4.829-8.158,11.076-15.546,17.124-22.669.611-.719-.536-1.243-1.157-.521-6.2,7.224-12.793,14.78-17.677,23.19Z",
    transform: "translate(56.664 -44.272)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31291",
    "data-name": "Path 31291",
    d: "M132.007,157.676c2.962-4.462,6.1-8.787,9.424-12.923.625-.778-.652-1.336-1.281-.553-3.467,4.317-6.76,8.808-9.8,13.477Z",
    transform: "translate(60.968 -41.186)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31292",
    "data-name": "Path 31292",
    d: "M136.356,172.829l.009-.016c.553-1.03,1.095-2.081,1.642-3.148,3.213-4.224,6.542-8.306,10.105-12.153.589-.634-.467-1.093-1.061-.467-2.19,2.316-4.3,4.689-6.258,7.066,8.133-17.079,15.037-34.772,22.213-52.166.227-.549-.706-.744-.935-.182-8.1,19.706-16.226,39.55-26.055,58.544q-.92,1.272-1.767,2.523Z",
    transform: "translate(62.793 -56.34)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31293",
    "data-name": "Path 31293",
    d: "M142.54,159.5c4.864-6.493,10.029-12.753,15.388-18.793.572-.644-.486-1.139-1.071-.481-5.526,6.2-10.867,12.608-15.88,19.274Z",
    transform: "translate(65.941 -43.013)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31294",
    "data-name": "Path 31294",
    d: "M8.122,168.893c7.437-15.508,14.437-31.247,21.984-46.648.917-1.868-1.173-3.446-2.122-1.537-7.88,15.884-15.128,32.158-22.848,48.184Z",
    transform: "translate(2.402 -52.403)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31295",
    "data-name": "Path 31295",
    d: "M27.939,171.86c9.386-18.385,18.229-37.06,28.539-54.876,1.471-2.541-1.663-4.949-3.15-2.4-10.833,18.529-20,38.059-29.742,57.277Z",
    transform: "translate(11.032 -55.37)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31296",
    "data-name": "Path 31296",
    d: "M33.624,168.893c9.8-15.614,19.04-31.6,28.929-47.1.9-1.419-.911-2.774-1.819-1.358-10.177,15.888-19.512,32.418-29.574,48.453Z",
    transform: "translate(14.575 -52.403)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31297",
    "data-name": "Path 31297",
    d: "M18.508,164.2c5.7-10.877,11.3-21.827,17.334-32.456.818-1.444-.914-2.676-1.738-1.22-6.276,11.058-12.074,22.4-17.98,33.676Z",
    transform: "translate(7.542 -47.711)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31298",
    "data-name": "Path 31298",
    d: "M16.76,182.613C31.838,150.531,46.7,116.822,72.326,91.9c.725-.7-.242-1.88-.976-1.176-26.3,25.21-42.108,59.253-57.728,91.888Z",
    transform: "translate(6.372 -66.123)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31299",
    "data-name": "Path 31299",
    d: "M41.627,182.09c4.993-8.1,9.84-16.3,14.793-24.423,4.042-5.789,8.238-11.466,12.768-16.785a1.712,1.712,0,0,0-.255-2.588c11.845-16.864,25.038-32.17,41.2-44.725,1.327-1.032-.205-2.62-1.534-1.628C83.048,111,65.371,137.184,48.861,164.193c-2.535,4.148-5.08,8.41-7.528,12.565-1.048,1.779-2.133,3.558-3.233,5.331Z",
    transform: "translate(17.821 -65.6)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31300",
    "data-name": "Path 31300",
    d: "M29.933,184.059C48.749,149.426,67.388,114.41,98.14,89.19c1.1-.9-.283-2.385-1.427-1.5-24.573,19-41.735,45.253-56.9,71.952,3.763-8.153,7.607-16.279,11.62-24.29.916-1.832-1.258-3.518-2.2-1.653-8.3,16.5-15.75,33.447-23.259,50.36Z",
    transform: "translate(12.151 -67.569)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31301",
    "data-name": "Path 31301",
    d: "M35.869,168.407c7.748-15.2,15.419-30.459,24.165-45.032,1.093-1.82-1.205-3.548-2.309-1.711-9.059,15.044-16.81,30.936-24.692,46.743Z",
    transform: "translate(15.451 -51.917)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31302",
    "data-name": "Path 31302",
    d: "M19.182,163.963c3.364-10.872,6.468-21.828,9.523-32.767.235-.838-.819-1.167-1.057-.317-3.106,11.056-6.231,22.11-9.615,33.084Z",
    transform: "translate(8.435 -47.473)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31303",
    "data-name": "Path 31303",
    d: "M10.243,184.275c5.912-13.512,11.431-27.206,17.328-40.724Q21.79,161.992,17.14,180.727c-.395,1.184-.8,2.365-1.19,3.548h2.122c.517-2.21,1.086-4.519,1.678-6.907,1.041-3.11,2.05-6.415,3.172-9.711a.663.663,0,0,0-.417-.939c3.618-13.18,7.657-26.192,12.278-39.061,2.806-5.918,5.673-11.814,8.7-17.613.49-.941-.477-1.814-1.092-1.252A210.345,210.345,0,0,1,53.11,88.264c.542-.9-.8-1.849-1.352-.942-7.735,12.592-13.512,26.359-18.746,40.329-8.654,18.68-16.3,37.8-24.614,56.624Z",
    transform: "translate(3.928 -67.785)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31304",
    "data-name": "Path 31304",
    d: "M31.776,173.99c9.828-21.53,19.522-43.175,31.078-63.654.564-1-.7-1.977-1.27-.963-11.862,20.917-22.076,42.764-32.24,64.617Z",
    transform: "translate(13.725 -57.5)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31305",
    "data-name": "Path 31305",
    d: "M23.371,176.991q3.267-6.7,6.533-13.4-2.6,6.706-5.225,13.4h1.827C30.633,166.7,34.6,156.35,38.748,146.073q5.145-9.821,10.582-19.474c-6.43,16.737-12.423,33.641-18.809,50.392H32.5c7.717-20.19,14.947-40.565,22.906-60.665.37-.619.741-1.245,1.121-1.849a.981.981,0,0,0,.035-1.045c1.314-3.25,2.618-6.457,3.936-9.58a.936.936,0,1,0-1.742-.669q-2.842,6.733-5.557,13.538-3.93,6.592-7.712,13.27c2.385-5.4,4.811-10.8,7.35-16.1.574-1.2-1.105-1.807-1.67-.624-5.178,10.838-9.9,21.956-14.448,33.12-5.184,10.136-10.135,20.381-15.131,30.608Z",
    transform: "translate(10.097 -60.501)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31306",
    "data-name": "Path 31306",
    d: "M6.641,167.032c4.923-14.252,9.819-28.523,15.081-42.6.244-.652-.547-.869-.794-.23-5.4,14.117-10.3,28.487-15.253,42.829Z",
    transform: "translate(2.654 -50.542)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31307",
    "data-name": "Path 31307",
    d: "M2.748,188.074c7.358-24.034,15-48.391,22.759-72.426.33-1.032-.96-1.46-1.295-.424q-4.72,14.647-9.338,29.372c5.834-21.683,11.5-43.507,17.906-64.943.229-.769-1.044-1.177-1.277-.408C20.659,115.294,12.077,152.271,1.257,188.074Z",
    transform: "translate(0.588 -71.584)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31308",
    "data-name": "Path 31308",
    d: "M6.118,176.736c8.812-24.225,17.355-48.56,27.288-72.3.569-1.352-1.211-1.952-1.776-.618C21.5,127.715,12.68,152.232,3.893,176.736Z",
    transform: "translate(1.821 -60.246)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31309",
    "data-name": "Path 31309",
    d: "M15.338,161.85c4.105-8.531,8.459-16.955,11.993-25.614.572-1.4-1.295-1.908-1.873-.506-3.653,8.855-8.244,17.409-12.474,26.12Z",
    transform: "translate(6.073 -45.36)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31310",
    "data-name": "Path 31310",
    d: "M11.976,169.949c5.687-17.739,14.686-34.687,23.861-50.5.818-1.411-.859-2.662-1.683-1.245-9.388,16.1-19.025,33.511-24.607,51.744Z",
    transform: "translate(4.466 -53.46)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31311",
    "data-name": "Path 31311",
    d: "M25.07,163.227a317.7,317.7,0,0,1,13.681-29.252c.834-1.551-1.046-2.89-1.895-1.312a292.638,292.638,0,0,0-14.178,30.564Z",
    transform: "translate(10.607 -46.737)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31312",
    "data-name": "Path 31312",
    d: "M31.716,189.069q.544-1.574,1.07-3.154c.662-1.977,1.306-4.02,1.971-6.11a230.49,230.49,0,0,1,13.374-23.865c.79-1.226-.784-2.357-1.582-1.13-2.933,4.512-5.695,9.184-8.373,13.9,8.963-30.318,15.99-61.45,26.54-91.232.233-.65-1.145-1.11-1.384-.455-12.367,33.947-20.29,69.5-31.367,103.9q-1.854,4.058-3.6,8.149Z",
    transform: "translate(13.269 -72.579)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31313",
    "data-name": "Path 31313",
    d: "M40.463,166.033c6.615-13.107,13.654-25.97,21.457-38.409.775-1.233-.793-2.37-1.578-1.135-8.089,12.734-15.4,26.008-22.214,39.544Z",
    transform: "translate(17.834 -49.543)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31314",
    "data-name": "Path 31314",
    d: "M36.731,184.138c.976-2.773,1.959-5.533,2.968-8.24,4.707-12.579,9.213-27.693,15.106-37.941.007-.012,0-.029.007-.05,8.04-17.614,17.007-34.775,29.227-49.591.593-.716-.729-1.5-1.336-.787-21.618,25.379-34.254,57.66-45.795,88.958q-1.561,3.826-3.142,7.65Z",
    transform: "translate(15.794 -67.648)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31315",
    "data-name": "Path 31315",
    d: "M30.93,176.494c9.244-23.8,18.125-47.826,25.474-72.154.205-.688-.838-1.083-1.066-.38-7.968,24.409-17.391,48.644-27.31,72.534Z",
    transform: "translate(13.11 -60.004)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31316",
    "data-name": "Path 31316",
    d: "M16.4,176.424a212.612,212.612,0,0,1,8.834-24.6c1.283-3.062,2.682-6.169,4.094-9.279-2.161,6.509-4.273,13.045-6.025,19.653q-1.874,7.076-3.571,14.227h2.409c.98-4.246,1.995-8.482,3.066-12.664a427.514,427.514,0,0,1,13.271-41.028c2.84-6.118,5.714-12.259,8.321-18.438.22-.525-.558-.8-.791-.273-.687,1.526-1.421,3.062-2.144,4.6.307-.781.608-1.565.911-2.344a.835.835,0,1,0-1.581-.531q-4.465,11.015-8.67,22.176c-3.543,7.259-7.151,14.579-10.427,21.874a197.068,197.068,0,0,0-9.967,26.623Z",
    transform: "translate(6.611 -59.934)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31317",
    "data-name": "Path 31317",
    d: "M73.335,169.149c11.839-16.2,23.255-32.713,35.1-48.9.572-.778-.515-1.359-1.083-.586C95.31,136,83.655,152.749,71.58,169.149Z",
    transform: "translate(33.481 -52.659)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31318",
    "data-name": "Path 31318",
    d: "M77.617,161.7c5.6-8.274,11.029-16.657,16.453-25.044.743-1.149-.881-2.059-1.639-.9C86.751,144.423,81.1,153.144,75.21,161.7Z",
    transform: "translate(35.179 -45.21)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31319",
    "data-name": "Path 31319",
    d: "M61.489,174.952c7.28-11.479,14.29-23.136,21.77-34.493-4.384,7.521-8.78,15.112-12.835,22.729-2.055,3.856-4.019,7.794-5.937,11.764h3.323c1.7-3.75,3.43-7.48,5.227-11.136,6.865-13.949,14.856-27.6,22.725-41.167,3.732-5.033,7.632-9.978,11.6-14.792.627-.757-.515-1.378-1.146-.637-1.676,1.956-3.349,3.935-4.976,5.931.975-1.71,1.964-3.418,2.925-5.125.487-.862-.894-1.17-1.384-.342-2.866,4.855-5.792,9.716-8.695,14.57-12.692,16.957-23.647,34.951-35.1,52.7Z",
    transform: "translate(27.588 -58.462)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31320",
    "data-name": "Path 31320",
    d: "M53.032,177.245C63.2,152.114,73.874,127.162,87.8,104.018c1.164-1.936-2.149-2.89-3.308-1.032-14.538,23.349-25.606,48.735-36.2,74.259Z",
    transform: "translate(22.586 -60.755)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31321",
    "data-name": "Path 31321",
    d: "M20.167,101.04A253.223,253.223,0,0,0,0,167.659v10.349H.641a258.2,258.2,0,0,1,21.278-76.469c.561-1.214-1.192-1.692-1.752-.5",
    transform: "translate(0 -61.52)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31322",
    "data-name": "Path 31322",
    d: "M5.791,169.547a286.539,286.539,0,0,1,18.765-50.385.5.5,0,1,0-.917-.414,277.9,277.9,0,0,0-19.873,50.8Z",
    transform: "translate(1.762 -53.057)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31323",
    "data-name": "Path 31323",
    d: "M11.456,169.65A423.79,423.79,0,0,1,29.571,118.8c.258-.594-.555-.82-.815-.241A418.626,418.626,0,0,0,9.865,169.65Z",
    transform: "translate(4.614 -53.16)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31324",
    "data-name": "Path 31324",
    d: "M93.439,164.264c7.02-10.805,13.8-21.781,20.971-32.431,1.183-1.758-1.2-3.013-2.4-1.236-7.485,11.08-14.567,22.465-21.919,33.667Z",
    transform: "translate(42.137 -47.775)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31325",
    "data-name": "Path 31325",
    d: "M98.024,162.663c7.086-9.344,13.926-18.872,20.882-28.317.728-.991-.652-1.7-1.386-.706-7.135,9.658-14.14,19.443-21.408,29.023Z",
    transform: "translate(44.956 -46.173)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31326",
    "data-name": "Path 31326",
    d: "M86.2,158.971c3.966-5.616,7.913-11.246,11.93-16.814.658-.908-.677-1.579-1.344-.668-4.227,5.751-8.353,11.626-12.5,17.482Z",
    transform: "translate(39.423 -42.481)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31327",
    "data-name": "Path 31327",
    d: "M84.695,172.129c13.26-20.231,26.513-40.369,42.952-58.206.583-.637-.134-1.4-.727-.76-16.85,17.974-30.894,38.411-44.713,58.966Z",
    transform: "translate(38.452 -55.639)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31328",
    "data-name": "Path 31328",
    d: "M117.488,170.9c16.235-18.941,32.714-37.584,51.182-54.359.659-.6-.062-1.393-.734-.791-18.821,16.809-35.6,35.869-52.1,55.15Z",
    transform: "translate(54.18 -54.415)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31329",
    "data-name": "Path 31329",
    d: "M109.863,170.893c3.96-5.2,7.913-10.4,11.944-15.542-2.3,5.153-4.5,10.342-6.681,15.542h2.29c2.935-7.208,5.946-14.375,9.166-21.472a250.047,250.047,0,0,1,28.332-29.578c1-.876-.07-2.033-1.077-1.162a249.729,249.729,0,0,0-24.109,24.251,181.929,181.929,0,0,1,16.65-26.742c.392-.518-.313-.892-.719-.387a179.858,179.858,0,0,0-20.572,32.628c-5.99,7.371-11.749,14.915-17.51,22.462Z",
    transform: "translate(50.318 -54.404)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31330",
    "data-name": "Path 31330",
    d: "M101.064,170.2c7.989-10.883,15.788-21.9,24.059-32.582-7.4,10.761-14.484,21.728-21.74,32.582h4.189c6.791-10.4,13.493-20.865,20.472-31.076,1.444-2.112-1.4-3.668-2.893-1.543,5.309-6.7,10.751-13.274,16.414-19.652.644-.728-.412-1.264-1.058-.562C125.2,133.956,112.169,152.189,98.683,170.2Z",
    transform: "translate(46.158 -53.713)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31331",
    "data-name": "Path 31331",
    d: "M14.787,172.852c5.962-20.738,13.207-41.167,22.539-60.447.489-1.013-1-1.463-1.488-.477-9.581,19.338-16.98,39.989-23.1,60.924Z",
    transform: "translate(5.959 -56.362)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31332",
    "data-name": "Path 31332",
    d: "M18.354,164.5c4.664-11.513,9.442-22.98,14.516-34.278.446-.994-.983-1.394-1.428-.4-5.175,11.44-10.019,23.044-14.779,34.681Z",
    transform: "translate(7.794 -48.006)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31333",
    "data-name": "Path 31333",
    d: "M5.4,183.222c1.8-8.959,4.139-17.8,6.782-26.569q-3.362,13.234-6.222,26.569H8.1c2.453-11.674,5.222-23.293,8.31-34.7,5.539-20.465,12.8-42.249,27.454-58.31.614-.672-.542-1.4-1.154-.743C29.754,103.405,22.735,121.7,17,139.56a1.05,1.05,0,0,0-.6.614A252.354,252.354,0,0,0,3.518,183.222Z",
    transform: "translate(1.646 -66.733)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31334",
    "data-name": "Path 31334",
    d: "M26.045,102.247c-.81,1.383-1.563,2.818-2.34,4.254.076-.157.15-.32.223-.477.558-1.18-1.135-1.641-1.681-.481A298.733,298.733,0,0,0,0,172.747v4.576H1.741c5-25.859,12.932-51.573,25.562-74.243.537-.964-.685-1.807-1.258-.834",
    transform: "translate(0 -60.835)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31335",
    "data-name": "Path 31335",
    d: "M41.86,160.424c.891-1.612,1.792-3.22,2.6-4.778a.516.516,0,0,0,.04-.452q4-8.225,8.014-16.445c.393-.8-.878-1.145-1.271-.357C47.59,145.725,44,153.151,40.306,160.424Z",
    transform: "translate(18.853 -43.934)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31336",
    "data-name": "Path 31336",
    d: "M55.329,176.72c.181-.427.357-.848.539-1.284,14.051-26.17,29.7-51.089,51.576-71.138.746-.681-.148-1.639-.913-.951C87.8,120.2,73.68,140.352,61.247,162.267q4.914-12.243,9.79-24.5c.363-.9-1.008-1.325-1.377-.42-5.241,12.938-10.474,25.879-15.948,38.72-.116.219-.232.432-.346.647Z",
    transform: "translate(24.961 -60.23)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31337",
    "data-name": "Path 31337",
    d: "M36.813,179.664c5.63-10.857,11.228-21.814,17.123-32.355,9.744-17.429,22.8-33.165,33.928-49.865.323-.48-.589-.891-.923-.426-11.431,15.969-24.428,31.214-34.128,48.187-5.591,9.784-15.238,28.344-18.4,34.458Z",
    transform: "translate(16.095 -63.174)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31338",
    "data-name": "Path 31338",
    d: "M34.893,154.358c.437-.907.939-1.93,1.3-2.654.417-.823-1.048-1.124-1.468-.3q-.757,1.473-1.5,2.952Z",
    transform: "translate(15.544 -37.868)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31339",
    "data-name": "Path 31339",
    d: "M45.326,157.19q2.162-5.746,4.165-11.531c.28-.807-1.051-1.148-1.337-.326q-2.072,5.947-4.295,11.856Z",
    transform: "translate(20.515 -40.7)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31340",
    "data-name": "Path 31340",
    d: "M64.442,163.4c5.41-10.439,11.125-20.7,17.522-30.506a.834.834,0,1,0-1.427-.854A345.53,345.53,0,0,0,62.306,163.4Z",
    transform: "translate(29.143 -46.907)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31341",
    "data-name": "Path 31341",
    d: "M71.05,170.487q1.867-3.932,3.71-7.877,3.351-6.173,7-12.175-4.212,9.958-8.062,20.052h1.9c3.724-9.762,7.682-19.42,11.955-28.97a180.425,180.425,0,0,1,12.921-15.975c-5.426,11.878-10.841,23.764-16.356,35.6q-2.175,4.665-4.333,9.345h2.874c5.457-8.329,10.91-16.662,16.522-24.894-3.9,8.293-7.628,16.71-11.779,24.894h6.031c.393-.778.787-1.559,1.168-2.337,1.9-2.7,3.884-5.489,5.9-8.369q-2.741,5.315-5.279,10.706h2.21a194.142,194.142,0,0,1,21.673-36.017.814.814,0,0,0,.173-.9c4.127-5.466,8.318-10.921,12.643-16.172.653-.793-.474-1.369-1.123-.593-10.873,13.066-20.907,26.867-30.821,40.728.138-.263.261-.537.4-.8a354.7,354.7,0,0,1,18.612-31.2c.71-1.073-.731-1.841-1.456-.762-1.6,2.373-3.164,4.767-4.688,7.148a.9.9,0,0,0-1.419.307c-6.878,11.228-13.521,22.649-20.14,34.06.818-1.769,1.642-3.6,2.5-5.441q5.7-12.188,11.768-24.262c4.645-6.351,9.379-12.719,14.328-18.724.621-.754-.44-1.289-1.066-.558-3.046,3.567-6.021,7.217-8.924,10.913.721-1.347,1.413-2.7,2.143-4.049.66-1.218-1.217-1.572-1.874-.373-2.291,4.183-4.46,8.448-6.577,12.731q-9.2,12.573-17.761,25.577c.313-.688.619-1.4.941-2.1,5.39-11.855,10.813-23.814,16.189-35.712a.682.682,0,0,0-.326-.991c.239-.232.455-.487.7-.727.8-.784-.166-1.845-.978-1.042a141.132,141.132,0,0,0-13.082,14.764.986.986,0,0,0-1.311.487c-.531,1.114-1.03,2.241-1.55,3.346-1.375,1.921-2.689,3.865-3.96,5.8q4.113-8.991,8.216-17.986c.66-1.452-1.581-2.037-2.24-.589-5.93,12.99-11.946,26.008-18.052,38.952-.21.382-.43.754-.64,1.13,5.878-13.995,11.76-28.006,18.122-41.76.357-.771-.826-1.08-1.184-.329-7,14.774-13.267,30.037-19.81,45.145Z",
    transform: "translate(31.275 -53.997)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31342",
    "data-name": "Path 31342",
    d: "M61.1,169.853c9.584-17.594,16.939-36.126,30.817-50.656.763-.8-.2-1.942-1-1.133A102.369,102.369,0,0,0,76.179,137.3a1.013,1.013,0,0,0-.982.474c-.738,1.047-1.46,2.118-2.175,3.178a1.069,1.069,0,0,0-.449.44c-.219.4-.434.8-.653,1.2-5.68,8.846-10.83,17.948-15.636,27.263Z",
    transform: "translate(26.326 -53.364)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31343",
    "data-name": "Path 31343",
    d: "M23.451,167.74q1.055-3.835,2.15-7.667c1.229-3.117,2.527-6.374,3.879-9.677a.67.67,0,0,0-.663-.978c2.787-8.708,5.73-17.377,8.936-25.909.455-1.208-1.259-1.725-1.717-.52-4.855,12.783-9.116,25.867-13.017,39.039-.744,1.9-1.475,3.806-2.212,5.711Z",
    transform: "translate(9.732 -51.251)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31344",
    "data-name": "Path 31344",
    d: "M50.948,163.243c4.895-10.076,9.515-20.29,14.115-30.492.371-.823-.9-1.189-1.281-.373-4.745,10.28-9.489,20.656-14.537,30.865Z",
    transform: "translate(23.034 -46.754)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31345",
    "data-name": "Path 31345",
    d: "M29.595,178.239c10.97-26.659,23-53.081,38.537-77.067a.837.837,0,0,0-1.386-.939c-16.035,24.25-28.219,51-39.416,78.006Z",
    transform: "translate(12.783 -61.749)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31346",
    "data-name": "Path 31346",
    d: "M32.737,181.1q.683-1.863,1.366-3.716c5.344-9.975,10.775-19.961,16.465-29.673,11.347-19.379,24.284-37.881,40.761-53.148.47-.436-.351-1.1-.838-.675C73.913,108.227,61.176,126.3,49.87,145.107c-5.012,8.335-9.8,16.92-14.494,25.506a.713.713,0,0,0-.3.349c-.091.23-.181.464-.274.7q-2.536,4.711-5.055,9.433Z",
    transform: "translate(13.916 -64.608)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31347",
    "data-name": "Path 31347",
    d: "M3.916,127.906Q1.882,133.7,0,139.555v6.737q2.783-9.086,5.93-17.994c.542-1.537-1.468-1.951-2.014-.392",
    transform: "translate(0 -49.091)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31348",
    "data-name": "Path 31348",
    d: "M110.64,171.145c3.762-4.707,7.656-9.285,11.875-13.649q-5.066,6.88-10.26,13.649h4.684A373.414,373.414,0,0,1,151.868,129.6c1.066-1.089-.163-2.439-1.237-1.344-6.643,6.737-12.982,13.781-19.125,21.02a.657.657,0,0,0-.285-.549q5.836-8.073,11.918-15.957c2.269-2.946,4.62-5.89,7-8.806s6.549-4.97,9.411-7.509c.961-.854-.063-1.977-1.045-1.132-2.664,2.306-5.654,4.067-8.5,6.129-2.7,1.959-5.334,6.432-7.355,8.986-5.247,6.639-10.308,13.59-15.285,20.371-.062.079-.11.158-.167.238a155.564,155.564,0,0,0-18.837,20.1Zm18.426-19.483.117-.161c.462-.374.926-.753,1.393-1.129-1.766,2.143-3.5,4.276-5.181,6.4,1.22-1.686,2.505-3.407,3.671-5.108",
    transform: "translate(50.685 -54.657)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31349",
    "data-name": "Path 31349",
    d: "M124.483,168.23c16.242-17.24,32.343-34.15,53.41-45.374,1.146-.611.539-2.049-.606-1.457-21.941,11.328-38.628,28.922-55.432,46.831Z",
    transform: "translate(56.996 -51.74)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31350",
    "data-name": "Path 31350",
    d: "M122.2,171.12q2.149-2.866,4.268-5.755c11.143-12.548,22.4-25.069,34.458-36.613,1.135-1.086-.125-2.5-1.274-1.394-7.679,7.339-15.04,15.04-22.245,22.885.123-.167.245-.339.371-.508,9.342-12.7,20.066-24.955,33.758-33.076,1.089-.646.49-2.059-.6-1.415-19.718,11.686-32.98,30.334-46.118,49.086q-3.012,3.4-6.041,6.79Z",
    transform: "translate(55.559 -54.63)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31351",
    "data-name": "Path 31351",
    d: "M103.871,173.4q5-6.869,10-13.75c3.285-3.982,6.649-7.886,10.167-11.607.646-.682.392-1.459-.156-1.651,10.1-12.631,20.912-24.52,33.315-34.678,1.071-.879-.057-2.075-1.136-1.209-18.819,15.15-33.856,34.407-48.133,53.733-2.1,2.842-4.176,5.711-6.084,8.394-.183.257-.368.512-.555.769Z",
    transform: "translate(47.375 -56.911)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31352",
    "data-name": "Path 31352",
    d: "M95.2,174.563c16.11-23.211,32.32-46.108,52.886-65.447.907-.85-.116-1.945-1.044-1.088-17.4,16.111-32.2,34.693-45.887,54.2,3.071-5.3,6.165-10.591,9.329-15.835.744-1.231-.923-2.1-1.676-.854-5.792,9.58-11.388,19.317-17.026,29.026Z",
    transform: "translate(42.929 -58.074)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31353",
    "data-name": "Path 31353",
    d: "M99.436,162.3c5.734-9.059,11.5-18.1,17.617-26.866.878-1.253-.864-2.153-1.755-.879-6.311,9-12.168,18.372-18.021,27.745Z",
    transform: "translate(45.5 -45.81)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31354",
    "data-name": "Path 31354",
    d: "M32.535,86.78c.32-.483-.429-.951-.753-.47C22.232,100.565,17.73,117.7,13.566,134.078c-2.047,8.053-4.027,16.179-5.972,24.284Q3.6,169.938,0,181.637v3.032H.545q1.8-6.054,3.68-12.085-1.416,6.039-2.783,12.085H2.9c1.987-8.974,4.1-17.94,6.239-26.893a424.674,424.674,0,0,1,19.879-48.192c.279-.559-.533-.785-.809-.248a383.046,383.046,0,0,0-16.489,37.675c.891-3.655,1.773-7.352,2.674-11.026,4.126-16.857,8.454-34.609,18.144-49.206",
    transform: "translate(0 -68.181)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31355",
    "data-name": "Path 31355",
    d: "M3.8,137.124c-1.262,4.264-2.539,8.538-3.8,12.812v4.75c1.672-5.795,3.361-11.589,5.09-17.338.286-.955-1-1.19-1.289-.223",
    transform: "translate(0 -44.609)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31356",
    "data-name": "Path 31356",
    d: "M24.046,74.057a50.924,50.924,0,0,0-4.255,6.6.668.668,0,0,0-.277.2C9.824,93.641,3.981,109.553,0,126.078v7.287c3.471-16.041,8.382-31.749,16.4-45.66-1.051,2.526-2.05,5.168-2.947,7.935-6.443,11.488-8.883,24.748-11.525,37.492Q.969,137.757,0,142.382v5.824q1.118-5.273,2.2-10.534c2.519-12.288,4.918-24.5,9.514-36.243C5.853,124.039,3.468,147.3,0,170.338v7.924c.113-.76.232-1.525.349-2.3,4.1-26.585,6.165-53.848,13.951-79.807a44.637,44.637,0,0,1,4.634-6.872c.393-.474-.376-.9-.766-.436a40.659,40.659,0,0,0-2.476,3.26,84.3,84.3,0,0,1,4.463-10.24c.117-.169.222-.335.339-.493a.462.462,0,0,0,.091-.282,51.049,51.049,0,0,1,4.229-6.658c.3-.385-.471-.763-.768-.376",
    transform: "translate(0 -73.894)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31357",
    "data-name": "Path 31357",
    d: "M22.647,172.264q3.027-8,6.032-15.994c-1.318,5.043-2.629,10.089-3.876,15.153-.126.285-.248.559-.374.841h1.265c.107-.448.214-.892.326-1.35,8.363-19.414,16.789-38.8,25.694-57.968.138-.3-.3-.439-.43-.163-8.363,17.181-16.16,35.254-23.993,52.994,1.041-4.183,2.14-8.381,3.219-12.527.1-.37-.2-.521-.506-.458q5.158-13.5,10.475-26.946c.181-.455-.461-.655-.638-.207-6.178,15.474-12.066,31.065-18.028,46.626Z",
    transform: "translate(10.202 -55.774)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31358",
    "data-name": "Path 31358",
    d: "M28.629,182.29c3.474-8.127,6.926-16.266,10.419-24.385q-3.877,12.129-7.265,24.385h2.392c6.926-12.385,13.43-24.978,19.625-37.75.2-.41-.414-.593-.608-.189-6.071,12.715-19.69,37.7-19.69,37.7s6.239-11.619,9.279-17.462c.269-.518-.568-.731-.837-.211-2.935,5.646-5.911,11.284-8.972,16.866q4.491-16.151,9.857-32.016c2.953-6.675,5.924-13.381,9.006-19.951.205-.439-.451-.656-.656-.222q-2.75,5.867-5.414,11.774c6.222-16.9,13.013-33.776,21.72-49.262.181-.323-.421-.543-.6-.205-10.257,18.7-18.154,38.437-25.172,58.563C37,160.687,32.426,171.5,27.8,182.29Z",
    transform: "translate(13.004 -65.801)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31359",
    "data-name": "Path 31359",
    d: "M39.88,165.566c6.622-12.554,12.628-25.462,18.492-38.31.134-.292-.314-.433-.448-.141-5.9,12.913-12.063,25.87-18.852,38.45Z",
    transform: "translate(18.276 -49.076)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31360",
    "data-name": "Path 31360",
    d: "M59.254,166.406c4.487-7.629,8.733-15.407,13.026-23.143-3.614,7.692-7.111,15.436-10.684,23.143H63c6.329-13.585,12.313-27.347,19.283-40.538.376-.709-.74-1.016-1.115-.32-1.364,2.517-2.664,5.07-3.944,7.607-6.2,11.106-12.286,22.277-18.721,33.25Z",
    transform: "translate(27.366 -49.917)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31361",
    "data-name": "Path 31361",
    d: "M58,165.445a335.25,335.25,0,0,1,20.214-37.417.517.517,0,1,0-.881-.536c-7.7,12.074-13.9,25.021-20.2,37.953Z",
    transform: "translate(26.725 -48.955)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31362",
    "data-name": "Path 31362",
    d: "M44.878,181.549c.122-.21.241-.412.363-.625-.057.213-.114.415-.173.625H46.3q.685-2.461,1.383-4.924c8.485-15.187,16.612-30.638,24.994-45.81.291-.527-.549-.79-.837-.273C64.1,144.584,56.578,158.8,48.811,172.862c8.234-27.1,17.792-53.8,29.654-79.512.236-.511-.681-.818-.922-.3a603.069,603.069,0,0,0-31.371,84.529c-.765,1.325-1.525,2.652-2.294,3.973Z",
    transform: "translate(20.524 -65.06)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31363",
    "data-name": "Path 31363",
    d: "M70.217,175.3q3.793-6.8,7.576-13.6c-2.072,4.527-4.117,9.068-6.184,13.6h1.113c3.661-8.008,7.255-16.045,11.03-24A493.649,493.649,0,0,1,112.7,106.782c.387-.52-.368-.91-.756-.387-7.908,10.587-15.253,21.742-22.267,33.056.318-.612.624-1.243.942-1.851.308-.589-.616-.81-.92-.229-2.285,4.4-4.544,8.821-6.7,13.295-4.726,8.164-9.323,16.4-13.924,24.632Z",
    transform: "translate(32.307 -58.808)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31364",
    "data-name": "Path 31364",
    d: "M63.943,171.682c5.329-10.114,10.518-20.3,16.006-30.329q-4.978,14.447-9.606,29c-.236.448-.47.884-.7,1.327h1.428c6.627-12.476,13.29-24.915,20.657-36.953a.634.634,0,1,0-1.085-.646c-6.257,10.2-12.047,20.67-17.642,31.258q4.733-14.639,9.888-29.13c1.074-1.889,2.119-3.81,3.229-5.695.339-.577-.583-.807-.913-.257-.145.244-.282.487-.42.731,2.052-5.511,4.124-11.058,6.313-16.462.264-.652-.732-.932-.994-.28Q85.747,125.2,81.741,136.28c-6.577,11.669-12.692,23.575-18.971,35.4Z",
    transform: "translate(29.36 -55.192)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31365",
    "data-name": "Path 31365",
    d: "M14.585,186.186c5.869-16.96,11.751-33.911,17.942-50.759q-4.423,17.428-8.191,35.006c-.729,3.368-1.446,6.672-2.125,9.837q-.967,2.961-1.936,5.916h1.735q.487-2.466.992-4.933c3.495-10.8,7.017-21.612,10.691-32.315a.479.479,0,1,0-.92-.258c-2.623,7.616-5.183,15.286-7.717,22.948q.321-1.493.646-3.024c3.4-15.869,7.179-31.807,11.664-47.358,3.719-12.9,7.568-26.447,14.884-37.9.261-.408-.571-.684-.828-.285-7.691,11.92-11.51,26.233-15.455,39.79-1.129,3.879-2.2,7.825-3.239,11.787a.345.345,0,0,0-.666.029c-6.376,17.077-12.445,34.3-18.53,51.515Z",
    transform: "translate(6.329 -69.696)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31366",
    "data-name": "Path 31366",
    d: "M49.278,181.457c4.03-7.014,8.043-14.036,12.138-21.014-1.8,3.8-3.564,7.525-5.3,11.1Q53.4,176.53,50.6,181.457h1.44q.542-1.055,1.074-2.111c4.208-7.522,8.241-15.171,12.144-22.82.351-.688-.75-.992-1.1-.311-.55,1.079-1.105,2.156-1.663,3.223a.458.458,0,0,0-.455-.05c1.907-3.21,3.888-6.446,5.886-9.7Q64.2,160.232,60.867,170.9c-1.861,3.536-3.737,7.055-5.658,10.555H56.48q1.372-2.5,2.718-5.012-.709,2.5-1.4,5.012h.978q1.292-4.645,2.662-9.27c6.917-13.295,13.806-26.675,21.475-39.459a.512.512,0,1,0-.859-.555c-6.693,11.1-12.8,22.668-18.837,34.222q3.322-10.3,7.01-20.466c2.278-3.665,4.628-7.315,6.972-10.911a.5.5,0,1,0-.829-.539c-1.493,2.254-2.955,4.556-4.415,6.838,6.537-16.656,13.876-33.139,23.4-47.992.205-.323-.417-.495-.625-.17-10.279,15.982-18.074,33.718-24.981,51.682-7.465,12.055-14.494,24.351-21.579,36.62Z",
    transform: "translate(22.532 -64.967)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31367",
    "data-name": "Path 31367",
    d: "M10.077,187.772c1-4.676,2.053-9.341,3.12-13.995.255-1.118.539-2.25.806-3.4a300.271,300.271,0,0,1,10.688-30.648c.245-.587-.558-.807-.8-.229-2.1,4.939-4.013,9.991-5.845,15.074,3.361-11.95,7.119-23.77,11.626-35.282,5.808-14.836,13.3-32.461,28.865-39.217.509-.222-.076-.766-.581-.552-14.162,6.1-21.612,21.036-27.338,34.4-7.569,17.664-12.928,36.239-17.541,54.933-.65,2.64-1.267,5.244-1.871,7.778Q9.686,182.2,8.22,187.772Z",
    transform: "translate(3.845 -71.282)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31368",
    "data-name": "Path 31368",
    d: "M86.076,158.765q3.525-8.346,6.775-16.794c.2-.512-.622-.677-.816-.17q-3.261,8.527-6.85,16.964Z",
    transform: "translate(39.845 -42.275)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31369",
    "data-name": "Path 31369",
    d: "M79.259,172.413c4.334-7.107,8.535-14.286,12.749-21.466q-4.5,10.647-8.5,21.466h1.41c.138-.389.277-.769.418-1.162.9-1.893,1.76-3.884,2.7-5.859a.388.388,0,0,0-.313-.575c3.069-8.04,6.5-15.913,10.122-23.722,2.328-3.91,4.7-7.822,7.057-11.695a.552.552,0,0,0-.826-.729c2.853-5.23,5.786-10.44,8.887-15.466.459-.747-.549-1.281-1.019-.518a311.517,311.517,0,0,0-15.479,28.482c-6.223,10.421-12.32,20.918-18.7,31.245Z",
    transform: "translate(36.373 -55.923)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31370",
    "data-name": "Path 31370",
    d: "M96.213,165.971c7.637-13.122,15.241-26.281,23.361-39.017.461-.724-.5-1.242-.969-.518-8.319,12.991-16.251,26.27-24.187,39.535Z",
    transform: "translate(44.163 -49.481)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31371",
    "data-name": "Path 31371",
    d: "M89.9,167.77q1.658-2.567,3.32-5.134c-.892,1.716-1.8,3.423-2.7,5.134H91.94c2.834-5.365,5.629-10.751,8.432-16.133q4.192-6.4,8.457-12.752c-4.587,9.655-9.163,19.31-13.9,28.885h1.546c5.875-11.918,11.492-23.962,17.208-35.96.3-.426.6-.867.9-1.3a.562.562,0,0,0,.05-.685c1.082-2.254,2.155-4.518,3.247-6.774.434-.9-.914-1.148-1.344-.258q-2.307,4.76-4.568,9.49-3.144,4.537-6.157,9.03c1.915-3.572,3.87-7.193,5.922-10.826.473-.837-.822-1.06-1.287-.236-4.005,7.121-7.854,14.4-11.654,21.671Q93.627,159.832,88.5,167.77Z",
    transform: "translate(41.396 -51.28)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31372",
    "data-name": "Path 31372",
    d: "M76.117,160.568c3.8-7.531,7.572-15.074,11.453-22.565.2-.382-.423-.515-.615-.138-3.844,7.51-7.712,15.11-11.592,22.7Z",
    transform: "translate(35.25 -44.078)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31373",
    "data-name": "Path 31373",
    d: "M115.411,169.839c12.239-16.627,23.148-34.284,34.809-51.146.5-.716-.474-1.256-.979-.527-11.8,17.129-22.862,34.9-35.262,51.673Z",
    transform: "translate(53.312 -53.349)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31374",
    "data-name": "Path 31374",
    d: "M109.242,166.19c7.616-11.294,14.974-22.746,23.13-33.683-6.395,11.194-12.692,22.446-19,33.683h1.271c7.475-13.362,14.925-26.763,22.423-40.012.349-.614-.593-.787-.939-.185s-.721,1.249-1.079,1.868a.748.748,0,0,0-.674.31c-9.471,12.06-17.679,25.188-26.287,38.019Z",
    transform: "translate(50.554 -49.7)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31375",
    "data-name": "Path 31375",
    d: "M116.494,169.911c13.034-17.431,26.014-34.92,39.859-51.632.414-.5-.294-.875-.7-.392-13.964,16.734-27.045,34.421-40.156,52.024Z",
    transform: "translate(54.024 -53.422)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31376",
    "data-name": "Path 31376",
    d: "M103.378,170.431c.226-.527.452-1.051.684-1.584q4.7-7.27,9.289-14.6c-3.056,5.394-6.062,10.813-9.156,16.185h1.061c7.309-12.609,14.071-25.571,22.17-37.514.335-.49-.335-.854-.677-.349-.991,1.455-1.949,2.931-2.911,4.4.681-1.149,1.369-2.294,2.046-3.448.545-.929-.9-1.186-1.444-.27q-8.064,13.591-16.563,26.945c6.558-14.556,13.509-28.9,21.125-42.911.434-.8-.788-1.027-1.226-.241-9.056,16.362-17.146,33.4-24.736,50.606q-.923,1.391-1.849,2.783Z",
    transform: "translate(47.332 -53.941)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31377",
    "data-name": "Path 31377",
    d: "M6.933,178.128c3.863-10.21,7.65-20.45,11.5-30.664-.386,2.844-.79,5.649-1.187,8.4-3.4,7.337-6.628,14.742-9.571,22.264H8.81c2.5-6.62,5.213-13.16,8.061-19.647q-1.5,9.843-3.189,19.647h1.435c4.986-21.266,10.98-43.291,20.049-63.158.32-.7-.7-1.024-1.011-.326a307.735,307.735,0,0,0-11.8,30.918c-1.315,2.523-2.574,5.062-3.8,7.587.442-3.091.876-6.245,1.292-9.432,3.192-8.39,6.395-16.838,9.706-25.125.247-.614-.609-.872-.859-.254-2.78,6.881-5.519,13.8-8.247,20.722,1.56-12.815,2.887-25.659,3.737-38.508.04-.6-.851-.606-.887-.013-.882,13.966-2.454,28.041-4.215,42.02q-6.926,17.749-13.663,35.569Zm14.277-28.863q-2.409,8.212-4.534,16.487c.517-3.291,1.03-6.712,1.541-10.205.967-2.083,1.955-4.179,2.993-6.282",
    transform: "translate(2.536 -61.638)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31378",
    "data-name": "Path 31378",
    d: "M5.6,166.112q6.495-19.819,13.232-39.576c.273-.8-.785-1.064-1.06-.261-4.538,13.242-9.062,26.5-13.329,39.837Z",
    transform: "translate(2.08 -49.622)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31379",
    "data-name": "Path 31379",
    d: "M16.042,185.2c1.684-4.937,3.542-9.819,5.426-14.691-1.234,4.9-2.48,9.8-3.778,14.691h3.145c5.453-13.572,11.579-26.857,18.263-39.859.44-.856-.823-1.2-1.259-.376C31.175,157.639,25,170.731,19.493,184.047q2.809-10.99,5.429-22.031c4.03-9.556,8.278-19.023,12.6-28.433.371-.81-.787-1.167-1.16-.361-3.286,7.1-6.549,14.23-9.725,21.392,5.219-22.948,10.167-46.047,13.913-69.2.085-.514-.842-.6-.928-.088-4.2,25.5-9.941,50.944-15.962,76.183-3.273,7.808-6.539,15.664-9.261,23.694Z",
    transform: "translate(6.737 -68.709)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31380",
    "data-name": "Path 31380",
    d: "M62.192,129.5c-7.207,11.787-16.635,22.682-23.256,35.026h1.971c6.286-12.081,15.538-23.032,22.3-34.379a.6.6,0,1,0-1.017-.647",
    transform: "translate(18.212 -48.035)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31381",
    "data-name": "Path 31381",
    d: "M37.591,186.548q.986-1.992,2.006-3.978-.671,1.995-1.377,3.978h1.7c1.315-3.8,2.561-7.615,3.8-11.443,5.237-9,10.773-17.823,16.4-26.587a.644.644,0,1,0-1.073-.709c-4.553,7.066-9.122,14.139-13.467,21.342,8.718-28.756,16.069-57.979,24.69-86.7.122-.409-.775-.509-.894-.107-9.128,30.51-17.5,61.981-27.249,92.681-2.131,3.816-4.174,7.634-6.087,11.517Z",
    transform: "translate(16.854 -70.059)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31382",
    "data-name": "Path 31382",
    d: "M26.184,183.455c3.531-7.974,7.37-15.8,11.429-23.534q-.872,6.829-1.8,13.653c-1.629,3.277-3.232,6.564-4.761,9.881h1.83q1.125-2.483,2.278-4.957-.343,2.479-.693,4.957h.978q.55-3.9,1.092-7.808a311.5,311.5,0,0,1,18.717-32.508.662.662,0,1,0-1.1-.737c-6.134,9.151-11.755,18.761-17,28.552q.878-6.682,1.711-13.371c2.708-4.848,5.494-9.647,8.406-14.353a.673.673,0,1,0-1.115-.746q-3.549,5.64-6.846,11.444c2.6-21.577,5.055-43.275,6.347-64.868.026-.417-.7-.492-.735-.076-1.537,22.414-4.052,44.8-6.841,67.121-4.9,8.952-9.542,18.033-13.685,27.35Z",
    transform: "translate(11.415 -66.965)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31383",
    "data-name": "Path 31383",
    d: "M47.01,160.763c4.418-7.635,9.071-15.132,14.005-22.379a.751.751,0,1,0-1.284-.774c-5.073,7.543-9.887,15.245-14.368,23.152Z",
    transform: "translate(21.218 -44.274)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31384",
    "data-name": "Path 31384",
    d: "M50.347,157.452q3.734-6.255,7.409-12.529c.367-.625-.707-.887-1.07-.275q-3.78,6.4-7.659,12.8Z",
    transform: "translate(22.932 -40.962)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31385",
    "data-name": "Path 31385",
    d: "M59.831,153.839c.194-.392.392-.775.584-1.174.319-.652-.891-.916-1.208-.26-.236.486-.477.956-.716,1.434Z",
    transform: "translate(27.359 -37.349)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31386",
    "data-name": "Path 31386",
    d: "M72.866,174.589c6.214-13.465,12.419-27.149,18.2-40.86.277-.655-.735-.909-1.011-.254-2.5,5.972-5.1,11.93-7.735,17.861,5.4-14.272,10.538-28.665,15.485-43.062.214-.627-.765-.879-.989-.238C89,130.341,81.364,153.124,71.62,174.589Z",
    transform: "translate(33.5 -58.1)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31387",
    "data-name": "Path 31387",
    d: "M75.767,166.6c7.227-13.615,14.2-27.37,21.376-41,.47-.894-.913-1.2-1.377-.326C88.491,139,81.241,152.825,73.918,166.6Z",
    transform: "translate(34.574 -50.109)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31388",
    "data-name": "Path 31388",
    d: "M83.577,157.475c2.752-4.1,5.491-8.191,7.874-12.435.473-.844-.982-1.118-1.452-.292-2.473,4.343-5.379,8.523-8.272,12.727Z",
    transform: "translate(38.228 -40.986)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31389",
    "data-name": "Path 31389",
    d: "M80.552,162.421c5.045-9.785,11.7-18.843,18.1-27.626.656-.9-.638-1.6-1.3-.7-6.593,8.87-13.7,18.194-18.8,28.327Z",
    transform: "translate(36.738 -45.931)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31390",
    "data-name": "Path 31390",
    d: "M91.091,158.465c2.952-5.181,6.044-10.264,9.35-15.149.668-.985-.765-1.7-1.447-.7-3.48,5.127-6.78,10.412-9.838,15.846Z",
    transform: "translate(41.701 -41.975)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31391",
    "data-name": "Path 31391",
    d: "M95.781,177.527c.4-.914.793-1.841,1.19-2.789a159.672,159.672,0,0,1,10.738-15.517c.65-.825-.549-1.408-1.2-.586-2.354,2.978-4.587,6.049-6.669,9.078,8.356-21.659,15.345-43.862,22.973-65.725.23-.665-.822-.863-1.058-.192-8.727,24.61-16.71,49.642-26.968,73.733-.4.662-.8,1.33-1.19,2Z",
    transform: "translate(43.78 -61.038)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31392",
    "data-name": "Path 31392",
    d: "M102.814,160.91c4.935-7.885,10.149-15.586,15.642-23,.618-.834-.574-1.435-1.2-.594q-8.494,11.451-16.154,23.6Z",
    transform: "translate(47.289 -44.42)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31393",
    "data-name": "Path 31393",
    d: "M113.553,179.015c2.341-4.625,4.547-9.317,6.7-14.032q9.916-17.963,20.425-35.571c.449-.749-.729-.961-1.17-.242-4.932,8.012-9.683,16.332-14.378,24.582,7.566-18.134,14.494-36.541,21.442-54.893.266-.706-.9-.938-1.167-.222-8.732,23.152-17.711,46.438-28.024,69.054q-3.054,5.652-6.068,11.324Z",
    transform: "translate(52.068 -62.525)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31394",
    "data-name": "Path 31394",
    d: "M109.7,156.331q2.314-4.423,4.609-8.845c.454-.878-1.026-1.113-1.49-.235q-2.409,4.544-4.842,9.079Z",
    transform: "translate(50.505 -39.841)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31395",
    "data-name": "Path 31395",
    d: "M117.379,167.253c8.375-14.539,17.272-28.813,25.931-43.1.53-.872-.841-1.14-1.369-.282-8.806,14.349-17.865,28.633-26.057,43.381Z",
    transform: "translate(54.203 -50.763)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31396",
    "data-name": "Path 31396",
    d: "M116,154.182c.336-.738.669-1.482,1.007-2.24.32-.722-.948-.919-1.278-.194-.37.823-.744,1.629-1.121,2.434Z",
    transform: "translate(53.605 -37.692)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31397",
    "data-name": "Path 31397",
    d: "M54.347,176.145c9.288-23.251,16.211-47.655,23.058-71.488.113-.4-.571-.439-.687-.038C69.8,128.474,62.765,152.883,53.4,176.145Z",
    transform: "translate(24.977 -59.655)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31398",
    "data-name": "Path 31398",
    d: "M119.63,153.9c.266-.509.53-1.013.8-1.532s-.619-.647-.906-.161a.8.8,0,0,0-1.063.282c-.276.474-.542.941-.815,1.412Z",
    transform: "translate(55.028 -37.407)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31399",
    "data-name": "Path 31399",
    d: "M104.4,153.421c.065-.619-1.143-.718-1.522,0Z",
    transform: "translate(48.118 -36.931)",
    fill: "#efddb9"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14643",
    "data-name": "Group 14643",
    transform: "translate(124.746 122.768)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14642",
    "data-name": "Group 14642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14641",
    "data-name": "Group 14641",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31400",
    "data-name": "Path 31400",
    d: "M241.407,168.775c-.615-.947-1.246-1.9-1.9-2.856-3.5-5.122-7.957-10.458-10.9-15.43l-.01-.022a219.064,219.064,0,0,0-20.523-23.543c-.424-.418.358-.791.791-.368a246.114,246.114,0,0,1,32.414,39.629c.644.878,1.27,1.738,1.895,2.591Z",
    transform: "translate(-27.478 -63.66)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31401",
    "data-name": "Path 31401",
    d: "M240.154,164.616c-6.6-9.439-13.132-18.987-18.3-29.051-.156-.308.474-.437.652-.122,5.674,10.154,12.488,19.721,19.445,29.173Z",
    transform: "translate(-20.987 -59.501)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31402",
    "data-name": "Path 31402",
    d: "M250.157,164.377a90.47,90.47,0,0,0-6.292-9.168c-.913-1.187-1.907-2.387-2.891-3.6,1.65,2.616,3.192,5.166,4.512,7.638.909,1.694,1.785,3.408,2.649,5.13h-1.5c-.724-1.471-1.477-2.978-2.271-4.515a185.916,185.916,0,0,0-9.765-16.1c-2.024-2.533-4.014-5.115-5.846-7.772-.16-.232.316-.311.478-.082.495.669,1.008,1.344,1.515,2-.211-.333-.434-.674-.65-1.005-.3-.462.659-.625.97-.169,2.087,3.072,4.176,6.153,6.184,9.151,2.47,2.911,5,5.768,7.252,8.555a87.42,87.42,0,0,1,7.074,9.934Z",
    transform: "translate(-17.765 -59.262)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31403",
    "data-name": "Path 31403",
    d: "M215.121,161.629c-7.807-6.7-15.737-13.243-23.857-19.552-.414-.324.3-.614.725-.288,8.253,6.336,16.318,13.025,24.262,19.839Z",
    transform: "translate(-35.342 -56.514)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31404",
    "data-name": "Path 31404",
    d: "M208.289,158.533q-5.315-4.822-10.632-9.633c-.517-.468.479-.9,1.013-.427q5.618,5,11.219,10.06Z",
    transform: "translate(-32.361 -53.418)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31405",
    "data-name": "Path 31405",
    d: "M225.141,164.3c-4.822-4.714-9.665-9.4-14.619-13.977,3.035,3.106,6.051,6.245,8.964,9.455,1.337,1.471,2.627,2.984,3.891,4.522h-2.062c-1.118-1.434-2.254-2.853-3.424-4.242-5.015-5.953-10.5-11.544-15.863-17.211q-3.8-3.208-8.064-6.454c-.451-.341.276-.65.728-.32,1.193.878,2.363,1.769,3.49,2.642-.706-.757-1.419-1.525-2.116-2.3-.352-.392.534-.556.891-.182,2.058,2.165,4.085,4.317,6.1,6.411,8.18,6.916,15.968,14.217,23.656,21.652Z",
    transform: "translate(-34.088 -59.186)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31406",
    "data-name": "Path 31406",
    d: "M228.8,165.393a358.778,358.778,0,0,0-24.4-30.867c-.82-.922,1.214-1.32,2.028-.423a362.864,362.864,0,0,1,25.3,31.289Z",
    transform: "translate(-29.229 -60.278)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31407",
    "data-name": "Path 31407",
    d: "M258.206,164.72a109.154,109.154,0,0,0-16.064-29.207c-.393-.511.691-.672,1.085-.17a108.077,108.077,0,0,1,16.33,29.377Z",
    transform: "translate(-11.525 -59.605)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31408",
    "data-name": "Path 31408",
    d: "M254.329,161.389a134.232,134.232,0,0,0-13.5-18.956c-.208-.244.341-.392.562-.148a125.51,125.51,0,0,1,14.234,19.1Z",
    transform: "translate(-12.12 -56.274)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31409",
    "data-name": "Path 31409",
    d: "M250.472,161.469a226.389,226.389,0,0,0-13.017-19.261c-.178-.235.327-.307.508-.081a187.293,187.293,0,0,1,13.531,19.342Z",
    transform: "translate(-13.696 -56.353)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31410",
    "data-name": "Path 31410",
    d: "M199.183,159.363q-7.1-6.169-14.488-11.943c-.931-.724.762-1.33,1.7-.6q7.734,6.032,15.149,12.542Z",
    transform: "translate(-38.483 -54.248)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31411",
    "data-name": "Path 31411",
    d: "M195.062,158.61q-6.948-5.048-13.977-9.989c-.584-.407.424-.744,1.008-.335q7.248,5.079,14.407,10.324Z",
    transform: "translate(-40.127 -53.495)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31412",
    "data-name": "Path 31412",
    d: "M201.444,157.283c-2.387-2-4.8-3.966-7.251-5.849-.483-.37.377-.707.859-.332,2.585,2.006,5.13,4.076,7.641,6.181Z",
    transform: "translate(-33.98 -52.168)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31413",
    "data-name": "Path 31413",
    d: "M210.2,162.738a199.161,199.161,0,0,0-31-23.005c-.459-.273.048-.634.518-.357a204.215,204.215,0,0,1,32.11,23.362Z",
    transform: "translate(-41.012 -57.623)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31414",
    "data-name": "Path 31414",
    d: "M113.321,156.523q-5.231-1.823-10.5-3.433c-.762-.232-.069-.7.69-.465,3.972,1.2,7.924,2.513,11.859,3.9Z",
    transform: "translate(-76.807 -51.408)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31415",
    "data-name": "Path 31415",
    d: "M103,155.867c-2.137-.479-4.281-.911-6.432-1.277-.722-.122-.539-.718.2-.612,3.286.473,6.539,1.129,9.772,1.889Z",
    transform: "translate(-79.791 -50.752)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31416",
    "data-name": "Path 31416",
    d: "M120.974,157.078c-3.821-1.767-7.651-3.5-11.506-5.166-.668-.292,0-.731.687-.439,4.2,1.8,8.379,3.678,12.542,5.605Z",
    transform: "translate(-73.672 -51.963)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31417",
    "data-name": "Path 31417",
    d: "M130.292,156.454c-2.111-1.079-4.212-2.168-6.286-3.276-.658-.352.4-.663,1.069-.313q3.463,1.81,6.956,3.589Z",
    transform: "translate(-66.841 -51.338)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31418",
    "data-name": "Path 31418",
    d: "M155.262,158.743c-8.118-3.716-16.317-7.249-24.592-10.43-.724-.279-.038-.677.687-.407q13.344,4.982,26.384,10.836Z",
    transform: "translate(-63.77 -53.628)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31419",
    "data-name": "Path 31419",
    d: "M152.823,162.289c-13.807-7.643-27.842-14.9-42.043-21.563-.572-.269,0-.669.574-.4,14.47,6.785,28.744,14.2,42.813,21.965Z",
    transform: "translate(-73.04 -57.174)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31420",
    "data-name": "Path 31420",
    d: "M145.763,150.972c5.756,2.033,11.516,4.176,17.247,6.338h-1.952c-5.347-2.023-10.709-4.008-16.07-5.912-.815-.292-.032-.712.775-.426",
    transform: "translate(-57.09 -52.196)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31421",
    "data-name": "Path 31421",
    d: "M170.031,161.963c-1.044-.6-2.1-1.218-3.179-1.826-11.9-6.7-24.313-12.763-36.563-18.8-.5-.245-.034-.559.549-.326,12.662,5.034,24.837,11.442,36.815,18.115q2.505,1.4,4.989,2.834Z",
    transform: "translate(-63.904 -56.848)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31422",
    "data-name": "Path 31422",
    d: "M169.03,158.782q-9.423-5.328-18.906-10.555c-.71-.392.4-.7,1.1-.321q9.828,5.352,19.608,10.876Z",
    transform: "translate(-54.634 -53.667)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31423",
    "data-name": "Path 31423",
    d: "M176.508,159.511q-11.156-6.539-22.423-12.868c-.662-.371.371-.668,1.023-.3q11.479,6.488,22.929,13.17Z",
    transform: "translate(-52.774 -54.396)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31424",
    "data-name": "Path 31424",
    d: "M187.479,162.042c-12.67-7.582-25.722-14.5-39-20.824-.568-.27.01-.625.581-.358,13.538,6.415,26.832,13.459,39.73,21.182Z",
    transform: "translate(-55.406 -56.926)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31425",
    "data-name": "Path 31425",
    d: "M192.426,162.055q-3.2-2.173-6.439-4.3c1.274,1.425,2.527,2.861,3.776,4.3h-1.769c-1.945-2.291-3.916-4.553-5.946-6.787a209,209,0,0,0-23.606-12.593c-.84-.377,0-.9.84-.518a209.265,209.265,0,0,1,20.068,10.359,101.531,101.531,0,0,0-14.09-11.507c-.332-.222.219-.392.561-.173a101.753,101.753,0,0,1,17.356,13.983q5.59,3.523,11.033,7.236Z",
    transform: "translate(-50.798 -56.94)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31426",
    "data-name": "Path 31426",
    d: "M198.139,161.771q-8.212-6.024-16.7-11.667,7.659,5.718,15.132,11.667H193.4q-6.988-5.616-14.152-10.968c-1.19-.887.961-1.606,2.175-.716q-6.664-4.289-13.452-8.34c-.539-.321.285-.568.82-.266a321.4,321.4,0,0,1,31.178,20.29Z",
    transform: "translate(-46.263 -56.656)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31427",
    "data-name": "Path 31427",
    d: "M249.445,162.8a187.876,187.876,0,0,0-16.073-23.249c-.341-.415.572-.561.913-.147a191.918,191.918,0,0,1,16.449,23.4Z",
    transform: "translate(-15.623 -57.68)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31428",
    "data-name": "Path 31428",
    d: "M245.155,159.514c-3.292-4.4-6.659-8.755-10.091-12.987-.308-.38.568-.517.884-.128q5.229,6.471,10.261,13.114Z",
    transform: "translate(-14.827 -54.399)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31429",
    "data-name": "Path 31429",
    d: "M259.09,167.292c-1.591-3.374-3.368-6.646-5.272-9.891q2.543,4.912,4.929,9.891h-1.394c-2.078-4.365-4.217-8.7-6.464-12.953a82.688,82.688,0,0,0-19.327-24.345c-.415-.357.28-.646.688-.3a82.688,82.688,0,0,1,17.983,21.268.649.649,0,0,1,.39.227,102.664,102.664,0,0,1,9.655,16.1Z",
    transform: "translate(-16.495 -62.177)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31430",
    "data-name": "Path 31430",
    d: "M258.549,164.475a114.354,114.354,0,0,0-18.655-28.408c-.368-.405.37-.725.765-.308.561.59,1.083,1.186,1.62,1.783-.054-.066-.1-.126-.153-.194-.389-.493.653-.649,1.036-.166a137.565,137.565,0,0,1,17.079,27.293Z",
    transform: "translate(-12.584 -59.359)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31431",
    "data-name": "Path 31431",
    d: "M229.414,158.063c-.423-.5-.85-.988-1.287-1.462a.165.165,0,0,1-.053-.191c-1.852-2.206-3.771-4.49-5.745-6.826-.277-.329.5-.445.772-.122,2.458,2.856,4.908,5.755,7.361,8.6Z",
    transform: "translate(-20.781 -52.948)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31432",
    "data-name": "Path 31432",
    d: "M230.324,165.146a.192.192,0,0,0-.022-.029c-10.5-11.732-22.057-22.323-35.346-30.416-.517-.314.034-.785.558-.47A143.169,143.169,0,0,1,226.27,159.5c-2.382-3.367-4.738-6.763-7.083-10.149-.264-.379.58-.534.838-.16,3.732,5.362,7.576,10.685,11.47,15.959Z",
    transform: "translate(-33.654 -60.031)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31433",
    "data-name": "Path 31433",
    d: "M241.561,166.51c-3.818-4.292-7.666-8.567-11.554-12.743-7.274-7.811-16.022-14.529-23.2-22.264-.222-.239.329-.418.562-.182,7.349,7.436,16.023,13.979,23.265,21.63,3.546,3.746,9.674,10.531,12.4,13.559Z",
    transform: "translate(-28.037 -61.395)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31434",
    "data-name": "Path 31434",
    d: "M231.691,155.523c-.153-.179-.3-.351-.42-.49-.314-.357.586-.471.9-.123l.537.614Z",
    transform: "translate(-16.601 -50.408)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31435",
    "data-name": "Path 31435",
    d: "M226.013,156.744c-.944-1.406-1.886-2.846-2.814-4.325-.211-.34.6-.471.819-.128q1.449,2.285,2.9,4.453Z",
    transform: "translate(-20.363 -51.629)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31436",
    "data-name": "Path 31436",
    d: "M217.107,159.356a164.769,164.769,0,0,0-11.875-12.3c-.44-.409.418-.781.869-.368a162.725,162.725,0,0,1,12.345,12.671Z",
    transform: "translate(-28.807 -54.241)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31437",
    "data-name": "Path 31437",
    d: "M223.1,162.054c-.737-.919-1.484-1.848-2.241-2.8-1.546-1.679-3.184-3.386-4.94-5.093q2.844,3.91,5.554,7.891h-1.207q-4.009-5.883-8.329-11.554a72.4,72.4,0,0,0-8.793-6.531c3.929,4.939,7.842,9.9,11.8,14.8.9,1.114,1.766,2.207,2.618,3.285h-2.075q-5.264-4.866-10.706-9.532c2.639,3.184,5.262,6.38,7.938,9.532h-4.048q-1.97-1.671-4.1-3.4,1.568,1.653,3.028,3.4h-1.554a85.643,85.643,0,0,0-15.273-13.669c-.21-.148-.227-.277-.158-.382-3.228-2.309-6.5-4.563-9.821-6.727-.518-.338.31-.621.816-.292A284.31,284.31,0,0,1,204.8,157.659c-.1-.11-.191-.222-.3-.33a172.7,172.7,0,0,0-13.983-12.822c-.546-.449.445-.829,1-.383,1.221.978,2.406,1.97,3.552,2.949a.858.858,0,0,1,1,.088q7.534,6.785,14.674,14.04c-.611-.76-1.224-1.537-1.848-2.309-2.784-3.433-5.714-6.746-8.67-10.039-3.464-2.7-7.041-5.246-10.656-7.7-.467-.317.267-.59.741-.285,2.338,1.5,4.549,3.009,6.647,4.5-.542-.559-1.073-1.132-1.626-1.7-.5-.515.771-.729,1.264-.225,1.766,1.8,3.389,3.571,4.943,5.319,4.284,3.294,8.388,6.819,12.391,10.453-.232-.3-.456-.594-.69-.888-3.941-4.907-7.847-9.935-11.779-14.859-.166-.2-.043-.363.178-.437-.17-.094-.327-.2-.492-.3-.561-.333.032-.815.6-.486a70.862,70.862,0,0,1,8.906,6.057.809.809,0,0,1,.837.185c.382.456.735.926,1.1,1.387.936.791,1.833,1.591,2.708,2.388-1.921-2.438-3.873-4.942-5.84-7.483-.476-.615.907-.9,1.377-.285,4.2,5.466,8.585,10.9,12.943,16.31.153.161.314.318.464.487q-6.455-8.844-13.122-17.523c-.25-.326.474-.471.728-.15,4.748,6.028,9.352,12.223,13.939,18.423Z",
    transform: "translate(-40.259 -56.939)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31438",
    "data-name": "Path 31438",
    d: "M222.634,162.086c-6.662-7.437-12.708-15.225-20.945-20.8-.5-.34.066-.847.586-.493a68.017,68.017,0,0,1,9.944,8.106.855.855,0,0,1,.627.2c.5.436.989.879,1.482,1.32a.834.834,0,0,1,.3.181c.156.172.3.342.451.5,3.691,3.524,7.224,7.16,10.568,10.988Z",
    transform: "translate(-30.498 -56.971)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31439",
    "data-name": "Path 31439",
    d: "M242.349,160.81q-.687-1.237-1.416-2.51c-.931-1.277-1.874-2.574-2.869-3.89-.179-.238.07-.383.379-.377-2.08-3.452-4.24-6.881-6.507-10.185-.326-.479.729-.644,1.054-.166,3.389,4.974,6.637,10.142,9.652,15.414q.634.865,1.246,1.713Z",
    transform: "translate(-16.289 -55.695)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31440",
    "data-name": "Path 31440",
    d: "M224.769,159.271c-3.305-4.052-6.581-8.133-9.78-12.247-.266-.343.52-.477.782-.139,3.233,4.165,6.6,8.3,10.016,12.386Z",
    transform: "translate(-24.212 -54.155)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31441",
    "data-name": "Path 31441",
    d: "M243.522,165.551a363.082,363.082,0,0,0-26.659-31.721c-.408-.433.4-.815.823-.368a350.592,350.592,0,0,1,27.243,32.089Z",
    transform: "translate(-23.362 -60.436)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31442",
    "data-name": "Path 31442",
    d: "M245.938,167.239c-.208-.31-.408-.614-.621-.928q-5.663-6.158-11.534-12.125a239.65,239.65,0,0,0-27.665-24.133c-.319-.238.169-.547.5-.324a198.985,198.985,0,0,1,27.505,23.443q5.09,5.095,10.05,10.339a.455.455,0,0,1,.2.144c.07.091.135.186.2.289q1.572,1.673,3.063,3.3Z",
    transform: "translate(-28.384 -62.124)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31443",
    "data-name": "Path 31443",
    d: "M258.5,159.88c-2.664-4.81-5.58-9.471-8.649-13.97-.392-.574.865-.743,1.253-.172,3.123,4.56,6.027,9.288,8.761,14.142Z",
    transform: "translate(-7.914 -54.765)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31444",
    "data-name": "Path 31444",
    d: "M194.354,162.151a110.685,110.685,0,0,0-11.689-6.185c-.047-.026-.1-.063-.144-.1-4.19-2.709-8.507-5.853-12.813-8.624-1.707-1.1-3.969-3.037-6.2-3.887-2.357-.9-4.848-1.678-7.088-2.7-.829-.377-1.642.129-.826.511,2.414,1.133,5.871,2.02,7.883,3.294s3.985,2.539,5.914,3.8q5.055,3.313,10.026,6.768c-.138.057-.223.139-.2.241-5.24-3.163-10.612-6.109-16.023-8.924-.911-.474-1.864.123-.972.591a255.628,255.628,0,0,1,25.75,15.212H191.6c-1.678-1.154-3.36-2.3-5.036-3.459q3.067,1.664,6.009,3.459ZM184.3,158.426c-1.394-.894-2.839-1.792-4.314-2.692.377.154.759.31,1.136.461l.1.065c1.024.69,2.059,1.453,3.079,2.166",
    transform: "translate(-52.128 -57.037)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31445",
    "data-name": "Path 31445",
    d: "M182.154,160.855c-12.928-6.879-26.118-12.9-40.279-16.848-.964-.27-.495-.91.484-.638,14.8,4.079,28.524,10.3,41.976,17.487Z",
    transform: "translate(-58.632 -55.739)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31446",
    "data-name": "Path 31446",
    d: "M184.224,162.14c-9.515-5.467-19.185-10.728-29-15.533-.96-.471.043-1.089,1.026-.6q9.537,4.709,18.868,9.807c-.1-.07-.21-.148-.32-.22-8.887-5.708-18.5-10.995-28.646-14.33-.909-.3-.462-.926.461-.633,14.332,4.551,26.844,12.31,39.126,21.184.188.107.376.219.561.326Z",
    transform: "translate(-56.615 -57.025)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31447",
    "data-name": "Path 31447",
    d: "M199.486,163.18q-2.609-1.9-5.237-3.765c-2.5-1.613-5.213-3.216-8.178-4.8-.53-.28-.351-.616.056-.713a199.151,199.151,0,0,0-27.507-14.883c-.9-.4-.021-.951.885-.555a225.1,225.1,0,0,1,39.343,22.784c.907.644,1.8,1.292,2.671,1.927Z",
    transform: "translate(-50.729 -58.064)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31448",
    "data-name": "Path 31448",
    d: "M206.066,163.737a242.264,242.264,0,0,0-40.128-25.944c-.751-.387.026-.907.793-.514a234.165,234.165,0,0,1,36.51,22.769q-3.45-3.164-7.314-6.509c-.589-.508.587-.935,1.177-.423,3.95,3.41,7.85,6.959,11.647,10.621Z",
    transform: "translate(-47.272 -58.622)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31449",
    "data-name": "Path 31449",
    d: "M193.707,158.467q-5.817-4.885-11.909-9.391c-.7-.524.568-.954,1.268-.432q6.286,4.685,12.27,9.822Z",
    transform: "translate(-39.807 -53.351)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31450",
    "data-name": "Path 31450",
    d: "M128.278,156.922q-4.28-1.508-8.569-3c-1.069-.373-.04-.966,1.016-.591.123.044.236.082.358.128-.911-.379-1.8-.768-2.715-1.149-.82-.335,0-.823.818-.487,4.027,1.66,8.051,3.373,12.066,5.1Z",
    transform: "translate(-69.54 -51.807)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31451",
    "data-name": "Path 31451",
    d: "M123.352,157.952q-3.76-1.68-7.522-3.341c-.721-.32.025-.785.766-.465,2.5,1.085,5,2.188,7.475,3.285-4.659-2.623-9.417-5.1-14.212-7.437-.688-.338.335-.684,1.01-.352,5.334,2.617,10.594,5.4,15.8,8.31Z",
    transform: "translate(-73.467 -52.837)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31452",
    "data-name": "Path 31452",
    d: "M116.921,157.4c-2.053-.825-4.11-1.647-6.141-2.448-.732-.291-.01-.753.735-.459.778.3,1.556.616,2.343.923-2.692-1.408-5.476-2.8-8.331-4.174-.781-.376.365-.776,1.143-.407q6.517,3.113,12.9,6.565Z",
    transform: "translate(-75.508 -52.285)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31453",
    "data-name": "Path 31453",
    d: "M110.312,157.687q-7.457-3.738-15.14-6.922c-.8-.333-.037-.926.772-.593,5.526,2.265,10.992,4.783,16.367,7.515Z",
    transform: "translate(-80.389 -52.572)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31454",
    "data-name": "Path 31454",
    d: "M103.339,155.735c-.828-.336-1.657-.678-2.485-1.01-.589-.239-.021-.643.586-.4q1.761.707,3.53,1.412Z",
    transform: "translate(-77.688 -50.619)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31455",
    "data-name": "Path 31455",
    d: "M175.411,159.948q-7.869-4.348-15.925-8.378c4.827,2.7,9.574,5.542,14.324,8.378h-3.674c-6.239-3.6-12.595-7.048-18.968-10.292-.882-.449.443-.82,1.311-.376q9.053,4.674,17.923,9.681c-1.324-.835-2.673-1.679-4.085-2.519a194.907,194.907,0,0,0-20.327-10.5c-.931-.418,0-.973.947-.558,2.052.892,4.005,1.81,5.89,2.73.088-.241.672-.379,1.255-.109,7.943,3.688,15.83,7.682,23.544,11.94Z",
    transform: "translate(-56.64 -54.833)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31456",
    "data-name": "Path 31456",
    d: "M171,159.882c-10.669-4.936-21.469-9.571-32.4-13.791-1.022-.393-.043-.973.989-.577,11.415,4.372,22.721,9.194,33.846,14.368Z",
    transform: "translate(-60.12 -54.767)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31457",
    "data-name": "Path 31457",
    d: "M179.487,164.014q-3.17-1.361-6.347-2.707c-6.427-3.546-12.979-6.939-19.562-10.08-.958-.458-1.959.139-1.013.593.7.333,1.386.684,2.078,1.023-.818-.123-1.554.2-.809.577.349.176.687.36,1.035.534-6.088-2.322-12.212-4.6-18.344-6.733-.954-.332-1.836.208-.879.542,6.191,2.161,12.379,4.477,18.529,6.828-.672-.015-1.186.276-.55.618q7.591,4.119,15.131,8.373-14.214-5.762-28.634-10.965c-5.981-3.432-12.008-6.853-17.9-10.367-.465-.276-1.193-.032-.74.242,4.967,3,10.009,5.943,15.05,8.845-1.5-.536-3.05-1.054-4.569-1.587-6.931-4.615-13.961-9.041-21.209-13.069-.586-.324-1.478-.009-.881.329q9.619,5.4,18.811,11.6c-.423-.145-.834-.3-1.251-.439-1-.345-1.927.235-.925.58q2.433.839,4.864,1.7,2.479,1.686,4.9,3.36c-.86-.109-1.478.357-.568.681,1.1.39,2.178.8,3.269,1.2q3.32,2.3,6.58,4.525c.343.233.681.468,1.029.694q-7.457-2.88-14.992-5.51a1.708,1.708,0,0,0-1.086-.028c-5.715-3.352-11.52-6.556-17.424-9.46-.694-.342-1.384.148-.712.484A243.363,243.363,0,0,1,140.7,162.908c-4.195-1.565-8.432-3.047-12.662-4.453-1.02-.338-1.974.22-.947.559.95.313,1.89.641,2.846.957-.128.128-.088.3.279.451q4.379,1.783,8.764,3.592h4.97q-5.687-3.82-11.488-7.449c.342.119.677.247,1.023.361a.954.954,0,0,0,.286.182q7.756,3.362,15.41,6.906h4.967q-1.777-.749-3.558-1.5-1.132-.749-2.232-1.5c-1.949-1.331-3.929-2.7-5.918-4.076,1.261.465,2.526.938,3.769,1.41q5.588,2.8,11.155,5.658h1.892c-.589-.3-1.177-.606-1.767-.907-.517-.333-1.029-.675-1.553-1.013,1.59.628,3.175,1.275,4.757,1.92h4.4q-2.109-1.081-4.218-2.149c-1.327-.668-2.717-1.4-4.158-2.128q5.345,2.1,10.656,4.277h4.085q-7.833-4.478-15.734-8.828,3.126,1.226,6.192,2.457,5.652,3.111,11.206,6.371H175.2q-2.657-1.572-5.331-3.117c.493.2.98.4,1.46.6q2.235,1.25,4.463,2.516Zm-38.794-10.27c2.456,1.443,4.877,2.874,7.24,4.3-.515-.194-1.049-.382-1.569-.577-.273-.135-.539-.273-.81-.414a1.8,1.8,0,0,0-.787-.175c-1.729-.643-3.44-1.289-5.193-1.923-1.584-1.1-3.208-2.21-4.845-3.327,2,.7,3.985,1.4,5.963,2.116m8.745,3.749c4.283,1.569,8.47,3.967,12.623,6.082q-5.046-2.056-10.327-4.1-3.591-2.193-7.367-4.4,2.479.911,4.927,1.829c-.363.117-.426.374.144.583",
    transform: "translate(-73.445 -58.9)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31458",
    "data-name": "Path 31458",
    d: "M102.13,156.485q-4.02-1.625-8.062-3.184c-.79-.305-.04-.878.76-.571q4.852,1.832,9.7,3.754Z",
    transform: "translate(-80.903 -51.37)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31459",
    "data-name": "Path 31459",
    d: "M97.526,156.14a55.286,55.286,0,0,0-5.7-2.008c-.87-.242-.484-.947.411-.7a71.128,71.128,0,0,1,7.594,2.708Z",
    transform: "translate(-82.023 -51.025)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31460",
    "data-name": "Path 31460",
    d: "M255.208,157.943c2.2,3.254,4.361,6.521,6.445,9.847h-.947q-1.385-2.254-2.809-4.482,1.158,2.3,2.249,4.482h-.931c-1.651-3.357-3.326-6.706-5-10.057-4.393-6.474-9.115-12.746-14.065-18.733-.2-.236.31-.316.5-.087,3.976,4.819,7.86,9.74,11.573,14.8-.671-1.364-1.352-2.755-2.02-4.143-3.562-7.428-7.637-14.679-13.261-20.791-.229-.245.217-.442.454-.188,5.561,5.946,9.667,13.016,13.263,20.258,1.541,3.1,3.065,6.148,4.547,9.091",
    transform: "translate(-13.946 -62.675)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31461",
    "data-name": "Path 31461",
    d: "M266.307,170.756c-.616-2.441-1.4-5.008-2.34-7.669-4.819-13.609-11.023-26.07-20.689-36.739a.385.385,0,0,0-.182-.112c-1-1.343-2.065-2.676-3.225-3.985-.223-.251-.672-.056-.455.194,1.165,1.3,2.221,2.646,3.21,3.989a.28.28,0,0,0,.078.156c.085.088.159.188.247.276a62.238,62.238,0,0,1,3.432,5.253c-.545-.549-1.124-1.095-1.739-1.629-.269-.233-.725-.048-.456.188a33.734,33.734,0,0,1,3.28,3.346c5,10.094,7.76,20.77,11.616,31.269.2.54.39,1.079.59,1.615-1.026-1.685-2.1-3.418-3.151-5.174-.217-.358-1.02-.251-.8.1,1.833,2.984,3.59,5.943,5.253,8.721.026.068.046.134.069.2h.969l-.361-.6c-.631-1.788-1.347-3.661-2.04-5.542-3.438-9.311-6.129-19.028-10.27-28.2,3.125,4.477,5.165,9.6,7.255,14.545,2.759,6.529,6.035,13.119,8.506,19.792Zm-2.366-4.952c-2.4-5.538-5.006-11.07-7.314-16.572a69.551,69.551,0,0,0-8.654-15.427c-.7-1.28-1.474-2.558-2.282-3.831,7.986,10.224,13.308,21.439,17.523,33.651.255.737.493,1.465.727,2.18",
    transform: "translate(-12.788 -65.64)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31462",
    "data-name": "Path 31462",
    d: "M245.459,162.747q-2.052-2.928-4.108-5.859,1.592,3.025,3.026,5.859h-.7c-6.085-7.794-12.2-15.558-18.253-23.375-.1-.125.164-.166.261-.043,5.613,7.164,11.3,14.268,16.985,21.379-.825-1.635-1.676-3.332-2.582-5.021-.084-.154.1-.205.294-.179-2.5-3.55-5.026-7.1-7.5-10.654-.128-.181.267-.244.393-.063,4.187,5.98,8.46,11.964,12.7,17.956Z",
    transform: "translate(-19.316 -57.632)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31463",
    "data-name": "Path 31463",
    d: "M229.561,150.685c2.1,2.322,4.186,4.593,6.222,6.772h-.593c-1.229-1.337-4.356-4.742-6.141-6.693-.191-.21.323-.289.512-.079",
    transform: "translate(-17.63 -52.344)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31464",
    "data-name": "Path 31464",
    d: "M244.059,167.481q-3.545-4.654-7.114-9.294,2.781,4.575,5.329,9.294H241.7c-2.382-4.315-4.861-8.551-7.428-12.761-2.058-2.652-4.157-5.414-6.308-8.133-.144-.186.254-.252.4-.069q1.907,2.446,3.791,4.846c-4.88-7.576-10.111-15.074-15.582-22.056-.136-.176.233-.248.367-.075,6.379,8.3,12.4,16.92,18.058,25.779q4.817,6.215,9.584,12.467Z",
    transform: "translate(-23.462 -62.366)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31465",
    "data-name": "Path 31465",
    d: "M224.223,145.148c3.722,4.55,11.319,12.693,13.381,14.89h-.5c-4.559-4.833-9.032-9.75-13.254-14.832-.137-.164.239-.227.377-.059",
    transform: "translate(-20.058 -54.923)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31466",
    "data-name": "Path 31466",
    d: "M232.337,160.158c-4.4-4.993-8.72-10.078-12.693-15.251-.092-.117.183-.166.273-.047,4,5.208,8.41,10.3,12.907,15.3Z",
    transform: "translate(-22.018 -55.043)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31467",
    "data-name": "Path 31467",
    d: "M221.278,160.621q-4.416-4.621-8.78-9.285c2.47,3.078,4.91,6.182,7.349,9.285H219c-4.394-5.6-8.783-11.2-13.433-16.521-.258-.3.424-.426.685-.137.939,1.057,1.858,2.124,2.755,3.179q6.314,6.77,12.7,13.478Z",
    transform: "translate(-28.62 -55.506)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31468",
    "data-name": "Path 31468",
    d: "M221.512,160.218a165.041,165.041,0,0,0-13.851-15.212c-.267-.261.26-.486.531-.23a167.6,167.6,0,0,1,13.886,15.442Z",
    transform: "translate(-27.648 -55.103)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31469",
    "data-name": "Path 31469",
    d: "M232.269,167.4c-.276-.517-.55-1.027-.84-1.554q-8.864-9.438-17.454-19.116c-.2-.223.311-.326.515-.1,5.285,5.914,10.619,11.812,16.037,17.623-6.8-11.856-14.271-23.312-21.811-34.67-.175-.266.385-.379.564-.114,8.014,12.015,16.148,24.1,23.146,36.79.364.383.728.76,1.091,1.139Z",
    transform: "translate(-27.136 -62.281)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31470",
    "data-name": "Path 31470",
    d: "M219.627,164.386h-.735q-2.415-2.611-4.851-5.2,2.059,2.589,4.082,5.2h-.7q-3.732-4.786-7.547-9.507a231.137,231.137,0,0,0-20.614-18.819c-.292-.235.208-.439.5-.2,5.506,4.519,10.8,9.19,15.946,14.123-.226-.26-.445-.514-.665-.769s.357-.358.565-.114c1.6,1.846,3.216,3.693,4.72,5.5q4.733,4.822,9.305,9.788",
    transform: "translate(-36.263 -59.271)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31471",
    "data-name": "Path 31471",
    d: "M219.448,162.881c-3.6-4.116-7.224-8.212-10.919-12.245q3.725,6.092,7.336,12.245h-.9c-4.537-5.115-9.188-10.154-14.039-14.893-.329-.323.317-.621.65-.294q6.378,6.3,12.36,13.016-3.661-6.145-7.437-12.21c-.747-.787-1.472-1.588-2.238-2.379-.236-.238.335-.342.556-.11.1.1.194.2.294.307-1.478-2.32-3-4.689-4.593-7.064-.185-.279.424-.409.616-.128,2.137,3.167,4.152,6.332,6.075,9.4,4.406,4.716,8.708,9.517,12.965,14.357Z",
    transform: "translate(-30.971 -57.766)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31472",
    "data-name": "Path 31472",
    d: "M252.972,169.048q-6.418-9.669-12.859-19.321c2.174,4.5,4.277,9.04,6.351,13.593q.907,1.986,1.8,3.928c.385.611.759,1.205,1.133,1.8h-.951c-.205-.462-.412-.928-.627-1.4-2.654-4.245-5.307-8.529-7.987-12.718-.163-.257.4-.342.562-.084,1.964,3.041,3.863,6.062,5.685,8.94-.179-.395-.363-.8-.534-1.189-2.718-6.229-5.789-12.505-8.921-18.62a102.571,102.571,0,0,0-11.1-17.964c-.191-.239.318-.33.5-.091a119.312,119.312,0,0,1,11.535,18.742c.828,1.593,1.637,3.189,2.407,4.751.044-.114.319-.131.424.025q6.6,9.817,13.242,19.6Z",
    transform: "translate(-19.282 -63.933)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31473",
    "data-name": "Path 31473",
    d: "M232.7,167.516q-3.985-4.2-8.033-8.343,1.913,2.367,3.784,4.626,1.711,1.867,3.443,3.716h-.825c-.11-.126-.216-.252-.327-.38-2.933-3.147-5.808-6.373-8.632-9.59-.25-.286.434-.4.675-.123.382.442.768.894,1.154,1.331a.452.452,0,0,1,.292-.015c-1.321-1.325-2.684-2.663-4.048-4.022,1.934,3.021,3.69,5.969,5.287,8.793q1.781,2.019,3.586,4.005h-.782c-.49-.547-.98-1.091-1.478-1.651.3.558.6,1.107.889,1.651h-.611q-.9-1.7-1.89-3.465c-4.918-5.585-9.869-11.178-15-16.512-.254-.264.257-.492.514-.228,4.466,4.638,8.806,9.471,13.1,14.308-1.579-2.733-3.317-5.564-5.2-8.459-1.554-1.522-3.15-3.069-4.755-4.6-.258-.248.233-.464.5-.213,1.011.954,2.015,1.932,3,2.891a258.3,258.3,0,0,0-16.718-22c-.142-.17.236-.252.38-.084a247.164,247.164,0,0,1,17.848,23.554Q226.246,160,233.4,167.516Z",
    transform: "translate(-30.919 -62.401)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31474",
    "data-name": "Path 31474",
    d: "M258.422,170.036q-1.2-2.538-2.425-5.064c-.211-.437-.436-.872-.655-1.314a119.377,119.377,0,0,0-7.76-11.71c-.172-.229.323-.307.5-.081,1.5,1.914,2.875,3.87,4.145,5.779-2.579-4.744-5.4-9.374-8.429-13.82-5.525-8.112-11.708-15.334-20.139-19.819-.321-.175-.007-.448.326-.282,8,3.992,13.98,10.753,19.038,17.879a174.119,174.119,0,0,1,12.837,21.46c.518,1.01,1.014,2.015,1.515,3.012.763,1.349,1.493,2.668,2.2,3.96Z",
    transform: "translate(-20.193 -64.92)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31475",
    "data-name": "Path 31475",
    d: "M200.672,157.242c-1.481-1.99-2.931-3.994-4.324-6-.151-.216.373-.316.518-.1,1.435,2.04,2.913,4.076,4.409,6.1Z",
    transform: "translate(-32.918 -52.127)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31476",
    "data-name": "Path 31476",
    d: "M211.289,163.012q-4.086-4.066-8.177-8.134c2.028,2.635,3.947,5.356,5.778,8.134h-.966c-.542-.677-1.076-1.368-1.629-2.034-.11-.132,0-.232.161-.263a114.45,114.45,0,0,0-7.532-9.872q-2.5-2.371-5.21-4.83c-.3-.27.183-.511.539-.336-2.086-2.181-4.342-4.386-6.784-6.565-.37-.329.323-.6.693-.269a124.27,124.27,0,0,1,11.67,12c4.182,4.02,8.309,8.1,12.435,12.172Z",
    transform: "translate(-37.108 -57.896)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31477",
    "data-name": "Path 31477",
    d: "M197.618,160.037c-5.426-5.049-11.059-9.873-16.77-14.6-.365-.3.339-.549.715-.244,5.875,4.785,11.7,9.7,17.3,14.848Z",
    transform: "translate(-40.204 -54.922)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31478",
    "data-name": "Path 31478",
    d: "M202.925,160.856c-.323-.285-.644-.572-.975-.859.272.288.527.572.8.859h-1.024c-1.7-1.811-3.407-3.622-5.128-5.415q-3.087-2.549-6.473-5.188,4.826,5.275,9.6,10.6h-1.085q-6.109-6.783-12.289-13.5c-.233-.175-.458-.364-.7-.54-.15-.11-.144-.217-.063-.291-.873-.945-1.744-1.908-2.632-2.864-.345-.373.628-.517.972-.142l3.684,3.986q2.45,1.871,4.755,3.688c-1.5-1.463-3.041-2.965-4.656-4.468-.37-.342.546-.483.909-.141q4.626,4.35,9.069,8.928,3.146,2.62,6.192,5.344Z",
    transform: "translate(-39.206 -55.741)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31479",
    "data-name": "Path 31479",
    d: "M208.046,158.1q-3.776-4.419-7.594-8.759c-.141-.157.239-.235.383-.073q3.9,4.359,7.717,8.833Z",
    transform: "translate(-31.001 -52.989)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31480",
    "data-name": "Path 31480",
    d: "M185.348,161.575c-8.777-6.345-17.38-12.931-26.039-19.423-.418-.316.361-.559.79-.238,8.773,6.527,17.5,13.22,26.4,19.66Z",
    transform: "translate(-50.286 -56.459)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31481",
    "data-name": "Path 31481",
    d: "M188.434,160.01c-5.324-4.117-10.7-8.15-16.264-11.966q6.761,5.938,13.434,11.966h-.969q-8.122-7.408-16.389-14.655c-.3-.264.455-.345.747-.092s.608.542.911.806a.916.916,0,0,1,.543.125c6.514,4.246,12.744,8.988,18.919,13.817Z",
    transform: "translate(-46.082 -54.894)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31482",
    "data-name": "Path 31482",
    d: "M185.576,161.6c-9.876-6.781-19.967-13.249-30.095-19.616-.34-.217.229-.389.572-.172,10.205,6.347,20.343,12.932,30.29,19.788Z",
    transform: "translate(-52.07 -56.484)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31483",
    "data-name": "Path 31483",
    d: "M193.135,161.918q-2.888-2.347-5.9-4.838,2.651,2.415,5.287,4.838h-.781c-5.221-4.775-10.453-9.52-16-13.74-.277-.211.229-.376.512-.164.823.612,1.606,1.234,2.381,1.846-.561-.478-1.127-.963-1.685-1.444-.449-.389.652-.534,1.1-.145,4.431,3.829,8.946,7.557,13.49,11.25-5.638-6.279-11.481-12.377-17.55-18.163-.363-.346.568-.468.929-.12,6.9,6.63,13.607,13.43,19.854,20.68Z",
    transform: "translate(-43.405 -56.803)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31484",
    "data-name": "Path 31484",
    d: "M161.69,157.768c-3.176-2.573-6.347-5.131-9.452-7.689-.235-.191.363-.25.592-.066,3.173,2.582,6.382,5.163,9.592,7.756Z",
    transform: "translate(-53.563 -52.653)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31485",
    "data-name": "Path 31485",
    d: "M154.737,157.214q-3.646-2.913-7.264-5.855c-.36-.294.569-.389.923-.1q3.67,3,7.406,5.958Z",
    transform: "translate(-55.805 -52.099)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31486",
    "data-name": "Path 31486",
    d: "M152.6,159.534c-.675-.487-1.349-.98-2.034-1.457q-6.567-3.738-13.2-7.34c-.443-.241.251-.44.7-.2q3.36,1.819,6.6,3.615c-4.413-2.674-8.874-5.2-13.447-7.506-.622-.316.043-.718.668-.4a162.234,162.234,0,0,1,21.7,12.984l.528.31Z",
    transform: "translate(-63.487 -54.419)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31487",
    "data-name": "Path 31487",
    d: "M156.519,161.244q-3.906-2.99-7.791-6.016c-6.517-4.372-13.238-8.516-20-12.4-.473-.273.266-.5.729-.236q9.24,5.3,18.153,11.177a1.1,1.1,0,0,1,.656.194c.627.511,1.281,1.024,1.936,1.534q4.093,2.822,8.086,5.751Z",
    transform: "translate(-64.603 -56.129)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31488",
    "data-name": "Path 31488",
    d: "M142.5,155.541c-.346-.2-.693-.4-1.036-.6-.395-.225.273-.4.666-.178l1.35.775Z",
    transform: "translate(-58.634 -50.426)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31489",
    "data-name": "Path 31489",
    d: "M154.457,159.127q-7.976-5.982-16.054-11.773c-.4-.286.352-.512.76-.225,5.526,3.872,10.99,7.9,16.411,12Z",
    transform: "translate(-60.062 -54.012)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31490",
    "data-name": "Path 31490",
    d: "M139.456,155.913q-1.733-.841-3.479-1.644c-.527-.242.04-.559.577-.31,1.381.636,2.762,1.29,4.133,1.954Z",
    transform: "translate(-61.241 -50.797)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31491",
    "data-name": "Path 31491",
    d: "M143.012,157.138q-4.531-2.772-9.077-5.514c-.5-.3.343-.534.838-.238q4.764,2.856,9.508,5.752Z",
    transform: "translate(-62.171 -52.023)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31492",
    "data-name": "Path 31492",
    d: "M136.654,157.1q-4.48-2.673-8.937-5.347c-.546-.329.386-.6.939-.272,3.2,1.9,6.317,3.781,9.369,5.619Z",
    transform: "translate(-65.085 -51.984)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31493",
    "data-name": "Path 31493",
    d: "M132.483,156.331c-2.059-.994-4.215-1.97-6.492-2.9-.641-.261.006-.633.647-.367q3.679,1.524,7.271,3.267Z",
    transform: "translate(-65.938 -51.216)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31494",
    "data-name": "Path 31494",
    d: "M120.611,154.532c-.771-.307-1.557-.616-2.35-.916-.662-.251-.026-.63.647-.376,2.576.96,5.081,1.973,7.513,3H124.8c-.546-.23-1.093-.461-1.641-.685.455.227.906.458,1.364.685h-1.132c-.964-.483-1.926-.958-2.891-1.425-.277-.131-.135-.251.113-.288",
    transform: "translate(-69.561 -51.13)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31495",
    "data-name": "Path 31495",
    d: "M127.151,157.127c-.137-.082-.269-.16-.4-.242-.948-.357-1.89-.716-2.839-1.067-.555-.2-.023-.5.534-.314-2.18-1.29-4.389-2.6-6.6-3.916-.4-.238.282-.452.688-.208,2.935,1.752,5.933,3.492,8.823,5.216l1.39.531Z",
    transform: "translate(-69.681 -52.012)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31496",
    "data-name": "Path 31496",
    d: "M117.827,155.713c-.644-.357-1.29-.716-1.932-1.076-.456-.257.3-.486.757-.233.778.436,1.562.873,2.343,1.309Z",
    transform: "translate(-70.602 -50.598)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31497",
    "data-name": "Path 31497",
    d: "M108.816,155.493l-.828-.345c-.492-.2,0-.521.5-.316.534.217,1.067.439,1.6.66Z",
    transform: "translate(-74.33 -50.377)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31498",
    "data-name": "Path 31498",
    d: "M163.4,159.528c-7.048-5.232-14.24-9.973-22.48-13.091-.445-.167-.018-.405.414-.244,8.388,3.144,15.731,7.979,22.933,13.334Z",
    transform: "translate(-58.918 -54.412)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31499",
    "data-name": "Path 31499",
    d: "M153.255,157.148c-2.8-1.987-5.619-3.937-8.425-5.776-.178-.116.154-.211.336-.088,2.865,1.915,5.727,3.879,8.577,5.864Z",
    transform: "translate(-57.026 -52.033)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31500",
    "data-name": "Path 31500",
    d: "M115.165,155.63c-.641-.294-1.284-.591-1.926-.884-.433-.2.2-.389.63-.2.79.357,1.576.719,2.365,1.079Z",
    transform: "translate(-71.847 -50.515)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31501",
    "data-name": "Path 31501",
    d: "M101.377,155.531c-.345-.145-.694-.294-1.041-.442-.49-.2-.006-.553.5-.341.625.26,1.251.523,1.877.782Z",
    transform: "translate(-77.91 -50.416)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31502",
    "data-name": "Path 31502",
    d: "M98.118,155.884q-1.8-.757-3.6-1.5c-.536-.217-.015-.614.534-.392q2.272.927,4.529,1.889Z",
    transform: "translate(-80.641 -50.769)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31503",
    "data-name": "Path 31503",
    d: "M183.477,163.354q-3.844-2.765-7.761-5.436,2.992,2.649,5.867,5.436h-1.524c-3.4-3.253-6.917-6.386-10.515-9.446q-6.129-3.8-12.354-7.425c-.308-.178.166-.316.471-.144,3.323,1.883,6.517,3.8,9.59,5.7a195.158,195.158,0,0,0-19.4-13.563c-.671-.412.4-.731,1.055-.333a191.924,191.924,0,0,1,24.715,17.931c3.581,2.373,7.123,4.791,10.613,7.283Z",
    transform: "translate(-55.688 -58.239)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31504",
    "data-name": "Path 31504",
    d: "M170.436,160.06c-8.109-5.281-16.474-10.148-25.021-14.644-.612-.321.314-.589.923-.272,8.673,4.534,17.18,9.51,25.423,14.915Z",
    transform: "translate(-56.823 -54.944)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31505",
    "data-name": "Path 31505",
    d: "M175.532,160.536q-5.449-3.906-11.076-7.588c1.457,1.174,2.884,2.348,4.336,3.492,1.694,1.333,3.354,2.705,5,4.1h-1.728A215.094,215.094,0,0,0,147.3,145.514c-.355-.183.025-.418.387-.23a224.658,224.658,0,0,1,22.571,13.355c-3.521-3.128-7.141-6.015-10.935-8.8-3.339-1.964-6.753-3.829-10.215-5.555-.368-.183.021-.415.389-.232,1.137.569,2.238,1.143,3.329,1.725a.669.669,0,0,1,.68,0,49.755,49.755,0,0,1,7.764,4.741c5.122,3.175,10.1,6.526,14.978,10.026Z",
    transform: "translate(-55.912 -55.421)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31506",
    "data-name": "Path 31506",
    d: "M172.261,158.531c-4.657-3.457-9.363-6.826-14.253-9.926-.429-.269.3-.477.725-.208,4.979,3.107,9.772,6.578,14.523,10.135Z",
    transform: "translate(-50.9 -53.415)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31507",
    "data-name": "Path 31507",
    d: "M256.441,164.8q-4.881-6.651-9.784-13.287a147.113,147.113,0,0,1-4.013-16.465c-.046-.247-.606-.266-.556-.016,1,5.093,2.218,10.117,3.593,15.146-1.924-2.636-3.914-5.335-5.821-8.071-.175-.25-.707-.161-.531.085,2.282,3.223,4.569,6.517,6.887,9.753q.546,1.814,1.133,3.58c-.86-.957-1.738-1.929-2.648-2.893-2.649-4.171-5.41-8.218-8.388-12.112-.225-.291-.853-.194-.627.1a141.615,141.615,0,0,1,14.82,24.177h.844c-.957-2.394-1.86-4.805-2.742-7.237,1.932,2.385,3.778,4.789,5.576,7.237h.79c-2.141-2.817-4.394-5.542-6.7-8.243q-.537-1.574-1.049-3.189,4.115,5.731,8.268,11.432Zm-8.787-8.363c.452,1.336.916,2.652,1.381,3.945-1.06-2.055-2.206-4.171-3.487-6.338q1.085,1.2,2.106,2.392",
    transform: "translate(-14.529 -59.69)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31508",
    "data-name": "Path 31508",
    d: "M253.085,160.067c-3.228-4.939-6.526-9.868-9.712-14.8-.2-.307.461-.4.655-.1,3.254,4.961,6.592,9.9,9.8,14.893Z",
    transform: "translate(-10.928 -54.951)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31509",
    "data-name": "Path 31509",
    d: "M249.442,168.295q-1.792-2.708-3.737-5.31c.9,1.782,1.838,3.55,2.784,5.31h-.945c-1.453-2.736-2.908-5.619-4.343-8.617-2.922-3.741-5.893-7.455-8.849-11.159-.261-.327.459-.442.721-.117,2.274,2.827,4.575,5.657,6.785,8.416a268.265,268.265,0,0,1-11.35-29.23c-.082-.264.493-.25.577.009a254.158,254.158,0,0,0,12.882,31.887c2.224,2.894,4.444,5.789,6.48,8.812Z",
    transform: "translate(-16.931 -63.18)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31510",
    "data-name": "Path 31510",
    d: "M233.506,144.87q6.741,7.411,12.981,15.344h-1.148c-3.957-5.285-8.218-10.339-12.6-15.229-.305-.339.464-.446.766-.114",
    transform: "translate(-15.917 -55.1)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31511",
    "data-name": "Path 31511",
    d: "M217.734,146.016c-.292-.289.305-.54.6-.248,4.838,4.75,10.641,8.962,15.452,13.993h-1.227c-4.55-4.974-10.214-9.154-14.83-13.745",
    transform: "translate(-22.939 -54.647)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31512",
    "data-name": "Path 31512",
    d: "M237.691,169.919c-.311-.36-.631-.719-.956-1.08.227.367.458.721.687,1.08h-1.055q-1.3-2.052-2.577-4.209c-3.706-3.7-7.477-7.334-11.274-10.93-.339-.321.3-.586.64-.263,3.057,2.9,6.179,5.8,9.209,8.754-7.135-12.711-13.439-25.889-19.248-39.158-.112-.252.454-.254.565,0a405.238,405.238,0,0,0,21.1,41.577q2.021,2.05,3.909,4.232Z",
    transform: "translate(-25.069 -64.804)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31513",
    "data-name": "Path 31513",
    d: "M243.178,167.614c-2.46-3.059-5.049-6.006-7.694-8.921.555,1.861,1.133,3.684,1.7,5.456q1.574,1.752,2.977,3.465h-1.13c-.386-.476-.779-.956-1.186-1.437.163.487.326.96.489,1.437h-.622q-.443-1.292-.876-2.629a172.037,172.037,0,0,0-12.969-13.218c-.355-.327.3-.594.661-.267,4.038,3.688,7.986,7.53,11.7,11.575-.552-1.725-1.086-3.5-1.616-5.316-1.811-1.91-3.743-3.844-5.752-5.781-.349-.335.311-.6.663-.266,1.606,1.534,3.164,3.076,4.673,4.609-2.571-9.009-4.641-18.125-6.42-27.322-.04-.2.414-.2.455.009,1.835,9.473,4.154,18.866,6.81,28.181,3.2,3.4,6.251,6.841,9.169,10.427Z",
    transform: "translate(-20.082 -62.499)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31514",
    "data-name": "Path 31514",
    d: "M226.961,158.242c-2.978-3.066-6.078-6-9.247-8.88-.4-.367.368-.675.774-.311,3.267,2.927,6.471,5.98,9.52,9.191Z",
    transform: "translate(-22.965 -53.127)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31515",
    "data-name": "Path 31515",
    d: "M223.364,156.878q-2.356-2.413-4.716-4.817c-.258-.264.4-.363.65-.106q2.431,2.457,4.882,4.923Z",
    transform: "translate(-22.503 -51.762)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31516",
    "data-name": "Path 31516",
    d: "M213.567,164.152c-4.28-5.413-8.652-10.914-12.658-16.486-.2-.277.423-.409.621-.136,1.83,2.53,3.685,5.014,5.547,7.424-4-6.044-7.786-12.2-11.5-18.414-.169-.288.458-.412.631-.126,5.705,9.411,11.589,18.968,18.194,27.739Z",
    transform: "translate(-33.279 -59.037)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31517",
    "data-name": "Path 31517",
    d: "M210.767,160.6c-4.848-5.505-9.727-10.992-14.658-16.39-.338-.373.546-.534.884-.166,5.017,5.459,10.014,10.973,14.936,16.556Z",
    transform: "translate(-33.053 -55.488)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31518",
    "data-name": "Path 31518",
    d: "M202.291,156.719c-1.531-1.394-3.041-2.786-4.458-4.22-.338-.341.575-.509.91-.17,1.49,1.485,3.073,2.938,4.679,4.39Z",
    transform: "translate(-32.245 -51.604)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31519",
    "data-name": "Path 31519",
    d: "M206.858,158.783a94.56,94.56,0,0,0-12-10.553c-.474-.367.355-.706.826-.34a96.631,96.631,0,0,1,12.454,10.894Z",
    transform: "translate(-33.669 -53.667)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31520",
    "data-name": "Path 31520",
    d: "M197.819,157.017q-2.732-2.622-5.7-4.977c-.511-.4.448-.76.964-.352a74.68,74.68,0,0,1,6.063,5.329Z",
    transform: "translate(-34.952 -51.902)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31521",
    "data-name": "Path 31521",
    d: "M199.6,165.253a73.126,73.126,0,0,0-7.855-6.013c-.5-.338.345-.622.837-.294,1.81,1.205,3.527,2.458,5.124,3.7-6.857-9.2-13.089-18.831-19.277-28.442-.2-.317.571-.439.776-.117a362.431,362.431,0,0,0,21.834,31.166Z",
    transform: "translate(-41.301 -60.138)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31522",
    "data-name": "Path 31522",
    d: "M190.466,157.844c-3.314-2.695-6.737-5.234-10.213-7.657-.5-.349.379-.637.876-.289,3.619,2.51,7.2,5.142,10.644,7.946Z",
    transform: "translate(-40.504 -52.728)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31523",
    "data-name": "Path 31523",
    d: "M187.839,165.853q-1.739-1.805-3.457-3.641c-5.671-5.168-11.478-10.195-17.313-15.162-.386-.329.546-.434.919-.119,4.083,3.446,8.139,6.972,12.168,10.506-6.655-7.886-12.884-16.048-18.8-24.494-.244-.349.678-.467.925-.12a305.308,305.308,0,0,0,24.426,30.507c.9.835,1.8,1.679,2.7,2.523Z",
    transform: "translate(-49.291 -60.738)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31524",
    "data-name": "Path 31524",
    d: "M182.7,155.865c-.52-.508-1.045-1.017-1.576-1.537-.383-.373.718-.514,1.107-.139l1.744,1.676Z",
    transform: "translate(-40.063 -50.75)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31525",
    "data-name": "Path 31525",
    d: "M182.067,160.446c-6.33-5.444-12.915-10.618-19.276-15.915-.452-.379.652-.5,1.095-.132,6.446,5.325,13.105,10.5,19.414,16.047Z",
    transform: "translate(-48.651 -55.331)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31526",
    "data-name": "Path 31526",
    d: "M178.644,159.527c-5.271-4.634-10.814-8.925-16.5-13.031-.405-.292.323-.512.729-.219a202,202,0,0,1,16.97,13.249Z",
    transform: "translate(-48.961 -54.412)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31527",
    "data-name": "Path 31527",
    d: "M175.089,158.082a142.163,142.163,0,0,0-12.3-8.4c-.567-.364.408-.647.98-.28a129.291,129.291,0,0,1,12.715,8.682Z",
    transform: "translate(-48.683 -52.967)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31528",
    "data-name": "Path 31528",
    d: "M177.469,165.682c-2.31-1.544-4.67-3.018-6.989-4.522q2.331,2.283,4.7,4.522h-1.226a398.678,398.678,0,0,1-30.142-32.362c-.3-.36.682-.483.994-.12q11.556,13.608,24.149,26.434a1.191,1.191,0,0,1,.864.151c3.029,1.986,6.276,3.854,9.4,5.9Z",
    transform: "translate(-57.507 -60.567)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31529",
    "data-name": "Path 31529",
    d: "M159.763,155.6c-.351-.223-.7-.451-1.057-.666-.531-.332.41-.578.948-.25.49.3.975.6,1.459.916Z",
    transform: "translate(-50.586 -50.487)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31530",
    "data-name": "Path 31530",
    d: "M159.259,155.791q-1.037-.638-2.08-1.271c-.522-.32.393-.558.92-.244q1.259.753,2.514,1.515Z",
    transform: "translate(-51.299 -50.676)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31531",
    "data-name": "Path 31531",
    d: "M159.961,161.576q-7.208-4.361-14.4-8.754c3.076,3.056,6.3,5.959,9.615,8.754h-1.236c-3.919-3.382-7.712-6.893-11.374-10.606-4.767-2.971-9.812-5.965-14.127-9.178-.035-.026.028-.047.063-.023,4.5,2.925,9.071,5.919,13.672,8.79-.062-.07-.138-.141-.2-.205-.333-.342.729-.476,1.064-.119.665.706,1.346,1.409,2.037,2.1q7.688,4.652,15.417,9.241Z",
    transform: "translate(-64.676 -56.461)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31532",
    "data-name": "Path 31532",
    d: "M146.413,159.695c-7.908-4.5-15.888-8.887-23.565-13.647-.338-.205.219-.379.555-.172,7.826,4.829,16,9.269,24.106,13.819Z",
    transform: "translate(-67.333 -54.579)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31533",
    "data-name": "Path 31533",
    d: "M141.687,159.53c-7.039-4.365-14.177-8.576-21.221-12.918-.6-.367.39-.683.988-.316,7.258,4.466,14.76,8.664,22.006,13.233Z",
    transform: "translate(-68.486 -54.415)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31534",
    "data-name": "Path 31534",
    d: "M133.326,157.364c-3.134-2.1-6.3-4.135-9.512-6.075-.671-.407.476-.75,1.154-.339,3.39,2.067,6.755,4.183,10.047,6.414Z",
    transform: "translate(-66.928 -52.249)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31535",
    "data-name": "Path 31535",
    d: "M128.7,157.341c-1.763-1.06-3.545-2.075-5.319-3.091-.716-.409.486-.766,1.211-.351,1.791,1.03,3.806,2.122,5.792,3.235a.947.947,0,0,1,.549-.1c-2.906-1.86-5.861-3.778-8.748-5.754-.53-.364.461-.66,1-.305,3.266,2.18,6.63,4.267,10,6.366Z",
    transform: "translate(-67.664 -52.225)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31536",
    "data-name": "Path 31536",
    d: "M125.778,156.918l-.164-.114c-.432-.258-.869-.518-1.318-.776-.123-.07-.164-.141-.159-.2-1.867-1.189-3.86-2.384-5.912-3.59-.663-.39.437-.729,1.114-.343,2.806,1.6,5.665,3.2,8.36,5.028Z",
    transform: "translate(-69.543 -51.802)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31537",
    "data-name": "Path 31537",
    d: "M118.59,155.826c-.837-.436-1.661-.853-2.414-1.262-.671-.365.465-.729,1.145-.346.945.537,1.9,1.074,2.828,1.609Z",
    transform: "translate(-70.501 -50.71)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31538",
    "data-name": "Path 31538",
    d: "M116.19,156.7c-1.908-1.347-3.821-2.7-5.689-4.077-.586-.437.826-.638,1.4-.214,2,1.457,4.057,2.862,6.1,4.292Z",
    transform: "translate(-73.125 -51.588)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31539",
    "data-name": "Path 31539",
    d: "M120.079,162.881c-9.813-6.072-18.812-13.641-24.275-23.776-.088-.164.352-.186.446-.022,5.767,10.3,15.128,17.755,25.21,23.8Z",
    transform: "translate(-79.94 -57.766)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31540",
    "data-name": "Path 31540",
    d: "M112.985,157.946a75.059,75.059,0,0,1-9.915-8.114c-.3-.289.572-.451.882-.156a81.655,81.655,0,0,0,10.343,8.269Z",
    transform: "translate(-76.564 -52.831)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31541",
    "data-name": "Path 31541",
    d: "M113.876,159.3c-5.642-3.926-11.131-8.051-16.59-12.259-.363-.283.326-.569.7-.286,5.629,4.29,11.31,8.517,17.143,12.545Z",
    transform: "translate(-79.289 -54.181)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31542",
    "data-name": "Path 31542",
    d: "M111.176,160.57a179.045,179.045,0,0,1-21.014-16.355c-.294-.269.418-.436.712-.173a187.876,187.876,0,0,0,21.488,16.528Z",
    transform: "translate(-82.606 -55.455)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31543",
    "data-name": "Path 31543",
    d: "M98.087,158.229q-6.689-4.278-13.028-9.038c-.229-.172.173-.386.407-.208q6.589,4.87,13.455,9.247Z",
    transform: "translate(-84.992 -53.114)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31544",
    "data-name": "Path 31544",
    d: "M95.4,155.648c-.48-.336-.97-.669-1.447-1.01-.25-.179.32-.291.564-.116.518.38,1.047.754,1.579,1.126Z",
    transform: "translate(-80.83 -50.532)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31545",
    "data-name": "Path 31545",
    d: "M258.572,165.573a159.744,159.744,0,0,1-4.638-32.236c-.013-.232.52-.106.528.122a148.593,148.593,0,0,0,5,32.114Z",
    transform: "translate(-5.97 -60.458)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31546",
    "data-name": "Path 31546",
    d: "M224.952,164.838a273.319,273.319,0,0,1-17.136-29.913c-.091-.183.333-.183.424,0a267.251,267.251,0,0,0,17.291,29.915Z",
    transform: "translate(-27.548 -59.722)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31547",
    "data-name": "Path 31547",
    d: "M283.5,161.476q-7.03-9.218-13.955-18.507c-.622-.828.662-1.434,1.309-.589,4.841,6.36,9.653,12.759,14.538,19.1Z",
    transform: "translate(1.252 -56.361)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31548",
    "data-name": "Path 31548",
    d: "M272.8,163.308c-6.074-7.976-12.128-15.966-18.414-23.748-1-1.23.926-2.158,1.933-.916,6.552,8.071,12.844,16.379,19.16,24.664Z",
    transform: "translate(-5.887 -58.193)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31549",
    "data-name": "Path 31549",
    d: "M268.774,162.14c-6.185-6.884-12.314-13.828-18.411-20.742-.606-.687.5-1.206,1.115-.521,6.288,7.052,12.537,14.19,18.847,21.263Z",
    transform: "translate(-7.723 -57.025)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31550",
    "data-name": "Path 31550",
    d: "M275.67,159.6c-3.483-4.339-6.992-8.652-10.579-12.827-.553-.644.511-1.115,1.07-.465,3.731,4.339,7.377,8.8,10.995,13.292Z",
    transform: "translate(-0.825 -54.481)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31551",
    "data-name": "Path 31551",
    d: "M285.235,168.909c-11.164-14.978-22.829-29.537-36.489-42.1-.483-.442.069-1.017.568-.561,14.018,12.828,26.286,27.463,37.866,42.66Z",
    transform: "translate(-8.484 -63.794)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31552",
    "data-name": "Path 31552",
    d: "M272.73,169.593c-3.059-3.492-6.1-7-9.176-10.483-2.718-2.809-5.554-5.514-8.507-8.067-.54-.464-.343-1.013.092-1.164a182.533,182.533,0,0,0-27.588-24.138c-.887-.624,0-1.529.889-.919,15.1,10.4,27.911,23.823,40.062,37.479,1.78,2,3.543,4.027,5.169,5.933.392.458.785.907,1.179,1.359Z",
    transform: "translate(-18.482 -64.478)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31553",
    "data-name": "Path 31553",
    d: "M279.92,170.542c-13.672-16.958-28.1-33.112-44.975-46.9-.756-.616.054-1.444.823-.826,14.064,11.293,26.582,24.254,38.3,38.072q-3.919-5.6-7.94-11.117c-.622-.862.712-1.5,1.352-.625,5.137,7,10.138,14.18,15.058,21.4Z",
    transform: "translate(-14.993 -65.426)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31554",
    "data-name": "Path 31554",
    d: "M266.736,161.891c-5.05-6.716-10.226-13.346-15.618-19.732-.738-.876.666-1.535,1.406-.655,5.544,6.587,10.8,13.446,15.959,20.387Z",
    transform: "translate(-7.385 -56.775)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31555",
    "data-name": "Path 31555",
    d: "M273.942,159.431q-3.21-6.334-6.217-12.753c-.172-.365.489-.473.659-.106q3.032,6.477,6.279,12.859Z",
    transform: "translate(0.467 -54.316)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31556",
    "data-name": "Path 31556",
    d: "M286.658,169.206c-3.69-5.293-7.308-10.641-10.957-15.965,2.667,5.262,5.235,10.557,7.591,15.965H282.17c-.194-.446-.39-.891-.587-1.346-.773-1.393-1.532-2.828-2.332-4.283-.122-.222.028-.365.238-.4-2.726-5.771-5.616-11.422-8.689-17.014-1.946-2.778-3.922-5.582-5.962-8.4-.338-.47.255-.82.662-.515-2.394-3.8-4.932-7.534-7.546-11.14-.387-.536.421-.947.818-.4a236.274,236.274,0,0,1,13.135,20.531c5.332,7.645,10.59,15.344,15.946,22.97Z",
    transform: "translate(-4.138 -64.091)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31557",
    "data-name": "Path 31557",
    d: "M270.714,164.487c-6.637-9.571-13.414-19.04-20.447-28.333-.382-.506.392-.885.787-.377,7.227,9.347,14.252,18.994,21.128,28.71Z",
    transform: "translate(-7.734 -59.372)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31558",
    "data-name": "Path 31558",
    d: "M276.9,165.795c-1.12-1.5-2.234-3-3.363-4.493q1.385,2.25,2.781,4.493h-1.129q-3.866-6.178-7.728-12.36-3.529-4.511-7.142-8.955,6.2,10.68,12.458,21.315h-1.237c-5.169-8.718-10.239-17.5-15.314-26.277-.247-.3-.5-.614-.753-.916-.159-.189-.157-.364-.057-.483-.919-1.588-1.83-3.2-2.764-4.8-.373-.63.716-.822,1.082-.2,1.311,2.244,2.6,4.49,3.89,6.706,1.774,2.121,3.5,4.24,5.2,6.344-1.637-2.516-3.3-5.071-5.042-7.622-.4-.587.643-.765,1.035-.183q5.077,7.554,9.935,15.269,4.67,6.041,9.254,12.157Z",
    transform: "translate(-6.604 -60.679)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31559",
    "data-name": "Path 31559",
    d: "M282.86,160.616c-3.229-5.539-6.471-11.071-9.794-16.552-.172-.282.321-.354.49-.084,3.37,5.485,6.649,11.055,9.915,16.635Z",
    transform: "translate(2.961 -55.501)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31560",
    "data-name": "Path 31560",
    d: "M289.21,170.756c-5.232-9.728-10.543-19.6-15.449-29.516-.236-.477.574-.608.812-.134,2.168,4.3,4.353,8.619,6.578,12.9-4.682-10.389-9.093-20.9-13.377-31.438-.191-.474.6-.625.794-.139,6.549,16.307,13.506,32.8,21.623,48.322Z",
    transform: "translate(0.489 -65.64)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31561",
    "data-name": "Path 31561",
    d: "M286.113,164.967c-6.057-9.962-12.084-19.945-18.181-29.87-.4-.65.715-.825,1.108-.2,6.222,9.932,12.376,19.994,18.483,30.065Z",
    transform: "translate(0.538 -59.852)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31562",
    "data-name": "Path 31562",
    d: "M276.451,158.5c-2.414-3.181-4.816-6.352-6.981-9.609-.4-.6.765-.779,1.161-.17,2.2,3.4,4.769,6.571,7.3,9.78Z",
    transform: "translate(1.258 -53.383)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31563",
    "data-name": "Path 31563",
    d: "M281.575,162.029c-4.358-7.361-9.994-14.029-15.451-20.457-.55-.647.484-1.12,1.044-.468,5.589,6.52,11.544,13.336,15.951,20.926Z",
    transform: "translate(-0.342 -56.914)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31564",
    "data-name": "Path 31564",
    d: "M271.086,159.245c-2.671-4.026-5.508-7.929-8.5-11.661-.564-.7.587-1.206,1.157-.5,3.129,3.894,6.1,7.948,8.846,12.16Z",
    transform: "translate(-1.996 -54.13)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31565",
    "data-name": "Path 31565",
    d: "M272.207,172.919l-.009-.015c-.5-.929-.988-1.877-1.482-2.84-2.9-3.813-5.9-7.5-9.118-10.967-.531-.572.421-.986.957-.421,1.976,2.09,3.881,4.233,5.648,6.376-7.34-15.411-13.569-31.376-20.045-47.073-.2-.5.638-.671.844-.164,7.311,17.783,14.642,35.688,23.513,52.828.553.766,1.082,1.523,1.592,2.276Z",
    transform: "translate(-8.687 -67.804)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31566",
    "data-name": "Path 31566",
    d: "M263.269,160.893c-4.39-5.859-9.05-11.509-13.886-16.958-.517-.581.439-1.027.967-.434,4.986,5.592,9.806,11.376,14.329,17.393Z",
    transform: "translate(-8.169 -55.778)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31567",
    "data-name": "Path 31567",
    d: "M386.884,169.366c-6.711-13.993-13.026-28.2-19.837-42.093-.826-1.685,1.058-3.109,1.914-1.386,7.113,14.332,13.653,29.019,20.619,43.479Z",
    transform: "translate(46.842 -64.251)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31568",
    "data-name": "Path 31568",
    d: "M371.325,172.044c-8.469-16.591-16.449-33.441-25.752-49.517-1.327-2.293,1.5-4.465,2.843-2.168,9.775,16.721,18.046,34.344,26.838,51.685Z",
    transform: "translate(36.731 -66.929)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31569",
    "data-name": "Path 31569",
    d: "M365.725,169.367c-8.84-14.089-17.18-28.515-26.1-42.5-.817-1.28.822-2.5,1.641-1.224,9.184,14.337,17.607,29.252,26.685,43.721Z",
    transform: "translate(34.005 -64.251)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31570",
    "data-name": "Path 31570",
    d: "M376,165.133c-5.146-9.815-10.194-19.7-15.64-29.287-.738-1.3.823-2.414,1.568-1.1,5.664,9.979,10.894,20.209,16.224,30.388Z",
    transform: "translate(43.718 -60.018)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31571",
    "data-name": "Path 31571",
    d: "M388.8,181.747c-13.607-28.95-27.012-59.367-50.139-81.853-.653-.636.217-1.7.881-1.063,23.732,22.749,38,53.467,52.09,82.916Z",
    transform: "translate(33.551 -76.632)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31572",
    "data-name": "Path 31572",
    d: "M370.266,181.275c-4.506-7.311-8.878-14.707-13.349-22.038-3.647-5.224-7.434-10.346-11.52-15.147a1.544,1.544,0,0,1,.23-2.334c-10.687-15.219-22.593-29.029-37.178-40.358-1.2-.931.183-2.363,1.383-1.469,23.058,17.195,39.01,40.827,53.907,65.2,2.287,3.744,4.584,7.59,6.793,11.34.945,1.6,1.924,3.21,2.918,4.81Z",
    transform: "translate(19.313 -76.159)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31573",
    "data-name": "Path 31573",
    d: "M380.824,183.051c-16.979-31.251-33.8-62.847-61.547-85.6-.992-.816.255-2.152,1.287-1.355,22.175,17.149,37.661,40.834,51.345,64.926-3.4-7.356-6.865-14.689-10.487-21.916-.825-1.653,1.136-3.175,1.984-1.491,7.488,14.886,14.212,30.18,20.989,45.441Z",
    transform: "translate(24.424 -77.936)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31574",
    "data-name": "Path 31574",
    d: "M362.449,168.928c-6.992-13.72-13.913-27.485-21.8-40.634-.988-1.642,1.088-3.2,2.081-1.544,8.177,13.577,15.168,27.913,22.28,42.178Z",
    transform: "translate(34.466 -63.813)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31575",
    "data-name": "Path 31575",
    d: "M372.736,164.918c-3.035-9.81-5.837-19.7-8.592-29.568-.213-.757.738-1.052.954-.286,2.8,9.978,5.621,19.952,8.674,29.854Z",
    transform: "translate(45.565 -59.803)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31576",
    "data-name": "Path 31576",
    d: "M390.619,183.246C385.283,171.052,380.3,158.7,374.983,146.5q5.218,16.64,9.413,33.547.535,1.6,1.074,3.2h-1.917c-.465-1.993-.979-4.077-1.512-6.233-.939-2.806-1.852-5.787-2.864-8.762a.6.6,0,0,1,.376-.847c-3.264-11.893-6.909-23.634-11.077-35.248-2.533-5.34-5.119-10.659-7.852-15.893-.442-.848.43-1.637.985-1.129a189.093,189.093,0,0,0-9.672-18.523c-.489-.809.719-1.669,1.221-.85,6.979,11.362,12.191,23.785,16.916,36.391,7.808,16.856,14.71,34.107,22.21,51.094Z",
    transform: "translate(39.816 -78.131)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31577",
    "data-name": "Path 31577",
    d: "M367.97,173.966c-8.868-19.427-17.616-38.96-28.041-57.439-.509-.9.625-1.785,1.145-.87,10.7,18.875,19.92,38.59,29.092,58.309Z",
    transform: "translate(34.193 -68.851)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31578",
    "data-name": "Path 31578",
    d: "M377.1,176.674q-2.948-6.046-5.894-12.091,2.345,6.05,4.716,12.091h-1.65c-3.725-9.282-7.3-18.626-11.048-27.9q-4.643-8.861-9.549-17.57c5.8,15.1,11.211,30.354,16.973,45.471h-1.782c-6.964-18.219-13.49-36.6-20.669-54.741-.335-.559-.669-1.123-1.013-1.669a.887.887,0,0,1-.032-.942c-1.184-2.933-2.363-5.827-3.552-8.645a.844.844,0,1,1,1.572-.6q2.565,6.074,5.014,12.217,3.547,5.947,6.959,11.974c-2.153-4.874-4.34-9.747-6.631-14.532-.518-1.083,1-1.629,1.506-.562,4.673,9.778,8.93,19.812,13.038,29.885,4.678,9.147,9.144,18.392,13.654,27.62Z",
    transform: "translate(35.927 -71.559)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31579",
    "data-name": "Path 31579",
    d: "M385.6,167.687c-4.441-12.86-8.861-25.737-13.609-38.439-.22-.589.493-.785.716-.207,4.877,12.737,9.294,25.7,13.764,38.646Z",
    transform: "translate(49.232 -62.572)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31580",
    "data-name": "Path 31580",
    d: "M393.56,186.674c-6.639-21.687-13.537-43.665-20.537-65.353-.3-.932.867-1.319,1.168-.383q4.258,13.216,8.426,26.5c-5.265-19.568-10.375-39.259-16.157-58.6-.207-.693.942-1.063,1.151-.368,9.787,32.53,17.529,65.9,27.293,98.2Z",
    transform: "translate(46.652 -81.559)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31581",
    "data-name": "Path 31581",
    d: "M389.965,176.444c-7.951-21.859-15.659-43.818-24.623-65.237-.514-1.22,1.093-1.761,1.6-.558,9.147,21.56,17.1,43.683,25.029,65.794Z",
    transform: "translate(46.093 -71.328)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31582",
    "data-name": "Path 31582",
    d: "M377.284,163.012c-3.7-7.7-7.632-15.3-10.822-23.113-.517-1.267,1.168-1.722,1.691-.458,3.3,7.992,7.439,15.711,11.255,23.57Z",
    transform: "translate(46.618 -57.896)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31583",
    "data-name": "Path 31583",
    d: "M383.782,170.32c-5.131-16.006-13.251-31.3-21.53-45.569-.737-1.273.775-2.4,1.518-1.121,8.473,14.523,17.168,30.238,22.205,46.69Z",
    transform: "translate(44.602 -65.205)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31584",
    "data-name": "Path 31584",
    d: "M369.027,164.254a286.044,286.044,0,0,0-12.345-26.394c-.751-1.4.944-2.61,1.71-1.186a264.218,264.218,0,0,1,12.794,27.58Z",
    transform: "translate(42.001 -59.138)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31585",
    "data-name": "Path 31585",
    d: "M368.809,187.572q-.491-1.42-.967-2.846c-.595-1.783-1.177-3.627-1.777-5.514A208.2,208.2,0,0,0,354,157.677c-.713-1.107.707-2.125,1.428-1.019,2.646,4.072,5.14,8.285,7.553,12.543-8.086-27.357-14.426-55.45-23.948-82.323-.208-.587,1.035-1,1.251-.411,11.159,30.633,18.309,62.711,28.305,93.75,1.113,2.441,2.2,4.888,3.245,7.353Z",
    transform: "translate(33.822 -82.457)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31586",
    "data-name": "Path 31586",
    d: "M357.357,166.786c-5.969-11.827-12.322-23.435-19.361-34.658-.7-1.113.715-2.14,1.422-1.024,7.3,11.491,13.9,23.469,20.046,35.682Z",
    transform: "translate(33.26 -61.67)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31587",
    "data-name": "Path 31587",
    d: "M368.323,183.122c-.882-2.5-1.769-4.993-2.679-7.436-4.246-11.35-8.313-24.99-13.631-34.237-.006-.009,0-.026-.006-.046-7.257-15.893-15.347-31.379-26.374-44.747-.534-.647.658-1.352,1.205-.709,19.508,22.9,30.909,52.028,41.324,80.271q1.407,3.452,2.834,6.9Z",
    transform: "translate(27.504 -78.007)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31588",
    "data-name": "Path 31588",
    d: "M367.226,176.226c-8.341-21.475-16.355-43.156-22.988-65.108-.185-.621.757-.979.961-.343,7.192,22.025,15.695,43.893,24.643,65.451Z",
    transform: "translate(36.258 -71.11)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31589",
    "data-name": "Path 31589",
    d: "M381.57,176.162a191.709,191.709,0,0,0-7.971-22.2c-1.158-2.764-2.419-5.567-3.693-8.373,1.949,5.874,3.854,11.77,5.436,17.733q1.689,6.385,3.222,12.838h-2.174c-.885-3.832-1.8-7.654-2.767-11.426a385.643,385.643,0,0,0-11.975-37.022c-2.561-5.52-5.155-11.061-7.507-16.638-.2-.473.5-.716.713-.247.619,1.38,1.281,2.764,1.934,4.155-.276-.7-.547-1.41-.822-2.114a.753.753,0,1,1,1.427-.48q4.029,9.938,7.823,20.011c3.2,6.551,6.454,13.155,9.41,19.738a178,178,0,0,1,8.993,24.023Z",
    transform: "translate(40.884 -71.047)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31590",
    "data-name": "Path 31590",
    d: "M331.439,169.6c-10.684-14.616-20.984-29.518-31.675-44.128-.517-.7.464-1.227.978-.528,10.869,14.746,21.384,29.858,32.282,44.656Z",
    transform: "translate(15.398 -64.482)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31591",
    "data-name": "Path 31591",
    d: "M322.408,162.876c-5.049-7.465-9.951-15.03-14.846-22.6-.671-1.038.794-1.858,1.48-.809,5.125,7.817,10.226,15.687,15.537,23.408Z",
    transform: "translate(19.033 -57.761)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31592",
    "data-name": "Path 31592",
    d: "M345.445,174.834c-6.57-10.359-12.9-20.877-19.644-31.125,3.956,6.785,7.923,13.635,11.582,20.51,1.855,3.48,3.628,7.033,5.357,10.615h-3c-1.534-3.385-3.094-6.75-4.716-10.048-6.194-12.587-13.4-24.9-20.5-37.147-3.368-4.543-6.887-9-10.465-13.348-.565-.683.465-1.245,1.036-.577,1.51,1.767,3.018,3.552,4.488,5.353-.881-1.543-1.775-3.084-2.64-4.623-.44-.778.806-1.057,1.249-.308,2.588,4.38,5.225,8.767,7.845,13.147,11.453,15.3,21.338,31.539,31.674,47.552Z",
    transform: "translate(17.397 -69.719)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31593",
    "data-name": "Path 31593",
    d: "M350.546,176.9c-9.172-22.677-18.806-45.192-31.372-66.075-1.051-1.748,1.939-2.61,2.985-.932,13.119,21.068,23.105,43.976,32.666,67.007Z",
    transform: "translate(24.442 -71.787)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31594",
    "data-name": "Path 31594",
    d: "M375.1,108.139a228.538,228.538,0,0,1,18.2,60.113v9.339h-.58a232.94,232.94,0,0,0-19.2-69c-.506-1.1,1.074-1.528,1.581-.451",
    transform: "translate(49.92 -72.478)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31595",
    "data-name": "Path 31595",
    d: "M387.738,169.956A258.484,258.484,0,0,0,370.8,124.492a.455.455,0,1,1,.829-.373,250.707,250.707,0,0,1,17.933,45.838Z",
    transform: "translate(48.669 -64.841)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31596",
    "data-name": "Path 31596",
    d: "M382.31,170.05a382.406,382.406,0,0,0-16.346-45.885c-.232-.536.5-.741.735-.216a378.056,378.056,0,0,1,17.048,46.1Z",
    transform: "translate(46.41 -64.934)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31597",
    "data-name": "Path 31597",
    d: "M309.738,165.19c-6.335-9.75-12.454-19.655-18.922-29.264-1.069-1.588,1.086-2.72,2.168-1.115,6.756,10,13.145,20.271,19.779,30.379Z",
    transform: "translate(11.146 -60.075)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31598",
    "data-name": "Path 31598",
    d: "M305.129,163.745c-6.393-8.431-12.565-17.029-18.841-25.552-.658-.894.586-1.532,1.249-.638,6.437,8.715,12.759,17.545,19.318,26.19Z",
    transform: "translate(9.076 -58.629)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31599",
    "data-name": "Path 31599",
    d: "M313.217,160.413c-3.578-5.067-7.139-10.148-10.764-15.172-.594-.82.609-1.427,1.212-.6,3.815,5.188,7.537,10.49,11.283,15.775Z",
    transform: "translate(16.648 -55.298)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31600",
    "data-name": "Path 31600",
    d: "M323.671,172.287c-11.965-18.256-23.924-36.426-38.757-52.523-.527-.574.12-1.259.655-.685,15.206,16.22,27.878,34.659,40.348,53.209Z",
    transform: "translate(8.429 -67.171)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31601",
    "data-name": "Path 31601",
    d: "M296.22,171.182c-14.648-17.092-29.519-33.914-46.184-49.052-.594-.54.056-1.256.662-.713,16.985,15.168,32.127,32.367,47.016,49.765Z",
    transform: "translate(-7.903 -66.067)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31602",
    "data-name": "Path 31602",
    d: "M301.56,171.172c-3.574-4.689-7.139-9.383-10.778-14.024,2.072,4.65,4.063,9.332,6.029,14.024h-2.068c-2.648-6.505-5.366-12.972-8.269-19.374a225.9,225.9,0,0,0-25.567-26.691c-.9-.79.063-1.835.973-1.049a225.508,225.508,0,0,1,21.753,21.885,164.27,164.27,0,0,0-15.022-24.133c-.355-.467.28-.8.647-.349A162.4,162.4,0,0,1,287.823,150.9c5.4,6.652,10.6,13.459,15.8,20.27Z",
    transform: "translate(-2.877 -66.056)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31603",
    "data-name": "Path 31603",
    d: "M308.161,170.548c-7.21-9.821-14.246-19.765-21.709-29.4,6.674,9.711,13.067,19.606,19.616,29.4h-3.779c-6.128-9.383-12.175-18.827-18.473-28.041-1.3-1.907,1.267-3.31,2.61-1.393-4.789-6.043-9.7-11.977-14.81-17.733-.583-.656.371-1.139.954-.506,13.811,14.967,25.571,31.418,37.74,47.674Z",
    transform: "translate(2.215 -65.433)",
    fill: "#6b401d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31604",
    "data-name": "Path 31604",
    d: "M380.722,172.939a341.938,341.938,0,0,0-20.339-54.544c-.44-.914.9-1.32,1.344-.432,8.644,17.45,15.32,36.084,20.84,54.976Z",
    transform: "translate(43.78 -67.823)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31605",
    "data-name": "Path 31605",
    d: "M375.092,165.4c-4.21-10.389-8.52-20.736-13.1-30.931-.4-.9.888-1.258,1.289-.363,4.672,10.321,9.041,20.793,13.337,31.294Z",
    transform: "translate(44.537 -60.283)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31606",
    "data-name": "Path 31606",
    d: "M393.744,182.3c-1.625-8.086-3.735-16.059-6.121-23.974q3.034,11.942,5.614,23.974h-1.927c-2.213-10.535-4.714-21.018-7.5-31.316-5-18.466-11.554-38.123-24.773-52.617-.553-.606.487-1.265,1.041-.671,11.692,12.581,18.027,29.092,23.2,45.2a.939.939,0,0,1,.539.553A227.69,227.69,0,0,1,395.445,182.3Z",
    transform: "translate(43.118 -77.182)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31607",
    "data-name": "Path 31607",
    d: "M371.355,109.228c.73,1.249,1.411,2.542,2.112,3.838-.069-.141-.135-.289-.2-.432-.5-1.064,1.022-1.481,1.515-.434a269.609,269.609,0,0,1,20.077,60.644v4.129h-1.573c-4.507-23.333-11.669-46.538-23.066-66.992-.483-.87.619-1.632,1.136-.753",
    transform: "translate(48.365 -71.86)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31608",
    "data-name": "Path 31608",
    d: "M352.728,161.725c-.806-1.453-1.617-2.906-2.35-4.309a.479.479,0,0,1-.035-.411q-3.613-7.419-7.23-14.837c-.357-.727.791-1.032,1.146-.321,3.3,6.615,6.539,13.315,9.87,19.879Z",
    transform: "translate(35.71 -56.609)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31609",
    "data-name": "Path 31609",
    d: "M352.671,176.429c-.16-.386-.323-.765-.484-1.16-12.681-23.614-26.8-46.1-46.541-64.19-.672-.615.135-1.479.825-.859,16.9,15.21,29.641,33.393,40.86,53.167q-4.432-11.048-8.834-22.1c-.327-.815.912-1.2,1.245-.379,4.728,11.674,9.449,23.352,14.388,34.94l.316.584Z",
    transform: "translate(18.1 -71.313)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31610",
    "data-name": "Path 31610",
    d: "M369.14,179.086c-5.081-9.8-10.132-19.684-15.451-29.2-8.793-15.725-20.575-29.924-30.614-45-.291-.433.531-.8.832-.385,10.314,14.41,22.044,28.167,30.795,43.482,5.045,8.828,13.753,25.577,16.606,31.094Z",
    transform: "translate(26.341 -73.97)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31611",
    "data-name": "Path 31611",
    d: "M356.354,156.251c-.393-.819-.845-1.741-1.176-2.394-.377-.744.945-1.016,1.325-.269q.68,1.328,1.35,2.662Z",
    transform: "translate(41.355 -51.135)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31612",
    "data-name": "Path 31612",
    d: "M347.7,158.806q-1.951-5.185-3.757-10.4c-.254-.728.947-1.035,1.206-.294q1.867,5.365,3.873,10.7Z",
    transform: "translate(36.112 -53.691)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31613",
    "data-name": "Path 31613",
    d: "M334.52,164.407c-4.882-9.42-10.039-18.676-15.811-27.527a.752.752,0,1,1,1.287-.771,311.635,311.635,0,0,1,16.449,28.3Z",
    transform: "translate(24.257 -59.292)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31614",
    "data-name": "Path 31614",
    d: "M341.622,170.8q-1.686-3.547-3.349-7.108-3.023-5.57-6.32-10.986,3.8,8.987,7.276,18.094h-1.714c-3.36-8.809-6.932-17.523-10.786-26.142a163.256,163.256,0,0,0-11.66-14.415c4.9,10.719,9.781,21.445,14.76,32.124,1.308,2.806,2.6,5.621,3.91,8.432h-2.594c-4.924-7.516-9.844-15.036-14.909-22.464,3.518,7.483,6.884,15.08,10.628,22.464H321.42c-.355-.7-.709-1.408-1.052-2.108-1.716-2.438-3.505-4.954-5.325-7.553q2.472,4.8,4.764,9.661h-2a175.067,175.067,0,0,0-19.556-32.5.73.73,0,0,1-.156-.816c-3.722-4.932-7.506-9.854-11.409-14.592-.589-.715.427-1.236,1.014-.536,9.81,11.79,18.865,24.244,27.811,36.752-.123-.236-.235-.486-.358-.722a320.033,320.033,0,0,0-16.8-28.154c-.64-.969.662-1.66,1.315-.687,1.446,2.141,2.856,4.3,4.23,6.449a.816.816,0,0,1,1.281.277c6.206,10.132,12.2,20.437,18.174,30.734-.737-1.6-1.482-3.247-2.257-4.911q-5.143-11-10.619-21.891c-4.19-5.73-8.463-11.478-12.928-16.9-.561-.681.4-1.164.961-.5q4.121,4.828,8.052,9.847c-.65-1.215-1.275-2.441-1.933-3.655-.6-1.1,1.1-1.418,1.689-.336,2.068,3.774,4.025,7.623,5.936,11.487q8.3,11.349,16.026,23.082c-.282-.622-.559-1.262-.848-1.9-4.864-10.7-9.758-21.489-14.608-32.224a.617.617,0,0,1,.3-.9c-.216-.208-.411-.437-.633-.655-.724-.706.15-1.664.882-.941a127.569,127.569,0,0,1,11.805,13.324.888.888,0,0,1,1.182.439c.48,1.005.929,2.021,1.4,3.019,1.239,1.735,2.425,3.487,3.571,5.237q-3.707-8.113-7.414-16.229c-.6-1.311,1.427-1.838,2.021-.53,5.351,11.72,10.779,23.468,16.289,35.147.189.345.389.682.578,1.02-5.306-12.627-10.612-25.272-16.354-37.683-.322-.693.747-.975,1.07-.3,6.32,13.331,11.971,27.1,17.874,40.737Z",
    transform: "translate(9.268 -65.69)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31615",
    "data-name": "Path 31615",
    d: "M342.163,170.233c-8.651-15.875-15.287-32.6-27.808-45.71-.688-.721.179-1.752.9-1.023a92.489,92.489,0,0,1,13.3,17.356.917.917,0,0,1,.887.427c.663.944,1.315,1.911,1.961,2.868a.972.972,0,0,1,.405.4c.2.358.393.725.591,1.083,5.125,7.985,9.771,16.2,14.108,24.6Z",
    transform: "translate(22.174 -65.118)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31616",
    "data-name": "Path 31616",
    d: "M370.7,168.326c-.637-2.307-1.278-4.616-1.94-6.919-1.11-2.812-2.281-5.752-3.5-8.732a.606.606,0,0,1,.6-.884c-2.513-7.857-5.169-15.678-8.062-23.377-.411-1.091,1.136-1.556,1.548-.47,4.383,11.535,8.227,23.341,11.748,35.227.671,1.714,1.331,3.435,1.995,5.153Z",
    transform: "translate(42.578 -63.211)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31617",
    "data-name": "Path 31617",
    d: "M345.561,164.269c-4.416-9.091-8.586-18.31-12.737-27.516-.335-.743.816-1.071,1.157-.336,4.281,9.276,8.561,18.64,13.117,27.852Z",
    transform: "translate(30.902 -59.153)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31618",
    "data-name": "Path 31618",
    d: "M372.035,177.8c-9.9-24.056-20.749-47.9-34.772-69.542a.755.755,0,0,1,1.249-.848c14.47,21.883,25.464,46.018,35.568,70.39Z",
    transform: "translate(32.946 -72.685)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31619",
    "data-name": "Path 31619",
    d: "M375.174,180.379q-.614-1.68-1.233-3.354c-4.823-9-9.724-18.012-14.859-26.775-10.238-17.487-21.912-34.182-36.779-47.958-.424-.395.317-.992.756-.611,14.961,12.941,26.453,29.255,36.655,46.221,4.522,7.522,8.843,15.267,13.079,23.016a.671.671,0,0,1,.267.316q.119.313.247.634,2.287,4.251,4.56,8.511Z",
    transform: "translate(25.95 -75.264)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31620",
    "data-name": "Path 31620",
    d: "M385.165,132.381q1.836,5.224,3.534,10.512v6.079q-2.51-8.2-5.351-16.239c-.489-1.386,1.324-1.758,1.817-.352",
    transform: "translate(54.523 -61.263)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31621",
    "data-name": "Path 31621",
    d: "M304.019,171.4a140.621,140.621,0,0,0-17-18.138c-.051-.069-.1-.142-.151-.213-4.491-6.12-9.057-12.391-13.792-18.382-1.824-2.306-4.2-6.341-6.637-8.109-2.564-1.86-5.262-3.449-7.666-5.529-.885-.763-1.81.248-.942,1.02,2.583,2.291,6.349,4.142,8.491,6.775s4.265,5.29,6.314,7.946q5.475,7.1,10.754,14.4a.6.6,0,0,0-.258.5c-5.541-6.533-11.262-12.89-17.258-18.968-.969-.989-2.077.229-1.114,1.212A336.949,336.949,0,0,1,296.275,171.4H300.5q-4.7-6.1-9.259-12.317c3.807,3.939,7.323,8.07,10.716,12.317Zm-15.373-12.972c-1.512-1.915-3.082-3.84-4.676-5.774q.634.511,1.258,1.019l.106.145c1.052,1.535,2.212,3.088,3.313,4.61",
    transform: "translate(-4.31 -66.285)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31622",
    "data-name": "Path 31622",
    d: "M290.932,168.768c-14.655-15.557-29.186-30.815-48.193-40.943-1.035-.55-.487-1.848.546-1.317,19.8,10.223,34.854,26.1,50.019,42.259Z",
    transform: "translate(-11.466 -63.653)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31623",
    "data-name": "Path 31623",
    d: "M292.035,171.376q-1.94-2.587-3.851-5.193c-10.057-11.322-20.214-22.621-31.094-33.039-1.024-.98.113-2.253,1.151-1.258,6.928,6.622,13.569,13.572,20.071,20.651-.112-.151-.222-.307-.335-.458-8.429-11.46-18.106-22.518-30.462-29.847-.983-.583-.443-1.857.54-1.277,17.792,10.546,29.758,27.372,41.615,44.292q2.717,3.073,5.45,6.128Z",
    transform: "translate(-9.216 -66.261)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31624",
    "data-name": "Path 31624",
    d: "M309.44,173.434q-4.518-6.2-9.019-12.407c-2.963-3.593-6-7.117-9.175-10.474-.581-.616-.352-1.317.141-1.49-9.113-11.4-18.869-22.126-30.061-31.294-.966-.793.051-1.871,1.024-1.089,16.982,13.669,30.55,31.046,43.433,48.484,1.9,2.566,3.768,5.155,5.489,7.574.166.235.332.465.5.7Z",
    transform: "translate(-2.695 -68.318)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31625",
    "data-name": "Path 31625",
    d: "M317.357,174.483c-14.535-20.945-29.163-41.606-47.722-59.055-.818-.769.107-1.757.942-.982,15.7,14.538,29.06,31.3,41.408,48.9-2.771-4.782-5.563-9.556-8.419-14.288-.672-1.111.834-1.9,1.513-.771,5.225,8.645,10.277,17.429,15.361,26.192Z",
    transform: "translate(1.225 -69.368)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31626",
    "data-name": "Path 31626",
    d: "M303,163.417c-5.175-8.174-10.374-16.329-15.9-24.243-.791-1.13.781-1.943,1.585-.794,5.695,8.125,10.98,16.578,16.26,25.037Z",
    transform: "translate(9.441 -58.302)",
    fill: "#a67d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31627",
    "data-name": "Path 31627",
    d: "M366.987,95.272c-.288-.436.387-.859.68-.424,8.617,12.863,12.678,28.32,16.437,43.1,1.848,7.267,3.634,14.6,5.39,21.912q3.6,10.449,6.853,21V183.6h-.493q-1.62-5.464-3.32-10.907,1.277,5.451,2.511,10.907h-1.311c-1.8-8.1-3.7-16.191-5.63-24.269a383.577,383.577,0,0,0-17.939-43.485c-.252-.5.48-.709.729-.225a345.93,345.93,0,0,1,14.879,34c-.8-3.3-1.6-6.634-2.413-9.948-3.724-15.212-7.629-31.231-16.373-44.4",
    transform: "translate(46.877 -78.489)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31628",
    "data-name": "Path 31628",
    d: "M385.012,140.7c1.139,3.848,2.291,7.706,3.432,11.561v4.286c-1.509-5.23-3.034-10.458-4.594-15.645-.258-.863.9-1.076,1.162-.2",
    transform: "translate(54.779 -57.218)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31629",
    "data-name": "Path 31629",
    d: "M372.425,83.791a46.125,46.125,0,0,1,3.84,5.958.61.61,0,0,1,.25.181c8.745,11.534,14.017,25.892,17.608,40.8v6.577c-3.132-14.475-7.565-28.65-14.8-41.2.948,2.278,1.849,4.663,2.66,7.161C387.8,113.633,390,125.6,392.38,137.1q.865,4.174,1.742,8.347V150.7q-1.011-4.758-1.989-9.507c-2.274-11.087-4.438-22.11-8.585-32.7,5.291,20.4,7.443,41.395,10.574,62.179v7.151c-.1-.684-.21-1.375-.317-2.077-3.694-23.987-5.561-48.59-12.587-72.013a40.3,40.3,0,0,0-4.18-6.2c-.357-.429.339-.807.69-.393a36.666,36.666,0,0,1,2.235,2.941,76.273,76.273,0,0,0-4.026-9.239c-.107-.153-.2-.3-.307-.445a.409.409,0,0,1-.082-.255,46.317,46.317,0,0,0-3.818-6.009c-.264-.346.426-.687.694-.338",
    transform: "translate(49.1 -83.644)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31630",
    "data-name": "Path 31630",
    d: "M375.138,172.408q-2.73-7.215-5.444-14.432c1.192,4.551,2.372,9.1,3.5,13.672.115.258.223.5.338.76h-1.142c-.1-.4-.194-.806-.294-1.218-7.547-17.519-15.151-35.009-23.186-52.309-.125-.27.27-.395.389-.147,7.546,15.5,14.581,31.812,21.651,47.82-.941-3.776-1.933-7.563-2.906-11.3-.087-.333.183-.47.458-.414q-4.656-12.184-9.454-24.315c-.161-.409.417-.59.578-.186,5.574,13.964,10.888,28.032,16.268,42.073Z",
    transform: "translate(38.442 -67.293)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31631",
    "data-name": "Path 31631",
    d: "M372.555,181.456c-3.137-7.333-6.25-14.677-9.4-22q3.5,10.946,6.556,22h-2.159c-6.25-11.174-12.118-22.539-17.711-34.063-.179-.37.374-.536.549-.17,5.481,11.47,17.768,34.021,17.768,34.021s-5.63-10.484-8.372-15.756c-.244-.467.511-.659.753-.191,2.649,5.095,5.334,10.183,8.1,15.219q-4.053-14.575-8.894-28.89c-2.665-6.024-5.345-12.074-8.127-18-.186-.395.407-.59.591-.2q2.481,5.3,4.886,10.625c-5.614-15.248-11.742-30.478-19.6-44.451-.163-.294.379-.49.544-.186,9.256,16.873,16.383,34.684,22.715,52.845,4.252,9.708,8.376,19.464,12.551,29.2Z",
    transform: "translate(33.099 -76.341)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31632",
    "data-name": "Path 31632",
    d: "M356.539,166.364c-5.977-11.328-11.4-22.975-16.687-34.568-.122-.263.283-.392.4-.129,5.321,11.654,10.885,23.346,17.011,34.7Z",
    transform: "translate(34.207 -61.249)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31633",
    "data-name": "Path 31633",
    d: "M340.359,167.123c-4.048-6.884-7.88-13.9-11.754-20.884,3.261,6.942,6.415,13.93,9.64,20.884h-1.27c-5.711-12.259-11.111-24.676-17.4-36.579-.341-.638.666-.916,1.005-.288,1.231,2.271,2.4,4.573,3.559,6.863,5.594,10.022,11.087,20.1,16.892,30Z",
    transform: "translate(24.701 -62.007)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31634",
    "data-name": "Path 31634",
    d: "M340.722,166.255a302.991,302.991,0,0,0-18.241-33.764.466.466,0,1,1,.794-.483c6.947,10.9,12.542,22.578,18.223,34.247Z",
    transform: "translate(26.05 -61.14)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31635",
    "data-name": "Path 31635",
    d: "M356.43,180.787c-.11-.191-.217-.373-.329-.564.054.191.106.373.159.564h-1.111q-.619-2.221-1.249-4.444c-7.656-13.7-14.989-27.643-22.552-41.336-.264-.476.495-.713.754-.245,6.981,12.67,13.77,25.5,20.779,38.186A558.624,558.624,0,0,0,326.122,101.2c-.214-.461.615-.738.831-.273A544.056,544.056,0,0,1,355.261,177.2q1.035,1.792,2.07,3.584Z",
    transform: "translate(27.779 -75.672)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31636",
    "data-name": "Path 31636",
    d: "M336.183,175.146c-2.282-4.088-4.55-8.184-6.837-12.27,1.87,4.085,3.715,8.183,5.579,12.27h-1c-3.3-7.226-6.548-14.478-9.953-21.658a445.51,445.51,0,0,0-26.117-40.166c-.351-.47.332-.822.682-.351,7.135,9.554,13.763,19.619,20.092,29.829-.286-.552-.562-1.123-.851-1.67-.277-.531.558-.732.831-.205,2.064,3.975,4.1,7.96,6.047,12,4.262,7.367,8.412,14.8,12.564,22.226Z",
    transform: "translate(14.527 -70.031)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31637",
    "data-name": "Path 31637",
    d: "M337.628,171.884c-4.808-9.126-9.492-18.316-14.444-27.367q4.5,13.036,8.67,26.17c.213.405.424.8.636,1.2H331.2c-5.983-11.258-11.993-22.481-18.642-33.344a.573.573,0,1,1,.98-.584c5.645,9.207,10.87,18.652,15.919,28.207q-4.273-13.208-8.924-26.287c-.97-1.7-1.911-3.436-2.913-5.137-.305-.521.524-.729.823-.232.132.22.255.44.379.659-1.849-4.971-3.722-9.978-5.695-14.855-.239-.587.662-.841.9-.252q3.928,9.881,7.543,19.881c5.934,10.53,11.451,21.275,17.118,31.945Z",
    transform: "translate(21.401 -66.768)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31638",
    "data-name": "Path 31638",
    d: "M384.954,184.971c-5.3-15.3-10.6-30.6-16.189-45.8q3.989,15.726,7.393,31.586c.658,3.041,1.3,6.022,1.917,8.877q.872,2.673,1.747,5.34h-1.566q-.44-2.226-.9-4.452c-3.151-9.74-6.329-19.5-9.645-29.158a.432.432,0,1,1,.829-.235c2.369,6.872,4.676,13.8,6.964,20.708-.194-.9-.388-1.811-.583-2.73-3.069-14.318-6.479-28.7-10.525-42.733-3.355-11.639-6.829-23.864-13.431-34.2-.235-.367.514-.615.747-.255,6.939,10.756,10.387,23.672,13.945,35.9,1.02,3.5,1.989,7.06,2.924,10.638a.311.311,0,0,1,.6.025c5.754,15.41,11.23,30.952,16.719,46.485Z",
    transform: "translate(39.396 -79.855)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31639",
    "data-name": "Path 31639",
    d: "M356.082,180.7c-3.637-6.329-7.258-12.667-10.954-18.962,1.626,3.432,3.217,6.79,4.782,10.02q2.455,4.5,4.977,8.941h-1.3q-.491-.951-.97-1.905c-3.8-6.788-7.436-13.69-10.958-20.591-.317-.622.677-.9.992-.28q.744,1.46,1.5,2.908a.406.406,0,0,1,.409-.044c-1.719-2.9-3.506-5.817-5.31-8.758q3.368,9.52,6.371,19.147c1.681,3.191,3.373,6.367,5.108,9.524h-1.149q-1.235-2.254-2.453-4.522.641,2.257,1.262,4.522h-.882q-1.167-4.192-2.4-8.365c-6.241-12-12.458-24.071-19.379-35.606a.463.463,0,1,1,.776-.5c6.038,10.022,11.553,20.456,17,30.881q-3-9.293-6.326-18.469c-2.055-3.307-4.176-6.6-6.291-9.844a.447.447,0,1,1,.749-.487c1.347,2.036,2.665,4.111,3.985,6.172-5.9-15.031-12.523-29.9-21.115-43.307-.186-.291.374-.445.564-.153,9.275,14.421,16.308,30.425,22.54,46.635,6.737,10.879,13.079,21.974,19.473,33.045Z",
    transform: "translate(22.342 -75.588)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31640",
    "data-name": "Path 31640",
    d: "M392.4,186.4c-.9-4.22-1.854-8.429-2.817-12.628-.229-1.008-.486-2.03-.727-3.063a270.845,270.845,0,0,0-9.645-27.657c-.222-.53.5-.728.722-.207,1.892,4.456,3.621,9.016,5.275,13.6-3.034-10.784-6.424-21.448-10.491-31.837-5.241-13.386-12-29.29-26.047-35.386-.459-.2.069-.693.524-.5,12.78,5.507,19.5,18.982,24.668,31.04,6.829,15.94,11.666,32.7,15.828,49.569.589,2.384,1.145,4.732,1.691,7.019q1.369,5.02,2.693,10.048Z",
    transform: "translate(38.259 -81.287)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31641",
    "data-name": "Path 31641",
    d: "M311.51,160.228q-3.179-7.532-6.113-15.154c-.179-.462.561-.611.737-.153q2.941,7.692,6.181,15.307Z",
    transform: "translate(18.088 -55.112)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31642",
    "data-name": "Path 31642",
    d: "M325.6,172.543c-3.911-6.413-7.7-12.891-11.5-19.37q4.06,9.608,7.672,19.37H320.5c-.125-.351-.25-.7-.376-1.049-.809-1.708-1.588-3.5-2.436-5.287-.131-.274.04-.464.283-.52-2.77-7.255-5.862-14.359-9.134-21.4-2.1-3.528-4.237-7.058-6.367-10.553a.5.5,0,0,1,.744-.659c-2.573-4.719-5.219-9.42-8.018-13.954-.415-.675.495-1.157.919-.47a281.491,281.491,0,0,1,13.968,25.7c5.614,9.4,11.115,18.875,16.87,28.194Z",
    transform: "translate(13.279 -67.428)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31643",
    "data-name": "Path 31643",
    d: "M307.419,166.73c-6.891-11.84-13.753-23.714-21.08-35.207-.415-.655.454-1.12.873-.468,7.509,11.723,14.664,23.705,21.825,35.675Z",
    transform: "translate(9.135 -61.615)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31644",
    "data-name": "Path 31644",
    d: "M314.319,168.353q-1.5-2.316-3-4.632c.8,1.547,1.622,3.088,2.435,4.632h-1.281c-2.558-4.841-5.08-9.7-7.607-14.559q-3.784-5.775-7.632-11.506c4.139,8.711,8.268,17.422,12.543,26.064h-1.394c-5.3-10.754-10.37-21.621-15.529-32.447-.267-.385-.542-.784-.813-1.171a.506.506,0,0,1-.044-.618c-.976-2.034-1.945-4.077-2.931-6.113-.392-.809.825-1.035,1.214-.232q2.083,4.293,4.123,8.563,2.836,4.093,5.555,8.146c-1.729-3.222-3.492-6.489-5.344-9.768-.427-.754.74-.955,1.161-.211,3.614,6.426,7.088,12.992,10.516,19.555q4.659,7.133,9.283,14.3Z",
    transform: "translate(10.428 -63.238)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31645",
    "data-name": "Path 31645",
    d: "M321.8,161.854c-3.424-6.8-6.832-13.6-10.333-20.362-.179-.343.382-.464.555-.123,3.468,6.777,6.957,13.634,10.459,20.485Z",
    transform: "translate(20.925 -56.739)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31646",
    "data-name": "Path 31646",
    d: "M293.287,170.22c-11.043-15-20.887-30.936-31.41-46.152-.449-.647.429-1.135.884-.476,10.647,15.455,20.629,31.493,31.818,46.627Z",
    transform: "translate(-2.313 -65.105)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31647",
    "data-name": "Path 31647",
    d: "M296.749,166.927c-6.873-10.192-13.512-20.523-20.871-30.394,5.77,10.1,11.451,20.253,17.149,30.394h-1.148c-6.744-12.057-13.468-24.15-20.233-36.1-.316-.553.534-.71.848-.166s.649,1.126.973,1.685a.676.676,0,0,1,.608.279c8.545,10.883,15.951,22.728,23.72,34.307Z",
    transform: "translate(2.282 -61.812)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31648",
    "data-name": "Path 31648",
    d: "M293.633,170.286c-11.761-15.728-23.474-31.511-35.967-46.591-.374-.451.264-.79.631-.354,12.6,15.1,24.4,31.06,36.233,46.944Z",
    transform: "translate(-4.278 -65.17)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31649",
    "data-name": "Path 31649",
    d: "M301.709,170.754c-.207-.476-.409-.947-.618-1.43q-4.243-6.559-8.382-13.174c2.758,4.866,5.47,9.756,8.262,14.6h-.957c-6.6-11.378-12.7-23.074-20.007-33.849-.3-.445.3-.772.612-.317.892,1.312,1.758,2.645,2.626,3.97-.615-1.038-1.236-2.071-1.848-3.112-.492-.84.816-1.071,1.3-.244q7.279,12.263,14.943,24.313c-5.916-13.133-12.187-26.079-19.062-38.72-.392-.724.713-.928,1.107-.217,8.172,14.763,15.473,30.143,22.32,45.664q.834,1.255,1.67,2.511Z",
    transform: "translate(5.521 -65.639)",
    fill: "#d7b789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31650",
    "data-name": "Path 31650",
    d: "M390.646,177.7q-6.114-16.065-12.328-32.1c-1.59-12.614-3.009-25.314-3.8-37.916-.032-.536-.837-.528-.8.012.768,11.6,1.965,23.184,3.371,34.747q-3.692-9.364-7.44-18.7c-.226-.558-1-.324-.775.23,2.987,7.477,5.877,15.1,8.758,22.671.374,2.875.766,5.721,1.164,8.511-1.107-2.278-2.241-4.569-3.43-6.846a277.522,277.522,0,0,0-10.644-27.9c-.285-.631-1.2-.341-.911.294,8.183,17.927,13.593,37.8,18.091,56.991h1.295q-1.53-8.846-2.878-17.729c2.571,5.853,5.023,11.757,7.274,17.729h1.022c-2.654-6.787-5.567-13.469-8.635-20.09-.36-2.482-.722-5.014-1.073-7.579,3.476,9.217,6.894,18.457,10.378,27.67ZM379.1,157.323c.461,3.153.925,6.239,1.39,9.209q-1.924-7.479-4.091-14.877c.936,1.9,1.827,3.79,2.7,5.668",
    transform: "translate(45.396 -72.584)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31651",
    "data-name": "Path 31651",
    d: "M386.062,166.856q-5.861-17.884-11.94-35.712c-.247-.722.709-.96.957-.235,4.1,11.947,8.177,23.915,12.027,35.946Z",
    transform: "translate(50.228 -61.741)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31652",
    "data-name": "Path 31652",
    d: "M380.013,184.08c-1.519-4.456-3.2-8.861-4.9-13.255,1.114,4.424,2.238,8.846,3.41,13.255h-2.837c-4.923-12.247-10.449-24.234-16.481-35.967-.4-.772.743-1.085,1.136-.339,6.013,11.438,11.591,23.25,16.555,35.267q-2.532-9.918-4.9-19.881c-3.637-8.623-7.471-17.165-11.372-25.656-.336-.729.707-1.052,1.047-.326,2.963,6.41,5.909,12.841,8.774,19.3-4.71-20.707-9.175-41.55-12.554-62.448-.076-.462.76-.537.837-.078,3.793,23.005,8.971,45.97,14.4,68.743,2.956,7.045,5.9,14.136,8.36,21.381Z",
    transform: "translate(42.654 -78.965)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31653",
    "data-name": "Path 31653",
    d: "M337.858,133.817c6.5,10.637,15.012,20.468,20.986,31.606h-1.779c-5.673-10.9-14.02-20.783-20.126-31.022a.545.545,0,1,1,.919-.584",
    transform: "translate(32.81 -60.31)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31654",
    "data-name": "Path 31654",
    d: "M362.893,185.3q-.889-1.8-1.81-3.589.605,1.8,1.242,3.589h-1.532c-1.186-3.426-2.312-6.872-3.424-10.324-4.726-8.125-9.721-16.084-14.795-23.992a.58.58,0,1,1,.966-.64c4.11,6.376,8.233,12.759,12.154,19.26-7.869-25.95-14.5-52.318-22.28-78.231-.11-.37.7-.459.806-.1,8.237,27.53,15.791,55.93,24.589,83.632,1.923,3.443,3.766,6.887,5.492,10.392Z",
    transform: "translate(31.201 -80.183)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31655",
    "data-name": "Path 31655",
    d: "M372.251,182.507c-3.186-7.195-6.65-14.259-10.312-21.237q.786,6.165,1.62,12.32c1.471,2.957,2.916,5.924,4.3,8.917H366.2q-1.015-2.241-2.056-4.472.313,2.237.627,4.472h-.882q-.5-3.525-.985-7.047a281.777,281.777,0,0,0-16.888-29.333.6.6,0,1,1,.989-.663c5.533,8.256,10.606,16.927,15.335,25.763q-.79-6.03-1.544-12.065c-2.444-4.375-4.957-8.707-7.585-12.953a.607.607,0,1,1,1.007-.672q3.2,5.09,6.178,10.326c-2.35-19.471-4.562-39.048-5.729-58.534-.022-.376.636-.445.665-.069,1.387,20.225,3.658,40.425,6.173,60.568,4.418,8.077,8.61,16.273,12.35,24.679Z",
    transform: "translate(37.044 -77.392)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31656",
    "data-name": "Path 31656",
    d: "M349.092,162.031c-3.985-6.89-8.184-13.654-12.637-20.193a.678.678,0,1,1,1.16-.7c4.578,6.806,8.921,13.759,12.965,20.892Z",
    transform: "translate(32.563 -56.916)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31657",
    "data-name": "Path 31657",
    d: "M344.068,159.043q-3.371-5.643-6.687-11.3c-.329-.565.639-.8.967-.248q3.408,5.777,6.911,11.553Z",
    transform: "translate(33.03 -53.927)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31658",
    "data-name": "Path 31658",
    d: "M333.546,155.783c-.173-.352-.352-.7-.527-1.06-.288-.589.8-.826,1.091-.233.213.437.43.862.646,1.293Z",
    transform: "translate(30.999 -50.667)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31659",
    "data-name": "Path 31659",
    d: "M328.754,174.507c-5.608-12.15-11.206-24.5-16.421-36.87-.249-.592.663-.82.913-.229,2.26,5.388,4.606,10.764,6.979,16.116-4.868-12.879-9.508-25.866-13.971-38.857-.194-.565.69-.794.891-.214,7.053,20.126,13.941,40.684,22.734,60.054Z",
    transform: "translate(18.489 -69.392)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31660",
    "data-name": "Path 31660",
    d: "M325.3,167.3c-6.52-12.285-12.813-24.7-19.289-37-.423-.806.825-1.083,1.243-.292,6.565,12.389,13.11,24.865,19.715,37.294Z",
    transform: "translate(18.35 -62.181)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31661",
    "data-name": "Path 31661",
    d: "M314.375,159.064c-2.483-3.7-4.955-7.392-7.107-11.221-.427-.76.887-1.01,1.311-.263,2.231,3.919,4.854,7.689,7.465,11.484Z",
    transform: "translate(18.937 -53.949)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31662",
    "data-name": "Path 31662",
    d: "M320.114,163.527c-4.553-8.83-10.56-17-16.33-24.928-.591-.816.577-1.44,1.176-.633,5.95,8,12.364,16.417,16.966,25.561Z",
    transform: "translate(17.27 -58.411)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31663",
    "data-name": "Path 31663",
    d: "M308.066,159.957c-2.662-4.676-5.454-9.263-8.437-13.669-.6-.889.691-1.534,1.306-.628,3.14,4.625,6.118,9.394,8.877,14.3Z",
    transform: "translate(15.33 -54.841)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31664",
    "data-name": "Path 31664",
    d: "M308.95,177.158c-.358-.825-.715-1.661-1.073-2.517a144.037,144.037,0,0,0-9.69-14c-.587-.746.495-1.27,1.079-.528,2.127,2.687,4.142,5.459,6.021,8.193-7.541-19.547-13.848-39.581-20.73-59.308-.208-.6.741-.779.954-.175,7.876,22.207,15.078,44.794,24.334,66.533.365.6.722,1.2,1.076,1.8Z",
    transform: "translate(8.339 -72.043)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31665",
    "data-name": "Path 31665",
    d: "M299.233,162.163c-4.453-7.116-9.157-14.064-14.114-20.755-.558-.751.518-1.295,1.085-.537q7.664,10.334,14.576,21.293Z",
    transform: "translate(8.544 -57.047)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31666",
    "data-name": "Path 31666",
    d: "M294.655,178.5c-2.112-4.174-4.1-8.406-6.051-12.661q-8.95-16.208-18.43-32.1c-.4-.675.659-.867,1.055-.217,4.45,7.229,8.737,14.735,12.975,22.181-6.826-16.365-13.078-32.974-19.351-49.533-.239-.637.81-.845,1.055-.2,7.879,20.89,15.982,41.9,25.288,62.31q2.754,5.1,5.473,10.218Z",
    transform: "translate(-0.88 -73.385)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31667",
    "data-name": "Path 31667",
    d: "M289.826,158.031q-2.089-3.989-4.16-7.98c-.41-.793.926-1.005,1.344-.213q2.173,4.1,4.369,8.193Z",
    transform: "translate(8.836 -52.916)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31668",
    "data-name": "Path 31668",
    d: "M288.971,167.886c-7.556-13.119-15.584-26-23.4-38.891-.481-.785.759-1.027,1.233-.254,7.948,12.947,16.122,25.838,23.515,39.145Z",
    transform: "translate(-0.577 -62.771)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31669",
    "data-name": "Path 31669",
    d: "M283,156.092c-.3-.666-.6-1.337-.908-2.021-.289-.65.856-.829,1.152-.175.336.744.674,1.471,1.013,2.2Z",
    transform: "translate(7.179 -50.976)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31670",
    "data-name": "Path 31670",
    d: "M344.835,175.91c-8.382-20.98-14.629-43-20.808-64.507-.1-.361.515-.4.621-.035,6.242,21.527,12.59,43.552,21.042,64.542Z",
    transform: "translate(26.81 -70.795)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31671",
    "data-name": "Path 31671",
    d: "M279.833,155.835c-.239-.458-.478-.914-.721-1.383s.558-.586.816-.147a.728.728,0,0,1,.96.255c.25.429.489.848.734,1.274Z",
    transform: "translate(5.786 -50.719)",
    fill: "#efddb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31672",
    "data-name": "Path 31672",
    d: "M293.2,155.405c-.059-.559,1.032-.647,1.374,0Z",
    transform: "translate(12.397 -50.29)",
    fill: "#efddb9"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg401403);
export default __webpack_public_path__ + "static/media/401&403.8294d2a3040c36131a50acdf85364590.svg";
export { ForwardRef as ReactComponent };